export const TRAINERS = [
  {
    "name": "BRADY",
    "trainerClass": "Youngster",
    "pokemon": [
      "Sunkern 1",
      "Azurill 1",
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Shedinja 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Spinarak 1",
      "Marill 1",
      "Hoppip 1",
      "Slugma 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Slakoth 1",
      "Paras 1",
      "Ekans 1",
      "Ditto 1",
      "Barboach 1",
      "Meowth 1",
      "Pineco 1",
      "Trapinch 1",
      "Spheal 1",
      "Horsea 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Vulpix 1"
    ]
  },
  {
    "name": "CONNER",
    "trainerClass": "Youngster",
    "pokemon": [
      "Sunkern 1",
      "Azurill 1",
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Shedinja 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Spinarak 1",
      "Marill 1",
      "Hoppip 1",
      "Slugma 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Slakoth 1",
      "Paras 1",
      "Ekans 1",
      "Ditto 1",
      "Barboach 1",
      "Meowth 1",
      "Pineco 1",
      "Trapinch 1",
      "Spheal 1",
      "Horsea 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Vulpix 1"
    ]
  },
  {
    "name": "BRADLEY",
    "trainerClass": "Youngster",
    "pokemon": [
      "Sunkern 1",
      "Azurill 1",
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Shedinja 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Spinarak 1",
      "Marill 1",
      "Hoppip 1",
      "Slugma 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Slakoth 1",
      "Paras 1",
      "Ekans 1",
      "Ditto 1",
      "Barboach 1",
      "Meowth 1",
      "Pineco 1",
      "Trapinch 1",
      "Spheal 1",
      "Horsea 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Vulpix 1"
    ]
  },
  {
    "name": "CYBIL",
    "trainerClass": "Lass",
    "pokemon": [
      "Sunkern 1",
      "Azurill 1",
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Shedinja 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Spinarak 1",
      "Marill 1",
      "Hoppip 1",
      "Slugma 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Slakoth 1",
      "Paras 1",
      "Ekans 1",
      "Ditto 1",
      "Barboach 1",
      "Meowth 1",
      "Pineco 1",
      "Trapinch 1",
      "Spheal 1",
      "Horsea 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Vulpix 1"
    ]
  },
  {
    "name": "RODETTE",
    "trainerClass": "Lass",
    "pokemon": [
      "Sunkern 1",
      "Azurill 1",
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Shedinja 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Spinarak 1",
      "Marill 1",
      "Hoppip 1",
      "Slugma 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Slakoth 1",
      "Paras 1",
      "Ekans 1",
      "Ditto 1",
      "Barboach 1",
      "Meowth 1",
      "Pineco 1",
      "Trapinch 1",
      "Spheal 1",
      "Horsea 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Vulpix 1"
    ]
  },
  {
    "name": "PEGGY",
    "trainerClass": "Lass",
    "pokemon": [
      "Sunkern 1",
      "Azurill 1",
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Shedinja 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Spinarak 1",
      "Marill 1",
      "Hoppip 1",
      "Slugma 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Slakoth 1",
      "Paras 1",
      "Ekans 1",
      "Ditto 1",
      "Barboach 1",
      "Meowth 1",
      "Pineco 1",
      "Trapinch 1",
      "Spheal 1",
      "Horsea 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Vulpix 1"
    ]
  },
  {
    "name": "KEITH",
    "trainerClass": "School Kid (M)",
    "pokemon": [
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Bellsprout 1",
      "Geodude 1",
      "Dratini 1",
      "Snubbull 1",
      "Remoraid 1",
      "Larvitar 1",
      "Baltoy 1",
      "Snorunt 1",
      "Bagon 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Numel 1",
      "Carvanha 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Abra 1",
      "Doduo 1",
      "Gastly 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Cubone 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Seel 1"
    ]
  },
  {
    "name": "GRAYSON",
    "trainerClass": "School Kid (M)",
    "pokemon": [
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Bellsprout 1",
      "Geodude 1",
      "Dratini 1",
      "Snubbull 1",
      "Remoraid 1",
      "Larvitar 1",
      "Baltoy 1",
      "Snorunt 1",
      "Bagon 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Numel 1",
      "Carvanha 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Abra 1",
      "Doduo 1",
      "Gastly 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Cubone 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Seel 1"
    ]
  },
  {
    "name": "GLENN",
    "trainerClass": "School Kid (M)",
    "pokemon": [
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Bellsprout 1",
      "Geodude 1",
      "Dratini 1",
      "Snubbull 1",
      "Remoraid 1",
      "Larvitar 1",
      "Baltoy 1",
      "Snorunt 1",
      "Bagon 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Numel 1",
      "Carvanha 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Abra 1",
      "Doduo 1",
      "Gastly 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Cubone 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Seel 1"
    ]
  },
  {
    "name": "LILIANA",
    "trainerClass": "School Kid (F)",
    "pokemon": [
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Bellsprout 1",
      "Geodude 1",
      "Dratini 1",
      "Snubbull 1",
      "Remoraid 1",
      "Larvitar 1",
      "Baltoy 1",
      "Snorunt 1",
      "Bagon 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Numel 1",
      "Carvanha 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Abra 1",
      "Doduo 1",
      "Gastly 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Cubone 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Seel 1"
    ]
  },
  {
    "name": "ELISE",
    "trainerClass": "School Kid (F)",
    "pokemon": [
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Bellsprout 1",
      "Geodude 1",
      "Dratini 1",
      "Snubbull 1",
      "Remoraid 1",
      "Larvitar 1",
      "Baltoy 1",
      "Snorunt 1",
      "Bagon 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Numel 1",
      "Carvanha 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Abra 1",
      "Doduo 1",
      "Gastly 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Cubone 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Seel 1"
    ]
  },
  {
    "name": "ZOEY",
    "trainerClass": "School Kid (F)",
    "pokemon": [
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Bellsprout 1",
      "Geodude 1",
      "Dratini 1",
      "Snubbull 1",
      "Remoraid 1",
      "Larvitar 1",
      "Baltoy 1",
      "Snorunt 1",
      "Bagon 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Numel 1",
      "Carvanha 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Abra 1",
      "Doduo 1",
      "Gastly 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Cubone 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Seel 1"
    ]
  },
  {
    "name": "MANUEL",
    "trainerClass": "Rich Boy",
    "pokemon": [
      "Ralts 1",
      "Poochyena 1",
      "Shedinja 1",
      "Zubat 1",
      "Spinarak 1",
      "Wynaut 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Meditite 1",
      "Ekans 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Oddish 1",
      "Natu 1",
      "Grimer 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Houndour 1",
      "Spoink 1",
      "Tentacool 1",
      "Koffing 1",
      "Nidorina 1",
      "Nidorino 1",
      "Beedrill 1",
      "Dustox 1",
      "Ariados 1"
    ]
  },
  {
    "name": "RUSS",
    "trainerClass": "Rich Boy",
    "pokemon": [
      "Ralts 1",
      "Poochyena 1",
      "Shedinja 1",
      "Zubat 1",
      "Spinarak 1",
      "Wynaut 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Meditite 1",
      "Ekans 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Oddish 1",
      "Natu 1",
      "Grimer 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Houndour 1",
      "Spoink 1",
      "Tentacool 1",
      "Koffing 1",
      "Nidorina 1",
      "Nidorino 1",
      "Beedrill 1",
      "Dustox 1",
      "Ariados 1"
    ]
  },
  {
    "name": "DUSTIN",
    "trainerClass": "Rich Boy",
    "pokemon": [
      "Ralts 1",
      "Poochyena 1",
      "Shedinja 1",
      "Zubat 1",
      "Spinarak 1",
      "Wynaut 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Meditite 1",
      "Ekans 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Oddish 1",
      "Natu 1",
      "Grimer 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Houndour 1",
      "Spoink 1",
      "Tentacool 1",
      "Koffing 1",
      "Nidorina 1",
      "Nidorino 1",
      "Beedrill 1",
      "Dustox 1",
      "Ariados 1"
    ]
  },
  {
    "name": "TINA",
    "trainerClass": "Lady",
    "pokemon": [
      "Ralts 1",
      "Poochyena 1",
      "Shedinja 1",
      "Zubat 1",
      "Spinarak 1",
      "Wynaut 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Meditite 1",
      "Ekans 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Oddish 1",
      "Natu 1",
      "Grimer 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Houndour 1",
      "Spoink 1",
      "Tentacool 1",
      "Koffing 1",
      "Nidorina 1",
      "Nidorino 1",
      "Beedrill 1",
      "Dustox 1",
      "Ariados 1"
    ]
  },
  {
    "name": "ZOE",
    "trainerClass": "Lady",
    "pokemon": [
      "Ralts 1",
      "Poochyena 1",
      "Shedinja 1",
      "Zubat 1",
      "Spinarak 1",
      "Wynaut 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Meditite 1",
      "Ekans 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Oddish 1",
      "Natu 1",
      "Grimer 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Houndour 1",
      "Spoink 1",
      "Tentacool 1",
      "Koffing 1",
      "Nidorina 1",
      "Nidorino 1",
      "Beedrill 1",
      "Dustox 1",
      "Ariados 1"
    ]
  },
  {
    "name": "CHEN",
    "trainerClass": "Camper",
    "pokemon": [
      "Grimer 1",
      "Krabby 1",
      "Exeggcute 1",
      "Eevee 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Houndour 1",
      "Phanpy 1",
      "Spoink 1",
      "Aron 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Cacnea 1",
      "Koffing 1",
      "Staryu 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Pidgeotto 1",
      "Growlithe 1",
      "Farfetch'd 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Nidorina 1",
      "Nidorino 1",
      "Flaaffy 1",
      "Magby 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Butterfree 1",
      "Beedrill 1",
      "Poliwhirl 1",
      "Onix 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "AL",
    "trainerClass": "Camper",
    "pokemon": [
      "Grimer 1",
      "Krabby 1",
      "Exeggcute 1",
      "Eevee 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Houndour 1",
      "Phanpy 1",
      "Spoink 1",
      "Aron 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Cacnea 1",
      "Koffing 1",
      "Staryu 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Pidgeotto 1",
      "Growlithe 1",
      "Farfetch'd 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Nidorina 1",
      "Nidorino 1",
      "Flaaffy 1",
      "Magby 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Butterfree 1",
      "Beedrill 1",
      "Poliwhirl 1",
      "Onix 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "MITCH",
    "trainerClass": "Camper",
    "pokemon": [
      "Grimer 1",
      "Krabby 1",
      "Exeggcute 1",
      "Eevee 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Houndour 1",
      "Phanpy 1",
      "Spoink 1",
      "Aron 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Cacnea 1",
      "Koffing 1",
      "Staryu 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Pidgeotto 1",
      "Growlithe 1",
      "Farfetch'd 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Nidorina 1",
      "Nidorino 1",
      "Flaaffy 1",
      "Magby 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Butterfree 1",
      "Beedrill 1",
      "Poliwhirl 1",
      "Onix 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "ANNE",
    "trainerClass": "Picnicker",
    "pokemon": [
      "Grimer 1",
      "Krabby 1",
      "Exeggcute 1",
      "Eevee 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Houndour 1",
      "Phanpy 1",
      "Spoink 1",
      "Aron 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Cacnea 1",
      "Koffing 1",
      "Staryu 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Pidgeotto 1",
      "Growlithe 1",
      "Farfetch'd 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Nidorina 1",
      "Nidorino 1",
      "Flaaffy 1",
      "Magby 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Butterfree 1",
      "Beedrill 1",
      "Poliwhirl 1",
      "Onix 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "ALIZE",
    "trainerClass": "Picnicker",
    "pokemon": [
      "Grimer 1",
      "Krabby 1",
      "Exeggcute 1",
      "Eevee 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Houndour 1",
      "Phanpy 1",
      "Spoink 1",
      "Aron 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Cacnea 1",
      "Koffing 1",
      "Staryu 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Pidgeotto 1",
      "Growlithe 1",
      "Farfetch'd 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Nidorina 1",
      "Nidorino 1",
      "Flaaffy 1",
      "Magby 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Butterfree 1",
      "Beedrill 1",
      "Poliwhirl 1",
      "Onix 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "LAUREN",
    "trainerClass": "Picnicker",
    "pokemon": [
      "Grimer 1",
      "Krabby 1",
      "Exeggcute 1",
      "Eevee 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Houndour 1",
      "Phanpy 1",
      "Spoink 1",
      "Aron 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Cacnea 1",
      "Koffing 1",
      "Staryu 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Pidgeotto 1",
      "Growlithe 1",
      "Farfetch'd 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Nidorina 1",
      "Nidorino 1",
      "Flaaffy 1",
      "Magby 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Butterfree 1",
      "Beedrill 1",
      "Poliwhirl 1",
      "Onix 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "KIPP",
    "trainerClass": "Tuber (M)",
    "pokemon": [
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Wooper 1",
      "Lotad 1",
      "Marill 1",
      "Wynaut 1",
      "Surskit 1",
      "Wingull 1",
      "Kirlia 1",
      "Meditite 1",
      "Barboach 1",
      "Spheal 1",
      "Horsea 1",
      "Poliwag 1",
      "Remoraid 1",
      "Shellder 1",
      "Smoochum 1",
      "Carvanha 1",
      "Corphish 1",
      "Abra 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Natu 1",
      "Seel 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1"
    ]
  },
  {
    "name": "JASON",
    "trainerClass": "Tuber (M)",
    "pokemon": [
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Wooper 1",
      "Lotad 1",
      "Marill 1",
      "Wynaut 1",
      "Surskit 1",
      "Wingull 1",
      "Kirlia 1",
      "Meditite 1",
      "Barboach 1",
      "Spheal 1",
      "Horsea 1",
      "Poliwag 1",
      "Remoraid 1",
      "Shellder 1",
      "Smoochum 1",
      "Carvanha 1",
      "Corphish 1",
      "Abra 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Natu 1",
      "Seel 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1"
    ]
  },
  {
    "name": "JOHN",
    "trainerClass": "Tuber (M)",
    "pokemon": [
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Wooper 1",
      "Lotad 1",
      "Marill 1",
      "Wynaut 1",
      "Surskit 1",
      "Wingull 1",
      "Kirlia 1",
      "Meditite 1",
      "Barboach 1",
      "Spheal 1",
      "Horsea 1",
      "Poliwag 1",
      "Remoraid 1",
      "Shellder 1",
      "Smoochum 1",
      "Carvanha 1",
      "Corphish 1",
      "Abra 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Natu 1",
      "Seel 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1"
    ]
  },
  {
    "name": "ANN",
    "trainerClass": "Tuber (F)",
    "pokemon": [
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Wooper 1",
      "Lotad 1",
      "Marill 1",
      "Wynaut 1",
      "Surskit 1",
      "Wingull 1",
      "Kirlia 1",
      "Meditite 1",
      "Barboach 1",
      "Spheal 1",
      "Horsea 1",
      "Poliwag 1",
      "Remoraid 1",
      "Shellder 1",
      "Smoochum 1",
      "Carvanha 1",
      "Corphish 1",
      "Abra 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Natu 1",
      "Seel 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1"
    ]
  },
  {
    "name": "EILEEN",
    "trainerClass": "Tuber (F)",
    "pokemon": [
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Wooper 1",
      "Lotad 1",
      "Marill 1",
      "Wynaut 1",
      "Surskit 1",
      "Wingull 1",
      "Kirlia 1",
      "Meditite 1",
      "Barboach 1",
      "Spheal 1",
      "Horsea 1",
      "Poliwag 1",
      "Remoraid 1",
      "Shellder 1",
      "Smoochum 1",
      "Carvanha 1",
      "Corphish 1",
      "Abra 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Natu 1",
      "Seel 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1"
    ]
  },
  {
    "name": "CARLIE",
    "trainerClass": "Tuber (F)",
    "pokemon": [
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Wooper 1",
      "Lotad 1",
      "Marill 1",
      "Wynaut 1",
      "Surskit 1",
      "Wingull 1",
      "Kirlia 1",
      "Meditite 1",
      "Barboach 1",
      "Spheal 1",
      "Horsea 1",
      "Poliwag 1",
      "Remoraid 1",
      "Shellder 1",
      "Smoochum 1",
      "Carvanha 1",
      "Corphish 1",
      "Abra 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Natu 1",
      "Seel 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1"
    ]
  },
  {
    "name": "GORDON",
    "trainerClass": "Swimmer\u2642",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Smeargle 1",
      "Rattata 1",
      "Skitty 1",
      "Jigglypuff 1",
      "Meditite 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Poliwag 1",
      "Snubbull 1",
      "Remoraid 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Carvanha 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Clefairy 1",
      "Seel 1",
      "Krabby 1",
      "Eevee 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Staryu 1",
      "Lombre 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Corsola 1",
      "Mawile 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "AYDEN",
    "trainerClass": "Swimmer\u2642",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Smeargle 1",
      "Rattata 1",
      "Skitty 1",
      "Jigglypuff 1",
      "Meditite 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Poliwag 1",
      "Snubbull 1",
      "Remoraid 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Carvanha 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Clefairy 1",
      "Seel 1",
      "Krabby 1",
      "Eevee 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Staryu 1",
      "Lombre 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Corsola 1",
      "Mawile 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "MARCO",
    "trainerClass": "Swimmer\u2642",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Smeargle 1",
      "Rattata 1",
      "Skitty 1",
      "Jigglypuff 1",
      "Meditite 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Poliwag 1",
      "Snubbull 1",
      "Remoraid 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Carvanha 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Clefairy 1",
      "Seel 1",
      "Krabby 1",
      "Eevee 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Staryu 1",
      "Lombre 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Corsola 1",
      "Mawile 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "CIERRA",
    "trainerClass": "Swimmer\u2640",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Sentret 1",
      "Cleffa 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Smeargle 1",
      "Rattata 1",
      "Skitty 1",
      "Jigglypuff 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Poliwag 1",
      "Snubbull 1",
      "Remoraid 1",
      "Snorunt 1",
      "Shellder 1",
      "Smoochum 1",
      "Carvanha 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Clefairy 1",
      "Seel 1",
      "Krabby 1",
      "Eevee 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Staryu 1",
      "Lombre 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Corsola 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "MARCY",
    "trainerClass": "Swimmer\u2640",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Sentret 1",
      "Cleffa 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Smeargle 1",
      "Rattata 1",
      "Skitty 1",
      "Jigglypuff 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Poliwag 1",
      "Snubbull 1",
      "Remoraid 1",
      "Snorunt 1",
      "Shellder 1",
      "Smoochum 1",
      "Carvanha 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Clefairy 1",
      "Seel 1",
      "Krabby 1",
      "Eevee 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Staryu 1",
      "Lombre 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Corsola 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "KATHY",
    "trainerClass": "Swimmer\u2640",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Sentret 1",
      "Cleffa 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Smeargle 1",
      "Rattata 1",
      "Skitty 1",
      "Jigglypuff 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Poliwag 1",
      "Snubbull 1",
      "Remoraid 1",
      "Snorunt 1",
      "Shellder 1",
      "Smoochum 1",
      "Carvanha 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Goldeen 1",
      "Clefairy 1",
      "Seel 1",
      "Krabby 1",
      "Eevee 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Staryu 1",
      "Lombre 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Corsola 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "PEYTON",
    "trainerClass": "Pok\u00e9fan (M)",
    "pokemon": [
      "Smoochum 1",
      "Numel 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Seel 1",
      "Exeggcute 1",
      "Eevee 1",
      "Teddiursa 1",
      "Phanpy 1",
      "Spoink 1",
      "Luvdisc 1",
      "Skiploom 1",
      "Clamperl 1",
      "Aipom 1",
      "Elekid 1",
      "Spinda 1",
      "Flaaffy 1",
      "Magby 1",
      "Corsola 1",
      "Mawile 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "JULIAN",
    "trainerClass": "Pok\u00e9fan (M)",
    "pokemon": [
      "Smoochum 1",
      "Numel 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Seel 1",
      "Exeggcute 1",
      "Eevee 1",
      "Teddiursa 1",
      "Phanpy 1",
      "Spoink 1",
      "Luvdisc 1",
      "Skiploom 1",
      "Clamperl 1",
      "Aipom 1",
      "Elekid 1",
      "Spinda 1",
      "Flaaffy 1",
      "Magby 1",
      "Corsola 1",
      "Mawile 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "QUINN",
    "trainerClass": "Pok\u00e9fan (M)",
    "pokemon": [
      "Smoochum 1",
      "Numel 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Seel 1",
      "Exeggcute 1",
      "Eevee 1",
      "Teddiursa 1",
      "Phanpy 1",
      "Spoink 1",
      "Luvdisc 1",
      "Skiploom 1",
      "Clamperl 1",
      "Aipom 1",
      "Elekid 1",
      "Spinda 1",
      "Flaaffy 1",
      "Magby 1",
      "Corsola 1",
      "Mawile 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "HAYLEE",
    "trainerClass": "Pok\u00e9fan (F)",
    "pokemon": [
      "Azurill 1",
      "Ralts 1",
      "Magikarp 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Marill 1",
      "Hoppip 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Ditto 1",
      "Meowth 1",
      "Spheal 1",
      "Shroomish 1",
      "Vulpix 1",
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Dratini 1",
      "Snubbull 1",
      "Gulpin 1"
    ]
  },
  {
    "name": "AMANDA",
    "trainerClass": "Pok\u00e9fan (F)",
    "pokemon": [
      "Azurill 1",
      "Ralts 1",
      "Magikarp 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Marill 1",
      "Hoppip 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Ditto 1",
      "Meowth 1",
      "Spheal 1",
      "Shroomish 1",
      "Vulpix 1",
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Dratini 1",
      "Snubbull 1",
      "Gulpin 1"
    ]
  },
  {
    "name": "STACY",
    "trainerClass": "Pok\u00e9fan (F)",
    "pokemon": [
      "Azurill 1",
      "Ralts 1",
      "Magikarp 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Marill 1",
      "Hoppip 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Ditto 1",
      "Meowth 1",
      "Spheal 1",
      "Shroomish 1",
      "Vulpix 1",
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Dratini 1",
      "Snubbull 1",
      "Gulpin 1"
    ]
  },
  {
    "name": "RAFAEL",
    "trainerClass": "PKMN Breeder (M)",
    "pokemon": [
      "Sunkern 1",
      "Azurill 1",
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Shedinja 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Spinarak 1",
      "Marill 1",
      "Hoppip 1",
      "Slugma 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Slakoth 1",
      "Paras 1",
      "Ekans 1",
      "Ditto 1",
      "Barboach 1",
      "Meowth 1",
      "Pineco 1",
      "Trapinch 1",
      "Spheal 1",
      "Horsea 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Vulpix 1"
    ]
  },
  {
    "name": "OLIVER",
    "trainerClass": "PKMN Breeder (M)",
    "pokemon": [
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Bellsprout 1",
      "Geodude 1",
      "Dratini 1",
      "Snubbull 1",
      "Remoraid 1",
      "Larvitar 1",
      "Baltoy 1",
      "Snorunt 1",
      "Bagon 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Numel 1",
      "Carvanha 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Abra 1",
      "Doduo 1",
      "Gastly 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Cubone 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Seel 1"
    ]
  },
  {
    "name": "PAYTON",
    "trainerClass": "PKMN Breeder (M)",
    "pokemon": [
      "Grimer 1",
      "Krabby 1",
      "Exeggcute 1",
      "Eevee 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Houndour 1",
      "Phanpy 1",
      "Spoink 1",
      "Aron 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Cacnea 1",
      "Koffing 1",
      "Staryu 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Pidgeotto 1",
      "Growlithe 1",
      "Farfetch'd 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Nidorina 1",
      "Nidorino 1",
      "Flaaffy 1",
      "Magby 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Butterfree 1",
      "Beedrill 1",
      "Poliwhirl 1",
      "Onix 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "PAMELA",
    "trainerClass": "PKMN Breeder (F)",
    "pokemon": [
      "Sunkern 1",
      "Azurill 1",
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Shedinja 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Spinarak 1",
      "Marill 1",
      "Hoppip 1",
      "Slugma 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Slakoth 1",
      "Paras 1",
      "Ekans 1",
      "Ditto 1",
      "Barboach 1",
      "Meowth 1",
      "Pineco 1",
      "Trapinch 1",
      "Spheal 1",
      "Horsea 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Vulpix 1"
    ]
  },
  {
    "name": "ELIZA",
    "trainerClass": "PKMN Breeder (F)",
    "pokemon": [
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Bellsprout 1",
      "Geodude 1",
      "Dratini 1",
      "Snubbull 1",
      "Remoraid 1",
      "Larvitar 1",
      "Baltoy 1",
      "Snorunt 1",
      "Bagon 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Numel 1",
      "Carvanha 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Abra 1",
      "Doduo 1",
      "Gastly 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Cubone 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Seel 1"
    ]
  },
  {
    "name": "MARISA",
    "trainerClass": "PKMN Breeder (F)",
    "pokemon": [
      "Grimer 1",
      "Krabby 1",
      "Exeggcute 1",
      "Eevee 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Houndour 1",
      "Phanpy 1",
      "Spoink 1",
      "Aron 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Cacnea 1",
      "Koffing 1",
      "Staryu 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Pidgeotto 1",
      "Growlithe 1",
      "Farfetch'd 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Nidorina 1",
      "Nidorino 1",
      "Flaaffy 1",
      "Magby 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Butterfree 1",
      "Beedrill 1",
      "Poliwhirl 1",
      "Onix 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "LEWIS",
    "trainerClass": "Bug Catcher",
    "pokemon": [
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Metapod 1",
      "Kakuna 1",
      "Shedinja 1",
      "Spinarak 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Paras 1",
      "Pineco 1",
      "Trapinch 1",
      "Venonat 1",
      "Exeggcute 1",
      "Vibrava 1",
      "Anorith 1",
      "Butterfree 1",
      "Beedrill 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "YOSHI",
    "trainerClass": "Bug Catcher",
    "pokemon": [
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Silcoon 1",
      "Cascoon 1",
      "Shedinja 1",
      "Spinarak 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Paras 1",
      "Pineco 1",
      "Trapinch 1",
      "Venonat 1",
      "Exeggcute 1",
      "Vibrava 1",
      "Anorith 1",
      "Butterfree 1",
      "Beedrill 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "DESTIN",
    "trainerClass": "Bug Catcher",
    "pokemon": [
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Shedinja 1",
      "Spinarak 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Paras 1",
      "Pineco 1",
      "Trapinch 1",
      "Venonat 1",
      "Exeggcute 1",
      "Vibrava 1",
      "Anorith 1",
      "Butterfree 1",
      "Beedrill 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "KEON",
    "trainerClass": "Ninja Boy",
    "pokemon": [
      "Ralts 1",
      "Shedinja 1",
      "Zubat 1",
      "Spinarak 1",
      "Wynaut 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Meditite 1",
      "Paras 1",
      "Ekans 1",
      "Pineco 1",
      "Trapinch 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Oddish 1",
      "Natu 1",
      "Grimer 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1",
      "Tentacool 1",
      "Koffing 1",
      "Vibrava 1",
      "Anorith 1",
      "Nidorina 1",
      "Nidorino 1",
      "Butterfree 1",
      "Beedrill 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "STUART",
    "trainerClass": "Ninja Boy",
    "pokemon": [
      "Ralts 1",
      "Shedinja 1",
      "Zubat 1",
      "Spinarak 1",
      "Wynaut 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Meditite 1",
      "Paras 1",
      "Ekans 1",
      "Pineco 1",
      "Trapinch 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Oddish 1",
      "Natu 1",
      "Grimer 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1",
      "Tentacool 1",
      "Koffing 1",
      "Vibrava 1",
      "Anorith 1",
      "Nidorina 1",
      "Nidorino 1",
      "Butterfree 1",
      "Beedrill 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "NESTOR",
    "trainerClass": "Ninja Boy",
    "pokemon": [
      "Ralts 1",
      "Shedinja 1",
      "Zubat 1",
      "Spinarak 1",
      "Wynaut 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Meditite 1",
      "Paras 1",
      "Ekans 1",
      "Pineco 1",
      "Trapinch 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Oddish 1",
      "Natu 1",
      "Grimer 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1",
      "Tentacool 1",
      "Koffing 1",
      "Vibrava 1",
      "Anorith 1",
      "Nidorina 1",
      "Nidorino 1",
      "Butterfree 1",
      "Beedrill 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "DERRICK",
    "trainerClass": "Bug Maniac",
    "pokemon": [
      "Shedinja 1",
      "Spinarak 1",
      "Hoppip 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Paras 1",
      "Pineco 1",
      "Trapinch 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Venonat 1",
      "Gastly 1",
      "Oddish 1",
      "Exeggcute 1",
      "Cacnea 1",
      "Skiploom 1",
      "Vibrava 1",
      "Lileep 1",
      "Anorith 1",
      "Butterfree 1",
      "Beedrill 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "BRYSON",
    "trainerClass": "Bug Maniac",
    "pokemon": [
      "Shedinja 1",
      "Spinarak 1",
      "Hoppip 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Paras 1",
      "Pineco 1",
      "Trapinch 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Venonat 1",
      "Gastly 1",
      "Oddish 1",
      "Exeggcute 1",
      "Cacnea 1",
      "Skiploom 1",
      "Vibrava 1",
      "Lileep 1",
      "Anorith 1",
      "Butterfree 1",
      "Beedrill 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "CLAYTON",
    "trainerClass": "Bug Maniac",
    "pokemon": [
      "Shedinja 1",
      "Spinarak 1",
      "Hoppip 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Paras 1",
      "Pineco 1",
      "Trapinch 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Bellsprout 1",
      "Venonat 1",
      "Gastly 1",
      "Oddish 1",
      "Exeggcute 1",
      "Cacnea 1",
      "Skiploom 1",
      "Vibrava 1",
      "Lileep 1",
      "Anorith 1",
      "Butterfree 1",
      "Beedrill 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "TRENTON",
    "trainerClass": "Fisherman",
    "pokemon": [
      "Magikarp 1",
      "Feebas 1",
      "Barboach 1",
      "Horsea 1",
      "Poliwag 1",
      "Remoraid 1",
      "Shellder 1",
      "Carvanha 1",
      "Corphish 1",
      "Goldeen 1",
      "Krabby 1",
      "Chinchou 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Staryu 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Corsola 1"
    ]
  },
  {
    "name": "JENSON",
    "trainerClass": "Fisherman",
    "pokemon": [
      "Magikarp 1",
      "Feebas 1",
      "Barboach 1",
      "Horsea 1",
      "Poliwag 1",
      "Remoraid 1",
      "Shellder 1",
      "Carvanha 1",
      "Corphish 1",
      "Goldeen 1",
      "Krabby 1",
      "Chinchou 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Staryu 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Corsola 1"
    ]
  },
  {
    "name": "WESLEY",
    "trainerClass": "Fisherman",
    "pokemon": [
      "Magikarp 1",
      "Feebas 1",
      "Barboach 1",
      "Horsea 1",
      "Poliwag 1",
      "Remoraid 1",
      "Shellder 1",
      "Carvanha 1",
      "Corphish 1",
      "Goldeen 1",
      "Krabby 1",
      "Chinchou 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Staryu 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Corsola 1"
    ]
  },
  {
    "name": "ANTON",
    "trainerClass": "Ruin Maniac",
    "pokemon": [
      "Swinub 1",
      "Diglett 1",
      "Trapinch 1",
      "Sandshrew 1",
      "Geodude 1",
      "Larvitar 1",
      "Baltoy 1",
      "Beldum 1",
      "Numel 1",
      "Cubone 1",
      "Magnemite 1",
      "Phanpy 1",
      "Aron 1",
      "Rhyhorn 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Onix 1"
    ]
  },
  {
    "name": "LAWSON",
    "trainerClass": "Ruin Maniac",
    "pokemon": [
      "Swinub 1",
      "Diglett 1",
      "Trapinch 1",
      "Sandshrew 1",
      "Geodude 1",
      "Larvitar 1",
      "Baltoy 1",
      "Beldum 1",
      "Numel 1",
      "Cubone 1",
      "Magnemite 1",
      "Phanpy 1",
      "Aron 1",
      "Rhyhorn 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Onix 1"
    ]
  },
  {
    "name": "SAMMY",
    "trainerClass": "Ruin Maniac",
    "pokemon": [
      "Swinub 1",
      "Diglett 1",
      "Trapinch 1",
      "Sandshrew 1",
      "Geodude 1",
      "Larvitar 1",
      "Baltoy 1",
      "Beldum 1",
      "Numel 1",
      "Cubone 1",
      "Magnemite 1",
      "Phanpy 1",
      "Aron 1",
      "Rhyhorn 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Onix 1"
    ]
  },
  {
    "name": "ARNIE",
    "trainerClass": "Collector",
    "pokemon": [
      "Sunkern 1",
      "Azurill 1",
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Shedinja 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Spinarak 1",
      "Marill 1",
      "Hoppip 1",
      "Slugma 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Slakoth 1",
      "Paras 1",
      "Ekans 1",
      "Ditto 1",
      "Barboach 1",
      "Meowth 1",
      "Pineco 1",
      "Trapinch 1",
      "Spheal 1",
      "Horsea 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Vulpix 1"
    ]
  },
  {
    "name": "ADRIAN",
    "trainerClass": "Collector",
    "pokemon": [
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Bellsprout 1",
      "Geodude 1",
      "Dratini 1",
      "Snubbull 1",
      "Remoraid 1",
      "Larvitar 1",
      "Baltoy 1",
      "Snorunt 1",
      "Bagon 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Numel 1",
      "Carvanha 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Abra 1",
      "Doduo 1",
      "Gastly 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Cubone 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Seel 1"
    ]
  },
  {
    "name": "TRISTAN",
    "trainerClass": "Collector",
    "pokemon": [
      "Grimer 1",
      "Krabby 1",
      "Exeggcute 1",
      "Eevee 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Houndour 1",
      "Phanpy 1",
      "Spoink 1",
      "Aron 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Cacnea 1",
      "Koffing 1",
      "Staryu 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Pidgeotto 1",
      "Growlithe 1",
      "Farfetch'd 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Nidorina 1",
      "Nidorino 1",
      "Flaaffy 1",
      "Magby 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Butterfree 1",
      "Beedrill 1",
      "Poliwhirl 1",
      "Onix 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "JULIANA",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "Sunkern 1",
      "Wooper 1",
      "Lotad 1",
      "Marill 1",
      "Surskit 1",
      "Trapinch 1",
      "Spheal 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Numel 1",
      "Delibird 1",
      "Phanpy 1",
      "Luvdisc 1",
      "Poliwhirl 1",
      "Onix 1",
      "Sudowoodo 1"
    ]
  },
  {
    "name": "RYLEE",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "Sunkern 1",
      "Wooper 1",
      "Lotad 1",
      "Marill 1",
      "Surskit 1",
      "Trapinch 1",
      "Spheal 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Numel 1",
      "Delibird 1",
      "Phanpy 1",
      "Luvdisc 1",
      "Poliwhirl 1",
      "Onix 1",
      "Sudowoodo 1"
    ]
  },
  {
    "name": "CHELSEA",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "Sunkern 1",
      "Wooper 1",
      "Lotad 1",
      "Marill 1",
      "Surskit 1",
      "Trapinch 1",
      "Spheal 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Numel 1",
      "Delibird 1",
      "Phanpy 1",
      "Luvdisc 1",
      "Poliwhirl 1",
      "Onix 1",
      "Sudowoodo 1"
    ]
  },
  {
    "name": "DANELA",
    "trainerClass": "Beauty",
    "pokemon": [
      "Sunkern 1",
      "Azurill 1",
      "Caterpie 1",
      "Weedle 1",
      "Wurmple 1",
      "Ralts 1",
      "Magikarp 1",
      "Feebas 1",
      "Pichu 1",
      "Igglybuff 1",
      "Wooper 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Seedot 1",
      "Lotad 1",
      "Poochyena 1",
      "Shedinja 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Spinarak 1",
      "Marill 1",
      "Hoppip 1",
      "Slugma 1",
      "Swinub 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Wynaut 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Diglett 1",
      "Ledyba 1",
      "Nincada 1",
      "Surskit 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Nidoran\u2642 1",
      "Nidoran\u2640 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Slakoth 1",
      "Paras 1",
      "Ekans 1",
      "Ditto 1",
      "Barboach 1",
      "Meowth 1",
      "Pineco 1",
      "Trapinch 1",
      "Spheal 1",
      "Horsea 1",
      "Shroomish 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Vulpix 1"
    ]
  },
  {
    "name": "LIZBETH",
    "trainerClass": "Beauty",
    "pokemon": [
      "Pikachu 1",
      "Sandshrew 1",
      "Poliwag 1",
      "Bellsprout 1",
      "Geodude 1",
      "Dratini 1",
      "Snubbull 1",
      "Remoraid 1",
      "Larvitar 1",
      "Baltoy 1",
      "Snorunt 1",
      "Bagon 1",
      "Beldum 1",
      "Gulpin 1",
      "Venonat 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Numel 1",
      "Carvanha 1",
      "Corphish 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Abra 1",
      "Doduo 1",
      "Gastly 1",
      "Swablu 1",
      "Treecko 1",
      "Torchic 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Psyduck 1",
      "Cubone 1",
      "Goldeen 1",
      "Natu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Seel 1"
    ]
  },
  {
    "name": "AMELIA",
    "trainerClass": "Beauty",
    "pokemon": [
      "Grimer 1",
      "Krabby 1",
      "Exeggcute 1",
      "Eevee 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Teddiursa 1",
      "Delibird 1",
      "Houndour 1",
      "Phanpy 1",
      "Spoink 1",
      "Aron 1",
      "Luvdisc 1",
      "Tentacool 1",
      "Cacnea 1",
      "Koffing 1",
      "Staryu 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Pidgeotto 1",
      "Growlithe 1",
      "Farfetch'd 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Nidorina 1",
      "Nidorino 1",
      "Flaaffy 1",
      "Magby 1",
      "Nosepass 1",
      "Corsola 1",
      "Mawile 1",
      "Butterfree 1",
      "Beedrill 1",
      "Poliwhirl 1",
      "Onix 1",
      "Beautifly 1",
      "Dustox 1",
      "Ledian 1",
      "Ariados 1",
      "Yanma 1"
    ]
  },
  {
    "name": "JILLIAN",
    "trainerClass": "Aroma Lady",
    "pokemon": [
      "Sunkern 1",
      "Ralts 1",
      "Seedot 1",
      "Lotad 1",
      "Hoppip 1",
      "Wynaut 1",
      "Kirlia 1",
      "Meditite 1",
      "Paras 1",
      "Shroomish 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Smoochum 1",
      "Abra 1",
      "Treecko 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Natu 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1",
      "Cacnea 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Lileep 1"
    ]
  },
  {
    "name": "ABBIE",
    "trainerClass": "Aroma Lady",
    "pokemon": [
      "Sunkern 1",
      "Ralts 1",
      "Seedot 1",
      "Lotad 1",
      "Hoppip 1",
      "Wynaut 1",
      "Kirlia 1",
      "Meditite 1",
      "Paras 1",
      "Shroomish 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Smoochum 1",
      "Abra 1",
      "Treecko 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Natu 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1",
      "Cacnea 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Lileep 1"
    ]
  },
  {
    "name": "BRIANA",
    "trainerClass": "Aroma Lady",
    "pokemon": [
      "Sunkern 1",
      "Ralts 1",
      "Seedot 1",
      "Lotad 1",
      "Hoppip 1",
      "Wynaut 1",
      "Kirlia 1",
      "Meditite 1",
      "Paras 1",
      "Shroomish 1",
      "Bellsprout 1",
      "Baltoy 1",
      "Beldum 1",
      "Smoochum 1",
      "Abra 1",
      "Treecko 1",
      "Slowpoke 1",
      "Bulbasaur 1",
      "Chikorita 1",
      "Oddish 1",
      "Natu 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Spoink 1",
      "Cacnea 1",
      "Skiploom 1",
      "Nuzleaf 1",
      "Lombre 1",
      "Lileep 1"
    ]
  },
  {
    "name": "ANTONIO",
    "trainerClass": "Guitarist",
    "pokemon": [
      "Ralts 1",
      "Pichu 1",
      "Poochyena 1",
      "Wynaut 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Pikachu 1",
      "Dratini 1",
      "Baltoy 1",
      "Bagon 1",
      "Beldum 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Natu 1",
      "Magnemite 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Houndour 1",
      "Spoink 1",
      "Aron 1",
      "Elekid 1",
      "Flaaffy 1",
      "Mawile 1"
    ]
  },
  {
    "name": "JADEN",
    "trainerClass": "Guitarist",
    "pokemon": [
      "Ralts 1",
      "Pichu 1",
      "Poochyena 1",
      "Wynaut 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Pikachu 1",
      "Dratini 1",
      "Baltoy 1",
      "Bagon 1",
      "Beldum 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Natu 1",
      "Magnemite 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Houndour 1",
      "Spoink 1",
      "Aron 1",
      "Elekid 1",
      "Flaaffy 1",
      "Mawile 1"
    ]
  },
  {
    "name": "DAKOTA",
    "trainerClass": "Guitarist",
    "pokemon": [
      "Ralts 1",
      "Pichu 1",
      "Poochyena 1",
      "Wynaut 1",
      "Kirlia 1",
      "Mareep 1",
      "Meditite 1",
      "Shuppet 1",
      "Duskull 1",
      "Electrike 1",
      "Pikachu 1",
      "Dratini 1",
      "Baltoy 1",
      "Bagon 1",
      "Beldum 1",
      "Smoochum 1",
      "Abra 1",
      "Gastly 1",
      "Slowpoke 1",
      "Natu 1",
      "Magnemite 1",
      "Exeggcute 1",
      "Drowzee 1",
      "Voltorb 1",
      "Chinchou 1",
      "Houndour 1",
      "Spoink 1",
      "Aron 1",
      "Elekid 1",
      "Flaaffy 1",
      "Mawile 1"
    ]
  },
  {
    "name": "BRAYDEN",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Sentret 1",
      "Cleffa 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Snubbull 1",
      "Doduo 1",
      "Swablu 1",
      "Torchic 1",
      "Natu 1",
      "Clefairy 1",
      "Eevee 1",
      "Teddiursa 1",
      "Delibird 1",
      "Pidgeotto 1",
      "Farfetch'd 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1"
    ]
  },
  {
    "name": "CORSON",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Sentret 1",
      "Cleffa 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Snubbull 1",
      "Doduo 1",
      "Swablu 1",
      "Torchic 1",
      "Natu 1",
      "Clefairy 1",
      "Eevee 1",
      "Teddiursa 1",
      "Delibird 1",
      "Pidgeotto 1",
      "Farfetch'd 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1"
    ]
  },
  {
    "name": "TREVIN",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Sentret 1",
      "Cleffa 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Zubat 1",
      "Togepi 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Wingull 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Snubbull 1",
      "Doduo 1",
      "Swablu 1",
      "Torchic 1",
      "Natu 1",
      "Clefairy 1",
      "Eevee 1",
      "Teddiursa 1",
      "Delibird 1",
      "Pidgeotto 1",
      "Farfetch'd 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1"
    ]
  },
  {
    "name": "PATRICK",
    "trainerClass": "Sailor",
    "pokemon": [
      "Tyrogue 1",
      "Makuhita 1",
      "Meditite 1",
      "Sandshrew 1",
      "Geodude 1",
      "Dratini 1",
      "Larvitar 1",
      "Bagon 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Carvanha 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Cubone 1",
      "Seel 1",
      "Krabby 1",
      "Phanpy 1",
      "Tentacool 1",
      "Staryu 1",
      "Lombre 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Corsola 1",
      "Poliwhirl 1",
      "Onix 1"
    ]
  },
  {
    "name": "KADEN",
    "trainerClass": "Sailor",
    "pokemon": [
      "Tyrogue 1",
      "Makuhita 1",
      "Meditite 1",
      "Sandshrew 1",
      "Geodude 1",
      "Dratini 1",
      "Larvitar 1",
      "Bagon 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Carvanha 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Cubone 1",
      "Seel 1",
      "Krabby 1",
      "Phanpy 1",
      "Tentacool 1",
      "Staryu 1",
      "Lombre 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Corsola 1",
      "Poliwhirl 1",
      "Onix 1"
    ]
  },
  {
    "name": "MAXWELL",
    "trainerClass": "Sailor",
    "pokemon": [
      "Tyrogue 1",
      "Makuhita 1",
      "Meditite 1",
      "Sandshrew 1",
      "Geodude 1",
      "Dratini 1",
      "Larvitar 1",
      "Bagon 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Carvanha 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Cubone 1",
      "Seel 1",
      "Krabby 1",
      "Phanpy 1",
      "Tentacool 1",
      "Staryu 1",
      "Lombre 1",
      "Rhyhorn 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Corsola 1",
      "Poliwhirl 1",
      "Onix 1"
    ]
  },
  {
    "name": "DARYL",
    "trainerClass": "Hiker",
    "pokemon": [
      "Tyrogue 1",
      "Makuhita 1",
      "Swinub 1",
      "Diglett 1",
      "Meditite 1",
      "Slakoth 1",
      "Trapinch 1",
      "Sandshrew 1",
      "Geodude 1",
      "Larvitar 1",
      "Baltoy 1",
      "Mankey 1",
      "Machop 1",
      "Numel 1",
      "Cubone 1",
      "Phanpy 1",
      "Aron 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Loudred 1",
      "Nosepass 1",
      "Onix 1"
    ]
  },
  {
    "name": "KENNETH",
    "trainerClass": "Hiker",
    "pokemon": [
      "Tyrogue 1",
      "Makuhita 1",
      "Swinub 1",
      "Diglett 1",
      "Meditite 1",
      "Slakoth 1",
      "Trapinch 1",
      "Sandshrew 1",
      "Geodude 1",
      "Larvitar 1",
      "Baltoy 1",
      "Mankey 1",
      "Machop 1",
      "Numel 1",
      "Cubone 1",
      "Phanpy 1",
      "Aron 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Loudred 1",
      "Nosepass 1",
      "Onix 1"
    ]
  },
  {
    "name": "RICH",
    "trainerClass": "Hiker",
    "pokemon": [
      "Tyrogue 1",
      "Makuhita 1",
      "Swinub 1",
      "Diglett 1",
      "Meditite 1",
      "Slakoth 1",
      "Trapinch 1",
      "Sandshrew 1",
      "Geodude 1",
      "Larvitar 1",
      "Baltoy 1",
      "Mankey 1",
      "Machop 1",
      "Numel 1",
      "Cubone 1",
      "Phanpy 1",
      "Aron 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Omanyte 1",
      "Kabuto 1",
      "Lileep 1",
      "Anorith 1",
      "Aipom 1",
      "Loudred 1",
      "Nosepass 1",
      "Onix 1"
    ]
  },
  {
    "name": "CADEN",
    "trainerClass": "Kindler",
    "pokemon": [
      "Slugma 1",
      "Shuppet 1",
      "Duskull 1",
      "Vulpix 1",
      "Geodude 1",
      "Larvitar 1",
      "Bagon 1",
      "Beldum 1",
      "Numel 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Torchic 1",
      "Magnemite 1",
      "Houndour 1",
      "Aron 1",
      "Rhyhorn 1",
      "Growlithe 1",
      "Magby 1",
      "Nosepass 1",
      "Mawile 1",
      "Onix 1"
    ]
  },
  {
    "name": "MARLON",
    "trainerClass": "Kindler",
    "pokemon": [
      "Slugma 1",
      "Shuppet 1",
      "Duskull 1",
      "Vulpix 1",
      "Geodude 1",
      "Larvitar 1",
      "Bagon 1",
      "Beldum 1",
      "Numel 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Torchic 1",
      "Magnemite 1",
      "Houndour 1",
      "Aron 1",
      "Rhyhorn 1",
      "Growlithe 1",
      "Magby 1",
      "Nosepass 1",
      "Mawile 1",
      "Onix 1"
    ]
  },
  {
    "name": "NASH",
    "trainerClass": "Kindler",
    "pokemon": [
      "Slugma 1",
      "Shuppet 1",
      "Duskull 1",
      "Vulpix 1",
      "Geodude 1",
      "Larvitar 1",
      "Bagon 1",
      "Beldum 1",
      "Numel 1",
      "Charmander 1",
      "Cyndaquil 1",
      "Torchic 1",
      "Magnemite 1",
      "Houndour 1",
      "Aron 1",
      "Rhyhorn 1",
      "Growlithe 1",
      "Magby 1",
      "Nosepass 1",
      "Mawile 1",
      "Onix 1"
    ]
  },
  {
    "name": "ROBBY",
    "trainerClass": "Triathlete (M runner)",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Meditite 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Sandshrew 1",
      "Geodude 1",
      "Snubbull 1",
      "Larvitar 1",
      "Baltoy 1",
      "Mankey 1",
      "Machop 1",
      "Numel 1",
      "Doduo 1",
      "Swablu 1",
      "Cubone 1",
      "Clefairy 1",
      "Eevee 1",
      "Teddiursa 1",
      "Phanpy 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Pidgeotto 1",
      "Farfetch'd 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Onix 1"
    ]
  },
  {
    "name": "REECE",
    "trainerClass": "Triathlete (M runner)",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Meditite 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Sandshrew 1",
      "Geodude 1",
      "Snubbull 1",
      "Larvitar 1",
      "Baltoy 1",
      "Mankey 1",
      "Machop 1",
      "Numel 1",
      "Doduo 1",
      "Swablu 1",
      "Cubone 1",
      "Clefairy 1",
      "Eevee 1",
      "Teddiursa 1",
      "Phanpy 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Pidgeotto 1",
      "Farfetch'd 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Onix 1"
    ]
  },
  {
    "name": "KATHRYN",
    "trainerClass": "Triathlete (F runner)",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Meditite 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Sandshrew 1",
      "Geodude 1",
      "Snubbull 1",
      "Larvitar 1",
      "Baltoy 1",
      "Mankey 1",
      "Machop 1",
      "Numel 1",
      "Doduo 1",
      "Swablu 1",
      "Cubone 1",
      "Clefairy 1",
      "Eevee 1",
      "Teddiursa 1",
      "Phanpy 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Pidgeotto 1",
      "Farfetch'd 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Onix 1"
    ]
  },
  {
    "name": "ELLEN",
    "trainerClass": "Triathlete (F runner)",
    "pokemon": [
      "Azurill 1",
      "Igglybuff 1",
      "Tyrogue 1",
      "Sentret 1",
      "Cleffa 1",
      "Makuhita 1",
      "Whismur 1",
      "Zigzagoon 1",
      "Togepi 1",
      "Smeargle 1",
      "Pidgey 1",
      "Rattata 1",
      "Skitty 1",
      "Spearow 1",
      "Hoothoot 1",
      "Jigglypuff 1",
      "Taillow 1",
      "Meditite 1",
      "Slakoth 1",
      "Ditto 1",
      "Meowth 1",
      "Sandshrew 1",
      "Geodude 1",
      "Snubbull 1",
      "Larvitar 1",
      "Baltoy 1",
      "Mankey 1",
      "Machop 1",
      "Numel 1",
      "Doduo 1",
      "Swablu 1",
      "Cubone 1",
      "Clefairy 1",
      "Eevee 1",
      "Teddiursa 1",
      "Phanpy 1",
      "Vibrava 1",
      "Rhyhorn 1",
      "Pidgeotto 1",
      "Farfetch'd 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Onix 1"
    ]
  },
  {
    "name": "RAMON",
    "trainerClass": "Triathlete (M swimmer)",
    "pokemon": [
      "Tyrogue 1",
      "Makuhita 1",
      "Meditite 1",
      "Dratini 1",
      "Snubbull 1",
      "Snorunt 1",
      "Bagon 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Clefairy 1",
      "Seel 1",
      "Krabby 1",
      "Eevee 1",
      "Teddiursa 1",
      "Delibird 1",
      "Lombre 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Corsola 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "ARTHUR",
    "trainerClass": "Triathlete (M swimmer)",
    "pokemon": [
      "Tyrogue 1",
      "Makuhita 1",
      "Meditite 1",
      "Dratini 1",
      "Snubbull 1",
      "Snorunt 1",
      "Bagon 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Clefairy 1",
      "Seel 1",
      "Krabby 1",
      "Eevee 1",
      "Teddiursa 1",
      "Delibird 1",
      "Lombre 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Corsola 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "ALONDRA",
    "trainerClass": "Triathlete (F swimmer)",
    "pokemon": [
      "Tyrogue 1",
      "Makuhita 1",
      "Meditite 1",
      "Dratini 1",
      "Snubbull 1",
      "Snorunt 1",
      "Bagon 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Clefairy 1",
      "Seel 1",
      "Krabby 1",
      "Eevee 1",
      "Teddiursa 1",
      "Delibird 1",
      "Lombre 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Corsola 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "ADRIANA",
    "trainerClass": "Triathlete (F swimmer)",
    "pokemon": [
      "Tyrogue 1",
      "Makuhita 1",
      "Meditite 1",
      "Dratini 1",
      "Snubbull 1",
      "Snorunt 1",
      "Bagon 1",
      "Mankey 1",
      "Machop 1",
      "Shellder 1",
      "Smoochum 1",
      "Corphish 1",
      "Mudkip 1",
      "Squirtle 1",
      "Totodile 1",
      "Slowpoke 1",
      "Psyduck 1",
      "Clefairy 1",
      "Seel 1",
      "Krabby 1",
      "Eevee 1",
      "Teddiursa 1",
      "Delibird 1",
      "Lombre 1",
      "Clamperl 1",
      "Omanyte 1",
      "Kabuto 1",
      "Aipom 1",
      "Loudred 1",
      "Spinda 1",
      "Corsola 1",
      "Poliwhirl 1"
    ]
  },
  {
    "name": "MALIK",
    "trainerClass": "Triathlete (M biker)",
    "pokemon": [
      "Pichu 1",
      "Tyrogue 1",
      "Makuhita 1",
      "Mareep 1",
      "Meditite 1",
      "Electrike 1",
      "Pikachu 1",
      "Dratini 1",
      "Snubbull 1",
      "Bagon 1",
      "Beldum 1",
      "Mankey 1",
      "Machop 1",
      "Doduo 1",
      "Swablu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Eevee 1",
      "Voltorb 1",
      "Teddiursa 1",
      "Aron 1",
      "Pidgeotto 1",
      "Farfetch'd 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Flaaffy 1",
      "Mawile 1"
    ]
  },
  {
    "name": "JILL",
    "trainerClass": "Triathlete (F biker)",
    "pokemon": [
      "Pichu 1",
      "Tyrogue 1",
      "Makuhita 1",
      "Mareep 1",
      "Meditite 1",
      "Electrike 1",
      "Pikachu 1",
      "Dratini 1",
      "Snubbull 1",
      "Bagon 1",
      "Beldum 1",
      "Mankey 1",
      "Machop 1",
      "Doduo 1",
      "Swablu 1",
      "Clefairy 1",
      "Magnemite 1",
      "Eevee 1",
      "Voltorb 1",
      "Teddiursa 1",
      "Aron 1",
      "Pidgeotto 1",
      "Farfetch'd 1",
      "Aipom 1",
      "Elekid 1",
      "Loudred 1",
      "Spinda 1",
      "Flaaffy 1",
      "Mawile 1"
    ]
  },
  {
    "name": "ERIK",
    "trainerClass": "Triathlete (M runner)",
    "pokemon": [
      "Delcatty 1",
      "Lickitung 1",
      "Porygon 1",
      "Machoke 1",
      "Togetic 1",
      "Murkrow 1",
      "Combusken 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Linoone 1",
      "Castform 1",
      "Wigglytuff 1",
      "Gligar 1",
      "Pelipper 1",
      "Swellow 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Noctowl 1",
      "Chansey 1",
      "Golbat 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Ninjask 1",
      "Zangoose 1",
      "Tropius 1",
      "Mantine 1",
      "Stantler 1",
      "Pidgeot 1",
      "Scyther 1"
    ]
  },
  {
    "name": "YAZMIN",
    "trainerClass": "Triathlete (F runner)",
    "pokemon": [
      "Delcatty 1",
      "Lickitung 1",
      "Porygon 1",
      "Machoke 1",
      "Togetic 1",
      "Murkrow 1",
      "Combusken 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Linoone 1",
      "Castform 1",
      "Wigglytuff 1",
      "Gligar 1",
      "Pelipper 1",
      "Swellow 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Noctowl 1",
      "Chansey 1",
      "Golbat 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Ninjask 1",
      "Zangoose 1",
      "Tropius 1",
      "Mantine 1",
      "Stantler 1",
      "Pidgeot 1",
      "Scyther 1"
    ]
  },
  {
    "name": "JAMAL",
    "trainerClass": "Triathlete (M swimmer)",
    "pokemon": [
      "Wailmer 1",
      "Wartortle 1",
      "Machoke 1",
      "Croconaw 1",
      "Combusken 1",
      "Marshtomp 1",
      "Azumarill 1",
      "Sealeo 1",
      "Qwilfish 1",
      "Sneasel 1",
      "Pelipper 1",
      "Seadra 1",
      "Seaking 1",
      "Piloswine 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Hitmontop 1",
      "Sharpedo 1",
      "Mantine 1",
      "Crawdaunt 1",
      "Kingler 1",
      "Octillery 1",
      "Huntail 1",
      "Gorebyss 1",
      "Relicanth 1",
      "Omastar 1",
      "Kabutops 1",
      "Poliwrath 1",
      "Politoed 1",
      "Cloyster 1"
    ]
  },
  {
    "name": "LESLIE",
    "trainerClass": "Triathlete (F swimmer)",
    "pokemon": [
      "Wailmer 1",
      "Wartortle 1",
      "Machoke 1",
      "Croconaw 1",
      "Combusken 1",
      "Marshtomp 1",
      "Azumarill 1",
      "Sealeo 1",
      "Qwilfish 1",
      "Sneasel 1",
      "Pelipper 1",
      "Seadra 1",
      "Seaking 1",
      "Piloswine 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Hitmontop 1",
      "Sharpedo 1",
      "Mantine 1",
      "Crawdaunt 1",
      "Kingler 1",
      "Octillery 1",
      "Huntail 1",
      "Gorebyss 1",
      "Relicanth 1",
      "Omastar 1",
      "Kabutops 1",
      "Poliwrath 1",
      "Politoed 1",
      "Cloyster 1"
    ]
  },
  {
    "name": "DAVE",
    "trainerClass": "Triathlete (M biker)",
    "pokemon": [
      "Delcatty 1",
      "Lickitung 1",
      "Porygon 1",
      "Machoke 1",
      "Togetic 1",
      "Plusle 1",
      "Minun 1",
      "Combusken 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Linoone 1",
      "Castform 1",
      "Metang 1",
      "Wigglytuff 1",
      "Swellow 1",
      "Lairon 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Noctowl 1",
      "Chansey 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Zangoose 1",
      "Magneton 1",
      "Stantler 1",
      "Pidgeot 1"
    ]
  },
  {
    "name": "CARLO",
    "trainerClass": "Triathlete (M biker)",
    "pokemon": [
      "Delcatty 1",
      "Lickitung 1",
      "Porygon 1",
      "Machoke 1",
      "Togetic 1",
      "Plusle 1",
      "Minun 1",
      "Combusken 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Linoone 1",
      "Castform 1",
      "Metang 1",
      "Wigglytuff 1",
      "Swellow 1",
      "Lairon 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Noctowl 1",
      "Chansey 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Zangoose 1",
      "Magneton 1",
      "Stantler 1",
      "Pidgeot 1"
    ]
  },
  {
    "name": "EMILIA",
    "trainerClass": "Triathlete (F biker)",
    "pokemon": [
      "Delcatty 1",
      "Lickitung 1",
      "Porygon 1",
      "Machoke 1",
      "Togetic 1",
      "Plusle 1",
      "Minun 1",
      "Combusken 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Linoone 1",
      "Castform 1",
      "Metang 1",
      "Wigglytuff 1",
      "Swellow 1",
      "Lairon 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Noctowl 1",
      "Chansey 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Zangoose 1",
      "Magneton 1",
      "Stantler 1",
      "Pidgeot 1"
    ]
  },
  {
    "name": "DALIA",
    "trainerClass": "Triathlete (F biker)",
    "pokemon": [
      "Delcatty 1",
      "Lickitung 1",
      "Porygon 1",
      "Machoke 1",
      "Togetic 1",
      "Plusle 1",
      "Minun 1",
      "Combusken 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Linoone 1",
      "Castform 1",
      "Metang 1",
      "Wigglytuff 1",
      "Swellow 1",
      "Lairon 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Noctowl 1",
      "Chansey 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Zangoose 1",
      "Magneton 1",
      "Stantler 1",
      "Pidgeot 1"
    ]
  },
  {
    "name": "HITOMI",
    "trainerClass": "Black Belt",
    "pokemon": [
      "Lickitung 1",
      "Graveler 1",
      "Charmeleon 1",
      "Machoke 1",
      "Quilava 1",
      "Combusken 1",
      "Ponyta 1",
      "Sudowoodo 1",
      "Magcargo 1",
      "Pupitar 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Mightyena 1",
      "Linoone 1",
      "Shelgon 1",
      "Metang 1",
      "Wigglytuff 1",
      "Gligar 1",
      "Lairon 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Lunatone 1",
      "Solrock 1",
      "Sandslash 1",
      "Chansey 1",
      "Piloswine 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Zangoose 1",
      "Camerupt 1",
      "Stantler 1",
      "Absol 1",
      "Torkoal 1",
      "Cacturne 1",
      "Poliwrath 1"
    ]
  },
  {
    "name": "RICARDO",
    "trainerClass": "Black Belt",
    "pokemon": [
      "Lickitung 1",
      "Graveler 1",
      "Charmeleon 1",
      "Machoke 1",
      "Quilava 1",
      "Combusken 1",
      "Ponyta 1",
      "Sudowoodo 1",
      "Magcargo 1",
      "Pupitar 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Mightyena 1",
      "Linoone 1",
      "Shelgon 1",
      "Metang 1",
      "Wigglytuff 1",
      "Gligar 1",
      "Lairon 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Lunatone 1",
      "Solrock 1",
      "Sandslash 1",
      "Chansey 1",
      "Piloswine 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Zangoose 1",
      "Camerupt 1",
      "Stantler 1",
      "Absol 1",
      "Torkoal 1",
      "Cacturne 1",
      "Poliwrath 1"
    ]
  },
  {
    "name": "SHIZUKA",
    "trainerClass": "Black Belt",
    "pokemon": [
      "Lickitung 1",
      "Graveler 1",
      "Charmeleon 1",
      "Machoke 1",
      "Quilava 1",
      "Combusken 1",
      "Ponyta 1",
      "Sudowoodo 1",
      "Magcargo 1",
      "Pupitar 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Mightyena 1",
      "Linoone 1",
      "Shelgon 1",
      "Metang 1",
      "Wigglytuff 1",
      "Gligar 1",
      "Lairon 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Lunatone 1",
      "Solrock 1",
      "Sandslash 1",
      "Chansey 1",
      "Piloswine 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Zangoose 1",
      "Camerupt 1",
      "Stantler 1",
      "Absol 1",
      "Torkoal 1",
      "Cacturne 1",
      "Poliwrath 1"
    ]
  },
  {
    "name": "JOANA",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "Lickitung 1",
      "Graveler 1",
      "Charmeleon 1",
      "Machoke 1",
      "Quilava 1",
      "Combusken 1",
      "Ponyta 1",
      "Sudowoodo 1",
      "Magcargo 1",
      "Pupitar 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Mightyena 1",
      "Linoone 1",
      "Shelgon 1",
      "Metang 1",
      "Wigglytuff 1",
      "Gligar 1",
      "Lairon 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Lunatone 1",
      "Solrock 1",
      "Sandslash 1",
      "Chansey 1",
      "Piloswine 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Zangoose 1",
      "Camerupt 1",
      "Stantler 1",
      "Absol 1",
      "Torkoal 1",
      "Cacturne 1",
      "Poliwrath 1"
    ]
  },
  {
    "name": "KELLY",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "Lickitung 1",
      "Graveler 1",
      "Charmeleon 1",
      "Machoke 1",
      "Quilava 1",
      "Combusken 1",
      "Ponyta 1",
      "Sudowoodo 1",
      "Magcargo 1",
      "Pupitar 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Mightyena 1",
      "Linoone 1",
      "Shelgon 1",
      "Metang 1",
      "Wigglytuff 1",
      "Gligar 1",
      "Lairon 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Lunatone 1",
      "Solrock 1",
      "Sandslash 1",
      "Chansey 1",
      "Piloswine 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Zangoose 1",
      "Camerupt 1",
      "Stantler 1",
      "Absol 1",
      "Torkoal 1",
      "Cacturne 1",
      "Poliwrath 1"
    ]
  },
  {
    "name": "RAYNA",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "Lickitung 1",
      "Graveler 1",
      "Charmeleon 1",
      "Machoke 1",
      "Quilava 1",
      "Combusken 1",
      "Ponyta 1",
      "Sudowoodo 1",
      "Magcargo 1",
      "Pupitar 1",
      "Raticate 1",
      "Furret 1",
      "Dunsparce 1",
      "Mightyena 1",
      "Linoone 1",
      "Shelgon 1",
      "Metang 1",
      "Wigglytuff 1",
      "Gligar 1",
      "Lairon 1",
      "Persian 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Lunatone 1",
      "Solrock 1",
      "Sandslash 1",
      "Chansey 1",
      "Piloswine 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1",
      "Zangoose 1",
      "Camerupt 1",
      "Stantler 1",
      "Absol 1",
      "Torkoal 1",
      "Cacturne 1",
      "Poliwrath 1"
    ]
  },
  {
    "name": "EVAN",
    "trainerClass": "Expert (M)",
    "pokemon": [
      "Delcatty 1",
      "Sableye 1",
      "Lickitung 1",
      "Weepinbell 1",
      "Graveler 1",
      "Gloom 1",
      "Porygon 1",
      "Kadabra 1",
      "Wailmer 1",
      "Roselia 1",
      "Volbeat 1",
      "Illumise 1",
      "Ivysaur 1",
      "Charmeleon 1",
      "Wartortle 1",
      "Parasect 1",
      "Machoke 1",
      "Haunter 1",
      "Bayleef 1",
      "Quilava 1",
      "Croconaw 1",
      "Togetic 1",
      "Murkrow 1",
      "Wobbuffet 1",
      "Plusle 1",
      "Minun 1",
      "Grovyle 1",
      "Combusken 1",
      "Marshtomp 1",
      "Ponyta 1",
      "Azumarill 1",
      "Sudowoodo 1",
      "Magcargo 1",
      "Pupitar 1",
      "Sealeo 1",
      "Raticate 1",
      "Masquerain 1",
      "Furret 1"
    ]
  },
  {
    "name": "JORDAN",
    "trainerClass": "Expert (M)",
    "pokemon": [
      "Dunsparce 1",
      "Dragonair 1",
      "Mightyena 1",
      "Linoone 1",
      "Castform 1",
      "Shelgon 1",
      "Metang 1",
      "Wigglytuff 1",
      "Sunflora 1",
      "Chimecho 1",
      "Gligar 1",
      "Qwilfish 1",
      "Sneasel 1",
      "Pelipper 1",
      "Swellow 1",
      "Lairon 1",
      "Tangela 1",
      "Arbok 1",
      "Persian 1",
      "Seadra 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Lunatone 1",
      "Solrock 1",
      "Noctowl 1",
      "Sandslash 1",
      "Venomoth 1",
      "Chansey 1",
      "Seaking 1",
      "Jumpluff 1",
      "Piloswine 1",
      "Golbat 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1"
    ]
  },
  {
    "name": "JOEL",
    "trainerClass": "Expert (M)",
    "pokemon": [
      "Banette 1",
      "Ninjask 1",
      "Seviper 1",
      "Zangoose 1",
      "Camerupt 1",
      "Sharpedo 1",
      "Tropius 1",
      "Magneton 1",
      "Mantine 1",
      "Stantler 1",
      "Absol 1",
      "Swalot 1",
      "Crawdaunt 1",
      "Pidgeot 1",
      "Grumpig 1",
      "Torkoal 1",
      "Kingler 1",
      "Cacturne 1",
      "Bellossom 1",
      "Octillery 1",
      "Huntail 1",
      "Gorebyss 1",
      "Relicanth 1",
      "Omastar 1",
      "Kabutops 1",
      "Poliwrath 1",
      "Scyther 1",
      "Pinsir 1",
      "Politoed 1",
      "Cloyster 1"
    ]
  },
  {
    "name": "KRISTEN",
    "trainerClass": "Expert (F)",
    "pokemon": [
      "Delcatty 1",
      "Sableye 1",
      "Lickitung 1",
      "Weepinbell 1",
      "Graveler 1",
      "Gloom 1",
      "Porygon 1",
      "Kadabra 1",
      "Wailmer 1",
      "Roselia 1",
      "Volbeat 1",
      "Illumise 1",
      "Ivysaur 1",
      "Charmeleon 1",
      "Wartortle 1",
      "Parasect 1",
      "Machoke 1",
      "Haunter 1",
      "Bayleef 1",
      "Quilava 1",
      "Croconaw 1",
      "Togetic 1",
      "Murkrow 1",
      "Wobbuffet 1",
      "Plusle 1",
      "Minun 1",
      "Grovyle 1",
      "Combusken 1",
      "Marshtomp 1",
      "Ponyta 1",
      "Azumarill 1",
      "Sudowoodo 1",
      "Magcargo 1",
      "Pupitar 1",
      "Sealeo 1",
      "Raticate 1",
      "Masquerain 1",
      "Furret 1"
    ]
  },
  {
    "name": "SELPHY",
    "trainerClass": "Expert (F)",
    "pokemon": [
      "Dunsparce 1",
      "Dragonair 1",
      "Mightyena 1",
      "Linoone 1",
      "Castform 1",
      "Shelgon 1",
      "Metang 1",
      "Wigglytuff 1",
      "Sunflora 1",
      "Chimecho 1",
      "Gligar 1",
      "Qwilfish 1",
      "Sneasel 1",
      "Pelipper 1",
      "Swellow 1",
      "Lairon 1",
      "Tangela 1",
      "Arbok 1",
      "Persian 1",
      "Seadra 1",
      "Kecleon 1",
      "Vigoroth 1",
      "Lunatone 1",
      "Solrock 1",
      "Noctowl 1",
      "Sandslash 1",
      "Venomoth 1",
      "Chansey 1",
      "Seaking 1",
      "Jumpluff 1",
      "Piloswine 1",
      "Golbat 1",
      "Primeape 1",
      "Hitmonlee 1",
      "Hitmonchan 1",
      "Girafarig 1",
      "Hitmontop 1"
    ]
  },
  {
    "name": "CHLOE",
    "trainerClass": "Expert (F)",
    "pokemon": [
      "Banette 1",
      "Ninjask 1",
      "Seviper 1",
      "Zangoose 1",
      "Camerupt 1",
      "Sharpedo 1",
      "Tropius 1",
      "Magneton 1",
      "Mantine 1",
      "Stantler 1",
      "Absol 1",
      "Swalot 1",
      "Crawdaunt 1",
      "Pidgeot 1",
      "Grumpig 1",
      "Torkoal 1",
      "Kingler 1",
      "Cacturne 1",
      "Bellossom 1",
      "Octillery 1",
      "Huntail 1",
      "Gorebyss 1",
      "Relicanth 1",
      "Omastar 1",
      "Kabutops 1",
      "Poliwrath 1",
      "Scyther 1",
      "Pinsir 1",
      "Politoed 1",
      "Cloyster 1"
    ]
  },
  {
    "name": "NORTON",
    "trainerClass": "Psychic (M)",
    "pokemon": [
      "Delcatty 2",
      "Sableye 2",
      "Porygon 2",
      "Kadabra 2",
      "Roselia 2",
      "Haunter 2",
      "Murkrow 2",
      "Wobbuffet 2",
      "Plusle 2",
      "Minun 2",
      "Mightyena 2",
      "Linoone 2",
      "Metang 2",
      "Wigglytuff 2",
      "Chimecho 2",
      "Sneasel 2",
      "Kecleon 2",
      "Lunatone 2",
      "Solrock 2",
      "Noctowl 2",
      "Venomoth 2",
      "Chansey 2",
      "Girafarig 2",
      "Banette 2",
      "Sharpedo 2",
      "Magneton 2",
      "Stantler 2",
      "Absol 2",
      "Crawdaunt 2",
      "Grumpig 2",
      "Cacturne 2",
      "Gorebyss 2",
      "Politoed 2"
    ]
  },
  {
    "name": "LUKAS",
    "trainerClass": "Psychic (M)",
    "pokemon": [
      "Delcatty 2",
      "Sableye 2",
      "Porygon 2",
      "Kadabra 2",
      "Roselia 2",
      "Haunter 2",
      "Murkrow 2",
      "Wobbuffet 2",
      "Plusle 2",
      "Minun 2",
      "Mightyena 2",
      "Linoone 2",
      "Metang 2",
      "Wigglytuff 2",
      "Chimecho 2",
      "Sneasel 2",
      "Kecleon 2",
      "Lunatone 2",
      "Solrock 2",
      "Noctowl 2",
      "Venomoth 2",
      "Chansey 2",
      "Girafarig 2",
      "Banette 2",
      "Sharpedo 2",
      "Magneton 2",
      "Stantler 2",
      "Absol 2",
      "Crawdaunt 2",
      "Grumpig 2",
      "Cacturne 2",
      "Gorebyss 2",
      "Politoed 2"
    ]
  },
  {
    "name": "ZACH",
    "trainerClass": "Psychic (M)",
    "pokemon": [
      "Delcatty 2",
      "Sableye 2",
      "Porygon 2",
      "Kadabra 2",
      "Roselia 2",
      "Haunter 2",
      "Murkrow 2",
      "Wobbuffet 2",
      "Plusle 2",
      "Minun 2",
      "Mightyena 2",
      "Linoone 2",
      "Metang 2",
      "Wigglytuff 2",
      "Chimecho 2",
      "Sneasel 2",
      "Kecleon 2",
      "Lunatone 2",
      "Solrock 2",
      "Noctowl 2",
      "Venomoth 2",
      "Chansey 2",
      "Girafarig 2",
      "Banette 2",
      "Sharpedo 2",
      "Magneton 2",
      "Stantler 2",
      "Absol 2",
      "Crawdaunt 2",
      "Grumpig 2",
      "Cacturne 2",
      "Gorebyss 2",
      "Politoed 2"
    ]
  },
  {
    "name": "KAITLYN",
    "trainerClass": "Psychic (F)",
    "pokemon": [
      "Delcatty 2",
      "Sableye 2",
      "Porygon 2",
      "Kadabra 2",
      "Roselia 2",
      "Haunter 2",
      "Murkrow 2",
      "Wobbuffet 2",
      "Plusle 2",
      "Minun 2",
      "Mightyena 2",
      "Linoone 2",
      "Metang 2",
      "Wigglytuff 2",
      "Chimecho 2",
      "Sneasel 2",
      "Kecleon 2",
      "Lunatone 2",
      "Solrock 2",
      "Noctowl 2",
      "Venomoth 2",
      "Chansey 2",
      "Girafarig 2",
      "Banette 2",
      "Sharpedo 2",
      "Magneton 2",
      "Stantler 2",
      "Absol 2",
      "Crawdaunt 2",
      "Grumpig 2",
      "Cacturne 2",
      "Gorebyss 2",
      "Politoed 2"
    ]
  },
  {
    "name": "BREANNA",
    "trainerClass": "Psychic (F)",
    "pokemon": [
      "Delcatty 2",
      "Sableye 2",
      "Porygon 2",
      "Kadabra 2",
      "Roselia 2",
      "Haunter 2",
      "Murkrow 2",
      "Wobbuffet 2",
      "Plusle 2",
      "Minun 2",
      "Mightyena 2",
      "Linoone 2",
      "Metang 2",
      "Wigglytuff 2",
      "Chimecho 2",
      "Sneasel 2",
      "Kecleon 2",
      "Lunatone 2",
      "Solrock 2",
      "Noctowl 2",
      "Venomoth 2",
      "Chansey 2",
      "Girafarig 2",
      "Banette 2",
      "Sharpedo 2",
      "Magneton 2",
      "Stantler 2",
      "Absol 2",
      "Crawdaunt 2",
      "Grumpig 2",
      "Cacturne 2",
      "Gorebyss 2",
      "Politoed 2"
    ]
  },
  {
    "name": "KENDRA",
    "trainerClass": "Psychic (F)",
    "pokemon": [
      "Delcatty 2",
      "Sableye 2",
      "Porygon 2",
      "Kadabra 2",
      "Roselia 2",
      "Haunter 2",
      "Murkrow 2",
      "Wobbuffet 2",
      "Plusle 2",
      "Minun 2",
      "Mightyena 2",
      "Linoone 2",
      "Metang 2",
      "Wigglytuff 2",
      "Chimecho 2",
      "Sneasel 2",
      "Kecleon 2",
      "Lunatone 2",
      "Solrock 2",
      "Noctowl 2",
      "Venomoth 2",
      "Chansey 2",
      "Girafarig 2",
      "Banette 2",
      "Sharpedo 2",
      "Magneton 2",
      "Stantler 2",
      "Absol 2",
      "Crawdaunt 2",
      "Grumpig 2",
      "Cacturne 2",
      "Gorebyss 2",
      "Politoed 2"
    ]
  },
  {
    "name": "MOLLY",
    "trainerClass": "Hex Maniac",
    "pokemon": [
      "Sableye 2",
      "Weepinbell 2",
      "Gloom 2",
      "Kadabra 2",
      "Parasect 2",
      "Haunter 2",
      "Murkrow 2",
      "Wobbuffet 2",
      "Masquerain 2",
      "Mightyena 2",
      "Metang 2",
      "Chimecho 2",
      "Sneasel 2",
      "Arbok 2",
      "Lunatone 2",
      "Solrock 2",
      "Venomoth 2",
      "Golbat 2",
      "Girafarig 2",
      "Banette 2",
      "Seviper 2",
      "Sharpedo 2",
      "Absol 2",
      "Swalot 2",
      "Crawdaunt 2",
      "Grumpig 2",
      "Cacturne 2"
    ]
  },
  {
    "name": "JAZMIN",
    "trainerClass": "Hex Maniac",
    "pokemon": [
      "Sableye 2",
      "Weepinbell 2",
      "Gloom 2",
      "Kadabra 2",
      "Parasect 2",
      "Haunter 2",
      "Murkrow 2",
      "Wobbuffet 2",
      "Masquerain 2",
      "Mightyena 2",
      "Metang 2",
      "Chimecho 2",
      "Sneasel 2",
      "Arbok 2",
      "Lunatone 2",
      "Solrock 2",
      "Venomoth 2",
      "Golbat 2",
      "Girafarig 2",
      "Banette 2",
      "Seviper 2",
      "Sharpedo 2",
      "Absol 2",
      "Swalot 2",
      "Crawdaunt 2",
      "Grumpig 2",
      "Cacturne 2"
    ]
  },
  {
    "name": "KELSEY",
    "trainerClass": "Hex Maniac",
    "pokemon": [
      "Sableye 2",
      "Weepinbell 2",
      "Gloom 2",
      "Kadabra 2",
      "Parasect 2",
      "Haunter 2",
      "Murkrow 2",
      "Wobbuffet 2",
      "Masquerain 2",
      "Mightyena 2",
      "Metang 2",
      "Chimecho 2",
      "Sneasel 2",
      "Arbok 2",
      "Lunatone 2",
      "Solrock 2",
      "Venomoth 2",
      "Golbat 2",
      "Girafarig 2",
      "Banette 2",
      "Seviper 2",
      "Sharpedo 2",
      "Absol 2",
      "Swalot 2",
      "Crawdaunt 2",
      "Grumpig 2",
      "Cacturne 2"
    ]
  },
  {
    "name": "JALEN",
    "trainerClass": "Pok\u00e9maniac",
    "pokemon": [
      "Lickitung 2",
      "Graveler 2",
      "Wailmer 2",
      "Ivysaur 2",
      "Charmeleon 2",
      "Wartortle 2",
      "Machoke 2",
      "Bayleef 2",
      "Quilava 2",
      "Croconaw 2",
      "Grovyle 2",
      "Combusken 2",
      "Marshtomp 2",
      "Pupitar 2",
      "Raticate 2",
      "Mightyena 2",
      "Shelgon 2",
      "Metang 2",
      "Lairon 2",
      "Arbok 2",
      "Vigoroth 2",
      "Sandslash 2",
      "Chansey 2",
      "Piloswine 2",
      "Seviper 2",
      "Zangoose 2",
      "Camerupt 2",
      "Tropius 2",
      "Mantine 2",
      "Swalot 2",
      "Torkoal 2"
    ]
  },
  {
    "name": "GRIFFEN",
    "trainerClass": "Pok\u00e9maniac",
    "pokemon": [
      "Lickitung 2",
      "Graveler 2",
      "Wailmer 2",
      "Ivysaur 2",
      "Charmeleon 2",
      "Wartortle 2",
      "Machoke 2",
      "Bayleef 2",
      "Quilava 2",
      "Croconaw 2",
      "Grovyle 2",
      "Combusken 2",
      "Marshtomp 2",
      "Pupitar 2",
      "Raticate 2",
      "Mightyena 2",
      "Shelgon 2",
      "Metang 2",
      "Lairon 2",
      "Arbok 2",
      "Vigoroth 2",
      "Sandslash 2",
      "Chansey 2",
      "Piloswine 2",
      "Seviper 2",
      "Zangoose 2",
      "Camerupt 2",
      "Tropius 2",
      "Mantine 2",
      "Swalot 2",
      "Torkoal 2"
    ]
  },
  {
    "name": "XANDER",
    "trainerClass": "Pok\u00e9maniac",
    "pokemon": [
      "Lickitung 2",
      "Graveler 2",
      "Wailmer 2",
      "Ivysaur 2",
      "Charmeleon 2",
      "Wartortle 2",
      "Machoke 2",
      "Bayleef 2",
      "Quilava 2",
      "Croconaw 2",
      "Grovyle 2",
      "Combusken 2",
      "Marshtomp 2",
      "Pupitar 2",
      "Raticate 2",
      "Mightyena 2",
      "Shelgon 2",
      "Metang 2",
      "Lairon 2",
      "Arbok 2",
      "Vigoroth 2",
      "Sandslash 2",
      "Chansey 2",
      "Piloswine 2",
      "Seviper 2",
      "Zangoose 2",
      "Camerupt 2",
      "Tropius 2",
      "Mantine 2",
      "Swalot 2",
      "Torkoal 2"
    ]
  },
  {
    "name": "MARVIN",
    "trainerClass": "Gentleman",
    "pokemon": [
      "Delcatty 2",
      "Sableye 2",
      "Lickitung 2",
      "Weepinbell 2",
      "Graveler 2",
      "Gloom 2",
      "Porygon 2",
      "Kadabra 2",
      "Wailmer 2",
      "Roselia 2",
      "Volbeat 2",
      "Illumise 2",
      "Ivysaur 2",
      "Charmeleon 2",
      "Wartortle 2",
      "Parasect 2",
      "Machoke 2",
      "Haunter 2",
      "Bayleef 2",
      "Quilava 2",
      "Croconaw 2",
      "Togetic 2",
      "Murkrow 2",
      "Wobbuffet 2",
      "Plusle 2",
      "Minun 2",
      "Grovyle 2",
      "Combusken 2",
      "Marshtomp 2",
      "Ponyta 2",
      "Azumarill 2",
      "Sudowoodo 2",
      "Magcargo 2",
      "Pupitar 2",
      "Sealeo 2",
      "Raticate 2",
      "Masquerain 2",
      "Furret 2"
    ]
  },
  {
    "name": "BRENNAN",
    "trainerClass": "Gentleman",
    "pokemon": [
      "Dunsparce 2",
      "Dragonair 2",
      "Mightyena 2",
      "Linoone 2",
      "Castform 2",
      "Shelgon 2",
      "Metang 2",
      "Wigglytuff 2",
      "Sunflora 2",
      "Chimecho 2",
      "Gligar 2",
      "Qwilfish 2",
      "Sneasel 2",
      "Pelipper 2",
      "Swellow 2",
      "Lairon 2",
      "Tangela 2",
      "Arbok 2",
      "Persian 2",
      "Seadra 2",
      "Kecleon 2",
      "Vigoroth 2",
      "Lunatone 2",
      "Solrock 2",
      "Noctowl 2",
      "Sandslash 2",
      "Venomoth 2",
      "Chansey 2",
      "Seaking 2",
      "Jumpluff 2",
      "Piloswine 2",
      "Golbat 2",
      "Primeape 2",
      "Hitmonlee 2",
      "Hitmonchan 2",
      "Girafarig 2",
      "Hitmontop 2"
    ]
  },
  {
    "name": "BALEY",
    "trainerClass": "Bug Maniac",
    "pokemon": [
      "Ledian 1",
      "Ariados 1",
      "Yanma 1",
      "Volbeat 1",
      "Illumise 1",
      "Parasect 1",
      "Masquerain 1",
      "Venomoth 1",
      "Ninjask 1",
      "Scyther 1",
      "Pinsir 1",
      "Volbeat 2",
      "Illumise 2",
      "Parasect 2",
      "Masquerain 2",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2"
    ]
  },
  {
    "name": "ZACKARY",
    "trainerClass": "Ruin Maniac",
    "pokemon": [
      "Graveler 2",
      "Machoke 2",
      "Combusken 2",
      "Marshtomp 2",
      "Sudowoodo 2",
      "Magcargo 2",
      "Pupitar 2",
      "Metang 2",
      "Gligar 2",
      "Lairon 2",
      "Lunatone 2",
      "Solrock 2",
      "Sandslash 2",
      "Piloswine 2",
      "Primeape 2",
      "Hitmonlee 2",
      "Hitmonchan 2",
      "Hitmontop 2",
      "Camerupt 2",
      "Relicanth 2",
      "Omastar 2",
      "Kabutops 2"
    ]
  },
  {
    "name": "GABRIEL",
    "trainerClass": "Collector",
    "pokemon": [
      "Banette 2",
      "Ninjask 2",
      "Seviper 2",
      "Zangoose 2",
      "Camerupt 2",
      "Sharpedo 2",
      "Tropius 2",
      "Magneton 2",
      "Mantine 2",
      "Stantler 2",
      "Absol 2",
      "Swalot 2",
      "Crawdaunt 2",
      "Pidgeot 2",
      "Grumpig 2",
      "Torkoal 2",
      "Kingler 2",
      "Cacturne 2",
      "Bellossom 2",
      "Octillery 2",
      "Huntail 2",
      "Gorebyss 2",
      "Relicanth 2",
      "Omastar 2",
      "Kabutops 2",
      "Poliwrath 2",
      "Scyther 2",
      "Pinsir 2",
      "Politoed 2",
      "Cloyster 2"
    ]
  },
  {
    "name": "EMILY",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "Gloom 2",
      "Sealeo 2",
      "Castform 2",
      "Sandslash 2",
      "Tropius 2",
      "Magneton 2",
      "Mantine 2",
      "Cacturne 2",
      "Bellossom 2",
      "Huntail 2",
      "Gorebyss 2",
      "Omastar 2"
    ]
  },
  {
    "name": "JORDYN",
    "trainerClass": "Beauty",
    "pokemon": [
      "Delcatty 2",
      "Lickitung 2",
      "Weepinbell 2",
      "Gloom 2",
      "Porygon 2",
      "Roselia 2",
      "Ivysaur 2",
      "Haunter 2",
      "Togetic 2",
      "Raticate 2",
      "Furret 2",
      "Dunsparce 2",
      "Linoone 2",
      "Castform 2",
      "Wigglytuff 2",
      "Qwilfish 2",
      "Swellow 2",
      "Arbok 2",
      "Persian 2",
      "Kecleon 2",
      "Vigoroth 2",
      "Noctowl 2",
      "Venomoth 2",
      "Chansey 2",
      "Golbat 2",
      "Girafarig 2",
      "Seviper 2",
      "Zangoose 2",
      "Stantler 2",
      "Swalot 2",
      "Pidgeot 2"
    ]
  },
  {
    "name": "SOFIA",
    "trainerClass": "Aroma Lady",
    "pokemon": [
      "Weepinbell 2",
      "Gloom 2",
      "Kadabra 2",
      "Roselia 2",
      "Ivysaur 2",
      "Parasect 2",
      "Bayleef 2",
      "Wobbuffet 2",
      "Grovyle 2",
      "Sunflora 2",
      "Chimecho 2",
      "Tangela 2",
      "Jumpluff 2",
      "Girafarig 2",
      "Tropius 2",
      "Grumpig 2",
      "Cacturne 2",
      "Bellossom 2"
    ]
  },
  {
    "name": "BRADEN",
    "trainerClass": "Cooltrainer (M)",
    "pokemon": [
      "Dugtrio 1",
      "Medicham 1",
      "Misdreavus 1",
      "Fearow 1",
      "Granbull 1",
      "Jynx 1",
      "Dusclops 1",
      "Dodrio 1",
      "Mrmime 1",
      "Lanturn 1",
      "Breloom 1",
      "Forretress 1",
      "Whiscash 1",
      "Xatu 1",
      "Skarmory 1",
      "Marowak 1",
      "Quagsire 1",
      "Clefable 1",
      "Hariyama 1",
      "Raichu 1",
      "Dewgong 1",
      "Manectric 1",
      "Vileplume 1",
      "Victreebel 1",
      "Electrode 1",
      "Exploud 1",
      "Shiftry 1",
      "Glalie 1",
      "Ludicolo 1",
      "Hypno 1",
      "Golem 1",
      "Rhydon 1",
      "Alakazam 1"
    ]
  },
  {
    "name": "KAYDEN",
    "trainerClass": "Cooltrainer (M)",
    "pokemon": [
      "Weezing 1",
      "Kangaskhan 1",
      "Electabuzz 1",
      "Tauros 1",
      "Slowbro 1",
      "Slowking 1",
      "Miltank 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Magmar 1",
      "Cradily 1",
      "Armaldo 1",
      "Golduck 1",
      "Rapidash 1",
      "Muk 1",
      "Gengar 1",
      "Ampharos 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Houndoom 1",
      "Donphan 1",
      "Claydol 1",
      "Wailord 1",
      "Ninetales 1",
      "Machamp 1",
      "Shuckle 1",
      "Steelix 1",
      "Tentacruel 1",
      "Aerodactyl 1",
      "Porygon2 1",
      "Gardevoir 1"
    ]
  },
  {
    "name": "COOPER",
    "trainerClass": "Cooltrainer (M)",
    "pokemon": [
      "Exeggutor 1",
      "Starmie 1",
      "Flygon 1",
      "Venusaur 1",
      "Vaporeon 1",
      "Jolteon 1",
      "Flareon 1",
      "Meganium 1",
      "Espeon 1",
      "Umbreon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Aggron 1",
      "Blaziken 1",
      "Walrein 1",
      "Sceptile 1",
      "Charizard 1",
      "Typhlosion 1",
      "Lapras 1",
      "Crobat 1",
      "Swampert 1",
      "Gyarados 1",
      "Snorlax 1",
      "Kingdra 1",
      "Blissey 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1",
      "Metagross 1",
      "Slaking 1"
    ]
  },
  {
    "name": "JULIA",
    "trainerClass": "Cooltrainer (F)",
    "pokemon": [
      "Dugtrio 1",
      "Medicham 1",
      "Misdreavus 1",
      "Fearow 1",
      "Granbull 1",
      "Jynx 1",
      "Dusclops 1",
      "Dodrio 1",
      "Mrmime 1",
      "Lanturn 1",
      "Breloom 1",
      "Forretress 1",
      "Whiscash 1",
      "Xatu 1",
      "Skarmory 1",
      "Marowak 1",
      "Quagsire 1",
      "Clefable 1",
      "Hariyama 1",
      "Raichu 1",
      "Dewgong 1",
      "Manectric 1",
      "Vileplume 1",
      "Victreebel 1",
      "Electrode 1",
      "Exploud 1",
      "Shiftry 1",
      "Glalie 1",
      "Ludicolo 1",
      "Hypno 1",
      "Golem 1",
      "Rhydon 1",
      "Alakazam 1"
    ]
  },
  {
    "name": "AMARA",
    "trainerClass": "Cooltrainer (F)",
    "pokemon": [
      "Weezing 1",
      "Kangaskhan 1",
      "Electabuzz 1",
      "Tauros 1",
      "Slowbro 1",
      "Slowking 1",
      "Miltank 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Magmar 1",
      "Cradily 1",
      "Armaldo 1",
      "Golduck 1",
      "Rapidash 1",
      "Muk 1",
      "Gengar 1",
      "Ampharos 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Houndoom 1",
      "Donphan 1",
      "Claydol 1",
      "Wailord 1",
      "Ninetales 1",
      "Machamp 1",
      "Shuckle 1",
      "Steelix 1",
      "Tentacruel 1",
      "Aerodactyl 1",
      "Porygon2 1",
      "Gardevoir 1"
    ]
  },
  {
    "name": "LYNN",
    "trainerClass": "Cooltrainer (F)",
    "pokemon": [
      "Exeggutor 1",
      "Starmie 1",
      "Flygon 1",
      "Venusaur 1",
      "Vaporeon 1",
      "Jolteon 1",
      "Flareon 1",
      "Meganium 1",
      "Espeon 1",
      "Umbreon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Aggron 1",
      "Blaziken 1",
      "Walrein 1",
      "Sceptile 1",
      "Charizard 1",
      "Typhlosion 1",
      "Lapras 1",
      "Crobat 1",
      "Swampert 1",
      "Gyarados 1",
      "Snorlax 1",
      "Kingdra 1",
      "Blissey 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1",
      "Metagross 1",
      "Slaking 1"
    ]
  },
  {
    "name": "JOVAN",
    "trainerClass": "PKMN Ranger (M)",
    "pokemon": [
      "Ninjask 1",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Fearow 1",
      "Granbull 1",
      "Dodrio 1",
      "Breloom 1",
      "Forretress 1",
      "Clefable 1",
      "Vileplume 1",
      "Victreebel 1",
      "Exploud 1",
      "Shiftry 1",
      "Ludicolo 1",
      "Kangaskhan 1",
      "Tauros 1",
      "Miltank 1",
      "Cradily 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Shuckle 1",
      "Porygon2 1",
      "Exeggutor 1",
      "Venusaur 1",
      "Meganium 1",
      "Sceptile 1",
      "Snorlax 1",
      "Blissey 1",
      "Slaking 1"
    ]
  },
  {
    "name": "DOMINIC",
    "trainerClass": "PKMN Ranger (M)",
    "pokemon": [
      "Ninjask 1",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Fearow 1",
      "Granbull 1",
      "Dodrio 1",
      "Breloom 1",
      "Forretress 1",
      "Clefable 1",
      "Vileplume 1",
      "Victreebel 1",
      "Exploud 1",
      "Shiftry 1",
      "Ludicolo 1",
      "Kangaskhan 1",
      "Tauros 1",
      "Miltank 1",
      "Cradily 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Shuckle 1",
      "Porygon2 1",
      "Exeggutor 1",
      "Venusaur 1",
      "Meganium 1",
      "Sceptile 1",
      "Snorlax 1",
      "Blissey 1",
      "Slaking 1"
    ]
  },
  {
    "name": "NIKOLAS",
    "trainerClass": "PKMN Ranger (M)",
    "pokemon": [
      "Ninjask 1",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Fearow 1",
      "Granbull 1",
      "Dodrio 1",
      "Breloom 1",
      "Forretress 1",
      "Clefable 1",
      "Vileplume 1",
      "Victreebel 1",
      "Exploud 1",
      "Shiftry 1",
      "Ludicolo 1",
      "Kangaskhan 1",
      "Tauros 1",
      "Miltank 1",
      "Cradily 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Shuckle 1",
      "Porygon2 1",
      "Exeggutor 1",
      "Venusaur 1",
      "Meganium 1",
      "Sceptile 1",
      "Snorlax 1",
      "Blissey 1",
      "Slaking 1"
    ]
  },
  {
    "name": "VALERIA",
    "trainerClass": "PKMN Ranger (F)",
    "pokemon": [
      "Ninjask 1",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Fearow 1",
      "Granbull 1",
      "Dodrio 1",
      "Breloom 1",
      "Forretress 1",
      "Clefable 1",
      "Vileplume 1",
      "Victreebel 1",
      "Exploud 1",
      "Shiftry 1",
      "Ludicolo 1",
      "Kangaskhan 1",
      "Tauros 1",
      "Miltank 1",
      "Cradily 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Shuckle 1",
      "Porygon2 1",
      "Exeggutor 1",
      "Venusaur 1",
      "Meganium 1",
      "Sceptile 1",
      "Snorlax 1",
      "Blissey 1",
      "Slaking 1"
    ]
  },
  {
    "name": "DELANEY",
    "trainerClass": "PKMN Ranger (F)",
    "pokemon": [
      "Ninjask 1",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Fearow 1",
      "Granbull 1",
      "Dodrio 1",
      "Breloom 1",
      "Forretress 1",
      "Clefable 1",
      "Vileplume 1",
      "Victreebel 1",
      "Exploud 1",
      "Shiftry 1",
      "Ludicolo 1",
      "Kangaskhan 1",
      "Tauros 1",
      "Miltank 1",
      "Cradily 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Shuckle 1",
      "Porygon2 1",
      "Exeggutor 1",
      "Venusaur 1",
      "Meganium 1",
      "Sceptile 1",
      "Snorlax 1",
      "Blissey 1",
      "Slaking 1"
    ]
  },
  {
    "name": "MEGHAN",
    "trainerClass": "PKMN Ranger (F)",
    "pokemon": [
      "Ninjask 1",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Fearow 1",
      "Granbull 1",
      "Dodrio 1",
      "Breloom 1",
      "Forretress 1",
      "Clefable 1",
      "Vileplume 1",
      "Victreebel 1",
      "Exploud 1",
      "Shiftry 1",
      "Ludicolo 1",
      "Kangaskhan 1",
      "Tauros 1",
      "Miltank 1",
      "Cradily 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Shuckle 1",
      "Porygon2 1",
      "Exeggutor 1",
      "Venusaur 1",
      "Meganium 1",
      "Sceptile 1",
      "Snorlax 1",
      "Blissey 1",
      "Slaking 1"
    ]
  },
  {
    "name": "ROBERTO",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "Skarmory 1",
      "Rhydon 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Aggron 1",
      "Sceptile 1",
      "Charizard 1",
      "Lapras 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1"
    ]
  },
  {
    "name": "DAMIAN",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "Skarmory 1",
      "Rhydon 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Aggron 1",
      "Sceptile 1",
      "Charizard 1",
      "Lapras 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1"
    ]
  },
  {
    "name": "BRODY",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "Skarmory 1",
      "Rhydon 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Aggron 1",
      "Sceptile 1",
      "Charizard 1",
      "Lapras 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1"
    ]
  },
  {
    "name": "GRAHAM",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "Skarmory 1",
      "Rhydon 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Aggron 1",
      "Sceptile 1",
      "Charizard 1",
      "Lapras 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1"
    ]
  },
  {
    "name": "TYLOR",
    "trainerClass": "Pok\u00e9fan (M)",
    "pokemon": [
      "Misdreavus 1",
      "Lanturn 1",
      "Breloom 1",
      "Xatu 1",
      "Quagsire 1",
      "Clefable 1",
      "Raichu 1",
      "Dewgong 1",
      "Vileplume 1",
      "Slowbro 1",
      "Miltank 1",
      "Altaria 1",
      "Rapidash 1",
      "Ninetales 1",
      "Shuckle 1",
      "Porygon2 1",
      "Flygon 1",
      "Lapras 1",
      "Snorlax 1",
      "Blissey 1",
      "Milotic 1",
      "Slaking 1"
    ]
  },
  {
    "name": "JAREN",
    "trainerClass": "Pok\u00e9fan (F)",
    "pokemon": [
      "Misdreavus 1",
      "Lanturn 1",
      "Breloom 1",
      "Xatu 1",
      "Quagsire 1",
      "Clefable 1",
      "Raichu 1",
      "Dewgong 1",
      "Vileplume 1",
      "Slowbro 1",
      "Miltank 1",
      "Altaria 1",
      "Rapidash 1",
      "Ninetales 1",
      "Shuckle 1",
      "Porygon2 1",
      "Flygon 1",
      "Lapras 1",
      "Snorlax 1",
      "Blissey 1",
      "Milotic 1",
      "Slaking 1"
    ]
  },
  {
    "name": "CORDELL",
    "trainerClass": "PKMN Breeder (M)",
    "pokemon": [
      "Muk 1",
      "Gengar 1",
      "Ampharos 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Houndoom 1",
      "Donphan 1",
      "Claydol 1",
      "Wailord 1",
      "Ninetales 1",
      "Machamp 1",
      "Shuckle 1",
      "Steelix 1",
      "Tentacruel 1",
      "Aerodactyl 1",
      "Porygon2 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Flygon 1",
      "Venusaur 1",
      "Vaporeon 1",
      "Jolteon 1",
      "Flareon 1",
      "Meganium 1",
      "Espeon 1",
      "Umbreon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Aggron 1",
      "Blaziken 1",
      "Walrein 1",
      "Sceptile 1",
      "Charizard 1",
      "Typhlosion 1",
      "Lapras 1",
      "Crobat 1",
      "Swampert 1",
      "Gyarados 1",
      "Snorlax 1",
      "Kingdra 1",
      "Blissey 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1",
      "Metagross 1",
      "Slaking 1"
    ]
  },
  {
    "name": "JAZLYN",
    "trainerClass": "PKMN Breeder (F)",
    "pokemon": [
      "Dugtrio 1",
      "Medicham 1",
      "Misdreavus 1",
      "Fearow 1",
      "Granbull 1",
      "Jynx 1",
      "Dusclops 1",
      "Dodrio 1",
      "Mrmime 1",
      "Lanturn 1",
      "Breloom 1",
      "Forretress 1",
      "Whiscash 1",
      "Xatu 1",
      "Skarmory 1",
      "Marowak 1",
      "Quagsire 1",
      "Clefable 1",
      "Hariyama 1",
      "Raichu 1",
      "Dewgong 1",
      "Manectric 1",
      "Vileplume 1",
      "Victreebel 1",
      "Electrode 1",
      "Exploud 1",
      "Shiftry 1",
      "Glalie 1",
      "Ludicolo 1",
      "Hypno 1",
      "Golem 1",
      "Rhydon 1",
      "Alakazam 1",
      "Weezing 1",
      "Kangaskhan 1",
      "Electabuzz 1",
      "Tauros 1",
      "Slowbro 1",
      "Slowking 1",
      "Miltank 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Magmar 1",
      "Cradily 1",
      "Armaldo 1",
      "Golduck 1",
      "Rapidash 1"
    ]
  },
  {
    "name": "ZACHERY",
    "trainerClass": "Youngster",
    "pokemon": [
      "Dugtrio 2",
      "Medicham 2",
      "Marowak 2",
      "Quagsire 2",
      "Misdreavus 2",
      "Fearow 2",
      "Granbull 2",
      "Jynx 2",
      "Dusclops 2",
      "Dodrio 2",
      "Mrmime 2",
      "Lanturn 2",
      "Breloom 2",
      "Forretress 2",
      "Skarmory 2",
      "Whiscash 2",
      "Xatu 2",
      "Clefable 2",
      "Hariyama 2",
      "Raichu 2",
      "Dewgong 2",
      "Manectric 2",
      "Vileplume 2",
      "Victreebel 2",
      "Electrode 2",
      "Exploud 2",
      "Shiftry 2",
      "Glalie 2",
      "Ludicolo 2",
      "Hypno 2",
      "Golem 2",
      "Rhydon 2",
      "Alakazam 2"
    ]
  },
  {
    "name": "JOHAN",
    "trainerClass": "Youngster",
    "pokemon": [
      "Medicham 2",
      "Marowak 2",
      "Quagsire 2",
      "Misdreavus 2",
      "Fearow 2",
      "Granbull 2",
      "Jynx 2",
      "Dusclops 2",
      "Dodrio 2",
      "Mrmime 2",
      "Lanturn 2",
      "Breloom 2",
      "Forretress 2",
      "Skarmory 2",
      "Whiscash 2",
      "Xatu 2",
      "Clefable 2",
      "Hariyama 2",
      "Raichu 2",
      "Dewgong 2",
      "Manectric 2",
      "Vileplume 2",
      "Victreebel 2",
      "Electrode 2",
      "Exploud 2",
      "Shiftry 2",
      "Glalie 2",
      "Ludicolo 2",
      "Hypno 2",
      "Golem 2",
      "Rhydon 2",
      "Alakazam 2"
    ]
  },
  {
    "name": "SHEA",
    "trainerClass": "Lass",
    "pokemon": [
      "Dugtrio 2",
      "Medicham 2",
      "Marowak 2",
      "Quagsire 2",
      "Misdreavus 2",
      "Fearow 2",
      "Granbull 2",
      "Jynx 2",
      "Dusclops 2",
      "Dodrio 2",
      "Mrmime 2",
      "Lanturn 2",
      "Breloom 2",
      "Forretress 2",
      "Skarmory 2",
      "Whiscash 2",
      "Xatu 2",
      "Clefable 2",
      "Hariyama 2",
      "Raichu 2",
      "Dewgong 2",
      "Manectric 2",
      "Vileplume 2",
      "Victreebel 2",
      "Electrode 2",
      "Exploud 2",
      "Shiftry 2",
      "Glalie 2",
      "Ludicolo 2",
      "Hypno 2",
      "Golem 2",
      "Rhydon 2",
      "Alakazam 2"
    ]
  },
  {
    "name": "KAILA",
    "trainerClass": "Lass",
    "pokemon": [
      "Dugtrio 2",
      "Medicham 2",
      "Marowak 2",
      "Quagsire 2",
      "Misdreavus 2",
      "Fearow 2",
      "Granbull 2",
      "Jynx 2",
      "Dusclops 2",
      "Dodrio 2",
      "Mrmime 2",
      "Lanturn 2",
      "Breloom 2",
      "Forretress 2",
      "Skarmory 2",
      "Whiscash 2",
      "Xatu 2",
      "Clefable 2",
      "Hariyama 2",
      "Raichu 2",
      "Dewgong 2",
      "Manectric 2",
      "Vileplume 2",
      "Victreebel 2",
      "Electrode 2",
      "Exploud 2",
      "Shiftry 2",
      "Glalie 2",
      "Ludicolo 2",
      "Hypno 2",
      "Golem 2",
      "Rhydon 2",
      "Alakazam 2"
    ]
  },
  {
    "name": "ISIAH",
    "trainerClass": "School Kid (M)",
    "pokemon": [
      "Weezing 2",
      "Kangaskhan 2",
      "Electabuzz 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Magmar 2",
      "Cradily 2",
      "Armaldo 2",
      "Golduck 2",
      "Rapidash 2",
      "Muk 2",
      "Gengar 2",
      "Ampharos 2",
      "Scizor 2",
      "Heracross 2",
      "Ursaring 2",
      "Houndoom 2",
      "Donphan 2",
      "Claydol 2",
      "Wailord 2",
      "Ninetales 2",
      "Machamp 2",
      "Shuckle 2",
      "Steelix 2",
      "Tentacruel 2",
      "Aerodactyl 2",
      "Porygon2 2",
      "Gardevoir 2"
    ]
  },
  {
    "name": "GARRETT",
    "trainerClass": "School Kid (M)",
    "pokemon": [
      "Weezing 2",
      "Kangaskhan 2",
      "Electabuzz 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Magmar 2",
      "Cradily 2",
      "Armaldo 2",
      "Golduck 2",
      "Rapidash 2",
      "Muk 2",
      "Gengar 2",
      "Ampharos 2",
      "Scizor 2",
      "Heracross 2",
      "Ursaring 2",
      "Houndoom 2",
      "Donphan 2",
      "Claydol 2",
      "Wailord 2",
      "Ninetales 2",
      "Machamp 2",
      "Shuckle 2",
      "Steelix 2",
      "Tentacruel 2",
      "Aerodactyl 2",
      "Porygon2 2",
      "Gardevoir 2"
    ]
  },
  {
    "name": "HAYLIE",
    "trainerClass": "School Kid (F)",
    "pokemon": [
      "Weezing 2",
      "Kangaskhan 2",
      "Electabuzz 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Magmar 2",
      "Cradily 2",
      "Armaldo 2",
      "Golduck 2",
      "Rapidash 2",
      "Muk 2",
      "Gengar 2",
      "Ampharos 2",
      "Scizor 2",
      "Heracross 2",
      "Ursaring 2",
      "Houndoom 2",
      "Donphan 2",
      "Claydol 2",
      "Wailord 2",
      "Ninetales 2",
      "Machamp 2",
      "Shuckle 2",
      "Steelix 2",
      "Tentacruel 2",
      "Aerodactyl 2",
      "Porygon2 2",
      "Gardevoir 2"
    ]
  },
  {
    "name": "MEGAN",
    "trainerClass": "School Kid (F)",
    "pokemon": [
      "Weezing 2",
      "Kangaskhan 2",
      "Electabuzz 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Magmar 2",
      "Cradily 2",
      "Armaldo 2",
      "Golduck 2",
      "Rapidash 2",
      "Muk 2",
      "Gengar 2",
      "Ampharos 2",
      "Scizor 2",
      "Heracross 2",
      "Ursaring 2",
      "Houndoom 2",
      "Donphan 2",
      "Claydol 2",
      "Wailord 2",
      "Ninetales 2",
      "Machamp 2",
      "Shuckle 2",
      "Steelix 2",
      "Tentacruel 2",
      "Aerodactyl 2",
      "Porygon2 2",
      "Gardevoir 2"
    ]
  },
  {
    "name": "ISSAC",
    "trainerClass": "Rich Boy",
    "pokemon": [
      "Exeggutor 2",
      "Starmie 2",
      "Flygon 2",
      "Venusaur 2",
      "Vaporeon 2",
      "Jolteon 2",
      "Flareon 2",
      "Meganium 2",
      "Espeon 2",
      "Umbreon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Aggron 2",
      "Blaziken 2",
      "Walrein 2",
      "Sceptile 2",
      "Charizard 2",
      "Typhlosion 2",
      "Lapras 2",
      "Crobat 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Arcanine 2",
      "Salamence 2",
      "Metagross 2",
      "Slaking 2"
    ]
  },
  {
    "name": "QUINTON",
    "trainerClass": "Rich Boy",
    "pokemon": [
      "Exeggutor 2",
      "Starmie 2",
      "Flygon 2",
      "Venusaur 2",
      "Vaporeon 2",
      "Jolteon 2",
      "Flareon 2",
      "Meganium 2",
      "Espeon 2",
      "Umbreon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Aggron 2",
      "Blaziken 2",
      "Walrein 2",
      "Sceptile 2",
      "Charizard 2",
      "Typhlosion 2",
      "Lapras 2",
      "Crobat 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Arcanine 2",
      "Salamence 2",
      "Metagross 2",
      "Slaking 2"
    ]
  },
  {
    "name": "SALMA",
    "trainerClass": "Lady",
    "pokemon": [
      "Exeggutor 2",
      "Starmie 2",
      "Flygon 2",
      "Venusaur 2",
      "Vaporeon 2",
      "Jolteon 2",
      "Flareon 2",
      "Meganium 2",
      "Espeon 2",
      "Umbreon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Aggron 2",
      "Blaziken 2",
      "Walrein 2",
      "Sceptile 2",
      "Charizard 2",
      "Typhlosion 2",
      "Lapras 2",
      "Crobat 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Arcanine 2",
      "Salamence 2",
      "Metagross 2",
      "Slaking 2"
    ]
  },
  {
    "name": "ANSLEY",
    "trainerClass": "Lady",
    "pokemon": [
      "Exeggutor 2",
      "Starmie 2",
      "Flygon 2",
      "Venusaur 2",
      "Vaporeon 2",
      "Jolteon 2",
      "Flareon 2",
      "Meganium 2",
      "Espeon 2",
      "Umbreon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Aggron 2",
      "Blaziken 2",
      "Walrein 2",
      "Sceptile 2",
      "Charizard 2",
      "Typhlosion 2",
      "Lapras 2",
      "Crobat 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Arcanine 2",
      "Salamence 2",
      "Metagross 2",
      "Slaking 2"
    ]
  },
  {
    "name": "HOLDEN",
    "trainerClass": "Bug Catcher",
    "pokemon": [
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Forretress 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Shuckle 1",
      "Breloom 2",
      "Forretress 2",
      "Vileplume 2",
      "Victreebel 2",
      "Shiftry 2",
      "Ludicolo 2",
      "Cradily 2",
      "Armaldo 2",
      "Scizor 2",
      "Heracross 2",
      "Shuckle 2",
      "Exeggutor 2",
      "Venusaur 2",
      "Meganium 2",
      "Sceptile 2"
    ]
  },
  {
    "name": "LUCA",
    "trainerClass": "Bug Catcher",
    "pokemon": [
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Forretress 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Shuckle 1",
      "Breloom 2",
      "Forretress 2",
      "Vileplume 2",
      "Victreebel 2",
      "Shiftry 2",
      "Ludicolo 2",
      "Cradily 2",
      "Armaldo 2",
      "Scizor 2",
      "Heracross 2",
      "Shuckle 2",
      "Exeggutor 2",
      "Venusaur 2",
      "Meganium 2",
      "Sceptile 2"
    ]
  },
  {
    "name": "JAMISON",
    "trainerClass": "Ninja Boy",
    "pokemon": [
      "Parasect 2",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Medicham 2",
      "Misdreavus 2",
      "Jynx 2",
      "Dusclops 2",
      "Mrmime 2",
      "Forretress 2",
      "Xatu 2",
      "Vileplume 2",
      "Victreebel 2",
      "Hypno 2",
      "Alakazam 2",
      "Weezing 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Armaldo 2",
      "Muk 2",
      "Gengar 2",
      "Scizor 2",
      "Heracross 2",
      "Claydol 2",
      "Shuckle 2",
      "Tentacruel 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Venusaur 2",
      "Espeon 2",
      "Crobat 2"
    ]
  },
  {
    "name": "GUNNAR",
    "trainerClass": "Ninja Boy",
    "pokemon": [
      "Parasect 2",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Medicham 2",
      "Misdreavus 2",
      "Jynx 2",
      "Dusclops 2",
      "Mrmime 2",
      "Forretress 2",
      "Xatu 2",
      "Vileplume 2",
      "Victreebel 2",
      "Hypno 2",
      "Alakazam 2",
      "Weezing 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Armaldo 2",
      "Muk 2",
      "Gengar 2",
      "Scizor 2",
      "Heracross 2",
      "Claydol 2",
      "Shuckle 2",
      "Tentacruel 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Venusaur 2",
      "Espeon 2",
      "Crobat 2"
    ]
  },
  {
    "name": "CRAIG",
    "trainerClass": "Tuber (M)",
    "pokemon": [
      "Quagsire 2",
      "Granbull 2",
      "Jynx 2",
      "Lanturn 2",
      "Whiscash 2",
      "Clefable 2",
      "Dewgong 2",
      "Exploud 2",
      "Glalie 2",
      "Ludicolo 2",
      "Kangaskhan 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Golduck 2",
      "Ursaring 2",
      "Wailord 2",
      "Tentacruel 2",
      "Porygon2 2",
      "Starmie 2",
      "Vaporeon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Walrein 2",
      "Lapras 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Slaking 2"
    ]
  },
  {
    "name": "PIERCE",
    "trainerClass": "Tuber (M)",
    "pokemon": [
      "Quagsire 2",
      "Granbull 2",
      "Jynx 2",
      "Lanturn 2",
      "Whiscash 2",
      "Clefable 2",
      "Dewgong 2",
      "Exploud 2",
      "Glalie 2",
      "Ludicolo 2",
      "Kangaskhan 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Golduck 2",
      "Ursaring 2",
      "Wailord 2",
      "Tentacruel 2",
      "Porygon2 2",
      "Starmie 2",
      "Vaporeon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Walrein 2",
      "Lapras 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Slaking 2"
    ]
  },
  {
    "name": "REGINA",
    "trainerClass": "Tuber (F)",
    "pokemon": [
      "Quagsire 2",
      "Granbull 2",
      "Jynx 2",
      "Lanturn 2",
      "Whiscash 2",
      "Clefable 2",
      "Dewgong 2",
      "Exploud 2",
      "Glalie 2",
      "Ludicolo 2",
      "Kangaskhan 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Golduck 2",
      "Ursaring 2",
      "Wailord 2",
      "Tentacruel 2",
      "Porygon2 2",
      "Starmie 2",
      "Vaporeon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Walrein 2",
      "Lapras 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Slaking 2"
    ]
  },
  {
    "name": "ALISON",
    "trainerClass": "Tuber (F)",
    "pokemon": [
      "Quagsire 2",
      "Granbull 2",
      "Jynx 2",
      "Lanturn 2",
      "Whiscash 2",
      "Clefable 2",
      "Dewgong 2",
      "Exploud 2",
      "Glalie 2",
      "Ludicolo 2",
      "Kangaskhan 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Golduck 2",
      "Ursaring 2",
      "Wailord 2",
      "Tentacruel 2",
      "Porygon2 2",
      "Starmie 2",
      "Vaporeon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Walrein 2",
      "Lapras 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Slaking 2"
    ]
  },
  {
    "name": "HANK",
    "trainerClass": "Bug Maniac",
    "pokemon": [
      "Volbeat 2",
      "Illumise 2",
      "Parasect 2",
      "Masquerain 2",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Forretress 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Shuckle 1",
      "Forretress 2",
      "Armaldo 2",
      "Scizor 2",
      "Heracross 2",
      "Shuckle 2",
      "Forretress 3",
      "Armaldo 3",
      "Scizor 3",
      "Heracross 3",
      "Shuckle 3"
    ]
  },
  {
    "name": "EARL",
    "trainerClass": "Bug Maniac",
    "pokemon": [
      "Volbeat 2",
      "Illumise 2",
      "Parasect 2",
      "Masquerain 2",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Forretress 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Shuckle 1",
      "Forretress 2",
      "Armaldo 2",
      "Scizor 2",
      "Heracross 2",
      "Shuckle 2",
      "Forretress 3",
      "Armaldo 3",
      "Scizor 3",
      "Heracross 3",
      "Shuckle 3"
    ]
  },
  {
    "name": "RAMIRO",
    "trainerClass": "Fisherman",
    "pokemon": [
      "Qwilfish 2",
      "Seaking 2",
      "Sharpedo 2",
      "Mantine 2",
      "Crawdaunt 2",
      "Kingler 2",
      "Octillery 2",
      "Huntail 2",
      "Gorebyss 2",
      "Relicanth 2",
      "Lanturn 3",
      "Whiscash 3",
      "Wailord 3",
      "Tentacruel 3",
      "Starmie 3"
    ]
  },
  {
    "name": "HUNTER",
    "trainerClass": "Fisherman",
    "pokemon": [
      "Qwilfish 2",
      "Seaking 2",
      "Sharpedo 2",
      "Mantine 2",
      "Crawdaunt 2",
      "Kingler 2",
      "Octillery 2",
      "Huntail 2",
      "Gorebyss 2",
      "Relicanth 2",
      "Lanturn 3",
      "Whiscash 3",
      "Wailord 3",
      "Tentacruel 3",
      "Starmie 3"
    ]
  },
  {
    "name": "AIDEN",
    "trainerClass": "Ruin Maniac",
    "pokemon": [
      "Dugtrio 3",
      "Forretress 3",
      "Whiscash 3",
      "Skarmory 3",
      "Marowak 3",
      "Quagsire 3",
      "Golem 3",
      "Rhydon 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Cradily 3",
      "Armaldo 3",
      "Scizor 3",
      "Donphan 3",
      "Claydol 3",
      "Shuckle 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Flygon 3",
      "Aggron 3",
      "Swampert 3",
      "Metagross 3"
    ]
  },
  {
    "name": "XAVIER",
    "trainerClass": "Ruin Maniac",
    "pokemon": [
      "Dugtrio 3",
      "Forretress 3",
      "Whiscash 3",
      "Skarmory 3",
      "Marowak 3",
      "Quagsire 3",
      "Golem 3",
      "Rhydon 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Cradily 3",
      "Armaldo 3",
      "Scizor 3",
      "Donphan 3",
      "Claydol 3",
      "Shuckle 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Flygon 3",
      "Aggron 3",
      "Swampert 3",
      "Metagross 3"
    ]
  },
  {
    "name": "CLINTON",
    "trainerClass": "Collector",
    "pokemon": [
      "Dugtrio 3",
      "Medicham 3",
      "Misdreavus 3",
      "Fearow 3",
      "Granbull 3",
      "Jynx 3",
      "Dusclops 3",
      "Dodrio 3",
      "Mrmime 3",
      "Lanturn 3",
      "Breloom 3",
      "Forretress 3",
      "Whiscash 3",
      "Xatu 3",
      "Skarmory 3",
      "Marowak 3",
      "Quagsire 3",
      "Clefable 3",
      "Hariyama 3",
      "Raichu 3",
      "Dewgong 3",
      "Manectric 3",
      "Vileplume 3",
      "Victreebel 3",
      "Electrode 3",
      "Exploud 3",
      "Shiftry 3",
      "Glalie 3",
      "Ludicolo 3",
      "Hypno 3",
      "Golem 3",
      "Rhydon 3",
      "Alakazam 3",
      "Weezing 3",
      "Kangaskhan 3",
      "Electabuzz 3",
      "Tauros 3",
      "Slowbro 3",
      "Slowking 3",
      "Miltank 3",
      "Altaria 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Magmar 3",
      "Cradily 3",
      "Armaldo 3",
      "Golduck 3",
      "Rapidash 3"
    ]
  },
  {
    "name": "JESSE",
    "trainerClass": "Collector",
    "pokemon": [
      "Dugtrio 3",
      "Medicham 3",
      "Misdreavus 3",
      "Fearow 3",
      "Granbull 3",
      "Jynx 3",
      "Dusclops 3",
      "Dodrio 3",
      "Mrmime 3",
      "Lanturn 3",
      "Breloom 3",
      "Forretress 3",
      "Whiscash 3",
      "Xatu 3",
      "Skarmory 3",
      "Marowak 3",
      "Quagsire 3",
      "Clefable 3",
      "Hariyama 3",
      "Raichu 3",
      "Dewgong 3",
      "Manectric 3",
      "Vileplume 3",
      "Victreebel 3",
      "Electrode 3",
      "Exploud 3",
      "Shiftry 3",
      "Glalie 3",
      "Ludicolo 3",
      "Hypno 3",
      "Golem 3",
      "Rhydon 3",
      "Alakazam 3",
      "Weezing 3",
      "Kangaskhan 3",
      "Electabuzz 3",
      "Tauros 3",
      "Slowbro 3",
      "Slowking 3",
      "Miltank 3",
      "Altaria 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Magmar 3",
      "Cradily 3",
      "Armaldo 3",
      "Golduck 3",
      "Rapidash 3"
    ]
  },
  {
    "name": "EDUARDO",
    "trainerClass": "Guitarist",
    "pokemon": [
      "Sableye 2",
      "Mightyena 2",
      "Sneasel 2",
      "Magneton 2",
      "Absol 2",
      "Lanturn 3",
      "Raichu 3",
      "Manectric 3",
      "Electrode 3",
      "Shiftry 3",
      "Electabuzz 3",
      "Ampharos 3",
      "Houndoom 3",
      "Jolteon 3",
      "Umbreon 3"
    ]
  },
  {
    "name": "HAL",
    "trainerClass": "Guitarist",
    "pokemon": [
      "Sableye 2",
      "Mightyena 2",
      "Sneasel 2",
      "Magneton 2",
      "Absol 2",
      "Lanturn 3",
      "Raichu 3",
      "Manectric 3",
      "Electrode 3",
      "Shiftry 3",
      "Electabuzz 3",
      "Ampharos 3",
      "Houndoom 3",
      "Jolteon 3",
      "Umbreon 3"
    ]
  },
  {
    "name": "GAGE",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "Murkrow 2",
      "Pelipper 2",
      "Swellow 2",
      "Noctowl 2",
      "Pidgeot 2",
      "Fearow 1",
      "Dodrio 1",
      "Xatu 1",
      "Skarmory 1",
      "Crobat 1",
      "Fearow 2",
      "Dodrio 2",
      "Skarmory 2",
      "Xatu 2",
      "Crobat 2",
      "Fearow 3",
      "Dodrio 3",
      "Xatu 3",
      "Skarmory 3",
      "Crobat 3"
    ]
  },
  {
    "name": "ARNOLD",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "Murkrow 2",
      "Pelipper 2",
      "Swellow 2",
      "Noctowl 2",
      "Pidgeot 2",
      "Fearow 1",
      "Dodrio 1",
      "Xatu 1",
      "Skarmory 1",
      "Crobat 1",
      "Fearow 2",
      "Dodrio 2",
      "Skarmory 2",
      "Xatu 2",
      "Crobat 2",
      "Fearow 3",
      "Dodrio 3",
      "Xatu 3",
      "Skarmory 3",
      "Crobat 3"
    ]
  },
  {
    "name": "JARRETT",
    "trainerClass": "Sailor",
    "pokemon": [
      "Medicham 3",
      "Lanturn 3",
      "Whiscash 3",
      "Quagsire 3",
      "Hariyama 3",
      "Dewgong 3",
      "Ludicolo 3",
      "Slowbro 3",
      "Slowking 3",
      "Golduck 3",
      "Wailord 3",
      "Machamp 3",
      "Tentacruel 3",
      "Starmie 3",
      "Vaporeon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Walrein 3",
      "Lapras 3",
      "Swampert 3",
      "Gyarados 3",
      "Kingdra 3",
      "Milotic 3"
    ]
  },
  {
    "name": "GARETT",
    "trainerClass": "Sailor",
    "pokemon": [
      "Medicham 3",
      "Lanturn 3",
      "Whiscash 3",
      "Quagsire 3",
      "Hariyama 3",
      "Dewgong 3",
      "Ludicolo 3",
      "Slowbro 3",
      "Slowking 3",
      "Golduck 3",
      "Wailord 3",
      "Machamp 3",
      "Tentacruel 3",
      "Starmie 3",
      "Vaporeon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Walrein 3",
      "Lapras 3",
      "Swampert 3",
      "Gyarados 3",
      "Kingdra 3",
      "Milotic 3"
    ]
  },
  {
    "name": "EMANUEL",
    "trainerClass": "Hiker",
    "pokemon": [
      "Dugtrio 3",
      "Medicham 3",
      "Breloom 3",
      "Marowak 3",
      "Hariyama 3",
      "Golem 3",
      "Rhydon 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Cradily 3",
      "Armaldo 3",
      "Heracross 3",
      "Donphan 3",
      "Claydol 3",
      "Machamp 3",
      "Shuckle 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Aggron 3",
      "Blaziken 3"
    ]
  },
  {
    "name": "GUSTAVO",
    "trainerClass": "Hiker",
    "pokemon": [
      "Dugtrio 3",
      "Medicham 3",
      "Breloom 3",
      "Marowak 3",
      "Hariyama 3",
      "Golem 3",
      "Rhydon 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Cradily 3",
      "Armaldo 3",
      "Heracross 3",
      "Donphan 3",
      "Claydol 3",
      "Machamp 3",
      "Shuckle 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Aggron 3",
      "Blaziken 3"
    ]
  },
  {
    "name": "KAMERON",
    "trainerClass": "Kindler",
    "pokemon": [
      "Granbull 3",
      "Clefable 3",
      "Exploud 3",
      "Kangaskhan 3",
      "Tauros 3",
      "Miltank 3",
      "Magmar 3",
      "Rapidash 3",
      "Ursaring 3",
      "Houndoom 3",
      "Ninetales 3",
      "Flareon 3",
      "Blaziken 3",
      "Charizard 3",
      "Typhlosion 3",
      "Snorlax 3",
      "Blissey 3",
      "Arcanine 3",
      "Slaking 3"
    ]
  },
  {
    "name": "ALFREDO",
    "trainerClass": "Kindler",
    "pokemon": [
      "Granbull 3",
      "Clefable 3",
      "Exploud 3",
      "Kangaskhan 3",
      "Tauros 3",
      "Miltank 3",
      "Magmar 3",
      "Rapidash 3",
      "Ursaring 3",
      "Houndoom 3",
      "Ninetales 3",
      "Flareon 3",
      "Blaziken 3",
      "Charizard 3",
      "Typhlosion 3",
      "Snorlax 3",
      "Blissey 3",
      "Arcanine 3",
      "Slaking 3"
    ]
  },
  {
    "name": "RUBEN",
    "trainerClass": "Gentleman",
    "pokemon": [
      "Muk 3",
      "Gengar 3",
      "Ampharos 3",
      "Scizor 3",
      "Heracross 3",
      "Ursaring 3",
      "Houndoom 3",
      "Donphan 3",
      "Claydol 3",
      "Wailord 3",
      "Ninetales 3",
      "Machamp 3",
      "Shuckle 3",
      "Steelix 3",
      "Tentacruel 3",
      "Aerodactyl 3",
      "Porygon2 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Flygon 3",
      "Venusaur 3",
      "Vaporeon 3",
      "Jolteon 3",
      "Flareon 3",
      "Meganium 3",
      "Espeon 3",
      "Umbreon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Aggron 3",
      "Blaziken 3",
      "Walrein 3",
      "Sceptile 3",
      "Charizard 3",
      "Typhlosion 3",
      "Lapras 3",
      "Crobat 3",
      "Swampert 3",
      "Gyarados 3",
      "Snorlax 3",
      "Kingdra 3",
      "Blissey 3",
      "Milotic 3",
      "Arcanine 3",
      "Salamence 3",
      "Metagross 3",
      "Slaking 3"
    ]
  },
  {
    "name": "LAMAR",
    "trainerClass": "Gentleman",
    "pokemon": [
      "Muk 3",
      "Gengar 3",
      "Ampharos 3",
      "Scizor 3",
      "Heracross 3",
      "Ursaring 3",
      "Houndoom 3",
      "Donphan 3",
      "Claydol 3",
      "Wailord 3",
      "Ninetales 3",
      "Machamp 3",
      "Shuckle 3",
      "Steelix 3",
      "Tentacruel 3",
      "Aerodactyl 3",
      "Porygon2 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Flygon 3",
      "Venusaur 3",
      "Vaporeon 3",
      "Jolteon 3",
      "Flareon 3",
      "Meganium 3",
      "Espeon 3",
      "Umbreon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Aggron 3",
      "Blaziken 3",
      "Walrein 3",
      "Sceptile 3",
      "Charizard 3",
      "Typhlosion 3",
      "Lapras 3",
      "Crobat 3",
      "Swampert 3",
      "Gyarados 3",
      "Snorlax 3",
      "Kingdra 3",
      "Blissey 3",
      "Milotic 3",
      "Arcanine 3",
      "Salamence 3",
      "Metagross 3",
      "Slaking 3"
    ]
  },
  {
    "name": "JAXON",
    "trainerClass": "Youngster",
    "pokemon": [
      "Dugtrio 4",
      "Medicham 4",
      "Misdreavus 4",
      "Fearow 4",
      "Granbull 4",
      "Jynx 4",
      "Dusclops 4",
      "Dodrio 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Forretress 4",
      "Whiscash 4",
      "Xatu 4",
      "Skarmory 4",
      "Marowak 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Raichu 4",
      "Dewgong 4",
      "Manectric 4",
      "Vileplume 4",
      "Victreebel 4",
      "Electrode 4",
      "Exploud 4",
      "Shiftry 4",
      "Glalie 4",
      "Ludicolo 4",
      "Hypno 4",
      "Golem 4",
      "Rhydon 4",
      "Alakazam 4"
    ]
  },
  {
    "name": "LOGAN",
    "trainerClass": "Youngster",
    "pokemon": [
      "Dugtrio 4",
      "Medicham 4",
      "Misdreavus 4",
      "Fearow 4",
      "Granbull 4",
      "Jynx 4",
      "Dusclops 4",
      "Dodrio 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Forretress 4",
      "Whiscash 4",
      "Xatu 4",
      "Skarmory 4",
      "Marowak 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Raichu 4",
      "Dewgong 4",
      "Manectric 4",
      "Vileplume 4",
      "Victreebel 4",
      "Electrode 4",
      "Exploud 4",
      "Shiftry 4",
      "Glalie 4",
      "Ludicolo 4",
      "Hypno 4",
      "Golem 4",
      "Rhydon 4",
      "Alakazam 4"
    ]
  },
  {
    "name": "EMILEE",
    "trainerClass": "Lass",
    "pokemon": [
      "Dugtrio 4",
      "Medicham 4",
      "Misdreavus 4",
      "Fearow 4",
      "Granbull 4",
      "Jynx 4",
      "Dusclops 4",
      "Dodrio 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Forretress 4",
      "Whiscash 4",
      "Xatu 4",
      "Skarmory 4",
      "Marowak 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Raichu 4",
      "Dewgong 4",
      "Manectric 4",
      "Vileplume 4",
      "Victreebel 4",
      "Electrode 4",
      "Exploud 4",
      "Shiftry 4",
      "Glalie 4",
      "Ludicolo 4",
      "Hypno 4",
      "Golem 4",
      "Rhydon 4",
      "Alakazam 4"
    ]
  },
  {
    "name": "JOSIE",
    "trainerClass": "Lass",
    "pokemon": [
      "Dugtrio 4",
      "Medicham 4",
      "Misdreavus 4",
      "Fearow 4",
      "Granbull 4",
      "Jynx 4",
      "Dusclops 4",
      "Dodrio 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Forretress 4",
      "Whiscash 4",
      "Xatu 4",
      "Skarmory 4",
      "Marowak 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Raichu 4",
      "Dewgong 4",
      "Manectric 4",
      "Vileplume 4",
      "Victreebel 4",
      "Electrode 4",
      "Exploud 4",
      "Shiftry 4",
      "Glalie 4",
      "Ludicolo 4",
      "Hypno 4",
      "Golem 4",
      "Rhydon 4",
      "Alakazam 4"
    ]
  },
  {
    "name": "ARMANDO",
    "trainerClass": "Camper",
    "pokemon": [
      "Weezing 4",
      "Kangaskhan 4",
      "Electabuzz 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Magmar 4",
      "Cradily 4",
      "Armaldo 4",
      "Golduck 4",
      "Rapidash 4",
      "Muk 4",
      "Gengar 4",
      "Ampharos 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Houndoom 4",
      "Donphan 4",
      "Claydol 4",
      "Wailord 4",
      "Ninetales 4",
      "Machamp 4",
      "Shuckle 4",
      "Steelix 4",
      "Tentacruel 4",
      "Aerodactyl 4",
      "Porygon2 4",
      "Gardevoir 4"
    ]
  },
  {
    "name": "SKYLER",
    "trainerClass": "Camper",
    "pokemon": [
      "Weezing 4",
      "Kangaskhan 4",
      "Electabuzz 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Magmar 4",
      "Cradily 4",
      "Armaldo 4",
      "Golduck 4",
      "Rapidash 4",
      "Muk 4",
      "Gengar 4",
      "Ampharos 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Houndoom 4",
      "Donphan 4",
      "Claydol 4",
      "Wailord 4",
      "Ninetales 4",
      "Machamp 4",
      "Shuckle 4",
      "Steelix 4",
      "Tentacruel 4",
      "Aerodactyl 4",
      "Porygon2 4",
      "Gardevoir 4"
    ]
  },
  {
    "name": "RUTH",
    "trainerClass": "Picnicker",
    "pokemon": [
      "Weezing 4",
      "Kangaskhan 4",
      "Electabuzz 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Magmar 4",
      "Cradily 4",
      "Armaldo 4",
      "Golduck 4",
      "Rapidash 4",
      "Muk 4",
      "Gengar 4",
      "Ampharos 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Houndoom 4",
      "Donphan 4",
      "Claydol 4",
      "Wailord 4",
      "Ninetales 4",
      "Machamp 4",
      "Shuckle 4",
      "Steelix 4",
      "Tentacruel 4",
      "Aerodactyl 4",
      "Porygon2 4",
      "Gardevoir 4"
    ]
  },
  {
    "name": "MELODY",
    "trainerClass": "Picnicker",
    "pokemon": [
      "Weezing 4",
      "Kangaskhan 4",
      "Electabuzz 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Magmar 4",
      "Cradily 4",
      "Armaldo 4",
      "Golduck 4",
      "Rapidash 4",
      "Muk 4",
      "Gengar 4",
      "Ampharos 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Houndoom 4",
      "Donphan 4",
      "Claydol 4",
      "Wailord 4",
      "Ninetales 4",
      "Machamp 4",
      "Shuckle 4",
      "Steelix 4",
      "Tentacruel 4",
      "Aerodactyl 4",
      "Porygon2 4",
      "Gardevoir 4"
    ]
  },
  {
    "name": "PEDRO",
    "trainerClass": "Swimmer\u2642",
    "pokemon": [
      "Sharpedo 2",
      "Medicham 4",
      "Granbull 4",
      "Lanturn 4",
      "Whiscash 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Dewgong 4",
      "Exploud 4",
      "Ludicolo 4",
      "Kangaskhan 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Golduck 4",
      "Ursaring 4",
      "Wailord 4",
      "Machamp 4",
      "Tentacruel 4",
      "Porygon2 4",
      "Starmie 4",
      "Vaporeon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Walrein 4",
      "Lapras 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Slaking 4"
    ]
  },
  {
    "name": "ERICK",
    "trainerClass": "Swimmer\u2642",
    "pokemon": [
      "Sharpedo 2",
      "Medicham 4",
      "Granbull 4",
      "Lanturn 4",
      "Whiscash 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Dewgong 4",
      "Exploud 4",
      "Ludicolo 4",
      "Kangaskhan 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Golduck 4",
      "Ursaring 4",
      "Wailord 4",
      "Machamp 4",
      "Tentacruel 4",
      "Porygon2 4",
      "Starmie 4",
      "Vaporeon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Walrein 4",
      "Lapras 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Slaking 4"
    ]
  },
  {
    "name": "ELAINE",
    "trainerClass": "Swimmer\u2640",
    "pokemon": [
      "Granbull 4",
      "Jynx 4",
      "Lanturn 4",
      "Whiscash 4",
      "Quagsire 4",
      "Clefable 4",
      "Dewgong 4",
      "Exploud 4",
      "Glalie 4",
      "Ludicolo 4",
      "Kangaskhan 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Golduck 4",
      "Ursaring 4",
      "Wailord 4",
      "Tentacruel 4",
      "Porygon2 4",
      "Starmie 4",
      "Vaporeon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Walrein 4",
      "Lapras 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Slaking 4"
    ]
  },
  {
    "name": "JOYCE",
    "trainerClass": "Swimmer\u2640",
    "pokemon": [
      "Granbull 4",
      "Jynx 4",
      "Lanturn 4",
      "Whiscash 4",
      "Quagsire 4",
      "Clefable 4",
      "Dewgong 4",
      "Exploud 4",
      "Glalie 4",
      "Ludicolo 4",
      "Kangaskhan 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Golduck 4",
      "Ursaring 4",
      "Wailord 4",
      "Tentacruel 4",
      "Porygon2 4",
      "Starmie 4",
      "Vaporeon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Walrein 4",
      "Lapras 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Slaking 4"
    ]
  },
  {
    "name": "TODD",
    "trainerClass": "Pok\u00e9fan (M)",
    "pokemon": [
      "Delcatty 2",
      "Porygon 2",
      "Dunsparce 2",
      "Wigglytuff 2",
      "Kecleon 2",
      "Chansey 2",
      "Absol 2",
      "Misdreavus 4",
      "Jynx 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Whiscash 4",
      "Xatu 4",
      "Quagsire 4",
      "Clefable 4",
      "Raichu 4",
      "Dewgong 4",
      "Vileplume 4",
      "Ludicolo 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Rapidash 4",
      "Ampharos 4",
      "Ninetales 4",
      "Shuckle 4",
      "Porygon2 4",
      "Gardevoir 4",
      "Flygon 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Espeon 4",
      "Umbreon 4",
      "Lapras 4",
      "Snorlax 4",
      "Blissey 4",
      "Milotic 4"
    ]
  },
  {
    "name": "GAVIN",
    "trainerClass": "Pok\u00e9fan (M)",
    "pokemon": [
      "Delcatty 2",
      "Porygon 2",
      "Dunsparce 2",
      "Wigglytuff 2",
      "Kecleon 2",
      "Chansey 2",
      "Absol 2",
      "Misdreavus 4",
      "Jynx 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Whiscash 4",
      "Xatu 4",
      "Quagsire 4",
      "Clefable 4",
      "Raichu 4",
      "Dewgong 4",
      "Vileplume 4",
      "Ludicolo 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Rapidash 4",
      "Ampharos 4",
      "Ninetales 4",
      "Shuckle 4",
      "Porygon2 4",
      "Gardevoir 4",
      "Flygon 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Espeon 4",
      "Umbreon 4",
      "Lapras 4",
      "Snorlax 4",
      "Blissey 4",
      "Milotic 4"
    ]
  },
  {
    "name": "MALORY",
    "trainerClass": "Pok\u00e9fan (F)",
    "pokemon": [
      "Delcatty 2",
      "Porygon 2",
      "Dunsparce 2",
      "Wigglytuff 2",
      "Kecleon 2",
      "Chansey 2",
      "Absol 2",
      "Misdreavus 4",
      "Jynx 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Whiscash 4",
      "Xatu 4",
      "Quagsire 4",
      "Clefable 4",
      "Raichu 4",
      "Dewgong 4",
      "Vileplume 4",
      "Ludicolo 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Rapidash 4",
      "Ampharos 4",
      "Ninetales 4",
      "Shuckle 4",
      "Porygon2 4",
      "Gardevoir 4",
      "Flygon 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Espeon 4",
      "Umbreon 4",
      "Lapras 4",
      "Snorlax 4",
      "Blissey 4",
      "Milotic 4"
    ]
  },
  {
    "name": "ESTHER",
    "trainerClass": "Pok\u00e9fan (F)",
    "pokemon": [
      "Delcatty 2",
      "Porygon 2",
      "Dunsparce 2",
      "Wigglytuff 2",
      "Kecleon 2",
      "Chansey 2",
      "Absol 2",
      "Misdreavus 4",
      "Jynx 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Whiscash 4",
      "Xatu 4",
      "Quagsire 4",
      "Clefable 4",
      "Raichu 4",
      "Dewgong 4",
      "Vileplume 4",
      "Ludicolo 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Rapidash 4",
      "Ampharos 4",
      "Ninetales 4",
      "Shuckle 4",
      "Porygon2 4",
      "Gardevoir 4",
      "Flygon 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Espeon 4",
      "Umbreon 4",
      "Lapras 4",
      "Snorlax 4",
      "Blissey 4",
      "Milotic 4"
    ]
  },
  {
    "name": "OSCAR",
    "trainerClass": "PKMN Breeder (M)",
    "pokemon": [
      "Exeggutor 4",
      "Starmie 4",
      "Flygon 4",
      "Venusaur 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Meganium 4",
      "Espeon 4",
      "Umbreon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Aggron 4",
      "Blaziken 4",
      "Walrein 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Lapras 4",
      "Crobat 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Arcanine 4",
      "Salamence 4",
      "Metagross 4",
      "Slaking 4"
    ]
  },
  {
    "name": "WILSON",
    "trainerClass": "PKMN Breeder (M)",
    "pokemon": [
      "Exeggutor 4",
      "Starmie 4",
      "Flygon 4",
      "Venusaur 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Meganium 4",
      "Espeon 4",
      "Umbreon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Aggron 4",
      "Blaziken 4",
      "Walrein 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Lapras 4",
      "Crobat 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Arcanine 4",
      "Salamence 4",
      "Metagross 4",
      "Slaking 4"
    ]
  },
  {
    "name": "CLARE",
    "trainerClass": "PKMN Breeder (F)",
    "pokemon": [
      "Exeggutor 4",
      "Starmie 4",
      "Flygon 4",
      "Venusaur 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Meganium 4",
      "Espeon 4",
      "Umbreon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Aggron 4",
      "Blaziken 4",
      "Walrein 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Lapras 4",
      "Crobat 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Arcanine 4",
      "Salamence 4",
      "Metagross 4",
      "Slaking 4"
    ]
  },
  {
    "name": "TESS",
    "trainerClass": "PKMN Breeder (F)",
    "pokemon": [
      "Exeggutor 4",
      "Starmie 4",
      "Flygon 4",
      "Venusaur 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Meganium 4",
      "Espeon 4",
      "Umbreon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Aggron 4",
      "Blaziken 4",
      "Walrein 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Lapras 4",
      "Crobat 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Arcanine 4",
      "Salamence 4",
      "Metagross 4",
      "Slaking 4"
    ]
  },
  {
    "name": "LEON",
    "trainerClass": "Cooltrainer (M)",
    "pokemon": [
      "Muk 1",
      "Gengar 1",
      "Ampharos 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Houndoom 1",
      "Donphan 1",
      "Claydol 1",
      "Wailord 1",
      "Ninetales 1",
      "Machamp 1",
      "Shuckle 1",
      "Steelix 1",
      "Tentacruel 1",
      "Aerodactyl 1",
      "Porygon2 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Flygon 1",
      "Venusaur 1",
      "Vaporeon 1",
      "Jolteon 1",
      "Muk 2",
      "Gengar 2",
      "Ampharos 2",
      "Scizor 2",
      "Heracross 2",
      "Ursaring 2",
      "Houndoom 2",
      "Donphan 2",
      "Claydol 2",
      "Wailord 2",
      "Ninetales 2",
      "Machamp 2",
      "Shuckle 2",
      "Steelix 2",
      "Tentacruel 2",
      "Aerodactyl 2",
      "Porygon2 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Flygon 2",
      "Venusaur 2",
      "Vaporeon 2",
      "Jolteon 2",
      "Muk 3",
      "Gengar 3",
      "Ampharos 3",
      "Scizor 3",
      "Heracross 3",
      "Ursaring 3",
      "Houndoom 3",
      "Donphan 3",
      "Claydol 3",
      "Wailord 3",
      "Ninetales 3",
      "Machamp 3",
      "Shuckle 3",
      "Steelix 3",
      "Tentacruel 3",
      "Aerodactyl 3",
      "Porygon2 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Flygon 3",
      "Venusaur 3",
      "Vaporeon 3",
      "Jolteon 3",
      "Muk 4",
      "Gengar 4",
      "Ampharos 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Houndoom 4",
      "Donphan 4",
      "Claydol 4",
      "Wailord 4",
      "Ninetales 4",
      "Machamp 4",
      "Shuckle 4",
      "Steelix 4",
      "Tentacruel 4",
      "Aerodactyl 4",
      "Porygon2 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Flygon 4",
      "Venusaur 4",
      "Vaporeon 4",
      "Jolteon 4"
    ]
  },
  {
    "name": "ALONZO",
    "trainerClass": "Cooltrainer (M)",
    "pokemon": [
      "Flareon 1",
      "Meganium 1",
      "Espeon 1",
      "Umbreon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Aggron 1",
      "Blaziken 1",
      "Walrein 1",
      "Sceptile 1",
      "Charizard 1",
      "Typhlosion 1",
      "Lapras 1",
      "Crobat 1",
      "Swampert 1",
      "Gyarados 1",
      "Snorlax 1",
      "Kingdra 1",
      "Blissey 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1",
      "Metagross 1",
      "Slaking 1",
      "Flareon 2",
      "Meganium 2",
      "Espeon 2",
      "Umbreon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Aggron 2",
      "Blaziken 2",
      "Walrein 2",
      "Sceptile 2",
      "Charizard 2",
      "Typhlosion 2",
      "Lapras 2",
      "Crobat 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Arcanine 2",
      "Salamence 2",
      "Metagross 2",
      "Slaking 2",
      "Flareon 3",
      "Meganium 3",
      "Espeon 3",
      "Umbreon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Aggron 3",
      "Blaziken 3",
      "Walrein 3",
      "Sceptile 3",
      "Charizard 3",
      "Typhlosion 3",
      "Lapras 3",
      "Crobat 3",
      "Swampert 3",
      "Gyarados 3",
      "Snorlax 3",
      "Kingdra 3",
      "Blissey 3",
      "Milotic 3",
      "Arcanine 3",
      "Salamence 3",
      "Metagross 3",
      "Slaking 3",
      "Flareon 4",
      "Meganium 4",
      "Espeon 4",
      "Umbreon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Aggron 4",
      "Blaziken 4",
      "Walrein 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Lapras 4",
      "Crobat 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Arcanine 4",
      "Salamence 4",
      "Metagross 4",
      "Slaking 4"
    ]
  },
  {
    "name": "VINCE",
    "trainerClass": "Cooltrainer (M)",
    "pokemon": [
      "Gengar 1",
      "Ursaring 1",
      "Machamp 1",
      "Gardevoir 1",
      "Starmie 1",
      "Lapras 1",
      "Snorlax 1",
      "Salamence 1",
      "Metagross 1",
      "Gengar 2",
      "Ursaring 2",
      "Machamp 2",
      "Gardevoir 2",
      "Starmie 2",
      "Lapras 2",
      "Snorlax 2",
      "Salamence 2",
      "Metagross 2",
      "Gengar 3",
      "Ursaring 3",
      "Machamp 3",
      "Gardevoir 3",
      "Starmie 3",
      "Lapras 3",
      "Snorlax 3",
      "Salamence 3",
      "Metagross 3",
      "Gengar 4",
      "Ursaring 4",
      "Machamp 4",
      "Gardevoir 4",
      "Starmie 4",
      "Lapras 4",
      "Snorlax 4",
      "Salamence 4",
      "Metagross 4",
      "Latios 1",
      "Latios 2",
      "Latios 3",
      "Latios 4",
      "Gengar 5",
      "Gengar 6",
      "Gengar 7",
      "Gengar 8",
      "Ursaring 5",
      "Ursaring 6",
      "Ursaring 7",
      "Ursaring 8",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8",
      "Snorlax 5",
      "Snorlax 6",
      "Snorlax 7",
      "Snorlax 8",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "BRYON",
    "trainerClass": "Cooltrainer (M)",
    "pokemon": [
      "Articuno 1",
      "Zapdos 1",
      "Moltres 1",
      "Raikou 1",
      "Entei 1",
      "Suicune 1",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Latios 1",
      "Articuno 2",
      "Zapdos 2",
      "Moltres 2",
      "Raikou 2",
      "Entei 2",
      "Suicune 2",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Latios 2",
      "Articuno 3",
      "Zapdos 3",
      "Moltres 3",
      "Raikou 3",
      "Entei 3",
      "Suicune 3",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Latios 3",
      "Articuno 4",
      "Zapdos 4",
      "Moltres 4",
      "Raikou 4",
      "Entei 4",
      "Suicune 4",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Latios 4",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10",
      "Articuno 5",
      "Articuno 6",
      "Zapdos 5",
      "Zapdos 6",
      "Moltres 5",
      "Moltres 6",
      "Raikou 5",
      "Raikou 6",
      "Entei 5",
      "Entei 6",
      "Suicune 5",
      "Suicune 6"
    ]
  },
  {
    "name": "AVA",
    "trainerClass": "Cooltrainer (F)",
    "pokemon": [
      "Dugtrio 1",
      "Medicham 1",
      "Misdreavus 1",
      "Fearow 1",
      "Granbull 1",
      "Jynx 1",
      "Dusclops 1",
      "Dodrio 1",
      "Mrmime 1",
      "Lanturn 1",
      "Breloom 1",
      "Forretress 1",
      "Whiscash 1",
      "Xatu 1",
      "Skarmory 1",
      "Marowak 1",
      "Quagsire 1",
      "Clefable 1",
      "Hariyama 1",
      "Raichu 1",
      "Dewgong 1",
      "Manectric 1",
      "Vileplume 1",
      "Victreebel 1",
      "Dugtrio 2",
      "Medicham 2",
      "Marowak 2",
      "Quagsire 2",
      "Misdreavus 2",
      "Fearow 2",
      "Granbull 2",
      "Jynx 2",
      "Dusclops 2",
      "Dodrio 2",
      "Mrmime 2",
      "Lanturn 2",
      "Breloom 2",
      "Forretress 2",
      "Skarmory 2",
      "Whiscash 2",
      "Xatu 2",
      "Clefable 2",
      "Hariyama 2",
      "Raichu 2",
      "Dewgong 2",
      "Manectric 2",
      "Vileplume 2",
      "Victreebel 2",
      "Dugtrio 3",
      "Medicham 3",
      "Misdreavus 3",
      "Fearow 3",
      "Granbull 3",
      "Jynx 3",
      "Dusclops 3",
      "Dodrio 3",
      "Mrmime 3",
      "Lanturn 3",
      "Breloom 3",
      "Forretress 3",
      "Whiscash 3",
      "Xatu 3",
      "Skarmory 3",
      "Marowak 3",
      "Quagsire 3",
      "Clefable 3",
      "Hariyama 3",
      "Raichu 3",
      "Dewgong 3",
      "Manectric 3",
      "Vileplume 3",
      "Victreebel 3",
      "Dugtrio 4",
      "Medicham 4",
      "Misdreavus 4",
      "Fearow 4",
      "Granbull 4",
      "Jynx 4",
      "Dusclops 4",
      "Dodrio 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Forretress 4",
      "Whiscash 4",
      "Xatu 4",
      "Skarmory 4",
      "Marowak 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Raichu 4",
      "Dewgong 4",
      "Manectric 4",
      "Vileplume 4",
      "Victreebel 4"
    ]
  },
  {
    "name": "MIRIAM",
    "trainerClass": "Cooltrainer (F)",
    "pokemon": [
      "Electrode 1",
      "Exploud 1",
      "Shiftry 1",
      "Glalie 1",
      "Ludicolo 1",
      "Hypno 1",
      "Golem 1",
      "Rhydon 1",
      "Alakazam 1",
      "Weezing 1",
      "Kangaskhan 1",
      "Electabuzz 1",
      "Tauros 1",
      "Slowbro 1",
      "Slowking 1",
      "Miltank 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Magmar 1",
      "Cradily 1",
      "Armaldo 1",
      "Golduck 1",
      "Rapidash 1",
      "Electrode 2",
      "Exploud 2",
      "Shiftry 2",
      "Glalie 2",
      "Ludicolo 2",
      "Hypno 2",
      "Golem 2",
      "Rhydon 2",
      "Alakazam 2",
      "Weezing 2",
      "Kangaskhan 2",
      "Electabuzz 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Magmar 2",
      "Cradily 2",
      "Armaldo 2",
      "Golduck 2",
      "Rapidash 2",
      "Electrode 3",
      "Exploud 3",
      "Shiftry 3",
      "Glalie 3",
      "Ludicolo 3",
      "Hypno 3",
      "Golem 3",
      "Rhydon 3",
      "Alakazam 3",
      "Weezing 3",
      "Kangaskhan 3",
      "Electabuzz 3",
      "Tauros 3",
      "Slowbro 3",
      "Slowking 3",
      "Miltank 3",
      "Altaria 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Magmar 3",
      "Cradily 3",
      "Armaldo 3",
      "Golduck 3",
      "Rapidash 3",
      "Electrode 4",
      "Exploud 4",
      "Shiftry 4",
      "Glalie 4",
      "Ludicolo 4",
      "Hypno 4",
      "Golem 4",
      "Rhydon 4",
      "Alakazam 4",
      "Weezing 4",
      "Kangaskhan 4",
      "Electabuzz 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Magmar 4",
      "Cradily 4",
      "Armaldo 4",
      "Golduck 4",
      "Rapidash 4"
    ]
  },
  {
    "name": "CARRIE",
    "trainerClass": "Cooltrainer (F)",
    "pokemon": [
      "Gengar 1",
      "Ursaring 1",
      "Machamp 1",
      "Gardevoir 1",
      "Starmie 1",
      "Lapras 1",
      "Snorlax 1",
      "Salamence 1",
      "Metagross 1",
      "Gengar 2",
      "Ursaring 2",
      "Machamp 2",
      "Gardevoir 2",
      "Starmie 2",
      "Lapras 2",
      "Snorlax 2",
      "Salamence 2",
      "Metagross 2",
      "Gengar 3",
      "Ursaring 3",
      "Machamp 3",
      "Gardevoir 3",
      "Starmie 3",
      "Lapras 3",
      "Snorlax 3",
      "Salamence 3",
      "Metagross 3",
      "Gengar 4",
      "Ursaring 4",
      "Machamp 4",
      "Gardevoir 4",
      "Starmie 4",
      "Lapras 4",
      "Snorlax 4",
      "Salamence 4",
      "Metagross 4",
      "Latias 1",
      "Latias 2",
      "Latias 3",
      "Latias 4",
      "Gengar 5",
      "Gengar 6",
      "Gengar 7",
      "Gengar 8",
      "Ursaring 5",
      "Ursaring 6",
      "Ursaring 7",
      "Ursaring 8",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8",
      "Snorlax 5",
      "Snorlax 6",
      "Snorlax 7",
      "Snorlax 8",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "GILLIAN",
    "trainerClass": "Cooltrainer (F)",
    "pokemon": [
      "Articuno 1",
      "Zapdos 1",
      "Moltres 1",
      "Raikou 1",
      "Entei 1",
      "Suicune 1",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Latias 1",
      "Articuno 2",
      "Zapdos 2",
      "Moltres 2",
      "Raikou 2",
      "Entei 2",
      "Suicune 2",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Latias 2",
      "Articuno 3",
      "Zapdos 3",
      "Moltres 3",
      "Raikou 3",
      "Entei 3",
      "Suicune 3",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Latias 3",
      "Articuno 4",
      "Zapdos 4",
      "Moltres 4",
      "Raikou 4",
      "Entei 4",
      "Suicune 4",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Latias 4",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10",
      "Articuno 5",
      "Articuno 6",
      "Zapdos 5",
      "Zapdos 6",
      "Moltres 5",
      "Moltres 6",
      "Raikou 5",
      "Raikou 6",
      "Entei 5",
      "Entei 6",
      "Suicune 5",
      "Suicune 6"
    ]
  },
  {
    "name": "TYLER",
    "trainerClass": "PKMN Ranger (M)",
    "pokemon": [
      "Dugtrio 4",
      "Medicham 4",
      "Misdreavus 4",
      "Fearow 4",
      "Granbull 4",
      "Jynx 4",
      "Dusclops 4",
      "Dodrio 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Forretress 4",
      "Whiscash 4",
      "Xatu 4",
      "Skarmory 4",
      "Marowak 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Raichu 4",
      "Dewgong 4",
      "Manectric 4",
      "Vileplume 4",
      "Victreebel 4",
      "Electrode 4",
      "Exploud 4",
      "Shiftry 4",
      "Glalie 4",
      "Ludicolo 4",
      "Hypno 4",
      "Golem 4",
      "Rhydon 4",
      "Alakazam 4",
      "Weezing 4",
      "Kangaskhan 4",
      "Electabuzz 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Magmar 4",
      "Cradily 4",
      "Armaldo 4",
      "Golduck 4",
      "Rapidash 4",
      "Muk 4",
      "Gengar 4",
      "Ampharos 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Houndoom 4",
      "Donphan 4",
      "Claydol 4",
      "Wailord 4",
      "Ninetales 4",
      "Machamp 4",
      "Shuckle 4",
      "Steelix 4",
      "Tentacruel 4",
      "Aerodactyl 4",
      "Porygon2 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Flygon 4",
      "Venusaur 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Meganium 4",
      "Espeon 4",
      "Umbreon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Aggron 4",
      "Blaziken 4",
      "Walrein 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Lapras 4",
      "Crobat 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Arcanine 4",
      "Salamence 4",
      "Metagross 4",
      "Slaking 4"
    ]
  },
  {
    "name": "CHAZ",
    "trainerClass": "PKMN Ranger (M)",
    "pokemon": [
      "Dugtrio 3",
      "Medicham 3",
      "Misdreavus 3",
      "Fearow 3",
      "Granbull 3",
      "Jynx 3",
      "Dusclops 3",
      "Dodrio 3",
      "Mrmime 3",
      "Lanturn 3",
      "Breloom 3",
      "Forretress 3",
      "Whiscash 3",
      "Xatu 3",
      "Skarmory 3",
      "Marowak 3",
      "Quagsire 3",
      "Clefable 3",
      "Hariyama 3",
      "Raichu 3",
      "Dewgong 3",
      "Manectric 3",
      "Vileplume 3",
      "Victreebel 3",
      "Electrode 3",
      "Exploud 3",
      "Shiftry 3",
      "Glalie 3",
      "Ludicolo 3",
      "Hypno 3",
      "Golem 3",
      "Rhydon 3",
      "Alakazam 3",
      "Weezing 3",
      "Kangaskhan 3",
      "Electabuzz 3",
      "Tauros 3",
      "Slowbro 3",
      "Slowking 3",
      "Miltank 3",
      "Altaria 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Magmar 3",
      "Cradily 3",
      "Armaldo 3",
      "Golduck 3",
      "Rapidash 3",
      "Muk 3",
      "Gengar 3",
      "Ampharos 3",
      "Scizor 3",
      "Heracross 3",
      "Ursaring 3",
      "Houndoom 3",
      "Donphan 3",
      "Claydol 3",
      "Wailord 3",
      "Ninetales 3",
      "Machamp 3",
      "Shuckle 3",
      "Steelix 3",
      "Tentacruel 3",
      "Aerodactyl 3",
      "Porygon2 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Flygon 3",
      "Venusaur 3",
      "Vaporeon 3",
      "Jolteon 3",
      "Flareon 3",
      "Meganium 3",
      "Espeon 3",
      "Umbreon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Aggron 3",
      "Blaziken 3",
      "Walrein 3",
      "Sceptile 3",
      "Charizard 3",
      "Typhlosion 3",
      "Lapras 3",
      "Crobat 3",
      "Swampert 3",
      "Gyarados 3",
      "Snorlax 3",
      "Kingdra 3",
      "Blissey 3",
      "Milotic 3",
      "Arcanine 3",
      "Salamence 3",
      "Metagross 3",
      "Slaking 3"
    ]
  },
  {
    "name": "NELSON",
    "trainerClass": "PKMN Ranger (M)",
    "pokemon": [
      "Articuno 1",
      "Zapdos 1",
      "Moltres 1",
      "Raikou 1",
      "Entei 1",
      "Suicune 1",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Latios 1",
      "Articuno 2",
      "Zapdos 2",
      "Moltres 2",
      "Raikou 2",
      "Entei 2",
      "Suicune 2",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Latios 2",
      "Articuno 3",
      "Zapdos 3",
      "Moltres 3",
      "Raikou 3",
      "Entei 3",
      "Suicune 3",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Latios 3",
      "Articuno 4",
      "Zapdos 4",
      "Moltres 4",
      "Raikou 4",
      "Entei 4",
      "Suicune 4",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Latios 4",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10",
      "Articuno 5",
      "Articuno 6",
      "Zapdos 5",
      "Zapdos 6",
      "Moltres 5",
      "Moltres 6",
      "Raikou 5",
      "Raikou 6",
      "Entei 5",
      "Entei 6",
      "Suicune 5",
      "Suicune 6"
    ]
  },
  {
    "name": "SHANIA",
    "trainerClass": "PKMN Ranger (F)",
    "pokemon": [
      "Dugtrio 2",
      "Medicham 2",
      "Marowak 2",
      "Quagsire 2",
      "Misdreavus 2",
      "Fearow 2",
      "Granbull 2",
      "Jynx 2",
      "Dusclops 2",
      "Dodrio 2",
      "Mrmime 2",
      "Lanturn 2",
      "Breloom 2",
      "Forretress 2",
      "Skarmory 2",
      "Whiscash 2",
      "Xatu 2",
      "Clefable 2",
      "Hariyama 2",
      "Raichu 2",
      "Dewgong 2",
      "Manectric 2",
      "Vileplume 2",
      "Victreebel 2",
      "Electrode 2",
      "Exploud 2",
      "Shiftry 2",
      "Glalie 2",
      "Ludicolo 2",
      "Hypno 2",
      "Golem 2",
      "Rhydon 2",
      "Alakazam 2",
      "Weezing 2",
      "Kangaskhan 2",
      "Electabuzz 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Magmar 2",
      "Cradily 2",
      "Armaldo 2",
      "Golduck 2",
      "Rapidash 2",
      "Muk 2",
      "Gengar 2",
      "Ampharos 2",
      "Scizor 2",
      "Heracross 2",
      "Ursaring 2",
      "Houndoom 2",
      "Donphan 2",
      "Claydol 2",
      "Wailord 2",
      "Ninetales 2",
      "Machamp 2",
      "Shuckle 2",
      "Steelix 2",
      "Tentacruel 2",
      "Aerodactyl 2",
      "Porygon2 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Flygon 2",
      "Venusaur 2",
      "Vaporeon 2",
      "Jolteon 2",
      "Flareon 2",
      "Meganium 2",
      "Espeon 2",
      "Umbreon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Aggron 2",
      "Blaziken 2",
      "Walrein 2",
      "Sceptile 2",
      "Charizard 2",
      "Typhlosion 2",
      "Lapras 2",
      "Crobat 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Arcanine 2",
      "Salamence 2",
      "Metagross 2",
      "Slaking 2"
    ]
  },
  {
    "name": "STELLA",
    "trainerClass": "PKMN Ranger (F)",
    "pokemon": [
      "Dugtrio 1",
      "Medicham 1",
      "Misdreavus 1",
      "Fearow 1",
      "Granbull 1",
      "Jynx 1",
      "Dusclops 1",
      "Dodrio 1",
      "Mrmime 1",
      "Lanturn 1",
      "Breloom 1",
      "Forretress 1",
      "Whiscash 1",
      "Xatu 1",
      "Skarmory 1",
      "Marowak 1",
      "Quagsire 1",
      "Clefable 1",
      "Hariyama 1",
      "Raichu 1",
      "Dewgong 1",
      "Manectric 1",
      "Vileplume 1",
      "Victreebel 1",
      "Electrode 1",
      "Exploud 1",
      "Shiftry 1",
      "Glalie 1",
      "Ludicolo 1",
      "Hypno 1",
      "Golem 1",
      "Rhydon 1",
      "Alakazam 1",
      "Weezing 1",
      "Kangaskhan 1",
      "Electabuzz 1",
      "Tauros 1",
      "Slowbro 1",
      "Slowking 1",
      "Miltank 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Magmar 1",
      "Cradily 1",
      "Armaldo 1",
      "Golduck 1",
      "Rapidash 1",
      "Muk 1",
      "Gengar 1",
      "Ampharos 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Houndoom 1",
      "Donphan 1",
      "Claydol 1",
      "Wailord 1",
      "Ninetales 1",
      "Machamp 1",
      "Shuckle 1",
      "Steelix 1",
      "Tentacruel 1",
      "Aerodactyl 1",
      "Porygon2 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Flygon 1",
      "Venusaur 1",
      "Vaporeon 1",
      "Jolteon 1",
      "Flareon 1",
      "Meganium 1",
      "Espeon 1",
      "Umbreon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Aggron 1",
      "Blaziken 1",
      "Walrein 1",
      "Sceptile 1",
      "Charizard 1",
      "Typhlosion 1",
      "Lapras 1",
      "Crobat 1",
      "Swampert 1",
      "Gyarados 1",
      "Snorlax 1",
      "Kingdra 1",
      "Blissey 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1",
      "Metagross 1",
      "Slaking 1"
    ]
  },
  {
    "name": "DORINE",
    "trainerClass": "PKMN Ranger (F)",
    "pokemon": [
      "Articuno 1",
      "Zapdos 1",
      "Moltres 1",
      "Raikou 1",
      "Entei 1",
      "Suicune 1",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Latias 1",
      "Articuno 2",
      "Zapdos 2",
      "Moltres 2",
      "Raikou 2",
      "Entei 2",
      "Suicune 2",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Latias 2",
      "Articuno 3",
      "Zapdos 3",
      "Moltres 3",
      "Raikou 3",
      "Entei 3",
      "Suicune 3",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Latias 3",
      "Articuno 4",
      "Zapdos 4",
      "Moltres 4",
      "Raikou 4",
      "Entei 4",
      "Suicune 4",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Latias 4",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10",
      "Articuno 5",
      "Articuno 6",
      "Zapdos 5",
      "Zapdos 6",
      "Moltres 5",
      "Moltres 6",
      "Raikou 5",
      "Raikou 6",
      "Entei 5",
      "Entei 6",
      "Suicune 5",
      "Suicune 6"
    ]
  },
  {
    "name": "MADDOX",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "Rhydon 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Aggron 1",
      "Charizard 1",
      "Lapras 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Salamence 1",
      "Rhydon 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Flygon 2",
      "Aggron 2",
      "Charizard 2",
      "Lapras 2",
      "Gyarados 2",
      "Kingdra 2",
      "Milotic 2",
      "Salamence 2",
      "Rhydon 3",
      "Altaria 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Flygon 3",
      "Aggron 3",
      "Charizard 3",
      "Lapras 3",
      "Gyarados 3",
      "Kingdra 3",
      "Milotic 3",
      "Salamence 3",
      "Rhydon 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Flygon 4",
      "Aggron 4",
      "Charizard 4",
      "Lapras 4",
      "Gyarados 4",
      "Kingdra 4",
      "Milotic 4",
      "Salamence 4",
      "Latias 1",
      "Latios 1",
      "Latias 2",
      "Latios 2",
      "Latias 3",
      "Latios 3",
      "Latias 4",
      "Latios 4",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "DAVIN",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "Rhydon 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Aggron 1",
      "Charizard 1",
      "Lapras 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Salamence 1",
      "Rhydon 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Flygon 2",
      "Aggron 2",
      "Charizard 2",
      "Lapras 2",
      "Gyarados 2",
      "Kingdra 2",
      "Milotic 2",
      "Salamence 2",
      "Rhydon 3",
      "Altaria 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Flygon 3",
      "Aggron 3",
      "Charizard 3",
      "Lapras 3",
      "Gyarados 3",
      "Kingdra 3",
      "Milotic 3",
      "Salamence 3",
      "Rhydon 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Flygon 4",
      "Aggron 4",
      "Charizard 4",
      "Lapras 4",
      "Gyarados 4",
      "Kingdra 4",
      "Milotic 4",
      "Salamence 4",
      "Latias 1",
      "Latios 1",
      "Latias 2",
      "Latios 2",
      "Latias 3",
      "Latios 3",
      "Latias 4",
      "Latios 4",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "TREVON",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "Rhydon 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Aggron 1",
      "Charizard 1",
      "Lapras 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Salamence 1",
      "Rhydon 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Flygon 2",
      "Aggron 2",
      "Charizard 2",
      "Lapras 2",
      "Gyarados 2",
      "Kingdra 2",
      "Milotic 2",
      "Salamence 2",
      "Rhydon 3",
      "Altaria 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Flygon 3",
      "Aggron 3",
      "Charizard 3",
      "Lapras 3",
      "Gyarados 3",
      "Kingdra 3",
      "Milotic 3",
      "Salamence 3",
      "Rhydon 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Flygon 4",
      "Aggron 4",
      "Charizard 4",
      "Lapras 4",
      "Gyarados 4",
      "Kingdra 4",
      "Milotic 4",
      "Salamence 4",
      "Latias 1",
      "Latios 1",
      "Latias 2",
      "Latios 2",
      "Latias 3",
      "Latios 3",
      "Latias 4",
      "Latios 4",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "MATEO",
    "trainerClass": "Black Belt",
    "pokemon": [
      "Medicham 1",
      "Breloom 1",
      "Hariyama 1",
      "Golem 1",
      "Rhydon 1",
      "Cradily 1",
      "Armaldo 1",
      "Heracross 1",
      "Machamp 1",
      "Shuckle 1",
      "Aerodactyl 1",
      "Aggron 1",
      "Blaziken 1",
      "Medicham 2",
      "Breloom 2",
      "Hariyama 2",
      "Golem 2",
      "Rhydon 2",
      "Cradily 2",
      "Armaldo 2",
      "Heracross 2",
      "Machamp 2",
      "Shuckle 2",
      "Aerodactyl 2",
      "Aggron 2",
      "Blaziken 2",
      "Medicham 3",
      "Breloom 3",
      "Hariyama 3",
      "Golem 3",
      "Rhydon 3",
      "Cradily 3",
      "Armaldo 3",
      "Heracross 3",
      "Machamp 3",
      "Shuckle 3",
      "Aerodactyl 3",
      "Aggron 3",
      "Blaziken 3",
      "Medicham 4",
      "Breloom 4",
      "Hariyama 4",
      "Golem 4",
      "Rhydon 4",
      "Cradily 4",
      "Armaldo 4",
      "Heracross 4",
      "Machamp 4",
      "Shuckle 4",
      "Aerodactyl 4",
      "Aggron 4",
      "Blaziken 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8"
    ]
  },
  {
    "name": "BRET",
    "trainerClass": "Black Belt",
    "pokemon": [
      "Medicham 1",
      "Breloom 1",
      "Hariyama 1",
      "Magmar 1",
      "Rapidash 1",
      "Heracross 1",
      "Houndoom 1",
      "Ninetales 1",
      "Machamp 1",
      "Flareon 1",
      "Blaziken 1",
      "Charizard 1",
      "Typhlosion 1",
      "Arcanine 1",
      "Medicham 2",
      "Breloom 2",
      "Hariyama 2",
      "Magmar 2",
      "Rapidash 2",
      "Heracross 2",
      "Houndoom 2",
      "Ninetales 2",
      "Machamp 2",
      "Flareon 2",
      "Blaziken 2",
      "Charizard 2",
      "Typhlosion 2",
      "Arcanine 2",
      "Medicham 3",
      "Breloom 3",
      "Hariyama 3",
      "Magmar 3",
      "Rapidash 3",
      "Heracross 3",
      "Houndoom 3",
      "Ninetales 3",
      "Machamp 3",
      "Flareon 3",
      "Blaziken 3",
      "Charizard 3",
      "Typhlosion 3",
      "Arcanine 3",
      "Medicham 4",
      "Breloom 4",
      "Hariyama 4",
      "Magmar 4",
      "Rapidash 4",
      "Heracross 4",
      "Houndoom 4",
      "Ninetales 4",
      "Machamp 4",
      "Flareon 4",
      "Blaziken 4",
      "Charizard 4",
      "Typhlosion 4",
      "Arcanine 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8"
    ]
  },
  {
    "name": "RAUL",
    "trainerClass": "Black Belt",
    "pokemon": [
      "Medicham 1",
      "Breloom 1",
      "Forretress 1",
      "Skarmory 1",
      "Hariyama 1",
      "Scizor 1",
      "Heracross 1",
      "Machamp 1",
      "Steelix 1",
      "Aggron 1",
      "Blaziken 1",
      "Metagross 1",
      "Medicham 2",
      "Breloom 2",
      "Forretress 2",
      "Skarmory 2",
      "Hariyama 2",
      "Scizor 2",
      "Heracross 2",
      "Machamp 2",
      "Steelix 2",
      "Aggron 2",
      "Blaziken 2",
      "Metagross 2",
      "Medicham 3",
      "Breloom 3",
      "Forretress 3",
      "Skarmory 3",
      "Hariyama 3",
      "Scizor 3",
      "Heracross 3",
      "Machamp 3",
      "Steelix 3",
      "Aggron 3",
      "Blaziken 3",
      "Metagross 3",
      "Medicham 4",
      "Breloom 4",
      "Forretress 4",
      "Skarmory 4",
      "Hariyama 4",
      "Scizor 4",
      "Heracross 4",
      "Machamp 4",
      "Steelix 4",
      "Aggron 4",
      "Blaziken 4",
      "Metagross 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8"
    ]
  },
  {
    "name": "KAY",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "Medicham 1",
      "Breloom 1",
      "Marowak 1",
      "Hariyama 1",
      "Golem 1",
      "Rhydon 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Heracross 1",
      "Donphan 1",
      "Machamp 1",
      "Steelix 1",
      "Blaziken 1",
      "Medicham 2",
      "Marowak 2",
      "Breloom 2",
      "Hariyama 2",
      "Golem 2",
      "Rhydon 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Heracross 2",
      "Donphan 2",
      "Machamp 2",
      "Steelix 2",
      "Blaziken 2",
      "Medicham 3",
      "Breloom 3",
      "Marowak 3",
      "Hariyama 3",
      "Golem 3",
      "Rhydon 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Heracross 3",
      "Donphan 3",
      "Machamp 3",
      "Steelix 3",
      "Blaziken 3",
      "Medicham 4",
      "Breloom 4",
      "Marowak 4",
      "Hariyama 4",
      "Golem 4",
      "Rhydon 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Heracross 4",
      "Donphan 4",
      "Machamp 4",
      "Steelix 4",
      "Blaziken 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8"
    ]
  },
  {
    "name": "ELENA",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "Medicham 1",
      "Breloom 1",
      "Hariyama 1",
      "Magmar 1",
      "Rapidash 1",
      "Heracross 1",
      "Houndoom 1",
      "Ninetales 1",
      "Machamp 1",
      "Flareon 1",
      "Blaziken 1",
      "Charizard 1",
      "Typhlosion 1",
      "Arcanine 1",
      "Medicham 2",
      "Breloom 2",
      "Hariyama 2",
      "Magmar 2",
      "Rapidash 2",
      "Heracross 2",
      "Houndoom 2",
      "Ninetales 2",
      "Machamp 2",
      "Flareon 2",
      "Blaziken 2",
      "Charizard 2",
      "Typhlosion 2",
      "Arcanine 2",
      "Medicham 3",
      "Breloom 3",
      "Hariyama 3",
      "Magmar 3",
      "Rapidash 3",
      "Heracross 3",
      "Houndoom 3",
      "Ninetales 3",
      "Machamp 3",
      "Flareon 3",
      "Blaziken 3",
      "Charizard 3",
      "Typhlosion 3",
      "Arcanine 3",
      "Medicham 4",
      "Breloom 4",
      "Hariyama 4",
      "Magmar 4",
      "Rapidash 4",
      "Heracross 4",
      "Houndoom 4",
      "Ninetales 4",
      "Machamp 4",
      "Flareon 4",
      "Blaziken 4",
      "Charizard 4",
      "Typhlosion 4",
      "Arcanine 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8"
    ]
  },
  {
    "name": "ALANA",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "Medicham 1",
      "Breloom 1",
      "Forretress 1",
      "Skarmory 1",
      "Hariyama 1",
      "Scizor 1",
      "Heracross 1",
      "Machamp 1",
      "Steelix 1",
      "Aggron 1",
      "Blaziken 1",
      "Metagross 1",
      "Medicham 2",
      "Breloom 2",
      "Forretress 2",
      "Skarmory 2",
      "Hariyama 2",
      "Scizor 2",
      "Heracross 2",
      "Machamp 2",
      "Steelix 2",
      "Aggron 2",
      "Blaziken 2",
      "Metagross 2",
      "Medicham 3",
      "Breloom 3",
      "Forretress 3",
      "Skarmory 3",
      "Hariyama 3",
      "Scizor 3",
      "Heracross 3",
      "Machamp 3",
      "Steelix 3",
      "Aggron 3",
      "Blaziken 3",
      "Metagross 3",
      "Medicham 4",
      "Breloom 4",
      "Forretress 4",
      "Skarmory 4",
      "Hariyama 4",
      "Scizor 4",
      "Heracross 4",
      "Machamp 4",
      "Steelix 4",
      "Aggron 4",
      "Blaziken 4",
      "Metagross 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8"
    ]
  },
  {
    "name": "ALEXAS",
    "trainerClass": "Expert (M)",
    "pokemon": [
      "Breloom 1",
      "Marowak 1",
      "Rhydon 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Machamp 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Aggron 1",
      "Gyarados 1",
      "Kingdra 1",
      "Salamence 1",
      "Metagross 1",
      "Marowak 2",
      "Breloom 2",
      "Rhydon 2",
      "Scizor 2",
      "Heracross 2",
      "Ursaring 2",
      "Machamp 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Aggron 2",
      "Gyarados 2",
      "Kingdra 2",
      "Salamence 2",
      "Metagross 2",
      "Breloom 3",
      "Marowak 3",
      "Rhydon 3",
      "Scizor 3",
      "Heracross 3",
      "Ursaring 3",
      "Machamp 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Aggron 3",
      "Gyarados 3",
      "Kingdra 3",
      "Salamence 3",
      "Metagross 3",
      "Breloom 4",
      "Marowak 4",
      "Rhydon 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Machamp 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Aggron 4",
      "Gyarados 4",
      "Kingdra 4",
      "Salamence 4",
      "Metagross 4",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Ursaring 5",
      "Ursaring 6",
      "Ursaring 7",
      "Ursaring 8",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "WESTON",
    "trainerClass": "Expert (M)",
    "pokemon": [
      "Misdreavus 1",
      "Jynx 1",
      "Alakazam 1",
      "Gengar 1",
      "Ampharos 1",
      "Houndoom 1",
      "Gardevoir 1",
      "Starmie 1",
      "Espeon 1",
      "Blaziken 1",
      "Sceptile 1",
      "Crobat 1",
      "Swampert 1",
      "Misdreavus 2",
      "Jynx 2",
      "Alakazam 2",
      "Gengar 2",
      "Ampharos 2",
      "Houndoom 2",
      "Gardevoir 2",
      "Starmie 2",
      "Espeon 2",
      "Blaziken 2",
      "Sceptile 2",
      "Crobat 2",
      "Swampert 2",
      "Misdreavus 3",
      "Jynx 3",
      "Alakazam 3",
      "Gengar 3",
      "Ampharos 3",
      "Houndoom 3",
      "Gardevoir 3",
      "Starmie 3",
      "Espeon 3",
      "Blaziken 3",
      "Sceptile 3",
      "Crobat 3",
      "Swampert 3",
      "Misdreavus 4",
      "Jynx 4",
      "Alakazam 4",
      "Gengar 4",
      "Ampharos 4",
      "Houndoom 4",
      "Gardevoir 4",
      "Starmie 4",
      "Espeon 4",
      "Blaziken 4",
      "Sceptile 4",
      "Crobat 4",
      "Swampert 4",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Latios 1",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Latios 2",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Latios 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Latios 4",
      "Gengar 5",
      "Gengar 6",
      "Gengar 7",
      "Gengar 8",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "JASPER",
    "trainerClass": "Expert (M)",
    "pokemon": [
      "Dusclops 1",
      "Quagsire 1",
      "Ludicolo 1",
      "Slowbro 1",
      "Slowking 1",
      "Miltank 1",
      "Cradily 1",
      "Wailord 1",
      "Shuckle 1",
      "Exeggutor 1",
      "Umbreon 1",
      "Walrein 1",
      "Lapras 1",
      "Snorlax 1",
      "Blissey 1",
      "Milotic 1",
      "Quagsire 2",
      "Dusclops 2",
      "Ludicolo 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Cradily 2",
      "Wailord 2",
      "Shuckle 2",
      "Exeggutor 2",
      "Umbreon 2",
      "Walrein 2",
      "Lapras 2",
      "Snorlax 2",
      "Blissey 2",
      "Milotic 2",
      "Dusclops 3",
      "Quagsire 3",
      "Ludicolo 3",
      "Slowbro 3",
      "Slowking 3",
      "Miltank 3",
      "Cradily 3",
      "Wailord 3",
      "Shuckle 3",
      "Exeggutor 3",
      "Umbreon 3",
      "Walrein 3",
      "Lapras 3",
      "Snorlax 3",
      "Blissey 3",
      "Milotic 3",
      "Dusclops 4",
      "Quagsire 4",
      "Ludicolo 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Cradily 4",
      "Wailord 4",
      "Shuckle 4",
      "Exeggutor 4",
      "Umbreon 4",
      "Walrein 4",
      "Lapras 4",
      "Snorlax 4",
      "Blissey 4",
      "Milotic 4",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8",
      "Snorlax 5",
      "Snorlax 6",
      "Snorlax 7",
      "Snorlax 8",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "NADIA",
    "trainerClass": "Expert (F)",
    "pokemon": [
      "Breloom 1",
      "Marowak 1",
      "Rhydon 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Machamp 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Aggron 1",
      "Gyarados 1",
      "Kingdra 1",
      "Salamence 1",
      "Metagross 1",
      "Marowak 2",
      "Breloom 2",
      "Rhydon 2",
      "Scizor 2",
      "Heracross 2",
      "Ursaring 2",
      "Machamp 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Aggron 2",
      "Gyarados 2",
      "Kingdra 2",
      "Salamence 2",
      "Metagross 2",
      "Breloom 3",
      "Marowak 3",
      "Rhydon 3",
      "Scizor 3",
      "Heracross 3",
      "Ursaring 3",
      "Machamp 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Aggron 3",
      "Gyarados 3",
      "Kingdra 3",
      "Salamence 3",
      "Metagross 3",
      "Breloom 4",
      "Marowak 4",
      "Rhydon 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Machamp 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Aggron 4",
      "Gyarados 4",
      "Kingdra 4",
      "Salamence 4",
      "Metagross 4",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Ursaring 5",
      "Ursaring 6",
      "Ursaring 7",
      "Ursaring 8",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10"
    ]
  },
  {
    "name": "MIRANDA",
    "trainerClass": "Expert (F)",
    "pokemon": [
      "Misdreavus 1",
      "Jynx 1",
      "Alakazam 1",
      "Gengar 1",
      "Ampharos 1",
      "Houndoom 1",
      "Gardevoir 1",
      "Starmie 1",
      "Espeon 1",
      "Blaziken 1",
      "Sceptile 1",
      "Crobat 1",
      "Swampert 1",
      "Misdreavus 2",
      "Jynx 2",
      "Alakazam 2",
      "Gengar 2",
      "Ampharos 2",
      "Houndoom 2",
      "Gardevoir 2",
      "Starmie 2",
      "Espeon 2",
      "Blaziken 2",
      "Sceptile 2",
      "Crobat 2",
      "Swampert 2",
      "Misdreavus 3",
      "Jynx 3",
      "Alakazam 3",
      "Gengar 3",
      "Ampharos 3",
      "Houndoom 3",
      "Gardevoir 3",
      "Starmie 3",
      "Espeon 3",
      "Blaziken 3",
      "Sceptile 3",
      "Crobat 3",
      "Swampert 3",
      "Misdreavus 4",
      "Jynx 4",
      "Alakazam 4",
      "Gengar 4",
      "Ampharos 4",
      "Houndoom 4",
      "Gardevoir 4",
      "Starmie 4",
      "Espeon 4",
      "Blaziken 4",
      "Sceptile 4",
      "Crobat 4",
      "Swampert 4",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Latias 1",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Latias 2",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Latias 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Latias 4",
      "Gengar 5",
      "Gengar 6",
      "Gengar 7",
      "Gengar 8",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "EMMA",
    "trainerClass": "Expert (F)",
    "pokemon": [
      "Dusclops 1",
      "Quagsire 1",
      "Ludicolo 1",
      "Slowbro 1",
      "Slowking 1",
      "Miltank 1",
      "Cradily 1",
      "Wailord 1",
      "Shuckle 1",
      "Exeggutor 1",
      "Umbreon 1",
      "Walrein 1",
      "Lapras 1",
      "Snorlax 1",
      "Blissey 1",
      "Milotic 1",
      "Quagsire 2",
      "Dusclops 2",
      "Ludicolo 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Cradily 2",
      "Wailord 2",
      "Shuckle 2",
      "Exeggutor 2",
      "Umbreon 2",
      "Walrein 2",
      "Lapras 2",
      "Snorlax 2",
      "Blissey 2",
      "Milotic 2",
      "Dusclops 3",
      "Quagsire 3",
      "Ludicolo 3",
      "Slowbro 3",
      "Slowking 3",
      "Miltank 3",
      "Cradily 3",
      "Wailord 3",
      "Shuckle 3",
      "Exeggutor 3",
      "Umbreon 3",
      "Walrein 3",
      "Lapras 3",
      "Snorlax 3",
      "Blissey 3",
      "Milotic 3",
      "Dusclops 4",
      "Quagsire 4",
      "Ludicolo 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Cradily 4",
      "Wailord 4",
      "Shuckle 4",
      "Exeggutor 4",
      "Umbreon 4",
      "Walrein 4",
      "Lapras 4",
      "Snorlax 4",
      "Blissey 4",
      "Milotic 4",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8",
      "Snorlax 5",
      "Snorlax 6",
      "Snorlax 7",
      "Snorlax 8",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10"
    ]
  },
  {
    "name": "ROLANDO",
    "trainerClass": "Psychic (M)",
    "pokemon": [
      "Wobbuffet 1",
      "Wobbuffet 2",
      "Jynx 1",
      "Mrmime 1",
      "Xatu 1",
      "Hypno 1",
      "Alakazam 1",
      "Slowbro 1",
      "Slowking 1",
      "Claydol 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Espeon 1",
      "Metagross 1",
      "Jynx 2",
      "Mrmime 2",
      "Xatu 2",
      "Hypno 2",
      "Alakazam 2",
      "Slowbro 2",
      "Slowking 2",
      "Claydol 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Espeon 2",
      "Metagross 2",
      "Jynx 3",
      "Mrmime 3",
      "Xatu 3",
      "Hypno 3",
      "Alakazam 3",
      "Slowbro 3",
      "Slowking 3",
      "Claydol 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Espeon 3",
      "Metagross 3",
      "Jynx 4",
      "Mrmime 4",
      "Xatu 4",
      "Hypno 4",
      "Alakazam 4",
      "Slowbro 4",
      "Slowking 4",
      "Claydol 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Espeon 4",
      "Metagross 4",
      "Articuno 1",
      "Zapdos 1",
      "Moltres 1",
      "Latios 1",
      "Articuno 2",
      "Zapdos 2",
      "Moltres 2",
      "Latios 2",
      "Articuno 3",
      "Zapdos 3",
      "Moltres 3",
      "Latios 3",
      "Articuno 4",
      "Zapdos 4",
      "Moltres 4",
      "Latios 4",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8",
      "Articuno 5",
      "Articuno 6",
      "Zapdos 5",
      "Zapdos 6",
      "Moltres 5",
      "Moltres 6"
    ]
  },
  {
    "name": "STANLY",
    "trainerClass": "Psychic (M)",
    "pokemon": [
      "Wobbuffet 1",
      "Wobbuffet 2",
      "Jynx 1",
      "Mrmime 1",
      "Xatu 1",
      "Hypno 1",
      "Alakazam 1",
      "Slowbro 1",
      "Slowking 1",
      "Claydol 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Espeon 1",
      "Metagross 1",
      "Jynx 2",
      "Mrmime 2",
      "Xatu 2",
      "Hypno 2",
      "Alakazam 2",
      "Slowbro 2",
      "Slowking 2",
      "Claydol 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Espeon 2",
      "Metagross 2",
      "Jynx 3",
      "Mrmime 3",
      "Xatu 3",
      "Hypno 3",
      "Alakazam 3",
      "Slowbro 3",
      "Slowking 3",
      "Claydol 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Espeon 3",
      "Metagross 3",
      "Jynx 4",
      "Mrmime 4",
      "Xatu 4",
      "Hypno 4",
      "Alakazam 4",
      "Slowbro 4",
      "Slowking 4",
      "Claydol 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Espeon 4",
      "Metagross 4",
      "Raikou 1",
      "Entei 1",
      "Suicune 1",
      "Latios 1",
      "Raikou 2",
      "Entei 2",
      "Suicune 2",
      "Latios 2",
      "Raikou 3",
      "Entei 3",
      "Suicune 3",
      "Latios 3",
      "Raikou 4",
      "Entei 4",
      "Suicune 4",
      "Latios 4",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8",
      "Raikou 5",
      "Raikou 6",
      "Entei 5",
      "Entei 6",
      "Suicune 5",
      "Suicune 6"
    ]
  },
  {
    "name": "DARIO",
    "trainerClass": "Psychic (M)",
    "pokemon": [
      "Wobbuffet 1",
      "Wobbuffet 2",
      "Jynx 1",
      "Mrmime 1",
      "Xatu 1",
      "Hypno 1",
      "Alakazam 1",
      "Slowbro 1",
      "Slowking 1",
      "Claydol 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Espeon 1",
      "Metagross 1",
      "Jynx 2",
      "Mrmime 2",
      "Xatu 2",
      "Hypno 2",
      "Alakazam 2",
      "Slowbro 2",
      "Slowking 2",
      "Claydol 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Espeon 2",
      "Metagross 2",
      "Jynx 3",
      "Mrmime 3",
      "Xatu 3",
      "Hypno 3",
      "Alakazam 3",
      "Slowbro 3",
      "Slowking 3",
      "Claydol 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Espeon 3",
      "Metagross 3",
      "Jynx 4",
      "Mrmime 4",
      "Xatu 4",
      "Hypno 4",
      "Alakazam 4",
      "Slowbro 4",
      "Slowking 4",
      "Claydol 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Espeon 4",
      "Metagross 4",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Latios 1",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Latios 2",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Latios 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Latios 4",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8"
    ]
  },
  {
    "name": "KARLEE",
    "trainerClass": "Psychic (F)",
    "pokemon": [
      "Wobbuffet 1",
      "Wobbuffet 2",
      "Jynx 1",
      "Mrmime 1",
      "Xatu 1",
      "Hypno 1",
      "Alakazam 1",
      "Slowbro 1",
      "Slowking 1",
      "Claydol 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Espeon 1",
      "Metagross 1",
      "Jynx 2",
      "Mrmime 2",
      "Xatu 2",
      "Hypno 2",
      "Alakazam 2",
      "Slowbro 2",
      "Slowking 2",
      "Claydol 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Espeon 2",
      "Metagross 2",
      "Jynx 3",
      "Mrmime 3",
      "Xatu 3",
      "Hypno 3",
      "Alakazam 3",
      "Slowbro 3",
      "Slowking 3",
      "Claydol 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Espeon 3",
      "Metagross 3",
      "Jynx 4",
      "Mrmime 4",
      "Xatu 4",
      "Hypno 4",
      "Alakazam 4",
      "Slowbro 4",
      "Slowking 4",
      "Claydol 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Espeon 4",
      "Metagross 4",
      "Articuno 1",
      "Zapdos 1",
      "Moltres 1",
      "Latias 1",
      "Articuno 2",
      "Zapdos 2",
      "Moltres 2",
      "Latias 2",
      "Articuno 3",
      "Zapdos 3",
      "Moltres 3",
      "Latias 3",
      "Articuno 4",
      "Zapdos 4",
      "Moltres 4",
      "Latias 4",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8",
      "Articuno 5",
      "Articuno 6",
      "Zapdos 5",
      "Zapdos 6",
      "Moltres 5",
      "Moltres 6"
    ]
  },
  {
    "name": "JAYLIN",
    "trainerClass": "Psychic (F)",
    "pokemon": [
      "Wobbuffet 1",
      "Wobbuffet 2",
      "Jynx 1",
      "Mrmime 1",
      "Xatu 1",
      "Hypno 1",
      "Alakazam 1",
      "Slowbro 1",
      "Slowking 1",
      "Claydol 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Espeon 1",
      "Metagross 1",
      "Jynx 2",
      "Mrmime 2",
      "Xatu 2",
      "Hypno 2",
      "Alakazam 2",
      "Slowbro 2",
      "Slowking 2",
      "Claydol 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Espeon 2",
      "Metagross 2",
      "Jynx 3",
      "Mrmime 3",
      "Xatu 3",
      "Hypno 3",
      "Alakazam 3",
      "Slowbro 3",
      "Slowking 3",
      "Claydol 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Espeon 3",
      "Metagross 3",
      "Jynx 4",
      "Mrmime 4",
      "Xatu 4",
      "Hypno 4",
      "Alakazam 4",
      "Slowbro 4",
      "Slowking 4",
      "Claydol 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Espeon 4",
      "Metagross 4",
      "Raikou 1",
      "Entei 1",
      "Suicune 1",
      "Latias 1",
      "Raikou 2",
      "Entei 2",
      "Suicune 2",
      "Latias 2",
      "Raikou 3",
      "Entei 3",
      "Suicune 3",
      "Latias 3",
      "Raikou 4",
      "Entei 4",
      "Suicune 4",
      "Latias 4",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8",
      "Raikou 5",
      "Raikou 6",
      "Entei 5",
      "Entei 6",
      "Suicune 5",
      "Suicune 6"
    ]
  },
  {
    "name": "INGRID",
    "trainerClass": "Psychic (F)",
    "pokemon": [
      "Wobbuffet 1",
      "Wobbuffet 2",
      "Jynx 1",
      "Mrmime 1",
      "Xatu 1",
      "Hypno 1",
      "Alakazam 1",
      "Slowbro 1",
      "Slowking 1",
      "Claydol 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Espeon 1",
      "Metagross 1",
      "Jynx 2",
      "Mrmime 2",
      "Xatu 2",
      "Hypno 2",
      "Alakazam 2",
      "Slowbro 2",
      "Slowking 2",
      "Claydol 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Espeon 2",
      "Metagross 2",
      "Jynx 3",
      "Mrmime 3",
      "Xatu 3",
      "Hypno 3",
      "Alakazam 3",
      "Slowbro 3",
      "Slowking 3",
      "Claydol 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Espeon 3",
      "Metagross 3",
      "Jynx 4",
      "Mrmime 4",
      "Xatu 4",
      "Hypno 4",
      "Alakazam 4",
      "Slowbro 4",
      "Slowking 4",
      "Claydol 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Espeon 4",
      "Metagross 4",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Latias 1",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Latias 2",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Latias 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Latias 4",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8"
    ]
  },
  {
    "name": "DELILAH",
    "trainerClass": "Hex Maniac",
    "pokemon": [
      "Sharpedo 2",
      "Absol 2",
      "Misdreavus 1",
      "Dusclops 1",
      "Shiftry 1",
      "Gengar 1",
      "Houndoom 1",
      "Umbreon 1",
      "Misdreavus 2",
      "Dusclops 2",
      "Shiftry 2",
      "Gengar 2",
      "Houndoom 2",
      "Umbreon 2",
      "Misdreavus 3",
      "Dusclops 3",
      "Shiftry 3",
      "Gengar 3",
      "Houndoom 3",
      "Umbreon 3",
      "Misdreavus 4",
      "Dusclops 4",
      "Shiftry 4",
      "Gengar 4",
      "Houndoom 4",
      "Umbreon 4",
      "Gengar 5",
      "Gengar 6",
      "Gengar 7",
      "Gengar 8"
    ]
  },
  {
    "name": "CARLY",
    "trainerClass": "Hex Maniac",
    "pokemon": [
      "Seviper 2",
      "Misdreavus 1",
      "Dusclops 1",
      "Vileplume 1",
      "Victreebel 1",
      "Weezing 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Muk 1",
      "Gengar 1",
      "Tentacruel 1",
      "Venusaur 1",
      "Crobat 1",
      "Misdreavus 2",
      "Dusclops 2",
      "Vileplume 2",
      "Victreebel 2",
      "Weezing 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Muk 2",
      "Gengar 2",
      "Tentacruel 2",
      "Venusaur 2",
      "Crobat 2",
      "Misdreavus 3",
      "Dusclops 3",
      "Vileplume 3",
      "Victreebel 3",
      "Weezing 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Muk 3",
      "Gengar 3",
      "Tentacruel 3",
      "Venusaur 3",
      "Crobat 3",
      "Misdreavus 4",
      "Dusclops 4",
      "Vileplume 4",
      "Victreebel 4",
      "Weezing 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Muk 4",
      "Gengar 4",
      "Tentacruel 4",
      "Venusaur 4",
      "Crobat 4",
      "Gengar 5",
      "Gengar 6",
      "Gengar 7",
      "Gengar 8"
    ]
  },
  {
    "name": "LEXIE",
    "trainerClass": "Hex Maniac",
    "pokemon": [
      "Seviper 2",
      "Sharpedo 2",
      "Absol 2",
      "Vileplume 1",
      "Victreebel 1",
      "Shiftry 1",
      "Weezing 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Muk 1",
      "Gengar 1",
      "Houndoom 1",
      "Tentacruel 1",
      "Venusaur 1",
      "Umbreon 1",
      "Crobat 1",
      "Vileplume 2",
      "Victreebel 2",
      "Shiftry 2",
      "Weezing 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Muk 2",
      "Gengar 2",
      "Houndoom 2",
      "Tentacruel 2",
      "Venusaur 2",
      "Umbreon 2",
      "Crobat 2",
      "Vileplume 3",
      "Victreebel 3",
      "Shiftry 3",
      "Weezing 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Muk 3",
      "Gengar 3",
      "Houndoom 3",
      "Tentacruel 3",
      "Venusaur 3",
      "Umbreon 3",
      "Crobat 3",
      "Vileplume 4",
      "Victreebel 4",
      "Shiftry 4",
      "Weezing 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Muk 4",
      "Gengar 4",
      "Houndoom 4",
      "Tentacruel 4",
      "Venusaur 4",
      "Umbreon 4",
      "Crobat 4",
      "Gengar 5",
      "Gengar 6",
      "Gengar 7",
      "Gengar 8"
    ]
  },
  {
    "name": "MILLER",
    "trainerClass": "Pok\u00e9maniac",
    "pokemon": [
      "Zangoose 2",
      "Granbull 1",
      "Skarmory 1",
      "Marowak 1",
      "Exploud 1",
      "Glalie 1",
      "Golem 1",
      "Rhydon 1",
      "Kangaskhan 1",
      "Tauros 1",
      "Miltank 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Ursaring 1",
      "Donphan 1",
      "Wailord 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Venusaur 1",
      "Meganium 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Aggron 1",
      "Walrein 1",
      "Charizard 1",
      "Lapras 1",
      "Swampert 1",
      "Gyarados 1",
      "Snorlax 1",
      "Blissey 1",
      "Salamence 1",
      "Metagross 1",
      "Slaking 1",
      "Marowak 2",
      "Granbull 2",
      "Skarmory 2",
      "Exploud 2",
      "Glalie 2",
      "Golem 2",
      "Rhydon 2",
      "Kangaskhan 2",
      "Tauros 2",
      "Miltank 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Ursaring 2",
      "Donphan 2",
      "Wailord 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Flygon 2",
      "Venusaur 2",
      "Meganium 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Aggron 2",
      "Walrein 2",
      "Charizard 2",
      "Lapras 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Blissey 2",
      "Salamence 2",
      "Metagross 2",
      "Slaking 2",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "MARV",
    "trainerClass": "Pok\u00e9maniac",
    "pokemon": [
      "Zangoose 2",
      "Granbull 3",
      "Skarmory 3",
      "Marowak 3",
      "Exploud 3",
      "Glalie 3",
      "Golem 3",
      "Rhydon 3",
      "Kangaskhan 3",
      "Tauros 3",
      "Miltank 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Ursaring 3",
      "Donphan 3",
      "Wailord 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Flygon 3",
      "Venusaur 3",
      "Meganium 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Aggron 3",
      "Walrein 3",
      "Charizard 3",
      "Lapras 3",
      "Swampert 3",
      "Gyarados 3",
      "Snorlax 3",
      "Blissey 3",
      "Salamence 3",
      "Metagross 3",
      "Slaking 3",
      "Granbull 4",
      "Skarmory 4",
      "Marowak 4",
      "Exploud 4",
      "Glalie 4",
      "Golem 4",
      "Rhydon 4",
      "Kangaskhan 4",
      "Tauros 4",
      "Miltank 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Ursaring 4",
      "Donphan 4",
      "Wailord 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Flygon 4",
      "Venusaur 4",
      "Meganium 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Aggron 4",
      "Walrein 4",
      "Charizard 4",
      "Lapras 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Blissey 4",
      "Salamence 4",
      "Metagross 4",
      "Slaking 4",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "LAYTON",
    "trainerClass": "Pok\u00e9maniac",
    "pokemon": [
      "Zangoose 2",
      "Ursaring 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Meganium 1",
      "Aggron 1",
      "Charizard 1",
      "Lapras 1",
      "Swampert 1",
      "Gyarados 1",
      "Snorlax 1",
      "Salamence 1",
      "Metagross 1",
      "Ursaring 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Meganium 2",
      "Aggron 2",
      "Charizard 2",
      "Lapras 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Salamence 2",
      "Metagross 2",
      "Ursaring 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Meganium 3",
      "Aggron 3",
      "Charizard 3",
      "Lapras 3",
      "Swampert 3",
      "Gyarados 3",
      "Snorlax 3",
      "Salamence 3",
      "Metagross 3",
      "Ursaring 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Meganium 4",
      "Aggron 4",
      "Charizard 4",
      "Lapras 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Salamence 4",
      "Metagross 4",
      "Ursaring 5",
      "Ursaring 6",
      "Ursaring 7",
      "Ursaring 8",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8",
      "Snorlax 5",
      "Snorlax 6",
      "Snorlax 7",
      "Snorlax 8",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "BROOKS",
    "trainerClass": "Gentleman",
    "pokemon": [
      "Dugtrio 4",
      "Medicham 4",
      "Misdreavus 4",
      "Fearow 4",
      "Granbull 4",
      "Jynx 4",
      "Dusclops 4",
      "Dodrio 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Forretress 4",
      "Whiscash 4",
      "Xatu 4",
      "Skarmory 4",
      "Marowak 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Raichu 4",
      "Dewgong 4",
      "Manectric 4",
      "Vileplume 4",
      "Victreebel 4",
      "Electrode 4",
      "Exploud 4",
      "Shiftry 4",
      "Glalie 4",
      "Ludicolo 4",
      "Hypno 4",
      "Golem 4",
      "Rhydon 4",
      "Alakazam 4",
      "Weezing 4",
      "Kangaskhan 4",
      "Electabuzz 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Magmar 4",
      "Cradily 4",
      "Armaldo 4",
      "Golduck 4",
      "Rapidash 4",
      "Muk 4",
      "Gengar 4",
      "Ampharos 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Houndoom 4",
      "Donphan 4",
      "Claydol 4",
      "Wailord 4",
      "Ninetales 4",
      "Machamp 4",
      "Shuckle 4",
      "Steelix 4",
      "Tentacruel 4",
      "Aerodactyl 4",
      "Porygon2 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Flygon 4",
      "Venusaur 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Meganium 4",
      "Espeon 4",
      "Umbreon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Aggron 4",
      "Blaziken 4",
      "Walrein 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Lapras 4",
      "Crobat 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Arcanine 4",
      "Salamence 4",
      "Metagross 4",
      "Slaking 4"
    ]
  },
  {
    "name": "GREGORY",
    "trainerClass": "Gentleman",
    "pokemon": [
      "Gengar 1",
      "Ursaring 1",
      "Machamp 1",
      "Gardevoir 1",
      "Starmie 1",
      "Lapras 1",
      "Snorlax 1",
      "Salamence 1",
      "Metagross 1",
      "Gengar 2",
      "Ursaring 2",
      "Machamp 2",
      "Gardevoir 2",
      "Starmie 2",
      "Lapras 2",
      "Snorlax 2",
      "Salamence 2",
      "Metagross 2",
      "Gengar 3",
      "Ursaring 3",
      "Machamp 3",
      "Gardevoir 3",
      "Starmie 3",
      "Lapras 3",
      "Snorlax 3",
      "Salamence 3",
      "Metagross 3",
      "Gengar 4",
      "Ursaring 4",
      "Machamp 4",
      "Gardevoir 4",
      "Starmie 4",
      "Lapras 4",
      "Snorlax 4",
      "Salamence 4",
      "Metagross 4",
      "Latias 1",
      "Latios 1",
      "Latias 2",
      "Latios 2",
      "Latias 3",
      "Latios 3",
      "Latias 4",
      "Latios 4",
      "Gengar 5",
      "Gengar 6",
      "Gengar 7",
      "Gengar 8",
      "Ursaring 5",
      "Ursaring 6",
      "Ursaring 7",
      "Ursaring 8",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8",
      "Snorlax 5",
      "Snorlax 6",
      "Snorlax 7",
      "Snorlax 8",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "REESE",
    "trainerClass": "Gentleman",
    "pokemon": [
      "Articuno 1",
      "Zapdos 1",
      "Moltres 1",
      "Raikou 1",
      "Entei 1",
      "Suicune 1",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Latias 1",
      "Latios 1",
      "Articuno 2",
      "Zapdos 2",
      "Moltres 2",
      "Raikou 2",
      "Entei 2",
      "Suicune 2",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Latias 2",
      "Latios 2",
      "Articuno 3",
      "Zapdos 3",
      "Moltres 3",
      "Raikou 3",
      "Entei 3",
      "Suicune 3",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Latias 3",
      "Latios 3",
      "Articuno 4",
      "Zapdos 4",
      "Moltres 4",
      "Raikou 4",
      "Entei 4",
      "Suicune 4",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Latias 4",
      "Latios 4",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6",
      "Latias 5",
      "Latias 6",
      "Latias 7",
      "Latias 8",
      "Latios 5",
      "Latios 6",
      "Latios 7",
      "Latios 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10",
      "Articuno 5",
      "Articuno 6",
      "Zapdos 5",
      "Zapdos 6",
      "Moltres 5",
      "Moltres 6",
      "Raikou 5",
      "Raikou 6",
      "Entei 5",
      "Entei 6",
      "Suicune 5",
      "Suicune 6"
    ]
  },
  {
    "name": "MASON",
    "trainerClass": "Triathlete (M runner)",
    "pokemon": [
      "Dugtrio 4",
      "Medicham 4",
      "Misdreavus 4",
      "Fearow 4",
      "Granbull 4",
      "Jynx 4",
      "Dusclops 4",
      "Dodrio 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Forretress 4",
      "Whiscash 4",
      "Xatu 4",
      "Skarmory 4",
      "Marowak 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Raichu 4",
      "Dewgong 4",
      "Manectric 4",
      "Vileplume 4",
      "Victreebel 4",
      "Electrode 4",
      "Exploud 4",
      "Shiftry 4",
      "Glalie 4",
      "Ludicolo 4",
      "Hypno 4",
      "Golem 4",
      "Rhydon 4",
      "Alakazam 4",
      "Weezing 4",
      "Kangaskhan 4",
      "Electabuzz 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Magmar 4",
      "Cradily 4",
      "Armaldo 4",
      "Golduck 4",
      "Rapidash 4",
      "Muk 4",
      "Gengar 4",
      "Ampharos 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Houndoom 4",
      "Donphan 4",
      "Claydol 4",
      "Wailord 4",
      "Ninetales 4",
      "Machamp 4",
      "Shuckle 4",
      "Steelix 4",
      "Tentacruel 4",
      "Aerodactyl 4",
      "Porygon2 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Flygon 4",
      "Venusaur 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Meganium 4",
      "Espeon 4",
      "Umbreon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Aggron 4",
      "Blaziken 4",
      "Walrein 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Lapras 4",
      "Crobat 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Arcanine 4",
      "Salamence 4",
      "Metagross 4",
      "Slaking 4"
    ]
  },
  {
    "name": "TOBY",
    "trainerClass": "Triathlete (M runner)",
    "pokemon": [
      "Dugtrio 3",
      "Medicham 3",
      "Misdreavus 3",
      "Fearow 3",
      "Granbull 3",
      "Jynx 3",
      "Dusclops 3",
      "Dodrio 3",
      "Mrmime 3",
      "Lanturn 3",
      "Breloom 3",
      "Forretress 3",
      "Whiscash 3",
      "Xatu 3",
      "Skarmory 3",
      "Marowak 3",
      "Quagsire 3",
      "Clefable 3",
      "Hariyama 3",
      "Raichu 3",
      "Dewgong 3",
      "Manectric 3",
      "Vileplume 3",
      "Victreebel 3",
      "Electrode 3",
      "Exploud 3",
      "Shiftry 3",
      "Glalie 3",
      "Ludicolo 3",
      "Hypno 3",
      "Golem 3",
      "Rhydon 3",
      "Alakazam 3",
      "Weezing 3",
      "Kangaskhan 3",
      "Electabuzz 3",
      "Tauros 3",
      "Slowbro 3",
      "Slowking 3",
      "Miltank 3",
      "Altaria 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Magmar 3",
      "Cradily 3",
      "Armaldo 3",
      "Golduck 3",
      "Rapidash 3",
      "Muk 3",
      "Gengar 3",
      "Ampharos 3",
      "Scizor 3",
      "Heracross 3",
      "Ursaring 3",
      "Houndoom 3",
      "Donphan 3",
      "Claydol 3",
      "Wailord 3",
      "Ninetales 3",
      "Machamp 3",
      "Shuckle 3",
      "Steelix 3",
      "Tentacruel 3",
      "Aerodactyl 3",
      "Porygon2 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Flygon 3",
      "Venusaur 3",
      "Vaporeon 3",
      "Jolteon 3",
      "Flareon 3",
      "Meganium 3",
      "Espeon 3",
      "Umbreon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Aggron 3",
      "Blaziken 3",
      "Walrein 3",
      "Sceptile 3",
      "Charizard 3",
      "Typhlosion 3",
      "Lapras 3",
      "Crobat 3",
      "Swampert 3",
      "Gyarados 3",
      "Snorlax 3",
      "Kingdra 3",
      "Blissey 3",
      "Milotic 3",
      "Arcanine 3",
      "Salamence 3",
      "Metagross 3",
      "Slaking 3"
    ]
  },
  {
    "name": "DOROTHY",
    "trainerClass": "Triathlete (F runner)",
    "pokemon": [
      "Dugtrio 2",
      "Medicham 2",
      "Marowak 2",
      "Quagsire 2",
      "Misdreavus 2",
      "Fearow 2",
      "Granbull 2",
      "Jynx 2",
      "Dusclops 2",
      "Dodrio 2",
      "Mrmime 2",
      "Lanturn 2",
      "Breloom 2",
      "Forretress 2",
      "Skarmory 2",
      "Whiscash 2",
      "Xatu 2",
      "Clefable 2",
      "Hariyama 2",
      "Raichu 2",
      "Dewgong 2",
      "Manectric 2",
      "Vileplume 2",
      "Victreebel 2",
      "Electrode 2",
      "Exploud 2",
      "Shiftry 2",
      "Glalie 2",
      "Ludicolo 2",
      "Hypno 2",
      "Golem 2",
      "Rhydon 2",
      "Alakazam 2",
      "Weezing 2",
      "Kangaskhan 2",
      "Electabuzz 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Magmar 2",
      "Cradily 2",
      "Armaldo 2",
      "Golduck 2",
      "Rapidash 2",
      "Muk 2",
      "Gengar 2",
      "Ampharos 2",
      "Scizor 2",
      "Heracross 2",
      "Ursaring 2",
      "Houndoom 2",
      "Donphan 2",
      "Claydol 2",
      "Wailord 2",
      "Ninetales 2",
      "Machamp 2",
      "Shuckle 2",
      "Steelix 2",
      "Tentacruel 2",
      "Aerodactyl 2",
      "Porygon2 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Flygon 2",
      "Venusaur 2",
      "Vaporeon 2",
      "Jolteon 2",
      "Flareon 2",
      "Meganium 2",
      "Espeon 2",
      "Umbreon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Aggron 2",
      "Blaziken 2",
      "Walrein 2",
      "Sceptile 2",
      "Charizard 2",
      "Typhlosion 2",
      "Lapras 2",
      "Crobat 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Arcanine 2",
      "Salamence 2",
      "Metagross 2",
      "Slaking 2"
    ]
  },
  {
    "name": "PIPER",
    "trainerClass": "Triathlete (F runner)",
    "pokemon": [
      "Dugtrio 1",
      "Medicham 1",
      "Misdreavus 1",
      "Fearow 1",
      "Granbull 1",
      "Jynx 1",
      "Dusclops 1",
      "Dodrio 1",
      "Mrmime 1",
      "Lanturn 1",
      "Breloom 1",
      "Forretress 1",
      "Whiscash 1",
      "Xatu 1",
      "Skarmory 1",
      "Marowak 1",
      "Quagsire 1",
      "Clefable 1",
      "Hariyama 1",
      "Raichu 1",
      "Dewgong 1",
      "Manectric 1",
      "Vileplume 1",
      "Victreebel 1",
      "Electrode 1",
      "Exploud 1",
      "Shiftry 1",
      "Glalie 1",
      "Ludicolo 1",
      "Hypno 1",
      "Golem 1",
      "Rhydon 1",
      "Alakazam 1",
      "Weezing 1",
      "Kangaskhan 1",
      "Electabuzz 1",
      "Tauros 1",
      "Slowbro 1",
      "Slowking 1",
      "Miltank 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Magmar 1",
      "Cradily 1",
      "Armaldo 1",
      "Golduck 1",
      "Rapidash 1",
      "Muk 1",
      "Gengar 1",
      "Ampharos 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Houndoom 1",
      "Donphan 1",
      "Claydol 1",
      "Wailord 1",
      "Ninetales 1",
      "Machamp 1",
      "Shuckle 1",
      "Steelix 1",
      "Tentacruel 1",
      "Aerodactyl 1",
      "Porygon2 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Flygon 1",
      "Venusaur 1",
      "Vaporeon 1",
      "Jolteon 1",
      "Flareon 1",
      "Meganium 1",
      "Espeon 1",
      "Umbreon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Aggron 1",
      "Blaziken 1",
      "Walrein 1",
      "Sceptile 1",
      "Charizard 1",
      "Typhlosion 1",
      "Lapras 1",
      "Crobat 1",
      "Swampert 1",
      "Gyarados 1",
      "Snorlax 1",
      "Kingdra 1",
      "Blissey 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1",
      "Metagross 1",
      "Slaking 1"
    ]
  },
  {
    "name": "FINN",
    "trainerClass": "Triathlete (M swimmer)",
    "pokemon": [
      "Sneasel 2",
      "Cloyster 2",
      "Medicham 1",
      "Jynx 1",
      "Hariyama 1",
      "Dewgong 1",
      "Glalie 1",
      "Machamp 1",
      "Walrein 1",
      "Lapras 1",
      "Medicham 2",
      "Jynx 2",
      "Hariyama 2",
      "Dewgong 2",
      "Glalie 2",
      "Machamp 2",
      "Walrein 2",
      "Lapras 2",
      "Medicham 3",
      "Jynx 3",
      "Lanturn 3",
      "Whiscash 3",
      "Quagsire 3",
      "Hariyama 3",
      "Dewgong 3",
      "Glalie 3",
      "Ludicolo 3",
      "Slowbro 3",
      "Slowking 3",
      "Golduck 3",
      "Wailord 3",
      "Machamp 3",
      "Tentacruel 3",
      "Starmie 3",
      "Vaporeon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Walrein 3",
      "Lapras 3",
      "Swampert 3",
      "Gyarados 3",
      "Kingdra 3",
      "Milotic 3",
      "Medicham 4",
      "Jynx 4",
      "Lanturn 4",
      "Whiscash 4",
      "Quagsire 4",
      "Hariyama 4",
      "Dewgong 4",
      "Glalie 4",
      "Ludicolo 4",
      "Slowbro 4",
      "Slowking 4",
      "Golduck 4",
      "Wailord 4",
      "Machamp 4",
      "Tentacruel 4",
      "Starmie 4",
      "Vaporeon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Walrein 4",
      "Lapras 4",
      "Swampert 4",
      "Gyarados 4",
      "Kingdra 4",
      "Milotic 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8"
    ]
  },
  {
    "name": "SAMIR",
    "trainerClass": "Triathlete (M swimmer)",
    "pokemon": [
      "Sneasel 2",
      "Cloyster 2",
      "Medicham 1",
      "Jynx 1",
      "Hariyama 1",
      "Dewgong 1",
      "Glalie 1",
      "Machamp 1",
      "Walrein 1",
      "Lapras 1",
      "Medicham 2",
      "Jynx 2",
      "Hariyama 2",
      "Dewgong 2",
      "Glalie 2",
      "Machamp 2",
      "Walrein 2",
      "Lapras 2",
      "Medicham 3",
      "Jynx 3",
      "Lanturn 3",
      "Whiscash 3",
      "Quagsire 3",
      "Hariyama 3",
      "Dewgong 3",
      "Glalie 3",
      "Ludicolo 3",
      "Slowbro 3",
      "Slowking 3",
      "Golduck 3",
      "Wailord 3",
      "Machamp 3",
      "Tentacruel 3",
      "Starmie 3",
      "Vaporeon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Walrein 3",
      "Lapras 3",
      "Swampert 3",
      "Gyarados 3",
      "Kingdra 3",
      "Milotic 3",
      "Medicham 4",
      "Jynx 4",
      "Lanturn 4",
      "Whiscash 4",
      "Quagsire 4",
      "Hariyama 4",
      "Dewgong 4",
      "Glalie 4",
      "Ludicolo 4",
      "Slowbro 4",
      "Slowking 4",
      "Golduck 4",
      "Wailord 4",
      "Machamp 4",
      "Tentacruel 4",
      "Starmie 4",
      "Vaporeon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Walrein 4",
      "Lapras 4",
      "Swampert 4",
      "Gyarados 4",
      "Kingdra 4",
      "Milotic 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8"
    ]
  },
  {
    "name": "FIONA",
    "trainerClass": "Triathlete (F swimmer)",
    "pokemon": [
      "Sneasel 2",
      "Cloyster 2",
      "Medicham 1",
      "Jynx 1",
      "Lanturn 1",
      "Whiscash 1",
      "Quagsire 1",
      "Hariyama 1",
      "Dewgong 1",
      "Glalie 1",
      "Ludicolo 1",
      "Slowbro 1",
      "Slowking 1",
      "Golduck 1",
      "Wailord 1",
      "Machamp 1",
      "Tentacruel 1",
      "Starmie 1",
      "Vaporeon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Walrein 1",
      "Lapras 1",
      "Swampert 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Medicham 2",
      "Quagsire 2",
      "Jynx 2",
      "Lanturn 2",
      "Whiscash 2",
      "Hariyama 2",
      "Dewgong 2",
      "Glalie 2",
      "Ludicolo 2",
      "Slowbro 2",
      "Slowking 2",
      "Golduck 2",
      "Wailord 2",
      "Machamp 2",
      "Tentacruel 2",
      "Starmie 2",
      "Vaporeon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Walrein 2",
      "Lapras 2",
      "Swampert 2",
      "Gyarados 2",
      "Kingdra 2",
      "Milotic 2",
      "Medicham 3",
      "Jynx 3",
      "Hariyama 3",
      "Dewgong 3",
      "Glalie 3",
      "Machamp 3",
      "Walrein 3",
      "Lapras 3",
      "Medicham 4",
      "Jynx 4",
      "Hariyama 4",
      "Dewgong 4",
      "Glalie 4",
      "Machamp 4",
      "Walrein 4",
      "Lapras 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8"
    ]
  },
  {
    "name": "GLORIA",
    "trainerClass": "Triathlete (F swimmer)",
    "pokemon": [
      "Sneasel 2",
      "Cloyster 2",
      "Medicham 1",
      "Jynx 1",
      "Lanturn 1",
      "Whiscash 1",
      "Quagsire 1",
      "Hariyama 1",
      "Dewgong 1",
      "Glalie 1",
      "Ludicolo 1",
      "Slowbro 1",
      "Slowking 1",
      "Golduck 1",
      "Wailord 1",
      "Machamp 1",
      "Tentacruel 1",
      "Starmie 1",
      "Vaporeon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Walrein 1",
      "Lapras 1",
      "Swampert 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Medicham 2",
      "Quagsire 2",
      "Jynx 2",
      "Lanturn 2",
      "Whiscash 2",
      "Hariyama 2",
      "Dewgong 2",
      "Glalie 2",
      "Ludicolo 2",
      "Slowbro 2",
      "Slowking 2",
      "Golduck 2",
      "Wailord 2",
      "Machamp 2",
      "Tentacruel 2",
      "Starmie 2",
      "Vaporeon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Walrein 2",
      "Lapras 2",
      "Swampert 2",
      "Gyarados 2",
      "Kingdra 2",
      "Milotic 2",
      "Medicham 3",
      "Jynx 3",
      "Hariyama 3",
      "Dewgong 3",
      "Glalie 3",
      "Machamp 3",
      "Walrein 3",
      "Lapras 3",
      "Medicham 4",
      "Jynx 4",
      "Hariyama 4",
      "Dewgong 4",
      "Glalie 4",
      "Machamp 4",
      "Walrein 4",
      "Lapras 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8"
    ]
  },
  {
    "name": "NICO",
    "trainerClass": "Triathlete (M biker)",
    "pokemon": [
      "Dugtrio 4",
      "Medicham 4",
      "Misdreavus 4",
      "Fearow 4",
      "Granbull 4",
      "Jynx 4",
      "Dusclops 4",
      "Dodrio 4",
      "Mrmime 4",
      "Lanturn 4",
      "Breloom 4",
      "Forretress 4",
      "Whiscash 4",
      "Xatu 4",
      "Skarmory 4",
      "Marowak 4",
      "Quagsire 4",
      "Clefable 4",
      "Hariyama 4",
      "Raichu 4",
      "Dewgong 4",
      "Manectric 4",
      "Vileplume 4",
      "Victreebel 4",
      "Electrode 4",
      "Exploud 4",
      "Shiftry 4",
      "Glalie 4",
      "Ludicolo 4",
      "Hypno 4",
      "Golem 4",
      "Rhydon 4",
      "Alakazam 4",
      "Weezing 4",
      "Kangaskhan 4",
      "Electabuzz 4",
      "Tauros 4",
      "Slowbro 4",
      "Slowking 4",
      "Miltank 4",
      "Altaria 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Magmar 4",
      "Cradily 4",
      "Armaldo 4",
      "Golduck 4",
      "Rapidash 4",
      "Muk 4",
      "Gengar 4",
      "Ampharos 4",
      "Scizor 4",
      "Heracross 4",
      "Ursaring 4",
      "Houndoom 4",
      "Donphan 4",
      "Claydol 4",
      "Wailord 4",
      "Ninetales 4",
      "Machamp 4",
      "Shuckle 4",
      "Steelix 4",
      "Tentacruel 4",
      "Aerodactyl 4",
      "Porygon2 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Flygon 4",
      "Venusaur 4",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Meganium 4",
      "Espeon 4",
      "Umbreon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Aggron 4",
      "Blaziken 4",
      "Walrein 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Lapras 4",
      "Crobat 4",
      "Swampert 4",
      "Gyarados 4",
      "Snorlax 4",
      "Kingdra 4",
      "Blissey 4",
      "Milotic 4",
      "Arcanine 4",
      "Salamence 4",
      "Metagross 4",
      "Slaking 4"
    ]
  },
  {
    "name": "JEREMY",
    "trainerClass": "Triathlete (M biker)",
    "pokemon": [
      "Dugtrio 3",
      "Medicham 3",
      "Misdreavus 3",
      "Fearow 3",
      "Granbull 3",
      "Jynx 3",
      "Dusclops 3",
      "Dodrio 3",
      "Mrmime 3",
      "Lanturn 3",
      "Breloom 3",
      "Forretress 3",
      "Whiscash 3",
      "Xatu 3",
      "Skarmory 3",
      "Marowak 3",
      "Quagsire 3",
      "Clefable 3",
      "Hariyama 3",
      "Raichu 3",
      "Dewgong 3",
      "Manectric 3",
      "Vileplume 3",
      "Victreebel 3",
      "Electrode 3",
      "Exploud 3",
      "Shiftry 3",
      "Glalie 3",
      "Ludicolo 3",
      "Hypno 3",
      "Golem 3",
      "Rhydon 3",
      "Alakazam 3",
      "Weezing 3",
      "Kangaskhan 3",
      "Electabuzz 3",
      "Tauros 3",
      "Slowbro 3",
      "Slowking 3",
      "Miltank 3",
      "Altaria 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Magmar 3",
      "Cradily 3",
      "Armaldo 3",
      "Golduck 3",
      "Rapidash 3",
      "Muk 3",
      "Gengar 3",
      "Ampharos 3",
      "Scizor 3",
      "Heracross 3",
      "Ursaring 3",
      "Houndoom 3",
      "Donphan 3",
      "Claydol 3",
      "Wailord 3",
      "Ninetales 3",
      "Machamp 3",
      "Shuckle 3",
      "Steelix 3",
      "Tentacruel 3",
      "Aerodactyl 3",
      "Porygon2 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Flygon 3",
      "Venusaur 3",
      "Vaporeon 3",
      "Jolteon 3",
      "Flareon 3",
      "Meganium 3",
      "Espeon 3",
      "Umbreon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Aggron 3",
      "Blaziken 3",
      "Walrein 3",
      "Sceptile 3",
      "Charizard 3",
      "Typhlosion 3",
      "Lapras 3",
      "Crobat 3",
      "Swampert 3",
      "Gyarados 3",
      "Snorlax 3",
      "Kingdra 3",
      "Blissey 3",
      "Milotic 3",
      "Arcanine 3",
      "Salamence 3",
      "Metagross 3",
      "Slaking 3"
    ]
  },
  {
    "name": "CAITLIN",
    "trainerClass": "Triathlete (F biker)",
    "pokemon": [
      "Dugtrio 2",
      "Medicham 2",
      "Marowak 2",
      "Quagsire 2",
      "Misdreavus 2",
      "Fearow 2",
      "Granbull 2",
      "Jynx 2",
      "Dusclops 2",
      "Dodrio 2",
      "Mrmime 2",
      "Lanturn 2",
      "Breloom 2",
      "Forretress 2",
      "Skarmory 2",
      "Whiscash 2",
      "Xatu 2",
      "Clefable 2",
      "Hariyama 2",
      "Raichu 2",
      "Dewgong 2",
      "Manectric 2",
      "Vileplume 2",
      "Victreebel 2",
      "Electrode 2",
      "Exploud 2",
      "Shiftry 2",
      "Glalie 2",
      "Ludicolo 2",
      "Hypno 2",
      "Golem 2",
      "Rhydon 2",
      "Alakazam 2",
      "Weezing 2",
      "Kangaskhan 2",
      "Electabuzz 2",
      "Tauros 2",
      "Slowbro 2",
      "Slowking 2",
      "Miltank 2",
      "Altaria 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Magmar 2",
      "Cradily 2",
      "Armaldo 2",
      "Golduck 2",
      "Rapidash 2",
      "Muk 2",
      "Gengar 2",
      "Ampharos 2",
      "Scizor 2",
      "Heracross 2",
      "Ursaring 2",
      "Houndoom 2",
      "Donphan 2",
      "Claydol 2",
      "Wailord 2",
      "Ninetales 2",
      "Machamp 2",
      "Shuckle 2",
      "Steelix 2",
      "Tentacruel 2",
      "Aerodactyl 2",
      "Porygon2 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Flygon 2",
      "Venusaur 2",
      "Vaporeon 2",
      "Jolteon 2",
      "Flareon 2",
      "Meganium 2",
      "Espeon 2",
      "Umbreon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Aggron 2",
      "Blaziken 2",
      "Walrein 2",
      "Sceptile 2",
      "Charizard 2",
      "Typhlosion 2",
      "Lapras 2",
      "Crobat 2",
      "Swampert 2",
      "Gyarados 2",
      "Snorlax 2",
      "Kingdra 2",
      "Blissey 2",
      "Milotic 2",
      "Arcanine 2",
      "Salamence 2",
      "Metagross 2",
      "Slaking 2"
    ]
  },
  {
    "name": "REENA",
    "trainerClass": "Triathlete (F biker)",
    "pokemon": [
      "Dugtrio 1",
      "Medicham 1",
      "Misdreavus 1",
      "Fearow 1",
      "Granbull 1",
      "Jynx 1",
      "Dusclops 1",
      "Dodrio 1",
      "Mrmime 1",
      "Lanturn 1",
      "Breloom 1",
      "Forretress 1",
      "Whiscash 1",
      "Xatu 1",
      "Skarmory 1",
      "Marowak 1",
      "Quagsire 1",
      "Clefable 1",
      "Hariyama 1",
      "Raichu 1",
      "Dewgong 1",
      "Manectric 1",
      "Vileplume 1",
      "Victreebel 1",
      "Electrode 1",
      "Exploud 1",
      "Shiftry 1",
      "Glalie 1",
      "Ludicolo 1",
      "Hypno 1",
      "Golem 1",
      "Rhydon 1",
      "Alakazam 1",
      "Weezing 1",
      "Kangaskhan 1",
      "Electabuzz 1",
      "Tauros 1",
      "Slowbro 1",
      "Slowking 1",
      "Miltank 1",
      "Altaria 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Magmar 1",
      "Cradily 1",
      "Armaldo 1",
      "Golduck 1",
      "Rapidash 1",
      "Muk 1",
      "Gengar 1",
      "Ampharos 1",
      "Scizor 1",
      "Heracross 1",
      "Ursaring 1",
      "Houndoom 1",
      "Donphan 1",
      "Claydol 1",
      "Wailord 1",
      "Ninetales 1",
      "Machamp 1",
      "Shuckle 1",
      "Steelix 1",
      "Tentacruel 1",
      "Aerodactyl 1",
      "Porygon2 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Flygon 1",
      "Venusaur 1",
      "Vaporeon 1",
      "Jolteon 1",
      "Flareon 1",
      "Meganium 1",
      "Espeon 1",
      "Umbreon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Aggron 1",
      "Blaziken 1",
      "Walrein 1",
      "Sceptile 1",
      "Charizard 1",
      "Typhlosion 1",
      "Lapras 1",
      "Crobat 1",
      "Swampert 1",
      "Gyarados 1",
      "Snorlax 1",
      "Kingdra 1",
      "Blissey 1",
      "Milotic 1",
      "Arcanine 1",
      "Salamence 1",
      "Metagross 1",
      "Slaking 1"
    ]
  },
  {
    "name": "AVERY",
    "trainerClass": "Bug Maniac",
    "pokemon": [
      "Shedinja 1",
      "Ninjask 1",
      "Parasect 2",
      "Masquerain 2",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Forretress 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Shuckle 1",
      "Forretress 2",
      "Armaldo 2",
      "Scizor 2",
      "Heracross 2",
      "Shuckle 2",
      "Forretress 3",
      "Armaldo 3",
      "Scizor 3",
      "Heracross 3",
      "Shuckle 3",
      "Forretress 4",
      "Armaldo 4",
      "Scizor 4",
      "Heracross 4",
      "Shuckle 4"
    ]
  },
  {
    "name": "LIAM",
    "trainerClass": "Bug Maniac",
    "pokemon": [
      "Shedinja 1",
      "Ninjask 1",
      "Parasect 2",
      "Masquerain 2",
      "Venomoth 2",
      "Ninjask 2",
      "Scyther 2",
      "Pinsir 2",
      "Forretress 1",
      "Armaldo 1",
      "Scizor 1",
      "Heracross 1",
      "Shuckle 1",
      "Forretress 2",
      "Armaldo 2",
      "Scizor 2",
      "Heracross 2",
      "Shuckle 2",
      "Forretress 3",
      "Armaldo 3",
      "Scizor 3",
      "Heracross 3",
      "Shuckle 3",
      "Forretress 4",
      "Armaldo 4",
      "Scizor 4",
      "Heracross 4",
      "Shuckle 4"
    ]
  },
  {
    "name": "THEO",
    "trainerClass": "Fisherman",
    "pokemon": [
      "Seaking 2",
      "Sharpedo 2",
      "Mantine 2",
      "Crawdaunt 2",
      "Kingler 2",
      "Octillery 2",
      "Huntail 2",
      "Gorebyss 2",
      "Relicanth 2",
      "Cloyster 2",
      "Lanturn 1",
      "Whiscash 1",
      "Wailord 1",
      "Tentacruel 1",
      "Starmie 1",
      "Lanturn 2",
      "Whiscash 2",
      "Wailord 2",
      "Tentacruel 2",
      "Starmie 2",
      "Lanturn 3",
      "Whiscash 3",
      "Wailord 3",
      "Tentacruel 3",
      "Starmie 3",
      "Lanturn 4",
      "Whiscash 4",
      "Wailord 4",
      "Tentacruel 4",
      "Starmie 4",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8"
    ]
  },
  {
    "name": "BAILEY",
    "trainerClass": "Fisherman",
    "pokemon": [
      "Seaking 2",
      "Sharpedo 2",
      "Mantine 2",
      "Crawdaunt 2",
      "Kingler 2",
      "Octillery 2",
      "Huntail 2",
      "Gorebyss 2",
      "Relicanth 2",
      "Cloyster 2",
      "Lanturn 1",
      "Whiscash 1",
      "Wailord 1",
      "Tentacruel 1",
      "Starmie 1",
      "Lanturn 2",
      "Whiscash 2",
      "Wailord 2",
      "Tentacruel 2",
      "Starmie 2",
      "Lanturn 3",
      "Whiscash 3",
      "Wailord 3",
      "Tentacruel 3",
      "Starmie 3",
      "Lanturn 4",
      "Whiscash 4",
      "Wailord 4",
      "Tentacruel 4",
      "Starmie 4",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8"
    ]
  },
  {
    "name": "HUGO",
    "trainerClass": "Ruin Maniac",
    "pokemon": [
      "Forretress 1",
      "Skarmory 1",
      "Golem 1",
      "Rhydon 1",
      "Cradily 1",
      "Armaldo 1",
      "Scizor 1",
      "Shuckle 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Aggron 1",
      "Metagross 1",
      "Forretress 2",
      "Skarmory 2",
      "Golem 2",
      "Rhydon 2",
      "Cradily 2",
      "Armaldo 2",
      "Scizor 2",
      "Shuckle 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Aggron 2",
      "Metagross 2",
      "Forretress 3",
      "Skarmory 3",
      "Golem 3",
      "Rhydon 3",
      "Cradily 3",
      "Armaldo 3",
      "Scizor 3",
      "Shuckle 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Aggron 3",
      "Metagross 3",
      "Forretress 4",
      "Skarmory 4",
      "Golem 4",
      "Rhydon 4",
      "Cradily 4",
      "Armaldo 4",
      "Scizor 4",
      "Shuckle 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Aggron 4",
      "Metagross 4",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6"
    ]
  },
  {
    "name": "BRYCE",
    "trainerClass": "Ruin Maniac",
    "pokemon": [
      "Forretress 1",
      "Skarmory 1",
      "Golem 1",
      "Rhydon 1",
      "Cradily 1",
      "Armaldo 1",
      "Scizor 1",
      "Shuckle 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Aggron 1",
      "Metagross 1",
      "Forretress 2",
      "Skarmory 2",
      "Golem 2",
      "Rhydon 2",
      "Cradily 2",
      "Armaldo 2",
      "Scizor 2",
      "Shuckle 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Aggron 2",
      "Metagross 2",
      "Forretress 3",
      "Skarmory 3",
      "Golem 3",
      "Rhydon 3",
      "Cradily 3",
      "Armaldo 3",
      "Scizor 3",
      "Shuckle 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Aggron 3",
      "Metagross 3",
      "Forretress 4",
      "Skarmory 4",
      "Golem 4",
      "Rhydon 4",
      "Cradily 4",
      "Armaldo 4",
      "Scizor 4",
      "Shuckle 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Aggron 4",
      "Metagross 4",
      "Regirock 1",
      "Regice 1",
      "Registeel 1",
      "Regirock 2",
      "Regice 2",
      "Registeel 2",
      "Regirock 3",
      "Regice 3",
      "Registeel 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Regirock 5",
      "Regirock 6",
      "Regice 5",
      "Regice 6",
      "Registeel 5",
      "Registeel 6"
    ]
  },
  {
    "name": "GIDEON",
    "trainerClass": "Collector",
    "pokemon": [
      "Venusaur 1",
      "Meganium 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Blaziken 1",
      "Sceptile 1",
      "Charizard 1",
      "Typhlosion 1",
      "Swampert 1",
      "Venusaur 2",
      "Meganium 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Blaziken 2",
      "Sceptile 2",
      "Charizard 2",
      "Typhlosion 2",
      "Swampert 2",
      "Venusaur 3",
      "Meganium 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Blaziken 3",
      "Sceptile 3",
      "Charizard 3",
      "Typhlosion 3",
      "Swampert 3",
      "Venusaur 4",
      "Meganium 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Blaziken 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Swampert 4"
    ]
  },
  {
    "name": "TRISTON",
    "trainerClass": "Collector",
    "pokemon": [
      "Venusaur 1",
      "Meganium 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Blaziken 1",
      "Sceptile 1",
      "Charizard 1",
      "Typhlosion 1",
      "Swampert 1",
      "Venusaur 2",
      "Meganium 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Blaziken 2",
      "Sceptile 2",
      "Charizard 2",
      "Typhlosion 2",
      "Swampert 2",
      "Venusaur 3",
      "Meganium 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Blaziken 3",
      "Sceptile 3",
      "Charizard 3",
      "Typhlosion 3",
      "Swampert 3",
      "Venusaur 4",
      "Meganium 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Blaziken 4",
      "Sceptile 4",
      "Charizard 4",
      "Typhlosion 4",
      "Swampert 4"
    ]
  },
  {
    "name": "CHARLES",
    "trainerClass": "Guitarist",
    "pokemon": [
      "Absol 2",
      "Lanturn 1",
      "Raichu 1",
      "Manectric 1",
      "Electrode 1",
      "Shiftry 1",
      "Electabuzz 1",
      "Ampharos 1",
      "Houndoom 1",
      "Jolteon 1",
      "Umbreon 1",
      "Lanturn 2",
      "Raichu 2",
      "Manectric 2",
      "Electrode 2",
      "Shiftry 2",
      "Electabuzz 2",
      "Ampharos 2",
      "Houndoom 2",
      "Jolteon 2",
      "Umbreon 2",
      "Lanturn 3",
      "Raichu 3",
      "Manectric 3",
      "Electrode 3",
      "Shiftry 3",
      "Electabuzz 3",
      "Ampharos 3",
      "Houndoom 3",
      "Jolteon 3",
      "Umbreon 3",
      "Lanturn 4",
      "Raichu 4",
      "Manectric 4",
      "Electrode 4",
      "Shiftry 4",
      "Electabuzz 4",
      "Ampharos 4",
      "Houndoom 4",
      "Jolteon 4",
      "Umbreon 4",
      "Articuno 1",
      "Zapdos 1",
      "Moltres 1",
      "Articuno 2",
      "Zapdos 2",
      "Moltres 2",
      "Articuno 3",
      "Zapdos 3",
      "Moltres 3",
      "Articuno 4",
      "Zapdos 4",
      "Moltres 4",
      "Articuno 5",
      "Articuno 6",
      "Zapdos 5",
      "Zapdos 6",
      "Moltres 5",
      "Moltres 6"
    ]
  },
  {
    "name": "RAYMOND",
    "trainerClass": "Guitarist",
    "pokemon": [
      "Misdreavus 1",
      "Granbull 1",
      "Lanturn 1",
      "Alakazam 1",
      "Electabuzz 1",
      "Ampharos 1",
      "Starmie 1",
      "Jolteon 1",
      "Gyarados 1",
      "Misdreavus 2",
      "Alakazam 2",
      "Slowking 2",
      "Miltank 2",
      "Ampharos 2",
      "Porygon2 2",
      "Aggron 2",
      "Misdreavus 3",
      "Manectric 3",
      "Electrode 3",
      "Porygon2 3",
      "Jolteon 3",
      "Raichu 4",
      "Manectric 4",
      "Electrode 4",
      "Ampharos 4",
      "Jolteon 4",
      "Regice 3",
      "Regirock 4",
      "Regice 4",
      "Registeel 4",
      "Starmie 6",
      "Latias 5",
      "Latias 6",
      "Latios 5",
      "Latios 6"
    ]
  },
  {
    "name": "DIRK",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "Pidgeot 2",
      "Fearow 1",
      "Dodrio 1",
      "Xatu 1",
      "Skarmory 1",
      "Altaria 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Charizard 1",
      "Crobat 1",
      "Gyarados 1",
      "Salamence 1",
      "Fearow 2",
      "Dodrio 2",
      "Skarmory 2",
      "Xatu 2",
      "Altaria 2",
      "Aerodactyl 2",
      "Flygon 2",
      "Charizard 2",
      "Crobat 2",
      "Gyarados 2",
      "Salamence 2",
      "Fearow 3",
      "Dodrio 3",
      "Xatu 3",
      "Skarmory 3",
      "Altaria 3",
      "Aerodactyl 3",
      "Flygon 3",
      "Charizard 3",
      "Crobat 3",
      "Gyarados 3",
      "Salamence 3",
      "Fearow 4",
      "Dodrio 4",
      "Xatu 4",
      "Skarmory 4",
      "Altaria 4",
      "Aerodactyl 4",
      "Flygon 4",
      "Charizard 4",
      "Crobat 4",
      "Gyarados 4",
      "Salamence 4",
      "Articuno 1",
      "Zapdos 1",
      "Moltres 1",
      "Articuno 2",
      "Zapdos 2",
      "Moltres 2",
      "Articuno 3",
      "Zapdos 3",
      "Moltres 3",
      "Articuno 4",
      "Zapdos 4",
      "Moltres 4",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8"
    ]
  },
  {
    "name": "HAROLD",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "Pidgeot 2",
      "Fearow 1",
      "Dodrio 1",
      "Xatu 1",
      "Skarmory 1",
      "Altaria 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Charizard 1",
      "Crobat 1",
      "Gyarados 1",
      "Salamence 1",
      "Fearow 2",
      "Dodrio 2",
      "Skarmory 2",
      "Xatu 2",
      "Altaria 2",
      "Aerodactyl 2",
      "Flygon 2",
      "Charizard 2",
      "Crobat 2",
      "Gyarados 2",
      "Salamence 2",
      "Fearow 3",
      "Dodrio 3",
      "Xatu 3",
      "Skarmory 3",
      "Altaria 3",
      "Aerodactyl 3",
      "Flygon 3",
      "Charizard 3",
      "Crobat 3",
      "Gyarados 3",
      "Salamence 3",
      "Fearow 4",
      "Dodrio 4",
      "Xatu 4",
      "Skarmory 4",
      "Altaria 4",
      "Aerodactyl 4",
      "Flygon 4",
      "Charizard 4",
      "Crobat 4",
      "Gyarados 4",
      "Salamence 4",
      "Articuno 1",
      "Zapdos 1",
      "Moltres 1",
      "Articuno 2",
      "Zapdos 2",
      "Moltres 2",
      "Articuno 3",
      "Zapdos 3",
      "Moltres 3",
      "Articuno 4",
      "Zapdos 4",
      "Moltres 4",
      "Salamence 5",
      "Salamence 6",
      "Salamence 7",
      "Salamence 8"
    ]
  },
  {
    "name": "OMAR",
    "trainerClass": "Sailor",
    "pokemon": [
      "Medicham 1",
      "Quagsire 1",
      "Hariyama 1",
      "Dewgong 1",
      "Ludicolo 1",
      "Slowbro 1",
      "Slowking 1",
      "Golduck 1",
      "Machamp 1",
      "Vaporeon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Walrein 1",
      "Lapras 1",
      "Swampert 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Medicham 2",
      "Quagsire 2",
      "Hariyama 2",
      "Dewgong 2",
      "Ludicolo 2",
      "Slowbro 2",
      "Slowking 2",
      "Golduck 2",
      "Machamp 2",
      "Vaporeon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Walrein 2",
      "Lapras 2",
      "Swampert 2",
      "Gyarados 2",
      "Kingdra 2",
      "Milotic 2",
      "Medicham 3",
      "Quagsire 3",
      "Hariyama 3",
      "Dewgong 3",
      "Ludicolo 3",
      "Slowbro 3",
      "Slowking 3",
      "Golduck 3",
      "Machamp 3",
      "Vaporeon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Walrein 3",
      "Lapras 3",
      "Swampert 3",
      "Gyarados 3",
      "Kingdra 3",
      "Milotic 3",
      "Medicham 4",
      "Quagsire 4",
      "Hariyama 4",
      "Dewgong 4",
      "Ludicolo 4",
      "Slowbro 4",
      "Slowking 4",
      "Golduck 4",
      "Machamp 4",
      "Vaporeon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Walrein 4",
      "Lapras 4",
      "Swampert 4",
      "Gyarados 4",
      "Kingdra 4",
      "Milotic 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8"
    ]
  },
  {
    "name": "PETER",
    "trainerClass": "Sailor",
    "pokemon": [
      "Medicham 1",
      "Quagsire 1",
      "Hariyama 1",
      "Dewgong 1",
      "Ludicolo 1",
      "Slowbro 1",
      "Slowking 1",
      "Golduck 1",
      "Machamp 1",
      "Vaporeon 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Walrein 1",
      "Lapras 1",
      "Swampert 1",
      "Gyarados 1",
      "Kingdra 1",
      "Milotic 1",
      "Medicham 2",
      "Quagsire 2",
      "Hariyama 2",
      "Dewgong 2",
      "Ludicolo 2",
      "Slowbro 2",
      "Slowking 2",
      "Golduck 2",
      "Machamp 2",
      "Vaporeon 2",
      "Blastoise 2",
      "Feraligatr 2",
      "Walrein 2",
      "Lapras 2",
      "Swampert 2",
      "Gyarados 2",
      "Kingdra 2",
      "Milotic 2",
      "Medicham 3",
      "Quagsire 3",
      "Hariyama 3",
      "Dewgong 3",
      "Ludicolo 3",
      "Slowbro 3",
      "Slowking 3",
      "Golduck 3",
      "Machamp 3",
      "Vaporeon 3",
      "Blastoise 3",
      "Feraligatr 3",
      "Walrein 3",
      "Lapras 3",
      "Swampert 3",
      "Gyarados 3",
      "Kingdra 3",
      "Milotic 3",
      "Medicham 4",
      "Quagsire 4",
      "Hariyama 4",
      "Dewgong 4",
      "Ludicolo 4",
      "Slowbro 4",
      "Slowking 4",
      "Golduck 4",
      "Machamp 4",
      "Vaporeon 4",
      "Blastoise 4",
      "Feraligatr 4",
      "Walrein 4",
      "Lapras 4",
      "Swampert 4",
      "Gyarados 4",
      "Kingdra 4",
      "Milotic 4",
      "Machamp 5",
      "Machamp 6",
      "Machamp 7",
      "Machamp 8",
      "Lapras 5",
      "Lapras 6",
      "Lapras 7",
      "Lapras 8"
    ]
  },
  {
    "name": "DEV",
    "trainerClass": "Hiker",
    "pokemon": [
      "Dugtrio 1",
      "Marowak 1",
      "Golem 1",
      "Rhydon 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Cradily 1",
      "Armaldo 1",
      "Donphan 1",
      "Claydol 1",
      "Shuckle 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Aggron 1",
      "Metagross 1",
      "Dugtrio 2",
      "Marowak 2",
      "Golem 2",
      "Rhydon 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Cradily 2",
      "Armaldo 2",
      "Donphan 2",
      "Claydol 2",
      "Shuckle 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Flygon 2",
      "Aggron 2",
      "Metagross 2",
      "Dugtrio 3",
      "Marowak 3",
      "Golem 3",
      "Rhydon 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Cradily 3",
      "Armaldo 3",
      "Donphan 3",
      "Claydol 3",
      "Shuckle 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Flygon 3",
      "Aggron 3",
      "Metagross 3",
      "Dugtrio 4",
      "Marowak 4",
      "Golem 4",
      "Rhydon 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Cradily 4",
      "Armaldo 4",
      "Donphan 4",
      "Claydol 4",
      "Shuckle 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Flygon 4",
      "Aggron 4",
      "Metagross 4",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "COREY",
    "trainerClass": "Hiker",
    "pokemon": [
      "Dugtrio 1",
      "Marowak 1",
      "Golem 1",
      "Rhydon 1",
      "Nidoqueen 1",
      "Nidoking 1",
      "Cradily 1",
      "Armaldo 1",
      "Donphan 1",
      "Claydol 1",
      "Shuckle 1",
      "Steelix 1",
      "Aerodactyl 1",
      "Flygon 1",
      "Aggron 1",
      "Metagross 1",
      "Dugtrio 2",
      "Marowak 2",
      "Golem 2",
      "Rhydon 2",
      "Nidoqueen 2",
      "Nidoking 2",
      "Cradily 2",
      "Armaldo 2",
      "Donphan 2",
      "Claydol 2",
      "Shuckle 2",
      "Steelix 2",
      "Aerodactyl 2",
      "Flygon 2",
      "Aggron 2",
      "Metagross 2",
      "Dugtrio 3",
      "Marowak 3",
      "Golem 3",
      "Rhydon 3",
      "Nidoqueen 3",
      "Nidoking 3",
      "Cradily 3",
      "Armaldo 3",
      "Donphan 3",
      "Claydol 3",
      "Shuckle 3",
      "Steelix 3",
      "Aerodactyl 3",
      "Flygon 3",
      "Aggron 3",
      "Metagross 3",
      "Dugtrio 4",
      "Marowak 4",
      "Golem 4",
      "Rhydon 4",
      "Nidoqueen 4",
      "Nidoking 4",
      "Cradily 4",
      "Armaldo 4",
      "Donphan 4",
      "Claydol 4",
      "Shuckle 4",
      "Steelix 4",
      "Aerodactyl 4",
      "Flygon 4",
      "Aggron 4",
      "Metagross 4",
      "Metagross 5",
      "Metagross 6",
      "Metagross 7",
      "Metagross 8",
      "Tyranitar 1",
      "Tyranitar 2",
      "Tyranitar 3",
      "Tyranitar 4",
      "Tyranitar 5",
      "Tyranitar 6",
      "Tyranitar 7",
      "Tyranitar 8",
      "Tyranitar 9",
      "Tyranitar 10"
    ]
  },
  {
    "name": "ANDRE",
    "trainerClass": "Kindler",
    "pokemon": [
      "Misdreavus 1",
      "Dusclops 1",
      "Magmar 1",
      "Rapidash 1",
      "Gengar 1",
      "Houndoom 1",
      "Ninetales 1",
      "Flareon 1",
      "Blaziken 1",
      "Charizard 1",
      "Typhlosion 1",
      "Arcanine 1",
      "Misdreavus 2",
      "Dusclops 2",
      "Magmar 2",
      "Rapidash 2",
      "Gengar 2",
      "Houndoom 2",
      "Ninetales 2",
      "Flareon 2",
      "Blaziken 2",
      "Charizard 2",
      "Typhlosion 2",
      "Arcanine 2",
      "Misdreavus 3",
      "Dusclops 3",
      "Magmar 3",
      "Rapidash 3",
      "Gengar 3",
      "Houndoom 3",
      "Ninetales 3",
      "Flareon 3",
      "Blaziken 3",
      "Charizard 3",
      "Typhlosion 3",
      "Arcanine 3",
      "Misdreavus 4",
      "Dusclops 4",
      "Magmar 4",
      "Rapidash 4",
      "Gengar 4",
      "Houndoom 4",
      "Ninetales 4",
      "Flareon 4",
      "Blaziken 4",
      "Charizard 4",
      "Typhlosion 4",
      "Arcanine 4",
      "Gengar 5",
      "Gengar 6",
      "Gengar 7",
      "Gengar 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10"
    ]
  },
  {
    "name": "FERRIS",
    "trainerClass": "Kindler",
    "pokemon": [
      "Misdreavus 1",
      "Dusclops 1",
      "Magmar 1",
      "Rapidash 1",
      "Gengar 1",
      "Houndoom 1",
      "Ninetales 1",
      "Flareon 1",
      "Blaziken 1",
      "Charizard 1",
      "Typhlosion 1",
      "Arcanine 1",
      "Misdreavus 2",
      "Dusclops 2",
      "Magmar 2",
      "Rapidash 2",
      "Gengar 2",
      "Houndoom 2",
      "Ninetales 2",
      "Flareon 2",
      "Blaziken 2",
      "Charizard 2",
      "Typhlosion 2",
      "Arcanine 2",
      "Misdreavus 3",
      "Dusclops 3",
      "Magmar 3",
      "Rapidash 3",
      "Gengar 3",
      "Houndoom 3",
      "Ninetales 3",
      "Flareon 3",
      "Blaziken 3",
      "Charizard 3",
      "Typhlosion 3",
      "Arcanine 3",
      "Misdreavus 4",
      "Dusclops 4",
      "Magmar 4",
      "Rapidash 4",
      "Gengar 4",
      "Houndoom 4",
      "Ninetales 4",
      "Flareon 4",
      "Blaziken 4",
      "Charizard 4",
      "Typhlosion 4",
      "Arcanine 4",
      "Gengar 5",
      "Gengar 6",
      "Gengar 7",
      "Gengar 8",
      "Dragonite 1",
      "Dragonite 2",
      "Dragonite 3",
      "Dragonite 4",
      "Dragonite 5",
      "Dragonite 6",
      "Dragonite 7",
      "Dragonite 8",
      "Dragonite 9",
      "Dragonite 10"
    ]
  },
  {
    "name": "ALIVIA",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "Glalie 1",
      "Ludicolo 1",
      "Slowbro 1",
      "Ampharos 1",
      "Exeggutor 1",
      "Venusaur 1",
      "Meganium 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Blaziken 1",
      "Walrein 1",
      "Charizard 1",
      "Typhlosion 1",
      "Manectric 2",
      "Electrode 2",
      "Exploud 2",
      "Electabuzz 2",
      "Ninetales 2",
      "Porygon2 2",
      "Starmie 2",
      "Flygon 2",
      "Arcanine 2",
      "Lanturn 3",
      "Raichu 3",
      "Shiftry 3",
      "Ludicolo 3",
      "Cradily 3",
      "Rapidash 3",
      "Claydol 3",
      "Gyarados 3",
      "Vileplume 4",
      "Ludicolo 4",
      "Houndoom 4",
      "Venusaur 4",
      "Flareon 4"
    ]
  },
  {
    "name": "PAIGE",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "Glalie 1",
      "Ludicolo 1",
      "Slowbro 1",
      "Ampharos 1",
      "Exeggutor 1",
      "Venusaur 1",
      "Meganium 1",
      "Blastoise 1",
      "Feraligatr 1",
      "Blaziken 1",
      "Walrein 1",
      "Charizard 1",
      "Typhlosion 1",
      "Manectric 2",
      "Electrode 2",
      "Exploud 2",
      "Electabuzz 2",
      "Ninetales 2",
      "Porygon2 2",
      "Starmie 2",
      "Flygon 2",
      "Arcanine 2",
      "Lanturn 3",
      "Raichu 3",
      "Shiftry 3",
      "Ludicolo 3",
      "Cradily 3",
      "Rapidash 3",
      "Claydol 3",
      "Gyarados 3",
      "Vileplume 4",
      "Ludicolo 4",
      "Houndoom 4",
      "Venusaur 4",
      "Flareon 4"
    ]
  },
  {
    "name": "ANYA",
    "trainerClass": "Beauty",
    "pokemon": [
      "Vaporeon 1",
      "Jolteon 1",
      "Flareon 1",
      "Espeon 1",
      "Umbreon 1",
      "Vaporeon 2",
      "Jolteon 2",
      "Flareon 2",
      "Espeon 2",
      "Umbreon 2",
      "Vaporeon 3",
      "Jolteon 3",
      "Flareon 3",
      "Espeon 3",
      "Umbreon 3",
      "Vaporeon 4",
      "Jolteon 4",
      "Flareon 4",
      "Espeon 4",
      "Umbreon 4"
    ]
  },
  {
    "name": "DAWN",
    "trainerClass": "Beauty",
    "pokemon": [
      "Jynx 1",
      "Lanturn 1",
      "Slowking 1",
      "Gengar 1",
      "Ampharos 1",
      "Jolteon 1",
      "Lapras 1",
      "Snorlax 1",
      "Kingdra 1",
      "Quagsire 2",
      "Misdreavus 2",
      "Fearow 2",
      "Xatu 2",
      "Victreebel 2",
      "Kangaskhan 2",
      "Electabuzz 2",
      "Miltank 2",
      "Altaria 2",
      "Rapidash 2",
      "Heracross 2",
      "Flareon 2",
      "Sceptile 2",
      "Jynx 3",
      "Breloom 3",
      "Raichu 3",
      "Vileplume 3",
      "Slowbro 3",
      "Ninetales 3",
      "Shuckle 3",
      "Umbreon 3",
      "Walrein 3",
      "Milotic 3",
      "Espeon 4",
      "Ursaring 5",
      "Machamp 7",
      "Gardevoir 8",
      "Lapras 8",
      "Salamence 8",
      "Latias 6"
    ]
  },
  {
    "name": "ABBY",
    "trainerClass": "Aroma Lady",
    "pokemon": [
      "Wobbuffet 1",
      "Wobbuffet 2",
      "Sunflora 2",
      "Jumpluff 2",
      "Tropius 2",
      "Cacturne 2",
      "Bellossom 2",
      "Jynx 1",
      "Mrmime 1",
      "Breloom 1",
      "Xatu 1",
      "Vileplume 1",
      "Victreebel 1",
      "Shiftry 1",
      "Ludicolo 1",
      "Hypno 1",
      "Alakazam 1",
      "Slowbro 1",
      "Slowking 1",
      "Cradily 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Venusaur 1",
      "Meganium 1",
      "Espeon 1",
      "Sceptile 1",
      "Jynx 2",
      "Mrmime 2",
      "Breloom 2",
      "Xatu 2",
      "Vileplume 2",
      "Victreebel 2",
      "Shiftry 2",
      "Ludicolo 2",
      "Hypno 2",
      "Alakazam 2",
      "Slowbro 2",
      "Slowking 2",
      "Cradily 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Venusaur 2",
      "Meganium 2",
      "Espeon 2",
      "Sceptile 2",
      "Jynx 3",
      "Mrmime 3",
      "Breloom 3",
      "Xatu 3",
      "Vileplume 3",
      "Victreebel 3",
      "Shiftry 3",
      "Ludicolo 3",
      "Hypno 3",
      "Alakazam 3",
      "Slowbro 3",
      "Slowking 3",
      "Cradily 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Venusaur 3",
      "Meganium 3",
      "Espeon 3",
      "Sceptile 3",
      "Jynx 4",
      "Mrmime 4",
      "Breloom 4",
      "Xatu 4",
      "Vileplume 4",
      "Victreebel 4",
      "Shiftry 4",
      "Ludicolo 4",
      "Hypno 4",
      "Alakazam 4",
      "Slowbro 4",
      "Slowking 4",
      "Cradily 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Venusaur 4",
      "Meganium 4",
      "Espeon 4",
      "Sceptile 4",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8"
    ]
  },
  {
    "name": "GRETEL",
    "trainerClass": "Aroma Lady",
    "pokemon": [
      "Wobbuffet 1",
      "Wobbuffet 2",
      "Sunflora 2",
      "Jumpluff 2",
      "Tropius 2",
      "Cacturne 2",
      "Bellossom 2",
      "Jynx 1",
      "Mrmime 1",
      "Breloom 1",
      "Xatu 1",
      "Vileplume 1",
      "Victreebel 1",
      "Shiftry 1",
      "Ludicolo 1",
      "Hypno 1",
      "Alakazam 1",
      "Slowbro 1",
      "Slowking 1",
      "Cradily 1",
      "Gardevoir 1",
      "Exeggutor 1",
      "Starmie 1",
      "Venusaur 1",
      "Meganium 1",
      "Espeon 1",
      "Sceptile 1",
      "Jynx 2",
      "Mrmime 2",
      "Breloom 2",
      "Xatu 2",
      "Vileplume 2",
      "Victreebel 2",
      "Shiftry 2",
      "Ludicolo 2",
      "Hypno 2",
      "Alakazam 2",
      "Slowbro 2",
      "Slowking 2",
      "Cradily 2",
      "Gardevoir 2",
      "Exeggutor 2",
      "Starmie 2",
      "Venusaur 2",
      "Meganium 2",
      "Espeon 2",
      "Sceptile 2",
      "Jynx 3",
      "Mrmime 3",
      "Breloom 3",
      "Xatu 3",
      "Vileplume 3",
      "Victreebel 3",
      "Shiftry 3",
      "Ludicolo 3",
      "Hypno 3",
      "Alakazam 3",
      "Slowbro 3",
      "Slowking 3",
      "Cradily 3",
      "Gardevoir 3",
      "Exeggutor 3",
      "Starmie 3",
      "Venusaur 3",
      "Meganium 3",
      "Espeon 3",
      "Sceptile 3",
      "Jynx 4",
      "Mrmime 4",
      "Breloom 4",
      "Xatu 4",
      "Vileplume 4",
      "Victreebel 4",
      "Shiftry 4",
      "Ludicolo 4",
      "Hypno 4",
      "Alakazam 4",
      "Slowbro 4",
      "Slowking 4",
      "Cradily 4",
      "Gardevoir 4",
      "Exeggutor 4",
      "Starmie 4",
      "Venusaur 4",
      "Meganium 4",
      "Espeon 4",
      "Sceptile 4",
      "Gardevoir 5",
      "Gardevoir 6",
      "Gardevoir 7",
      "Gardevoir 8",
      "Starmie 5",
      "Starmie 6",
      "Starmie 7",
      "Starmie 8"
    ]
  }
];

export const POKEMON = [
  {
    "entry": 1,
    "name": "Sunkern 1",
    "species": "Sunkern",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Lax Incense",
    "move1": "Mega Drain",
    "move2": "Helping Hand",
    "move3": "Sunny Day",
    "move4": "Light Screen",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 2,
    "name": "Azurill 1",
    "species": "Azurill",
    "instance": "1",
    "nature": "Rash",
    "item": "Cheri Berry",
    "move1": "Water Pulse",
    "move2": "Attract",
    "move3": "Sing",
    "move4": "Charm",
    "speed50": 40,
    "speed100": 76
  },
  {
    "entry": 3,
    "name": "Caterpie 1",
    "species": "Caterpie",
    "instance": "1",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Tackle",
    "move2": "String Shot",
    "move3": "---",
    "move4": "---",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 4,
    "name": "Weedle 1",
    "species": "Weedle",
    "instance": "1",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Poison Sting",
    "move2": "String Shot",
    "move3": "---",
    "move4": "---",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 5,
    "name": "Wurmple 1",
    "species": "Wurmple",
    "instance": "1",
    "nature": "Quirky",
    "item": "Lax Incense",
    "move1": "Tackle",
    "move2": "String Shot",
    "move3": "Poison Sting",
    "move4": "---",
    "speed50": 40,
    "speed100": 76
  },
  {
    "entry": 6,
    "name": "Ralts 1",
    "species": "Ralts",
    "instance": "1",
    "nature": "Docile",
    "item": "TwistedSpoon",
    "move1": "Confusion",
    "move2": "Imprison",
    "move3": "Double Team",
    "move4": "Light Screen",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 7,
    "name": "Magikarp 1",
    "species": "Magikarp",
    "instance": "1",
    "nature": "Hardy",
    "item": "Focus Band",
    "move1": "Flail",
    "move2": "---",
    "move3": "---",
    "move4": "---",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 8,
    "name": "Feebas 1",
    "species": "Feebas",
    "instance": "1",
    "nature": "Lonely",
    "item": "Focus Band",
    "move1": "Flail",
    "move2": "Mirror Coat",
    "move3": "---",
    "move4": "---",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 9,
    "name": "Metapod 1",
    "species": "Metapod",
    "instance": "1",
    "nature": "Bashful",
    "item": "Lax Incense",
    "move1": "Harden",
    "move2": "---",
    "move3": "---",
    "move4": "---",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 10,
    "name": "Kakuna 1",
    "species": "Kakuna",
    "instance": "1",
    "nature": "Bashful",
    "item": "Lax Incense",
    "move1": "Harden",
    "move2": "---",
    "move3": "---",
    "move4": "---",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 11,
    "name": "Pichu 1",
    "species": "Pichu",
    "instance": "1",
    "nature": "Rash",
    "item": "Sitrus Berry",
    "move1": "Sweet Kiss",
    "move2": "Thunder Wave",
    "move3": "Attract",
    "move4": "Shock Wave",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 12,
    "name": "Silcoon 1",
    "species": "Silcoon",
    "instance": "1",
    "nature": "Bashful",
    "item": "Lax Incense",
    "move1": "Harden",
    "move2": "---",
    "move3": "---",
    "move4": "---",
    "speed50": 35,
    "speed100": 66
  },
  {
    "entry": 13,
    "name": "Cascoon 1",
    "species": "Cascoon",
    "instance": "1",
    "nature": "Bashful",
    "item": "Lax Incense",
    "move1": "Harden",
    "move2": "---",
    "move3": "---",
    "move4": "---",
    "speed50": 35,
    "speed100": 66
  },
  {
    "entry": 14,
    "name": "Igglybuff 1",
    "species": "Igglybuff",
    "instance": "1",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Sweet Kiss",
    "move2": "Sing",
    "move3": "Attract",
    "move4": "Seismic Toss",
    "speed50": 35,
    "speed100": 66
  },
  {
    "entry": 15,
    "name": "Wooper 1",
    "species": "Wooper",
    "instance": "1",
    "nature": "Docile",
    "item": "Sitrus Berry",
    "move1": "Yawn",
    "move2": "Dig",
    "move3": "Water Pulse",
    "move4": "Rain Dance",
    "speed50": 35,
    "speed100": 66
  },
  {
    "entry": 16,
    "name": "Tyrogue 1",
    "species": "Tyrogue",
    "instance": "1",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Mach Punch",
    "move2": "Protect",
    "move3": "Double Team",
    "move4": "Facade",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 17,
    "name": "Sentret 1",
    "species": "Sentret",
    "instance": "1",
    "nature": "Docile",
    "item": "King's Rock",
    "move1": "Quick Attack",
    "move2": "Follow Me",
    "move3": "Helping Hand",
    "move4": "Assist",
    "speed50": 40,
    "speed100": 76
  },
  {
    "entry": 18,
    "name": "Cleffa 1",
    "species": "Cleffa",
    "instance": "1",
    "nature": "Serious",
    "item": "Lax Incense",
    "move1": "Sweet Kiss",
    "move2": "Sing",
    "move3": "Attract",
    "move4": "Metronome",
    "speed50": 35,
    "speed100": 66
  },
  {
    "entry": 19,
    "name": "Seedot 1",
    "species": "Seedot",
    "instance": "1",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Bullet Seed",
    "move2": "Bide",
    "move3": "Defense Curl",
    "move4": "Rollout",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 20,
    "name": "Lotad 1",
    "species": "Lotad",
    "instance": "1",
    "nature": "Docile",
    "item": "Lax Incense",
    "move1": "Rain Dance",
    "move2": "Water Pulse",
    "move3": "Sunny Day",
    "move4": "Mega Drain",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 21,
    "name": "Poochyena 1",
    "species": "Poochyena",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Petaya Berry",
    "move1": "Crunch",
    "move2": "Swagger",
    "move3": "Roar",
    "move4": "Sand-Attack",
    "speed50": 49,
    "speed100": 95
  },
  {
    "entry": 22,
    "name": "Shedinja 1",
    "species": "Shedinja",
    "instance": "1",
    "nature": "Naive",
    "item": "Lax Incense",
    "move1": "Shadow Ball",
    "move2": "Confuse Ray",
    "move3": "Silver Wind",
    "move4": "Grudge",
    "speed50": 101,
    "speed100": 196
  },
  {
    "entry": 23,
    "name": "Makuhita 1",
    "species": "Makuhita",
    "instance": "1",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Fake Out",
    "move2": "Seismic Toss",
    "move3": "Detect",
    "move4": "Whirlwind",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 24,
    "name": "Whismur 1",
    "species": "Whismur",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Cheri Berry",
    "move1": "Uproar",
    "move2": "Swagger",
    "move3": "Body Slam",
    "move4": "SmellingSalt",
    "speed50": 43,
    "speed100": 82
  },
  {
    "entry": 25,
    "name": "Zigzagoon 1",
    "species": "Zigzagoon",
    "instance": "1",
    "nature": "Timid",
    "item": "Silk Scarf",
    "move1": "Headbutt",
    "move2": "Pin Missile",
    "move3": "Swift",
    "move4": "Sand-Attack",
    "speed50": 88,
    "speed100": 171
  },
  {
    "entry": 26,
    "name": "Zubat 1",
    "species": "Zubat",
    "instance": "1",
    "nature": "Sassy",
    "item": "Cheri Berry",
    "move1": "Poison Fang",
    "move2": "Whirlwind",
    "move3": "Confuse Ray",
    "move4": "Aerial Ace",
    "speed50": 67,
    "speed100": 131
  },
  {
    "entry": 27,
    "name": "Togepi 1",
    "species": "Togepi",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Lax Incense",
    "move1": "Return",
    "move2": "Yawn",
    "move3": "Wish",
    "move4": "Sweet Kiss",
    "speed50": 36,
    "speed100": 68
  },
  {
    "entry": 28,
    "name": "Spinarak 1",
    "species": "Spinarak",
    "instance": "1",
    "nature": "Quirky",
    "item": "Liechi Berry",
    "move1": "Signal Beam",
    "move2": "Night Shade",
    "move3": "Spider Web",
    "move4": "Scary Face",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 29,
    "name": "Marill 1",
    "species": "Marill",
    "instance": "1",
    "nature": "Gentle",
    "item": "Mystic Water",
    "move1": "Water Pulse",
    "move2": "Rain Dance",
    "move3": "Light Screen",
    "move4": "Return",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 30,
    "name": "Hoppip 1",
    "species": "Hoppip",
    "instance": "1",
    "nature": "Lax",
    "item": "Lax Incense",
    "move1": "Mega Drain",
    "move2": "Leech Seed",
    "move3": "Sleep Powder",
    "move4": "Stun Spore",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 31,
    "name": "Slugma 1",
    "species": "Slugma",
    "instance": "1",
    "nature": "Sassy",
    "item": "Sitrus Berry",
    "move1": "Ember",
    "move2": "Rock Slide",
    "move3": "Yawn",
    "move4": "Body Slam",
    "speed50": 36,
    "speed100": 68
  },
  {
    "entry": 32,
    "name": "Swinub 1",
    "species": "Swinub",
    "instance": "1",
    "nature": "Gentle",
    "item": "Sitrus Berry",
    "move1": "Icy Wind",
    "move2": "Dig",
    "move3": "Rock Tomb",
    "move4": "Endure",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 33,
    "name": "Smeargle 1",
    "species": "Smeargle",
    "instance": "1",
    "nature": "Hardy",
    "item": "King's Rock",
    "move1": "ExtremeSpeed",
    "move2": "Fake Out",
    "move3": "Quick Attack",
    "move4": "Mach Punch",
    "speed50": 95,
    "speed100": 186
  },
  {
    "entry": 34,
    "name": "Pidgey 1",
    "species": "Pidgey",
    "instance": "1",
    "nature": "Lonely",
    "item": "Sharp Beak",
    "move1": "Gust",
    "move2": "Sand-Attack",
    "move3": "Whirlwind",
    "move4": "Quick Attack",
    "speed50": 76,
    "speed100": 148
  },
  {
    "entry": 35,
    "name": "Rattata 1",
    "species": "Rattata",
    "instance": "1",
    "nature": "Docile",
    "item": "King's Rock",
    "move1": "Hyper Fang",
    "move2": "Pursuit",
    "move3": "Quick Attack",
    "move4": "Swagger",
    "speed50": 92,
    "speed100": 180
  },
  {
    "entry": 36,
    "name": "Wynaut 1",
    "species": "Wynaut",
    "instance": "1",
    "nature": "Jolly",
    "item": "Lax Incense",
    "move1": "Encore",
    "move2": "Counter",
    "move3": "Mirror Coat",
    "move4": "Charm",
    "speed50": 47,
    "speed100": 90
  },
  {
    "entry": 37,
    "name": "Skitty 1",
    "species": "Skitty",
    "instance": "1",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Sing",
    "move2": "Attract",
    "move3": "Charm",
    "move4": "DoubleSlap",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 38,
    "name": "Spearow 1",
    "species": "Spearow",
    "instance": "1",
    "nature": "Docile",
    "item": "Liechi Berry",
    "move1": "Fury Attack",
    "move2": "Pursuit",
    "move3": "Mirror Move",
    "move4": "Protect",
    "speed50": 122,
    "speed100": 239
  },
  {
    "entry": 39,
    "name": "Hoothoot 1",
    "species": "Hoothoot",
    "instance": "1",
    "nature": "Quirky",
    "item": "Persim Berry",
    "move1": "Confusion",
    "move2": "Hypnosis",
    "move3": "Supersonic",
    "move4": "Reflect",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 40,
    "name": "Diglett 1",
    "species": "Diglett",
    "instance": "1",
    "nature": "Naive",
    "item": "King's Rock",
    "move1": "Magnitude",
    "move2": "Slash",
    "move3": "Rock Tomb",
    "move4": "Sand-Attack",
    "speed50": 161,
    "speed100": 317
  },
  {
    "entry": 41,
    "name": "Ledyba 1",
    "species": "Ledyba",
    "instance": "1",
    "nature": "Bashful",
    "item": "Sitrus Berry",
    "move1": "Psybeam",
    "move2": "Agility",
    "move3": "Baton Pass",
    "move4": "Light Screen",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 42,
    "name": "Nincada 1",
    "species": "Nincada",
    "instance": "1",
    "nature": "Calm",
    "item": "Pecha Berry",
    "move1": "Mud-Slap",
    "move2": "Dig",
    "move3": "Toxic",
    "move4": "Protect",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 43,
    "name": "Surskit 1",
    "species": "Surskit",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Mystic Water",
    "move1": "BubbleBeam",
    "move2": "Rain Dance",
    "move3": "Sweet Scent",
    "move4": "Quick Attack",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 44,
    "name": "Jigglypuff 1",
    "species": "Jigglypuff",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Lax Incense",
    "move1": "Sing",
    "move2": "Wish",
    "move3": "Mimic",
    "move4": "DoubleSlap",
    "speed50": 36,
    "speed100": 68
  },
  {
    "entry": 45,
    "name": "Taillow 1",
    "species": "Taillow",
    "instance": "1",
    "nature": "Gentle",
    "item": "Salac Berry",
    "move1": "Fly",
    "move2": "Quick Attack",
    "move3": "Endeavor",
    "move4": "Focus Energy",
    "speed50": 126,
    "speed100": 248
  },
  {
    "entry": 46,
    "name": "Wingull 1",
    "species": "Wingull",
    "instance": "1",
    "nature": "Hardy",
    "item": "Persim Berry",
    "move1": "Water Pulse",
    "move2": "Fly",
    "move3": "Quick Attack",
    "move4": "Steel Wing",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 47,
    "name": "Nidoran\u2642 1",
    "species": "Nidoran\u2642",
    "instance": "1",
    "nature": "Quirky",
    "item": "Sitrus Berry",
    "move1": "Double Kick",
    "move2": "Poison Sting",
    "move3": "Disable",
    "move4": "Helping Hand",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 48,
    "name": "Nidoran\u2640 1",
    "species": "Nidoran\u2640",
    "instance": "1",
    "nature": "Quirky",
    "item": "Sitrus Berry",
    "move1": "Crunch",
    "move2": "Double Kick",
    "move3": "Flatter",
    "move4": "Helping Hand",
    "speed50": 61,
    "speed100": 118
  },
  {
    "entry": 49,
    "name": "Kirlia 1",
    "species": "Kirlia",
    "instance": "1",
    "nature": "Docile",
    "item": "White Herb",
    "move1": "Confusion",
    "move2": "Will-O-Wisp",
    "move3": "Future Sight",
    "move4": "Light Screen",
    "speed50": 102,
    "speed100": 199
  },
  {
    "entry": 50,
    "name": "Mareep 1",
    "species": "Mareep",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Cheri Berry",
    "move1": "Shock Wave",
    "move2": "Flash",
    "move3": "Reflect",
    "move4": "Cotton Spore",
    "speed50": 49,
    "speed100": 95
  },
  {
    "entry": 51,
    "name": "Meditite 1",
    "species": "Meditite",
    "instance": "1",
    "nature": "Naughty",
    "item": "Mental Herb",
    "move1": "Hi Jump Kick",
    "move2": "Meditate",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 52,
    "name": "Slakoth 1",
    "species": "Slakoth",
    "instance": "1",
    "nature": "Quirky",
    "item": "Leftovers",
    "move1": "Yawn",
    "move2": "Scratch",
    "move3": "Encore",
    "move4": "Counter",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 53,
    "name": "Paras 1",
    "species": "Paras",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Sitrus Berry",
    "move1": "Spore",
    "move2": "Leech Life",
    "move3": "Slash",
    "move4": "Light Screen",
    "speed50": 40,
    "speed100": 77
  },
  {
    "entry": 54,
    "name": "Ekans 1",
    "species": "Ekans",
    "instance": "1",
    "nature": "Docile",
    "item": "Poison Barb",
    "move1": "Acid",
    "move2": "Dig",
    "move3": "Screech",
    "move4": "Torment",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 55,
    "name": "Ditto 1",
    "species": "Ditto",
    "instance": "1",
    "nature": "Hardy",
    "item": "Metal Powder",
    "move1": "Transform",
    "move2": "---",
    "move3": "---",
    "move4": "---",
    "speed50": 100,
    "speed100": 195
  },
  {
    "entry": 56,
    "name": "Barboach 1",
    "species": "Barboach",
    "instance": "1",
    "nature": "Bashful",
    "item": "Focus Band",
    "move1": "Magnitude",
    "move2": "Water Pulse",
    "move3": "Spark",
    "move4": "Future Sight",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 57,
    "name": "Meowth 1",
    "species": "Meowth",
    "instance": "1",
    "nature": "Quirky",
    "item": "Persim Berry",
    "move1": "Slash",
    "move2": "Bite",
    "move3": "Screech",
    "move4": "Fake Out",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 58,
    "name": "Pineco 1",
    "species": "Pineco",
    "instance": "1",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Selfdestruct",
    "move2": "Take Down",
    "move3": "Reflect",
    "move4": "Light Screen",
    "speed50": 35,
    "speed100": 66
  },
  {
    "entry": 59,
    "name": "Trapinch 1",
    "species": "Trapinch",
    "instance": "1",
    "nature": "Serious",
    "item": "Lax Incense",
    "move1": "Toxic",
    "move2": "Dig",
    "move3": "Sandstorm",
    "move4": "Sand-Attack",
    "speed50": 30,
    "speed100": 56
  },
  {
    "entry": 60,
    "name": "Spheal 1",
    "species": "Spheal",
    "instance": "1",
    "nature": "Docile",
    "item": "NeverMeltIce",
    "move1": "Ice Ball",
    "move2": "Water Pulse",
    "move3": "Hail",
    "move4": "Mud-Slap",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 61,
    "name": "Horsea 1",
    "species": "Horsea",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Petaya Berry",
    "move1": "Water Gun",
    "move2": "Agility",
    "move3": "Icy Wind",
    "move4": "Twister",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 62,
    "name": "Shroomish 1",
    "species": "Shroomish",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Miracle Seed",
    "move1": "Spore",
    "move2": "Bullet Seed",
    "move3": "Leech Seed",
    "move4": "Headbutt",
    "speed50": 49,
    "speed100": 95
  },
  {
    "entry": 63,
    "name": "Shuppet 1",
    "species": "Shuppet",
    "instance": "1",
    "nature": "Rash",
    "item": "Rawst Berry",
    "move1": "Will-O-Wisp",
    "move2": "Night Shade",
    "move3": "Grudge",
    "move4": "Knock Off",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 64,
    "name": "Duskull 1",
    "species": "Duskull",
    "instance": "1",
    "nature": "Quirky",
    "item": "Persim Berry",
    "move1": "Skill Swap",
    "move2": "Night Shade",
    "move3": "Disable",
    "move4": "Confuse Ray",
    "speed50": 77,
    "speed100": 149
  },
  {
    "entry": 65,
    "name": "Electrike 1",
    "species": "Electrike",
    "instance": "1",
    "nature": "Docile",
    "item": "Cheri Berry",
    "move1": "Spark",
    "move2": "Thunder Wave",
    "move3": "Roar",
    "move4": "Quick Attack",
    "speed50": 117,
    "speed100": 229
  },
  {
    "entry": 66,
    "name": "Vulpix 1",
    "species": "Vulpix",
    "instance": "1",
    "nature": "Docile",
    "item": "Rawst Berry",
    "move1": "Will-O-Wisp",
    "move2": "Confuse Ray",
    "move3": "Fire Spin",
    "move4": "Quick Attack",
    "speed50": 117,
    "speed100": 229
  },
  {
    "entry": 67,
    "name": "Pikachu 1",
    "species": "Pikachu",
    "instance": "1",
    "nature": "Docile",
    "item": "Light Ball",
    "move1": "ThunderPunch",
    "move2": "Thunder Wave",
    "move3": "Double Team",
    "move4": "Quick Attack",
    "speed50": 142,
    "speed100": 279
  },
  {
    "entry": 68,
    "name": "Sandshrew 1",
    "species": "Sandshrew",
    "instance": "1",
    "nature": "Docile",
    "item": "Soft Sand",
    "move1": "Dig",
    "move2": "Rock Tomb",
    "move3": "Sandstorm",
    "move4": "Sand-Attack",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 69,
    "name": "Poliwag 1",
    "species": "Poliwag",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Mystic Water",
    "move1": "Hypnosis",
    "move2": "Icy Wind",
    "move3": "Water Gun",
    "move4": "Rain Dance",
    "speed50": 127,
    "speed100": 251
  },
  {
    "entry": 70,
    "name": "Bellsprout 1",
    "species": "Bellsprout",
    "instance": "1",
    "nature": "Lax",
    "item": "Sitrus Berry",
    "move1": "Razor Leaf",
    "move2": "Acid",
    "move3": "Stun Spore",
    "move4": "Wrap",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 71,
    "name": "Geodude 1",
    "species": "Geodude",
    "instance": "1",
    "nature": "Brave",
    "item": "Focus Band",
    "move1": "Magnitude",
    "move2": "Rock Blast",
    "move3": "Strength",
    "move4": "Protect",
    "speed50": 36,
    "speed100": 68
  },
  {
    "entry": 72,
    "name": "Dratini 1",
    "species": "Dratini",
    "instance": "1",
    "nature": "Docile",
    "item": "Persim Berry",
    "move1": "Outrage",
    "move2": "Thunder Wave",
    "move3": "Supersonic",
    "move4": "Water Pulse",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 73,
    "name": "Snubbull 1",
    "species": "Snubbull",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Scope Lens",
    "move1": "Bite",
    "move2": "Charm",
    "move3": "Swagger",
    "move4": "Scary Face",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 74,
    "name": "Remoraid 1",
    "species": "Remoraid",
    "instance": "1",
    "nature": "Quirky",
    "item": "Petaya Berry",
    "move1": "BubbleBeam",
    "move2": "Aurora Beam",
    "move3": "Psybeam",
    "move4": "Protect",
    "speed50": 117,
    "speed100": 229
  },
  {
    "entry": 75,
    "name": "Larvitar 1",
    "species": "Larvitar",
    "instance": "1",
    "nature": "Naughty",
    "item": "Persim Berry",
    "move1": "Thrash",
    "move2": "Rock Slide",
    "move3": "Dig",
    "move4": "Dragon Dance",
    "speed50": 61,
    "speed100": 118
  },
  {
    "entry": 76,
    "name": "Baltoy 1",
    "species": "Baltoy",
    "instance": "1",
    "nature": "Naughty",
    "item": "Persim Berry",
    "move1": "Psybeam",
    "move2": "AncientPower",
    "move3": "Light Screen",
    "move4": "Mud-Slap",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 77,
    "name": "Snorunt 1",
    "species": "Snorunt",
    "instance": "1",
    "nature": "Brave",
    "item": "Persim Berry",
    "move1": "Icy Wind",
    "move2": "Headbutt",
    "move3": "Leer",
    "move4": "Bite",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 78,
    "name": "Bagon 1",
    "species": "Bagon",
    "instance": "1",
    "nature": "Naughty",
    "item": "Liechi Berry",
    "move1": "DragonBreath",
    "move2": "Headbutt",
    "move3": "Brick Break",
    "move4": "Scary Face",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 79,
    "name": "Beldum 1",
    "species": "Beldum",
    "instance": "1",
    "nature": "Hardy",
    "item": "Choice Band",
    "move1": "Take Down",
    "move2": "---",
    "move3": "---",
    "move4": "---",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 80,
    "name": "Gulpin 1",
    "species": "Gulpin",
    "instance": "1",
    "nature": "Serious",
    "item": "Lax Incense",
    "move1": "Toxic",
    "move2": "Yawn",
    "move3": "Pain Split",
    "move4": "Attract",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 81,
    "name": "Venonat 1",
    "species": "Venonat",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Sitrus Berry",
    "move1": "Psybeam",
    "move2": "Supersonic",
    "move3": "Stun Spore",
    "move4": "Skill Swap",
    "speed50": 58,
    "speed100": 113
  },
  {
    "entry": 82,
    "name": "Mankey 1",
    "species": "Mankey",
    "instance": "1",
    "nature": "Naughty",
    "item": "Black Belt",
    "move1": "Karate Chop",
    "move2": "Low Kick",
    "move3": "Screech",
    "move4": "Swagger",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 83,
    "name": "Machop 1",
    "species": "Machop",
    "instance": "1",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Seismic Toss",
    "move2": "Revenge",
    "move3": "Rock Tomb",
    "move4": "Scary Face",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 84,
    "name": "Shellder 1",
    "species": "Shellder",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Cheri Berry",
    "move1": "Icicle Spear",
    "move2": "Supersonic",
    "move3": "Clamp",
    "move4": "Withdraw",
    "speed50": 54,
    "speed100": 104
  },
  {
    "entry": 85,
    "name": "Smoochum 1",
    "species": "Smoochum",
    "instance": "1",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Sweet Kiss",
    "move2": "Sing",
    "move3": "Mud-Slap",
    "move4": "Fake Out",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 86,
    "name": "Numel 1",
    "species": "Numel",
    "instance": "1",
    "nature": "Hardy",
    "item": "Lax Incense",
    "move1": "Ember",
    "move2": "Magnitude",
    "move3": "Rock Tomb",
    "move4": "Sandstorm",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 87,
    "name": "Carvanha 1",
    "species": "Carvanha",
    "instance": "1",
    "nature": "Quiet",
    "item": "Shell Bell",
    "move1": "Bite",
    "move2": "Screech",
    "move3": "Scary Face",
    "move4": "Swagger",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 88,
    "name": "Corphish 1",
    "species": "Corphish",
    "instance": "1",
    "nature": "Brave",
    "item": "Mystic Water",
    "move1": "Crabhammer",
    "move2": "Water Pulse",
    "move3": "Mud-Slap",
    "move4": "Protect",
    "speed50": 49,
    "speed100": 95
  },
  {
    "entry": 89,
    "name": "Charmander 1",
    "species": "Charmander",
    "instance": "1",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Fire Spin",
    "move2": "Metal Claw",
    "move3": "SmokeScreen",
    "move4": "Scary Face",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 90,
    "name": "Cyndaquil 1",
    "species": "Cyndaquil",
    "instance": "1",
    "nature": "Docile",
    "item": "Sitrus Berry",
    "move1": "Ember",
    "move2": "Swift",
    "move3": "Quick Attack",
    "move4": "SmokeScreen",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 91,
    "name": "Abra 1",
    "species": "Abra",
    "instance": "1",
    "nature": "Lonely",
    "item": "TwistedSpoon",
    "move1": "Mimic",
    "move2": "Metronome",
    "move3": "Flash",
    "move4": "Seismic Toss",
    "speed50": 142,
    "speed100": 279
  },
  {
    "entry": 92,
    "name": "Doduo 1",
    "species": "Doduo",
    "instance": "1",
    "nature": "Lonely",
    "item": "Liechi Berry",
    "move1": "Fury Attack",
    "move2": "Uproar",
    "move3": "Mud-Slap",
    "move4": "Faint Attack",
    "speed50": 127,
    "speed100": 249
  },
  {
    "entry": 93,
    "name": "Gastly 1",
    "species": "Gastly",
    "instance": "1",
    "nature": "Lonely",
    "item": "Lax Incense",
    "move1": "Dream Eater",
    "move2": "Hypnosis",
    "move3": "Night Shade",
    "move4": "Confuse Ray",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 94,
    "name": "Swablu 1",
    "species": "Swablu",
    "instance": "1",
    "nature": "Lonely",
    "item": "Mental Herb",
    "move1": "Take Down",
    "move2": "Dream Eater",
    "move3": "Sing",
    "move4": "Attract",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 95,
    "name": "Treecko 1",
    "species": "Treecko",
    "instance": "1",
    "nature": "Lonely",
    "item": "Scope Lens",
    "move1": "Bullet Seed",
    "move2": "Aerial Ace",
    "move3": "Quick Attack",
    "move4": "Double Team",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 96,
    "name": "Torchic 1",
    "species": "Torchic",
    "instance": "1",
    "nature": "Lonely",
    "item": "BrightPowder",
    "move1": "Fire Spin",
    "move2": "Quick Attack",
    "move3": "Sand-Attack",
    "move4": "Double Team",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 97,
    "name": "Mudkip 1",
    "species": "Mudkip",
    "instance": "1",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Whirlpool",
    "move2": "Endeavor",
    "move3": "Mud Sport",
    "move4": "Mud-Slap",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 98,
    "name": "Squirtle 1",
    "species": "Squirtle",
    "instance": "1",
    "nature": "Docile",
    "item": "Sitrus Berry",
    "move1": "Water Pulse",
    "move2": "Bite",
    "move3": "Withdraw",
    "move4": "Protect",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 99,
    "name": "Totodile 1",
    "species": "Totodile",
    "instance": "1",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Slash",
    "move2": "Water Pulse",
    "move3": "Screech",
    "move4": "Icy Wind",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 100,
    "name": "Slowpoke 1",
    "species": "Slowpoke",
    "instance": "1",
    "nature": "Brave",
    "item": "Sitrus Berry",
    "move1": "Confusion",
    "move2": "Disable",
    "move3": "Water Pulse",
    "move4": "Yawn",
    "speed50": 31,
    "speed100": 59
  },
  {
    "entry": 101,
    "name": "Bulbasaur 1",
    "species": "Bulbasaur",
    "instance": "1",
    "nature": "Relaxed",
    "item": "BrightPowder",
    "move1": "Razor Leaf",
    "move2": "Sweet Scent",
    "move3": "Sleep Powder",
    "move4": "Light Screen",
    "speed50": 58,
    "speed100": 113
  },
  {
    "entry": 102,
    "name": "Chikorita 1",
    "species": "Chikorita",
    "instance": "1",
    "nature": "Relaxed",
    "item": "BrightPowder",
    "move1": "Secret Power",
    "move2": "Bullet Seed",
    "move3": "Mud-Slap",
    "move4": "Light Screen",
    "speed50": 58,
    "speed100": 113
  },
  {
    "entry": 103,
    "name": "Oddish 1",
    "species": "Oddish",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Pecha Berry",
    "move1": "Acid",
    "move2": "Stun Spore",
    "move3": "Sweet Scent",
    "move4": "Moonlight",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 104,
    "name": "Psyduck 1",
    "species": "Psyduck",
    "instance": "1",
    "nature": "Hasty",
    "item": "Persim Berry",
    "move1": "Confusion",
    "move2": "Fury Swipes",
    "move3": "Aerial Ace",
    "move4": "Disable",
    "speed50": 83,
    "speed100": 160
  },
  {
    "entry": 105,
    "name": "Cubone 1",
    "species": "Cubone",
    "instance": "1",
    "nature": "Hardy",
    "item": "Soft Sand",
    "move1": "Bone Club",
    "move2": "Headbutt",
    "move3": "Brick Break",
    "move4": "Aerial Ace",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 106,
    "name": "Goldeen 1",
    "species": "Goldeen",
    "instance": "1",
    "nature": "Docile",
    "item": "Petaya Berry",
    "move1": "Waterfall",
    "move2": "Fury Attack",
    "move3": "Agility",
    "move4": "Psybeam",
    "speed50": 83,
    "speed100": 162
  },
  {
    "entry": 107,
    "name": "Natu 1",
    "species": "Natu",
    "instance": "1",
    "nature": "Relaxed",
    "item": "TwistedSpoon",
    "move1": "Night Shade",
    "move2": "Future Sight",
    "move3": "Confuse Ray",
    "move4": "Flash",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 108,
    "name": "Clefairy 1",
    "species": "Clefairy",
    "instance": "1",
    "nature": "Lonely",
    "item": "Lax Incense",
    "move1": "Follow Me",
    "move2": "Return",
    "move3": "Encore",
    "move4": "Sing",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 109,
    "name": "Magnemite 1",
    "species": "Magnemite",
    "instance": "1",
    "nature": "Gentle",
    "item": "Rawst Berry",
    "move1": "Shock Wave",
    "move2": "Supersonic",
    "move3": "Metal Sound",
    "move4": "Reflect",
    "speed50": 97,
    "speed100": 189
  },
  {
    "entry": 110,
    "name": "Seel 1",
    "species": "Seel",
    "instance": "1",
    "nature": "Hardy",
    "item": "Aspear Berry",
    "move1": "Aurora Beam",
    "move2": "Dive",
    "move3": "Body Slam",
    "move4": "Fake Out",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 111,
    "name": "Grimer 1",
    "species": "Grimer",
    "instance": "1",
    "nature": "Quirky",
    "item": "Pecha Berry",
    "move1": "Sludge",
    "move2": "Rock Tomb",
    "move3": "Acid Armor",
    "move4": "Minimize",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 112,
    "name": "Krabby 1",
    "species": "Krabby",
    "instance": "1",
    "nature": "Hardy",
    "item": "Focus Band",
    "move1": "Crabhammer",
    "move2": "Mud Shot",
    "move3": "Flail",
    "move4": "Knock Off",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 113,
    "name": "Exeggcute 1",
    "species": "Exeggcute",
    "instance": "1",
    "nature": "Naughty",
    "item": "Persim Berry",
    "move1": "Confusion",
    "move2": "AncientPower",
    "move3": "Leech Seed",
    "move4": "Light Screen",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 114,
    "name": "Eevee 1",
    "species": "Eevee",
    "instance": "1",
    "nature": "Docile",
    "item": "Salac Berry",
    "move1": "Charm",
    "move2": "Attract",
    "move3": "Flail",
    "move4": "Endure",
    "speed50": 107,
    "speed100": 209
  },
  {
    "entry": 115,
    "name": "Drowzee 1",
    "species": "Drowzee",
    "instance": "1",
    "nature": "Quirky",
    "item": "Sitrus Berry",
    "move1": "Confusion",
    "move2": "Headbutt",
    "move3": "Disable",
    "move4": "Barrier",
    "speed50": 62,
    "speed100": 120
  },
  {
    "entry": 116,
    "name": "Voltorb 1",
    "species": "Voltorb",
    "instance": "1",
    "nature": "Docile",
    "item": "Lax Incense",
    "move1": "Spark",
    "move2": "Screech",
    "move3": "Rollout",
    "move4": "Light Screen",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 117,
    "name": "Chinchou 1",
    "species": "Chinchou",
    "instance": "1",
    "nature": "Hardy",
    "item": "Lax Incense",
    "move1": "Spark",
    "move2": "Dive",
    "move3": "Confuse Ray",
    "move4": "Take Down",
    "speed50": 87,
    "speed100": 170
  },
  {
    "entry": 118,
    "name": "Teddiursa 1",
    "species": "Teddiursa",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Chesto Berry",
    "move1": "Secret Power",
    "move2": "Fake Tears",
    "move3": "Faint Attack",
    "move4": "Rest",
    "speed50": 54,
    "speed100": 104
  },
  {
    "entry": 119,
    "name": "Delibird 1",
    "species": "Delibird",
    "instance": "1",
    "nature": "Docile",
    "item": "NeverMeltIce",
    "move1": "Present",
    "move2": "Ice Ball",
    "move3": "Aerial Ace",
    "move4": "Hail",
    "speed50": 95,
    "speed100": 186
  },
  {
    "entry": 120,
    "name": "Houndour 1",
    "species": "Houndour",
    "instance": "1",
    "nature": "Docile",
    "item": "Charcoal",
    "move1": "Crunch",
    "move2": "Ember",
    "move3": "Roar",
    "move4": "Protect",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 121,
    "name": "Phanpy 1",
    "species": "Phanpy",
    "instance": "1",
    "nature": "Naughty",
    "item": "Lax Incense",
    "move1": "Rollout",
    "move2": "Defense Curl",
    "move3": "Rock Tomb",
    "move4": "Sandstorm",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 122,
    "name": "Spoink 1",
    "species": "Spoink",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Sitrus Berry",
    "move1": "Psywave",
    "move2": "Bounce",
    "move3": "Magic Coat",
    "move4": "Confuse Ray",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 123,
    "name": "Aron 1",
    "species": "Aron",
    "instance": "1",
    "nature": "Docile",
    "item": "Persim Berry",
    "move1": "Metal Claw",
    "move2": "Aerial Ace",
    "move3": "Metal Sound",
    "move4": "Roar",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 124,
    "name": "Luvdisc 1",
    "species": "Luvdisc",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Quick Claw",
    "move1": "Sweet Kiss",
    "move2": "Attract",
    "move3": "Dive",
    "move4": "Rain Dance",
    "speed50": 105,
    "speed100": 207
  },
  {
    "entry": 125,
    "name": "Tentacool 1",
    "species": "Tentacool",
    "instance": "1",
    "nature": "Hardy",
    "item": "Pecha Berry",
    "move1": "BubbleBeam",
    "move2": "Acid",
    "move3": "Barrier",
    "move4": "Wrap",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 126,
    "name": "Cacnea 1",
    "species": "Cacnea",
    "instance": "1",
    "nature": "Quirky",
    "item": "Sitrus Berry",
    "move1": "Needle Arm",
    "move2": "Faint Attack",
    "move3": "Cotton Spore",
    "move4": "Sand-Attack",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 127,
    "name": "Unown 1",
    "species": "Unown",
    "instance": "1",
    "nature": "Hardy",
    "item": "Lax Incense",
    "move1": "Hidden Power",
    "move2": "---",
    "move3": "---",
    "move4": "---",
    "speed50": 68,
    "speed100": 132
  },
  {
    "entry": 128,
    "name": "Koffing 1",
    "species": "Koffing",
    "instance": "1",
    "nature": "Quirky",
    "item": "Poison Barb",
    "move1": "Sludge",
    "move2": "SmokeScreen",
    "move3": "Torment",
    "move4": "Haze",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 129,
    "name": "Staryu 1",
    "species": "Staryu",
    "instance": "1",
    "nature": "Quirky",
    "item": "Shell Bell",
    "move1": "BubbleBeam",
    "move2": "Minimize",
    "move3": "Swift",
    "move4": "Light Screen",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 130,
    "name": "Skiploom 1",
    "species": "Skiploom",
    "instance": "1",
    "nature": "Docile",
    "item": "Persim Berry",
    "move1": "Mega Drain",
    "move2": "Confusion",
    "move3": "Cotton Spore",
    "move4": "Synthesis",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 131,
    "name": "Nuzleaf 1",
    "species": "Nuzleaf",
    "instance": "1",
    "nature": "Hardy",
    "item": "Sitrus Berry",
    "move1": "Extrasensory",
    "move2": "Fake Out",
    "move3": "Razor Wind",
    "move4": "Faint Attack",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 132,
    "name": "Lombre 1",
    "species": "Lombre",
    "instance": "1",
    "nature": "Quirky",
    "item": "Lax Incense",
    "move1": "Water Pulse",
    "move2": "Fake Out",
    "move3": "Brick Break",
    "move4": "Absorb",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 133,
    "name": "Vibrava 1",
    "species": "Vibrava",
    "instance": "1",
    "nature": "Quirky",
    "item": "Cheri Berry",
    "move1": "DragonBreath",
    "move2": "Dig",
    "move3": "Screech",
    "move4": "Rock Tomb",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 134,
    "name": "Rhyhorn 1",
    "species": "Rhyhorn",
    "instance": "1",
    "nature": "Hardy",
    "item": "Focus Band",
    "move1": "Rock Blast",
    "move2": "Dig",
    "move3": "Scary Face",
    "move4": "Roar",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 135,
    "name": "Clamperl 1",
    "species": "Clamperl",
    "instance": "1",
    "nature": "Docile",
    "item": "DeepSeaScale",
    "move1": "Dive",
    "move2": "Toxic",
    "move3": "Iron Defense",
    "move4": "Double Team",
    "speed50": 52,
    "speed100": 100
  },
  {
    "entry": 136,
    "name": "Pidgeotto 1",
    "species": "Pidgeotto",
    "instance": "1",
    "nature": "Quirky",
    "item": "White Herb",
    "move1": "Aerial Ace",
    "move2": "Quick Attack",
    "move3": "FeatherDance",
    "move4": "Sand-Attack",
    "speed50": 91,
    "speed100": 178
  },
  {
    "entry": 137,
    "name": "Growlithe 1",
    "species": "Growlithe",
    "instance": "1",
    "nature": "Docile",
    "item": "Rawst Berry",
    "move1": "Flame Wheel",
    "move2": "Bite",
    "move3": "Roar",
    "move4": "Agility",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 138,
    "name": "Farfetch'd 1",
    "species": "Farfetch'd",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Stick",
    "move1": "Slash",
    "move2": "Knock Off",
    "move3": "Swords Dance",
    "move4": "Agility",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 139,
    "name": "Omanyte 1",
    "species": "Omanyte",
    "instance": "1",
    "nature": "Quirky",
    "item": "Sitrus Berry",
    "move1": "Mud Shot",
    "move2": "Water Gun",
    "move3": "AncientPower",
    "move4": "Tickle",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 140,
    "name": "Kabuto 1",
    "species": "Kabuto",
    "instance": "1",
    "nature": "Hardy",
    "item": "Sitrus Berry",
    "move1": "Mega Drain",
    "move2": "AncientPower",
    "move3": "Sand-Attack",
    "move4": "Protect",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 141,
    "name": "Lileep 1",
    "species": "Lileep",
    "instance": "1",
    "nature": "Docile",
    "item": "Lax Incense",
    "move1": "AncientPower",
    "move2": "Acid",
    "move3": "Ingrain",
    "move4": "Confuse Ray",
    "speed50": 43,
    "speed100": 82
  },
  {
    "entry": 142,
    "name": "Anorith 1",
    "species": "Anorith",
    "instance": "1",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Metal Claw",
    "move2": "Fury Cutter",
    "move3": "AncientPower",
    "move4": "Water Gun",
    "speed50": 95,
    "speed100": 186
  },
  {
    "entry": 143,
    "name": "Aipom 1",
    "species": "Aipom",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Silk Scarf",
    "move1": "Fury Swipes",
    "move2": "Sand-Attack",
    "move3": "Baton Pass",
    "move4": "Agility",
    "speed50": 94,
    "speed100": 185
  },
  {
    "entry": 144,
    "name": "Elekid 1",
    "species": "Elekid",
    "instance": "1",
    "nature": "Naive",
    "item": "Cheri Berry",
    "move1": "ThunderPunch",
    "move2": "Quick Attack",
    "move3": "Swift",
    "move4": "Light Screen",
    "speed50": 127,
    "speed100": 248
  },
  {
    "entry": 145,
    "name": "Loudred 1",
    "species": "Loudred",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Focus Band",
    "move1": "Stomp",
    "move2": "Howl",
    "move3": "Astonish",
    "move4": "Supersonic",
    "speed50": 61,
    "speed100": 118
  },
  {
    "entry": 146,
    "name": "Spinda 1",
    "species": "Spinda",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Sitrus Berry",
    "move1": "Dizzy Punch",
    "move2": "Teeter Dance",
    "move3": "Psybeam",
    "move4": "Faint Attack",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 147,
    "name": "Nidorina 1",
    "species": "Nidorina",
    "instance": "1",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Double Kick",
    "move2": "Bite",
    "move3": "Aerial Ace",
    "move4": "Flatter",
    "speed50": 76,
    "speed100": 148
  },
  {
    "entry": 148,
    "name": "Nidorino 1",
    "species": "Nidorino",
    "instance": "1",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Double Kick",
    "move2": "Water Pulse",
    "move3": "Mud-Slap",
    "move4": "Flatter",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 149,
    "name": "Flaaffy 1",
    "species": "Flaaffy",
    "instance": "1",
    "nature": "Mild",
    "item": "Magnet",
    "move1": "Shock Wave",
    "move2": "Thunder Wave",
    "move3": "Cotton Spore",
    "move4": "Light Screen",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 150,
    "name": "Magby 1",
    "species": "Magby",
    "instance": "1",
    "nature": "Docile",
    "item": "Lax Incense",
    "move1": "Fire Punch",
    "move2": "SmokeScreen",
    "move3": "Confuse Ray",
    "move4": "Smog",
    "speed50": 103,
    "speed100": 202
  },
  {
    "entry": 151,
    "name": "Nosepass 1",
    "species": "Nosepass",
    "instance": "1",
    "nature": "Sassy",
    "item": "Hard Stone",
    "move1": "Rock Slide",
    "move2": "Shock Wave",
    "move3": "Thunder Wave",
    "move4": "Sandstorm",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 152,
    "name": "Corsola 1",
    "species": "Corsola",
    "instance": "1",
    "nature": "Impish",
    "item": "Sitrus Berry",
    "move1": "BubbleBeam",
    "move2": "Mirror Coat",
    "move3": "Attract",
    "move4": "AncientPower",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 153,
    "name": "Mawile 1",
    "species": "Mawile",
    "instance": "1",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Crunch",
    "move2": "Fake Tears",
    "move3": "Iron Defense",
    "move4": "Baton Pass",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 154,
    "name": "Butterfree 1",
    "species": "Butterfree",
    "instance": "1",
    "nature": "Quirky",
    "item": "Pecha Berry",
    "move1": "Silver Wind",
    "move2": "Psybeam",
    "move3": "Toxic",
    "move4": "Whirlwind",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 155,
    "name": "Beedrill 1",
    "species": "Beedrill",
    "instance": "1",
    "nature": "Naughty",
    "item": "Scope Lens",
    "move1": "Twineedle",
    "move2": "Pursuit",
    "move3": "Endeavor",
    "move4": "Agility",
    "speed50": 127,
    "speed100": 249
  },
  {
    "entry": 156,
    "name": "Poliwhirl 1",
    "species": "Poliwhirl",
    "instance": "1",
    "nature": "Quirky",
    "item": "Petaya Berry",
    "move1": "Water Pulse",
    "move2": "DoubleSlap",
    "move3": "Icy Wind",
    "move4": "Rain Dance",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 157,
    "name": "Onix 1",
    "species": "Onix",
    "instance": "1",
    "nature": "Hardy",
    "item": "Sitrus Berry",
    "move1": "Rock Slide",
    "move2": "Bind",
    "move3": "DragonBreath",
    "move4": "Sandstorm",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 158,
    "name": "Beautifly 1",
    "species": "Beautifly",
    "instance": "1",
    "nature": "Docile",
    "item": "Mental Herb",
    "move1": "Silver Wind",
    "move2": "Mega Drain",
    "move3": "Attract",
    "move4": "Whirlwind",
    "speed50": 117,
    "speed100": 229
  },
  {
    "entry": 159,
    "name": "Dustox 1",
    "species": "Dustox",
    "instance": "1",
    "nature": "Docile",
    "item": "SilverPowder",
    "move1": "Silver Wind",
    "move2": "Toxic",
    "move3": "Psybeam",
    "move4": "Whirlwind",
    "speed50": 117,
    "speed100": 229
  },
  {
    "entry": 160,
    "name": "Ledian 1",
    "species": "Ledian",
    "instance": "1",
    "nature": "Bashful",
    "item": "Focus Band",
    "move1": "Comet Punch",
    "move2": "Baton Pass",
    "move3": "Swords Dance",
    "move4": "Agility",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 161,
    "name": "Ariados 1",
    "species": "Ariados",
    "instance": "1",
    "nature": "Serious",
    "item": "Lax Incense",
    "move1": "Signal Beam",
    "move2": "Spider Web",
    "move3": "Night Shade",
    "move4": "Toxic",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 162,
    "name": "Yanma 1",
    "species": "Yanma",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Lax Incense",
    "move1": "Signal Beam",
    "move2": "Aerial Ace",
    "move3": "Double Team",
    "move4": "Detect",
    "speed50": 103,
    "speed100": 203
  },
  {
    "entry": 163,
    "name": "Delcatty 1",
    "species": "Delcatty",
    "instance": "1",
    "nature": "Lonely",
    "item": "Sitrus Berry",
    "move1": "Secret Power",
    "move2": "Faint Attack",
    "move3": "Double Team",
    "move4": "Heal Bell",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 164,
    "name": "Sableye 1",
    "species": "Sableye",
    "instance": "1",
    "nature": "Lonely",
    "item": "BlackGlasses",
    "move1": "Faint Attack",
    "move2": "Confuse Ray",
    "move3": "Knock Off",
    "move4": "Fake Out",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 165,
    "name": "Lickitung 1",
    "species": "Lickitung",
    "instance": "1",
    "nature": "Quirky",
    "item": "Sitrus Berry",
    "move1": "Slam",
    "move2": "Brick Break",
    "move3": "Lick",
    "move4": "Mud-Slap",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 166,
    "name": "Weepinbell 1",
    "species": "Weepinbell",
    "instance": "1",
    "nature": "Quiet",
    "item": "Scope Lens",
    "move1": "Razor Leaf",
    "move2": "Acid",
    "move3": "Wrap",
    "move4": "Sweet Scent",
    "speed50": 67,
    "speed100": 131
  },
  {
    "entry": 167,
    "name": "Graveler 1",
    "species": "Graveler",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Magnitude",
    "move2": "Rock Throw",
    "move3": "Defense Curl",
    "move4": "Brick Break",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 168,
    "name": "Gloom 1",
    "species": "Gloom",
    "instance": "1",
    "nature": "Quirky",
    "item": "Persim Berry",
    "move1": "Petal Dance",
    "move2": "Acid",
    "move3": "Stun Spore",
    "move4": "Moonlight",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 169,
    "name": "Porygon 1",
    "species": "Porygon",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Sitrus Berry",
    "move1": "Psybeam",
    "move2": "Icy Wind",
    "move3": "Recycle",
    "move4": "Agility",
    "speed50": 54,
    "speed100": 104
  },
  {
    "entry": 170,
    "name": "Kadabra 1",
    "species": "Kadabra",
    "instance": "1",
    "nature": "Impish",
    "item": "TwistedSpoon",
    "move1": "Confusion",
    "move2": "Role Play",
    "move3": "Future Sight",
    "move4": "Disable",
    "speed50": 125,
    "speed100": 246
  },
  {
    "entry": 171,
    "name": "Wailmer 1",
    "species": "Wailmer",
    "instance": "1",
    "nature": "Docile",
    "item": "Lax Incense",
    "move1": "Whirlpool",
    "move2": "Roar",
    "move3": "Defense Curl",
    "move4": "Rollout",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 172,
    "name": "Roselia 1",
    "species": "Roselia",
    "instance": "1",
    "nature": "Docile",
    "item": "Pecha Berry",
    "move1": "Magical Leaf",
    "move2": "Toxic",
    "move3": "GrassWhistle",
    "move4": "Cotton Spore",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 173,
    "name": "Volbeat 1",
    "species": "Volbeat",
    "instance": "1",
    "nature": "Quirky",
    "item": "Liechi Berry",
    "move1": "Silver Wind",
    "move2": "Confuse Ray",
    "move3": "Quick Attack",
    "move4": "Helping Hand",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 174,
    "name": "Illumise 1",
    "species": "Illumise",
    "instance": "1",
    "nature": "Quirky",
    "item": "Liechi Berry",
    "move1": "Silver Wind",
    "move2": "Wish",
    "move3": "Quick Attack",
    "move4": "Helping Hand",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 175,
    "name": "Ivysaur 1",
    "species": "Ivysaur",
    "instance": "1",
    "nature": "Gentle",
    "item": "Persim Berry",
    "move1": "Petal Dance",
    "move2": "Growth",
    "move3": "Sweet Scent",
    "move4": "Fury Cutter",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 176,
    "name": "Charmeleon 1",
    "species": "Charmeleon",
    "instance": "1",
    "nature": "Naughty",
    "item": "Scope Lens",
    "move1": "Slash",
    "move2": "Fire Spin",
    "move3": "Swords Dance",
    "move4": "Aerial Ace",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 177,
    "name": "Wartortle 1",
    "species": "Wartortle",
    "instance": "1",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Water Pulse",
    "move2": "Bite",
    "move3": "Mud-Slap",
    "move4": "Yawn",
    "speed50": 78,
    "speed100": 152
  },
  {
    "entry": 178,
    "name": "Parasect 1",
    "species": "Parasect",
    "instance": "1",
    "nature": "Rash",
    "item": "Sitrus Berry",
    "move1": "Slash",
    "move2": "Psybeam",
    "move3": "Stun Spore",
    "move4": "Flash",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 179,
    "name": "Machoke 1",
    "species": "Machoke",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Low Kick",
    "move2": "Rock Tomb",
    "move3": "Foresight",
    "move4": "Scary Face",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 180,
    "name": "Haunter 1",
    "species": "Haunter",
    "instance": "1",
    "nature": "Rash",
    "item": "Persim Berry",
    "move1": "Shadow Punch",
    "move2": "Confuse Ray",
    "move3": "Spite",
    "move4": "Grudge",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 181,
    "name": "Bayleef 1",
    "species": "Bayleef",
    "instance": "1",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Razor Leaf",
    "move2": "Toxic",
    "move3": "Safeguard",
    "move4": "Light Screen",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 182,
    "name": "Quilava 1",
    "species": "Quilava",
    "instance": "1",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Flame Wheel",
    "move2": "Fury Swipes",
    "move3": "Swift",
    "move4": "SmokeScreen",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 183,
    "name": "Croconaw 1",
    "species": "Croconaw",
    "instance": "1",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Slash",
    "move2": "Water Pulse",
    "move3": "Bite",
    "move4": "Scary Face",
    "speed50": 78,
    "speed100": 152
  },
  {
    "entry": 184,
    "name": "Togetic 1",
    "species": "Togetic",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Lax Incense",
    "move1": "Aerial Ace",
    "move2": "Magical Leaf",
    "move3": "Wish",
    "move4": "Follow Me",
    "speed50": 54,
    "speed100": 104
  },
  {
    "entry": 185,
    "name": "Murkrow 1",
    "species": "Murkrow",
    "instance": "1",
    "nature": "Quirky",
    "item": "Lax Incense",
    "move1": "Faint Attack",
    "move2": "Fly",
    "move3": "Torment",
    "move4": "Taunt",
    "speed50": 111,
    "speed100": 218
  },
  {
    "entry": 186,
    "name": "Wobbuffet 1",
    "species": "Wobbuffet",
    "instance": "1",
    "nature": "Careful",
    "item": "Focus Band",
    "move1": "Counter",
    "move2": "Mirror Coat",
    "move3": "Charm",
    "move4": "Safeguard",
    "speed50": 53,
    "speed100": 102
  },
  {
    "entry": 187,
    "name": "Plusle 1",
    "species": "Plusle",
    "instance": "1",
    "nature": "Docile",
    "item": "Petaya Berry",
    "move1": "Spark",
    "move2": "Fake Tears",
    "move3": "Quick Attack",
    "move4": "Helping Hand",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 188,
    "name": "Minun 1",
    "species": "Minun",
    "instance": "1",
    "nature": "Docile",
    "item": "Salac Berry",
    "move1": "Spark",
    "move2": "Charm",
    "move3": "Encore",
    "move4": "Helping Hand",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 189,
    "name": "Grovyle 1",
    "species": "Grovyle",
    "instance": "1",
    "nature": "Relaxed",
    "item": "BrightPowder",
    "move1": "Fury Cutter",
    "move2": "Endeavor",
    "move3": "Brick Break",
    "move4": "Double Team",
    "speed50": 103,
    "speed100": 203
  },
  {
    "entry": 190,
    "name": "Combusken 1",
    "species": "Combusken",
    "instance": "1",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Ember",
    "move2": "Double Kick",
    "move3": "Quick Attack",
    "move4": "Sand-Attack",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 191,
    "name": "Marshtomp 1",
    "species": "Marshtomp",
    "instance": "1",
    "nature": "Hardy",
    "item": "Focus Band",
    "move1": "Mud Shot",
    "move2": "Water Gun",
    "move3": "Rock Tomb",
    "move4": "Mud-Slap",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 192,
    "name": "Ponyta 1",
    "species": "Ponyta",
    "instance": "1",
    "nature": "Hardy",
    "item": "Rawst Berry",
    "move1": "Fire Spin",
    "move2": "Bounce",
    "move3": "Quick Attack",
    "move4": "Tail Whip",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 193,
    "name": "Azumarill 1",
    "species": "Azumarill",
    "instance": "1",
    "nature": "Docile",
    "item": "Sitrus Berry",
    "move1": "BubbleBeam",
    "move2": "Facade",
    "move3": "Dig",
    "move4": "Protect",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 194,
    "name": "Sudowoodo 1",
    "species": "Sudowoodo",
    "instance": "1",
    "nature": "Hardy",
    "item": "Hard Stone",
    "move1": "Rock Slide",
    "move2": "Faint Attack",
    "move3": "Sandstorm",
    "move4": "Block",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 195,
    "name": "Magcargo 1",
    "species": "Magcargo",
    "instance": "1",
    "nature": "Gentle",
    "item": "Lax Incense",
    "move1": "Rock Slide",
    "move2": "Ember",
    "move3": "Acid Armor",
    "move4": "Sandstorm",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 196,
    "name": "Pupitar 1",
    "species": "Pupitar",
    "instance": "1",
    "nature": "Hardy",
    "item": "Soft Sand",
    "move1": "Dig",
    "move2": "Bite",
    "move3": "Scary Face",
    "move4": "Sandstorm",
    "speed50": 103,
    "speed100": 201
  },
  {
    "entry": 197,
    "name": "Sealeo 1",
    "species": "Sealeo",
    "instance": "1",
    "nature": "Quirky",
    "item": "Persim Berry",
    "move1": "Ice Ball",
    "move2": "Hail",
    "move3": "Snore",
    "move4": "Rest",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 198,
    "name": "Raticate 1",
    "species": "Raticate",
    "instance": "1",
    "nature": "Naive",
    "item": "Silk Scarf",
    "move1": "Endeavor",
    "move2": "Pursuit",
    "move3": "Scary Face",
    "move4": "Quick Attack",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 199,
    "name": "Masquerain 1",
    "species": "Masquerain",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Cheri Berry",
    "move1": "Silver Wind",
    "move2": "Aerial Ace",
    "move3": "Icy Wind",
    "move4": "Stun Spore",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 200,
    "name": "Furret 1",
    "species": "Furret",
    "instance": "1",
    "nature": "Serious",
    "item": "Liechi Berry",
    "move1": "Slam",
    "move2": "Protect",
    "move3": "Helping Hand",
    "move4": "Follow Me",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 201,
    "name": "Dunsparce 1",
    "species": "Dunsparce",
    "instance": "1",
    "nature": "Docile",
    "item": "Lax Incense",
    "move1": "Headbutt",
    "move2": "Glare",
    "move3": "Defense Curl",
    "move4": "Rollout",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 202,
    "name": "Dragonair 1",
    "species": "Dragonair",
    "instance": "1",
    "nature": "Docile",
    "item": "Cheri Berry",
    "move1": "DragonBreath",
    "move2": "Leer",
    "move3": "Wrap",
    "move4": "Safeguard",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 203,
    "name": "Mightyena 1",
    "species": "Mightyena",
    "instance": "1",
    "nature": "Timid",
    "item": "Mental Herb",
    "move1": "Bite",
    "move2": "Poison Fang",
    "move3": "Taunt",
    "move4": "Roar",
    "speed50": 99,
    "speed100": 193
  },
  {
    "entry": 204,
    "name": "Linoone 1",
    "species": "Linoone",
    "instance": "1",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Secret Power",
    "move2": "Sand-Attack",
    "move3": "Covet",
    "move4": "Tickle",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 205,
    "name": "Castform 1",
    "species": "Castform",
    "instance": "1",
    "nature": "Hasty",
    "item": "Petaya Berry",
    "move1": "Ember",
    "move2": "Water Pulse",
    "move3": "Shock Wave",
    "move4": "Icy Wind",
    "speed50": 99,
    "speed100": 193
  },
  {
    "entry": 206,
    "name": "Shelgon 1",
    "species": "Shelgon",
    "instance": "1",
    "nature": "Hardy",
    "item": "Cheri Berry",
    "move1": "Headbutt",
    "move2": "DragonBreath",
    "move3": "Protect",
    "move4": "Scary Face",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 207,
    "name": "Metang 1",
    "species": "Metang",
    "instance": "1",
    "nature": "Hardy",
    "item": "Focus Band",
    "move1": "Metal Claw",
    "move2": "Confusion",
    "move3": "Pursuit",
    "move4": "Scary Face",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 208,
    "name": "Wigglytuff 1",
    "species": "Wigglytuff",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Silk Scarf",
    "move1": "Sing",
    "move2": "Disable",
    "move3": "Wish",
    "move4": "Secret Power",
    "speed50": 58,
    "speed100": 113
  },
  {
    "entry": 209,
    "name": "Sunflora 1",
    "species": "Sunflora",
    "instance": "1",
    "nature": "Quirky",
    "item": "Persim Berry",
    "move1": "Petal Dance",
    "move2": "Ingrain",
    "move3": "Leech Seed",
    "move4": "Light Screen",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 210,
    "name": "Chimecho 1",
    "species": "Chimecho",
    "instance": "1",
    "nature": "Sassy",
    "item": "TwistedSpoon",
    "move1": "Psywave",
    "move2": "Take Down",
    "move3": "Heal Bell",
    "move4": "Safeguard",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 211,
    "name": "Gligar 1",
    "species": "Gligar",
    "instance": "1",
    "nature": "Hasty",
    "item": "Scope Lens",
    "move1": "Metal Claw",
    "move2": "Dig",
    "move3": "Aerial Ace",
    "move4": "Quick Attack",
    "speed50": 116,
    "speed100": 226
  },
  {
    "entry": 212,
    "name": "Qwilfish 1",
    "species": "Qwilfish",
    "instance": "1",
    "nature": "Impish",
    "item": "Cheri Berry",
    "move1": "BubbleBeam",
    "move2": "Pin Missile",
    "move3": "Spikes",
    "move4": "Minimize",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 213,
    "name": "Sneasel 1",
    "species": "Sneasel",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Persim Berry",
    "move1": "Faint Attack",
    "move2": "Fake Out",
    "move3": "Icy Wind",
    "move4": "Quick Attack",
    "speed50": 121,
    "speed100": 239
  },
  {
    "entry": 214,
    "name": "Pelipper 1",
    "species": "Pelipper",
    "instance": "1",
    "nature": "Quiet",
    "item": "Sitrus Berry",
    "move1": "Water Pulse",
    "move2": "Aerial Ace",
    "move3": "Stockpile",
    "move4": "Swallow",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 215,
    "name": "Swellow 1",
    "species": "Swellow",
    "instance": "1",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Fly",
    "move2": "Endeavor",
    "move3": "Facade",
    "move4": "Quick Attack",
    "speed50": 145,
    "speed100": 286
  },
  {
    "entry": 216,
    "name": "Lairon 1",
    "species": "Lairon",
    "instance": "1",
    "nature": "Sassy",
    "item": "Metal Coat",
    "move1": "Metal Claw",
    "move2": "Rock Tomb",
    "move3": "Iron Defense",
    "move4": "Protect",
    "speed50": 54,
    "speed100": 104
  },
  {
    "entry": 217,
    "name": "Tangela 1",
    "species": "Tangela",
    "instance": "1",
    "nature": "Hardy",
    "item": "Lax Incense",
    "move1": "Mega Drain",
    "move2": "Slam",
    "move3": "Toxic",
    "move4": "Bind",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 218,
    "name": "Arbok 1",
    "species": "Arbok",
    "instance": "1",
    "nature": "Adamant",
    "item": "Persim Berry",
    "move1": "Poison Fang",
    "move2": "Dig",
    "move3": "Bite",
    "move4": "Glare",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 219,
    "name": "Persian 1",
    "species": "Persian",
    "instance": "1",
    "nature": "Quirky",
    "item": "Silk Scarf",
    "move1": "Fake Out",
    "move2": "Slash",
    "move3": "Torment",
    "move4": "Swagger",
    "speed50": 135,
    "speed100": 266
  },
  {
    "entry": 220,
    "name": "Seadra 1",
    "species": "Seadra",
    "instance": "1",
    "nature": "Sassy",
    "item": "Mystic Water",
    "move1": "Aurora Beam",
    "move2": "SmokeScreen",
    "move3": "Water Gun",
    "move4": "Rain Dance",
    "speed50": 94,
    "speed100": 185
  },
  {
    "entry": 221,
    "name": "Kecleon 1",
    "species": "Kecleon",
    "instance": "1",
    "nature": "Naive",
    "item": "Focus Band",
    "move1": "Secret Power",
    "move2": "Psybeam",
    "move3": "Magic Coat",
    "move4": "Seismic Toss",
    "speed50": 66,
    "speed100": 127
  },
  {
    "entry": 222,
    "name": "Vigoroth 1",
    "species": "Vigoroth",
    "instance": "1",
    "nature": "Lonely",
    "item": "Focus Band",
    "move1": "Slash",
    "move2": "Counter",
    "move3": "Encore",
    "move4": "Uproar",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 223,
    "name": "Lunatone 1",
    "species": "Lunatone",
    "instance": "1",
    "nature": "Quiet",
    "item": "Sitrus Berry",
    "move1": "Confusion",
    "move2": "Cosmic Power",
    "move3": "Light Screen",
    "move4": "Sandstorm",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 224,
    "name": "Solrock 1",
    "species": "Solrock",
    "instance": "1",
    "nature": "Quiet",
    "item": "Sitrus Berry",
    "move1": "Confusion",
    "move2": "Fire Spin",
    "move3": "Light Screen",
    "move4": "Sandstorm",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 225,
    "name": "Noctowl 1",
    "species": "Noctowl",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Persim Berry",
    "move1": "Confusion",
    "move2": "Aerial Ace",
    "move3": "Faint Attack",
    "move4": "Reflect",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 226,
    "name": "Sandslash 1",
    "species": "Sandslash",
    "instance": "1",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Crush Claw",
    "move2": "Rock Slide",
    "move3": "Swift",
    "move4": "Sandstorm",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 227,
    "name": "Venomoth 1",
    "species": "Venomoth",
    "instance": "1",
    "nature": "Quirky",
    "item": "Persim Berry",
    "move1": "Silver Wind",
    "move2": "Psybeam",
    "move3": "Sleep Powder",
    "move4": "Skill Swap",
    "speed50": 142,
    "speed100": 279
  },
  {
    "entry": 228,
    "name": "Chansey 1",
    "species": "Chansey",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Sitrus Berry",
    "move1": "Metronome",
    "move2": "Refresh",
    "move3": "Defense Curl",
    "move4": "Minimize",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 229,
    "name": "Seaking 1",
    "species": "Seaking",
    "instance": "1",
    "nature": "Docile",
    "item": "Sitrus Berry",
    "move1": "Water Pulse",
    "move2": "Psybeam",
    "move3": "Swift",
    "move4": "Agility",
    "speed50": 88,
    "speed100": 172
  },
  {
    "entry": 230,
    "name": "Jumpluff 1",
    "species": "Jumpluff",
    "instance": "1",
    "nature": "Docile",
    "item": "Lax Incense",
    "move1": "Aerial Ace",
    "move2": "Swagger",
    "move3": "Psych Up",
    "move4": "Synthesis",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 231,
    "name": "Piloswine 1",
    "species": "Piloswine",
    "instance": "1",
    "nature": "Quirky",
    "item": "Soft Sand",
    "move1": "Dig",
    "move2": "AncientPower",
    "move3": "Hail",
    "move4": "Light Screen",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 232,
    "name": "Golbat 1",
    "species": "Golbat",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Scope Lens",
    "move1": "Air Cutter",
    "move2": "Confuse Ray",
    "move3": "Toxic",
    "move4": "Steel Wing",
    "speed50": 99,
    "speed100": 194
  },
  {
    "entry": 233,
    "name": "Primeape 1",
    "species": "Primeape",
    "instance": "1",
    "nature": "Quirky",
    "item": "Scope Lens",
    "move1": "Karate Chop",
    "move2": "Counter",
    "move3": "Swagger",
    "move4": "Screech",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 234,
    "name": "Hitmonlee 1",
    "species": "Hitmonlee",
    "instance": "1",
    "nature": "Adamant",
    "item": "Black Belt",
    "move1": "Rolling Kick",
    "move2": "Brick Break",
    "move3": "Focus Energy",
    "move4": "Facade",
    "speed50": 107,
    "speed100": 210
  },
  {
    "entry": 235,
    "name": "Hitmonchan 1",
    "species": "Hitmonchan",
    "instance": "1",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Mach Punch",
    "move2": "Sky Uppercut",
    "move3": "Detect",
    "move4": "Counter",
    "speed50": 96,
    "speed100": 188
  },
  {
    "entry": 236,
    "name": "Girafarig 1",
    "species": "Girafarig",
    "instance": "1",
    "nature": "Quiet",
    "item": "Petaya Berry",
    "move1": "Psybeam",
    "move2": "Stomp",
    "move3": "Wish",
    "move4": "Skill Swap",
    "speed50": 94,
    "speed100": 185
  },
  {
    "entry": 237,
    "name": "Hitmontop 1",
    "species": "Hitmontop",
    "instance": "1",
    "nature": "Hardy",
    "item": "Liechi Berry",
    "move1": "Triple Kick",
    "move2": "Dig",
    "move3": "Mach Punch",
    "move4": "Quick Attack",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 238,
    "name": "Banette 1",
    "species": "Banette",
    "instance": "1",
    "nature": "Sassy",
    "item": "Rawst Berry",
    "move1": "Night Shade",
    "move2": "Will-O-Wisp",
    "move3": "Spite",
    "move4": "Knock Off",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 239,
    "name": "Ninjask 1",
    "species": "Ninjask",
    "instance": "1",
    "nature": "Mild",
    "item": "Petaya Berry",
    "move1": "Baton Pass",
    "move2": "Swords Dance",
    "move3": "Endure",
    "move4": "Dig",
    "speed50": 180,
    "speed100": 356
  },
  {
    "entry": 240,
    "name": "Seviper 1",
    "species": "Seviper",
    "instance": "1",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Poison Tail",
    "move2": "Bite",
    "move3": "Glare",
    "move4": "Screech",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 241,
    "name": "Zangoose 1",
    "species": "Zangoose",
    "instance": "1",
    "nature": "Hardy",
    "item": "Persim Berry",
    "move1": "Slash",
    "move2": "Double Kick",
    "move3": "Roar",
    "move4": "Quick Attack",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 242,
    "name": "Camerupt 1",
    "species": "Camerupt",
    "instance": "1",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Magnitude",
    "move2": "Protect",
    "move3": "Sandstorm",
    "move4": "Rock Slide",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 243,
    "name": "Sharpedo 1",
    "species": "Sharpedo",
    "instance": "1",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Slash",
    "move2": "Bite",
    "move3": "Water Pulse",
    "move4": "Scary Face",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 244,
    "name": "Tropius 1",
    "species": "Tropius",
    "instance": "1",
    "nature": "Hardy",
    "item": "Sitrus Berry",
    "move1": "Magical Leaf",
    "move2": "Whirlwind",
    "move3": "Aerial Ace",
    "move4": "Steel Wing",
    "speed50": 71,
    "speed100": 138
  },
  {
    "entry": 245,
    "name": "Magneton 1",
    "species": "Magneton",
    "instance": "1",
    "nature": "Lonely",
    "item": "Cheri Berry",
    "move1": "Shock Wave",
    "move2": "SonicBoom",
    "move3": "Thunder Wave",
    "move4": "Supersonic",
    "speed50": 122,
    "speed100": 239
  },
  {
    "entry": 246,
    "name": "Mantine 1",
    "species": "Mantine",
    "instance": "1",
    "nature": "Docile",
    "item": "Mystic Water",
    "move1": "BubbleBeam",
    "move2": "Aerial Ace",
    "move3": "Rain Dance",
    "move4": "Icy Wind",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 247,
    "name": "Stantler 1",
    "species": "Stantler",
    "instance": "1",
    "nature": "Gentle",
    "item": "TwistedSpoon",
    "move1": "Extrasensory",
    "move2": "Confuse Ray",
    "move3": "Stomp",
    "move4": "Sand-Attack",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 248,
    "name": "Absol 1",
    "species": "Absol",
    "instance": "1",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Bite",
    "move2": "Razor Wind",
    "move3": "Future Sight",
    "move4": "Quick Attack",
    "speed50": 95,
    "speed100": 186
  },
  {
    "entry": 249,
    "name": "Swalot 1",
    "species": "Swalot",
    "instance": "1",
    "nature": "Quirky",
    "item": "Lax Incense",
    "move1": "Stockpile",
    "move2": "Swallow",
    "move3": "Spit Up",
    "move4": "Sludge",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 250,
    "name": "Crawdaunt 1",
    "species": "Crawdaunt",
    "instance": "1",
    "nature": "Adamant",
    "item": "Persim Berry",
    "move1": "BubbleBeam",
    "move2": "ViceGrip",
    "move3": "Knock Off",
    "move4": "Protect",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 251,
    "name": "Pidgeot 1",
    "species": "Pidgeot",
    "instance": "1",
    "nature": "Hardy",
    "item": "Sharp Beak",
    "move1": "Aerial Ace",
    "move2": "FeatherDance",
    "move3": "Mud-Slap",
    "move4": "Faint Attack",
    "speed50": 111,
    "speed100": 218
  },
  {
    "entry": 252,
    "name": "Grumpig 1",
    "species": "Grumpig",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Petaya Berry",
    "move1": "Psybeam",
    "move2": "Confuse Ray",
    "move3": "Future Sight",
    "move4": "Magic Coat",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 253,
    "name": "Torkoal 1",
    "species": "Torkoal",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Sitrus Berry",
    "move1": "Ember",
    "move2": "Fire Spin",
    "move3": "SmokeScreen",
    "move4": "Amnesia",
    "speed50": 36,
    "speed100": 68
  },
  {
    "entry": 254,
    "name": "Kingler 1",
    "species": "Kingler",
    "instance": "1",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Crabhammer",
    "move2": "Metal Claw",
    "move3": "Mud Shot",
    "move4": "Protect",
    "speed50": 95,
    "speed100": 186
  },
  {
    "entry": 255,
    "name": "Cacturne 1",
    "species": "Cacturne",
    "instance": "1",
    "nature": "Hasty",
    "item": "Scope Lens",
    "move1": "Needle Arm",
    "move2": "Faint Attack",
    "move3": "Acid",
    "move4": "Mega Punch",
    "speed50": 117,
    "speed100": 229
  },
  {
    "entry": 256,
    "name": "Bellossom 1",
    "species": "Bellossom",
    "instance": "1",
    "nature": "Quiet",
    "item": "Persim Berry",
    "move1": "Petal Dance",
    "move2": "Safeguard",
    "move3": "Sunny Day",
    "move4": "Synthesis",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 257,
    "name": "Octillery 1",
    "species": "Octillery",
    "instance": "1",
    "nature": "Hardy",
    "item": "Shell Bell",
    "move1": "Octazooka",
    "move2": "Aurora Beam",
    "move3": "Psybeam",
    "move4": "Rock Blast",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 258,
    "name": "Huntail 1",
    "species": "Huntail",
    "instance": "1",
    "nature": "Quiet",
    "item": "Persim Berry",
    "move1": "Whirlpool",
    "move2": "Scary Face",
    "move3": "Mud-Slap",
    "move4": "Bite",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 259,
    "name": "Gorebyss 1",
    "species": "Gorebyss",
    "instance": "1",
    "nature": "Brave",
    "item": "Persim Berry",
    "move1": "Whirlpool",
    "move2": "Amnesia",
    "move3": "Icy Wind",
    "move4": "Confusion",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 260,
    "name": "Relicanth 1",
    "species": "Relicanth",
    "instance": "1",
    "nature": "Sassy",
    "item": "Liechi Berry",
    "move1": "AncientPower",
    "move2": "Water Pulse",
    "move3": "Harden",
    "move4": "Amnesia",
    "speed50": 67,
    "speed100": 131
  },
  {
    "entry": 261,
    "name": "Omastar 1",
    "species": "Omastar",
    "instance": "1",
    "nature": "Quirky",
    "item": "Shell Bell",
    "move1": "BubbleBeam",
    "move2": "Spike Cannon",
    "move3": "Tickle",
    "move4": "AncientPower",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 262,
    "name": "Kabutops 1",
    "species": "Kabutops",
    "instance": "1",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Slash",
    "move2": "Dig",
    "move3": "Fury Cutter",
    "move4": "Knock Off",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 263,
    "name": "Poliwrath 1",
    "species": "Poliwrath",
    "instance": "1",
    "nature": "Adamant",
    "item": "Black Belt",
    "move1": "Submission",
    "move2": "Dig",
    "move3": "Rock Tomb",
    "move4": "BubbleBeam",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 264,
    "name": "Scyther 1",
    "species": "Scyther",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Liechi Berry",
    "move1": "Fury Cutter",
    "move2": "Aerial Ace",
    "move3": "Light Screen",
    "move4": "Double Team",
    "speed50": 112,
    "speed100": 221
  },
  {
    "entry": 265,
    "name": "Pinsir 1",
    "species": "Pinsir",
    "instance": "1",
    "nature": "Naughty",
    "item": "Black Belt",
    "move1": "Submission",
    "move2": "Focus Energy",
    "move3": "Swords Dance",
    "move4": "Revenge",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 266,
    "name": "Politoed 1",
    "species": "Politoed",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Shell Bell",
    "move1": "Dive",
    "move2": "Dig",
    "move3": "Hypnosis",
    "move4": "Swagger",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 267,
    "name": "Cloyster 1",
    "species": "Cloyster",
    "instance": "1",
    "nature": "Sassy",
    "item": "NeverMeltIce",
    "move1": "Aurora Beam",
    "move2": "Spike Cannon",
    "move3": "Supersonic",
    "move4": "Protect",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 268,
    "name": "Delcatty 2",
    "species": "Delcatty",
    "instance": "2",
    "nature": "Modest",
    "item": "Quick Claw",
    "move1": "Fake Tears",
    "move2": "Sing",
    "move3": "Thunderbolt",
    "move4": "Ice Beam",
    "speed50": 122,
    "speed100": 239
  },
  {
    "entry": 269,
    "name": "Sableye 2",
    "species": "Sableye",
    "instance": "2",
    "nature": "Quirky",
    "item": "Lum Berry",
    "move1": "Shadow Ball",
    "move2": "Faint Attack",
    "move3": "Confuse Ray",
    "move4": "Recover",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 270,
    "name": "Lickitung 2",
    "species": "Lickitung",
    "instance": "2",
    "nature": "Adamant",
    "item": "Cheri Berry",
    "move1": "Earthquake",
    "move2": "Body Slam",
    "move3": "Shadow Ball",
    "move4": "Rock Slide",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 271,
    "name": "Weepinbell 2",
    "species": "Weepinbell",
    "instance": "2",
    "nature": "Quirky",
    "item": "Scope Lens",
    "move1": "Sludge Bomb",
    "move2": "Razor Leaf",
    "move3": "Sleep Powder",
    "move4": "Reflect",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 272,
    "name": "Graveler 2",
    "species": "Graveler",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Brick Break",
    "move4": "Counter",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 273,
    "name": "Gloom 2",
    "species": "Gloom",
    "instance": "2",
    "nature": "Quirky",
    "item": "Pecha Berry",
    "move1": "SolarBeam",
    "move2": "Sunny Day",
    "move3": "Sludge Bomb",
    "move4": "Moonlight",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 274,
    "name": "Porygon 2",
    "species": "Porygon",
    "instance": "2",
    "nature": "Quiet",
    "item": "Cheri Berry",
    "move1": "Tri Attack",
    "move2": "Psychic",
    "move3": "Thunder Wave",
    "move4": "Recover",
    "speed50": 54,
    "speed100": 104
  },
  {
    "entry": 275,
    "name": "Kadabra 2",
    "species": "Kadabra",
    "instance": "2",
    "nature": "Modest",
    "item": "TwistedSpoon",
    "move1": "Psychic",
    "move2": "Thunder Wave",
    "move3": "Reflect",
    "move4": "Recover",
    "speed50": 125,
    "speed100": 246
  },
  {
    "entry": 276,
    "name": "Wailmer 2",
    "species": "Wailmer",
    "instance": "2",
    "nature": "Docile",
    "item": "Chesto Berry",
    "move1": "Water Spout",
    "move2": "Earthquake",
    "move3": "Body Slam",
    "move4": "Rest",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 277,
    "name": "Roselia 2",
    "species": "Roselia",
    "instance": "2",
    "nature": "Docile",
    "item": "Quick Claw",
    "move1": "Giga Drain",
    "move2": "Sludge Bomb",
    "move3": "GrassWhistle",
    "move4": "Synthesis",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 278,
    "name": "Volbeat 2",
    "species": "Volbeat",
    "instance": "2",
    "nature": "Quirky",
    "item": "Petaya Berry",
    "move1": "Signal Beam",
    "move2": "Thunderbolt",
    "move3": "Ice Punch",
    "move4": "Tail Glow",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 279,
    "name": "Illumise 2",
    "species": "Illumise",
    "instance": "2",
    "nature": "Quirky",
    "item": "Petaya Berry",
    "move1": "Silver Wind",
    "move2": "Thunderbolt",
    "move3": "Ice Punch",
    "move4": "Giga Drain",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 280,
    "name": "Ivysaur 2",
    "species": "Ivysaur",
    "instance": "2",
    "nature": "Quirky",
    "item": "BrightPowder",
    "move1": "Giga Drain",
    "move2": "Sludge Bomb",
    "move3": "Sleep Powder",
    "move4": "Leech Seed",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 281,
    "name": "Charmeleon 2",
    "species": "Charmeleon",
    "instance": "2",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Flamethrower",
    "move2": "Slash",
    "move3": "AncientPower",
    "move4": "Dragon Rage",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 282,
    "name": "Wartortle 2",
    "species": "Wartortle",
    "instance": "2",
    "nature": "Docile",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Rapid Spin",
    "move4": "Protect",
    "speed50": 78,
    "speed100": 152
  },
  {
    "entry": 283,
    "name": "Parasect 2",
    "species": "Parasect",
    "instance": "2",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Spore",
    "move2": "Giga Drain",
    "move3": "Dig",
    "move4": "Double Team",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 284,
    "name": "Machoke 2",
    "species": "Machoke",
    "instance": "2",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Cross Chop",
    "move2": "Rock Slide",
    "move3": "Foresight",
    "move4": "Scary Face",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 285,
    "name": "Haunter 2",
    "species": "Haunter",
    "instance": "2",
    "nature": "Relaxed",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Hypnosis",
    "move3": "Nightmare",
    "move4": "Confuse Ray",
    "speed50": 103,
    "speed100": 203
  },
  {
    "entry": 286,
    "name": "Bayleef 2",
    "species": "Bayleef",
    "instance": "2",
    "nature": "Docile",
    "item": "Chesto Berry",
    "move1": "Giga Drain",
    "move2": "Body Slam",
    "move3": "GrassWhistle",
    "move4": "Rest",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 287,
    "name": "Quilava 2",
    "species": "Quilava",
    "instance": "2",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Flamethrower",
    "move2": "Crush Claw",
    "move3": "Body Slam",
    "move4": "SmokeScreen",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 288,
    "name": "Croconaw 2",
    "species": "Croconaw",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Mega Kick",
    "move2": "Aerial Ace",
    "move3": "Rock Slide",
    "move4": "Dig",
    "speed50": 78,
    "speed100": 152
  },
  {
    "entry": 289,
    "name": "Togetic 2",
    "species": "Togetic",
    "instance": "2",
    "nature": "Relaxed",
    "item": "Scope Lens",
    "move1": "Return",
    "move2": "Sweet Kiss",
    "move3": "Aerial Ace",
    "move4": "Yawn",
    "speed50": 54,
    "speed100": 104
  },
  {
    "entry": 290,
    "name": "Murkrow 2",
    "species": "Murkrow",
    "instance": "2",
    "nature": "Quirky",
    "item": "BrightPowder",
    "move1": "Perish Song",
    "move2": "Mean Look",
    "move3": "Double Team",
    "move4": "Thunder Wave",
    "speed50": 111,
    "speed100": 218
  },
  {
    "entry": 291,
    "name": "Wobbuffet 2",
    "species": "Wobbuffet",
    "instance": "2",
    "nature": "Careful",
    "item": "Focus Band",
    "move1": "Counter",
    "move2": "Mirror Coat",
    "move3": "Encore",
    "move4": "Destiny Bond",
    "speed50": 53,
    "speed100": 102
  },
  {
    "entry": 292,
    "name": "Plusle 2",
    "species": "Plusle",
    "instance": "2",
    "nature": "Docile",
    "item": "Petaya Berry",
    "move1": "Thunderbolt",
    "move2": "Thunder Wave",
    "move3": "Seismic Toss",
    "move4": "Wish",
    "speed50": 147,
    "speed100": 289
  },
  {
    "entry": 293,
    "name": "Minun 2",
    "species": "Minun",
    "instance": "2",
    "nature": "Docile",
    "item": "Salac Berry",
    "move1": "Thunderbolt",
    "move2": "Attract",
    "move3": "Charm",
    "move4": "Wish",
    "speed50": 147,
    "speed100": 289
  },
  {
    "entry": 294,
    "name": "Grovyle 2",
    "species": "Grovyle",
    "instance": "2",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "Giga Drain",
    "move2": "Crush Claw",
    "move3": "Screech",
    "move4": "Rock Tomb",
    "speed50": 147,
    "speed100": 289
  },
  {
    "entry": 295,
    "name": "Combusken 2",
    "species": "Combusken",
    "instance": "2",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Flamethrower",
    "move2": "Sky Uppercut",
    "move3": "Slash",
    "move4": "Sand-Attack",
    "speed50": 96,
    "speed100": 188
  },
  {
    "entry": 296,
    "name": "Marshtomp 2",
    "species": "Marshtomp",
    "instance": "2",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Muddy Water",
    "move2": "Earthquake",
    "move3": "Mud-Slap",
    "move4": "Protect",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 297,
    "name": "Ponyta 2",
    "species": "Ponyta",
    "instance": "2",
    "nature": "Quirky",
    "item": "Sitrus Berry",
    "move1": "Flamethrower",
    "move2": "Body Slam",
    "move3": "Double Kick",
    "move4": "Double Team",
    "speed50": 142,
    "speed100": 279
  },
  {
    "entry": 298,
    "name": "Azumarill 2",
    "species": "Azumarill",
    "instance": "2",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Mega Kick",
    "move2": "Brick Break",
    "move3": "Iron Tail",
    "move4": "Dig",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 299,
    "name": "Sudowoodo 2",
    "species": "Sudowoodo",
    "instance": "2",
    "nature": "Hardy",
    "item": "Focus Band",
    "move1": "Mega Kick",
    "move2": "Earthquake",
    "move3": "Low Kick",
    "move4": "Selfdestruct",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 300,
    "name": "Magcargo 2",
    "species": "Magcargo",
    "instance": "2",
    "nature": "Quiet",
    "item": "Quick Claw",
    "move1": "Overheat",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Body Slam",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 301,
    "name": "Pupitar 2",
    "species": "Pupitar",
    "instance": "2",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Crunch",
    "move4": "Scary Face",
    "speed50": 71,
    "speed100": 138
  },
  {
    "entry": 302,
    "name": "Sealeo 2",
    "species": "Sealeo",
    "instance": "2",
    "nature": "Quiet",
    "item": "Sitrus Berry",
    "move1": "Ice Beam",
    "move2": "Surf",
    "move3": "Body Slam",
    "move4": "Hail",
    "speed50": 58,
    "speed100": 113
  },
  {
    "entry": 303,
    "name": "Raticate 2",
    "species": "Raticate",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Super Fang",
    "move2": "Hyper Fang",
    "move3": "Shadow Ball",
    "move4": "Scary Face",
    "speed50": 149,
    "speed100": 293
  },
  {
    "entry": 304,
    "name": "Masquerain 2",
    "species": "Masquerain",
    "instance": "2",
    "nature": "Quiet",
    "item": "Lax Incense",
    "move1": "Hydro Pump",
    "move2": "Ice Beam",
    "move3": "Giga Drain",
    "move4": "Stun Spore",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 305,
    "name": "Furret 2",
    "species": "Furret",
    "instance": "2",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Trick",
    "move2": "Frustration",
    "move3": "Shadow Ball",
    "move4": "Follow Me",
    "speed50": 142,
    "speed100": 279
  },
  {
    "entry": 306,
    "name": "Dunsparce 2",
    "species": "Dunsparce",
    "instance": "2",
    "nature": "Quiet",
    "item": "Lax Incense",
    "move1": "Ice Beam",
    "move2": "Rock Tomb",
    "move3": "Bite",
    "move4": "Shadow Ball",
    "speed50": 58,
    "speed100": 113
  },
  {
    "entry": 307,
    "name": "Dragonair 2",
    "species": "Dragonair",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Return",
    "move2": "Rest",
    "move3": "Thunder Wave",
    "move4": "Dragon Dance",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 308,
    "name": "Mightyena 2",
    "species": "Mightyena",
    "instance": "2",
    "nature": "Quirky",
    "item": "King's Rock",
    "move1": "Crunch",
    "move2": "Shadow Ball",
    "move3": "Frustration",
    "move4": "Scary Face",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 309,
    "name": "Linoone 2",
    "species": "Linoone",
    "instance": "2",
    "nature": "Jolly",
    "item": "Choice Band",
    "move1": "Trick",
    "move2": "Frustration",
    "move3": "Thunder Wave",
    "move4": "Sand-Attack",
    "speed50": 167,
    "speed100": 328
  },
  {
    "entry": 310,
    "name": "Castform 2",
    "species": "Castform",
    "instance": "2",
    "nature": "Modest",
    "item": "Lax Incense",
    "move1": "Thunderbolt",
    "move2": "Flamethrower",
    "move3": "Ice Beam",
    "move4": "Water Pulse",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 311,
    "name": "Shelgon 2",
    "species": "Shelgon",
    "instance": "2",
    "nature": "Hardy",
    "item": "Focus Band",
    "move1": "Frustration",
    "move2": "Dragon Dance",
    "move3": "Crunch",
    "move4": "Scary Face",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 312,
    "name": "Metang 2",
    "species": "Metang",
    "instance": "2",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Meteor Mash",
    "move2": "Psychic",
    "move3": "Body Slam",
    "move4": "Scary Face",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 313,
    "name": "Wigglytuff 2",
    "species": "Wigglytuff",
    "instance": "2",
    "nature": "Docile",
    "item": "Sitrus Berry",
    "move1": "Fake Tears",
    "move2": "Sing",
    "move3": "Dream Eater",
    "move4": "Brick Break",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 314,
    "name": "Sunflora 2",
    "species": "Sunflora",
    "instance": "2",
    "nature": "Quiet",
    "item": "Leftovers",
    "move1": "Giga Drain",
    "move2": "GrassWhistle",
    "move3": "Growth",
    "move4": "Double Team",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 315,
    "name": "Chimecho 2",
    "species": "Chimecho",
    "instance": "2",
    "nature": "Quiet",
    "item": "TwistedSpoon",
    "move1": "Psychic",
    "move2": "Hypnosis",
    "move3": "Dream Eater",
    "move4": "Heal Bell",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 316,
    "name": "Gligar 2",
    "species": "Gligar",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Aerial Ace",
    "move3": "Guillotine",
    "move4": "Screech",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 317,
    "name": "Qwilfish 2",
    "species": "Qwilfish",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Revenge",
    "move2": "Sludge Bomb",
    "move3": "Shadow Ball",
    "move4": "Destiny Bond",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 318,
    "name": "Sneasel 2",
    "species": "Sneasel",
    "instance": "2",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Crush Claw",
    "move2": "Brick Break",
    "move3": "Aerial Ace",
    "move4": "Screech",
    "speed50": 172,
    "speed100": 338
  },
  {
    "entry": 319,
    "name": "Pelipper 2",
    "species": "Pelipper",
    "instance": "2",
    "nature": "Quiet",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Blizzard",
    "move3": "Aerial Ace",
    "move4": "Protect",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 320,
    "name": "Swellow 2",
    "species": "Swellow",
    "instance": "2",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Facade",
    "move2": "Aerial Ace",
    "move3": "Pursuit",
    "move4": "Double Team",
    "speed50": 145,
    "speed100": 286
  },
  {
    "entry": 321,
    "name": "Lairon 2",
    "species": "Lairon",
    "instance": "2",
    "nature": "Sassy",
    "item": "Sitrus Berry",
    "move1": "Earthquake",
    "move2": "Iron Tail",
    "move3": "Roar",
    "move4": "Protect",
    "speed50": 54,
    "speed100": 104
  },
  {
    "entry": 322,
    "name": "Tangela 2",
    "species": "Tangela",
    "instance": "2",
    "nature": "Calm",
    "item": "Chesto Berry",
    "move1": "Giga Drain",
    "move2": "Stun Spore",
    "move3": "Rest",
    "move4": "Amnesia",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 323,
    "name": "Arbok 2",
    "species": "Arbok",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Sludge Bomb",
    "move2": "Earthquake",
    "move3": "Iron Tail",
    "move4": "Glare",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 324,
    "name": "Persian 2",
    "species": "Persian",
    "instance": "2",
    "nature": "Quirky",
    "item": "Silk Scarf",
    "move1": "Frustration",
    "move2": "Shadow Ball",
    "move3": "Roar",
    "move4": "Fake Out",
    "speed50": 135,
    "speed100": 266
  },
  {
    "entry": 325,
    "name": "Seadra 2",
    "species": "Seadra",
    "instance": "2",
    "nature": "Docile",
    "item": "Shell Bell",
    "move1": "Hydro Pump",
    "move2": "Frustration",
    "move3": "DragonBreath",
    "move4": "Dragon Dance",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 326,
    "name": "Kecleon 2",
    "species": "Kecleon",
    "instance": "2",
    "nature": "Docile",
    "item": "Choice Band",
    "move1": "Trick",
    "move2": "Brick Break",
    "move3": "Shadow Ball",
    "move4": "Skill Swap",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 327,
    "name": "Vigoroth 2",
    "species": "Vigoroth",
    "instance": "2",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Crush Claw",
    "move2": "Reversal",
    "move3": "Endure",
    "move4": "Shadow Ball",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 328,
    "name": "Lunatone 2",
    "species": "Lunatone",
    "instance": "2",
    "nature": "Quiet",
    "item": "Lax Incense",
    "move1": "Psychic",
    "move2": "Ice Beam",
    "move3": "Cosmic Power",
    "move4": "Calm Mind",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 329,
    "name": "Solrock 2",
    "species": "Solrock",
    "instance": "2",
    "nature": "Hardy",
    "item": "White Herb",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Cosmic Power",
    "move4": "Overheat",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 330,
    "name": "Noctowl 2",
    "species": "Noctowl",
    "instance": "2",
    "nature": "Quiet",
    "item": "Persim Berry",
    "move1": "Psychic",
    "move2": "Faint Attack",
    "move3": "Aerial Ace",
    "move4": "Reflect",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 331,
    "name": "Sandslash 2",
    "species": "Sandslash",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Crush Claw",
    "move4": "Sandstorm",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 332,
    "name": "Venomoth 2",
    "species": "Venomoth",
    "instance": "2",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "Signal Beam",
    "move2": "Psychic",
    "move3": "Sludge Bomb",
    "move4": "Giga Drain",
    "speed50": 142,
    "speed100": 279
  },
  {
    "entry": 333,
    "name": "Chansey 2",
    "species": "Chansey",
    "instance": "2",
    "nature": "Relaxed",
    "item": "Leftovers",
    "move1": "Seismic Toss",
    "move2": "Shadow Ball",
    "move3": "Double Team",
    "move4": "Softboiled",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 334,
    "name": "Seaking 2",
    "species": "Seaking",
    "instance": "2",
    "nature": "Impish",
    "item": "Quick Claw",
    "move1": "Horn Drill",
    "move2": "Megahorn",
    "move3": "Sleep Talk",
    "move4": "Rest",
    "speed50": 88,
    "speed100": 172
  },
  {
    "entry": 335,
    "name": "Jumpluff 2",
    "species": "Jumpluff",
    "instance": "2",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Leech Seed",
    "move2": "Sleep Powder",
    "move3": "Giga Drain",
    "move4": "Double Team",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 336,
    "name": "Piloswine 2",
    "species": "Piloswine",
    "instance": "2",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Body Slam",
    "move4": "Roar",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 337,
    "name": "Golbat 2",
    "species": "Golbat",
    "instance": "2",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Sludge Bomb",
    "move2": "Shadow Ball",
    "move3": "Confuse Ray",
    "move4": "Air Cutter",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 338,
    "name": "Primeape 2",
    "species": "Primeape",
    "instance": "2",
    "nature": "Quirky",
    "item": "Scope Lens",
    "move1": "Cross Chop",
    "move2": "Rock Tomb",
    "move3": "Overheat",
    "move4": "Bulk Up",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 339,
    "name": "Hitmonlee 2",
    "species": "Hitmonlee",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Mega Kick",
    "move2": "Brick Break",
    "move3": "Foresight",
    "move4": "Rock Tomb",
    "speed50": 107,
    "speed100": 210
  },
  {
    "entry": 340,
    "name": "Hitmonchan 2",
    "species": "Hitmonchan",
    "instance": "2",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "DynamicPunch",
    "move2": "Mach Punch",
    "move3": "Detect",
    "move4": "Counter",
    "speed50": 96,
    "speed100": 188
  },
  {
    "entry": 341,
    "name": "Girafarig 2",
    "species": "Girafarig",
    "instance": "2",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Crunch",
    "move3": "Baton Pass",
    "move4": "Agility",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 342,
    "name": "Hitmontop 2",
    "species": "Hitmontop",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Double-Edge",
    "move2": "Seismic Toss",
    "move3": "Rock Slide",
    "move4": "Counter",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 343,
    "name": "Banette 2",
    "species": "Banette",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Shadow Ball",
    "move2": "Frustration",
    "move3": "Screech",
    "move4": "Will-O-Wisp",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 344,
    "name": "Ninjask 2",
    "species": "Ninjask",
    "instance": "2",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Slash",
    "move2": "Shadow Ball",
    "move3": "Swords Dance",
    "move4": "Baton Pass",
    "speed50": 180,
    "speed100": 356
  },
  {
    "entry": 345,
    "name": "Seviper 2",
    "species": "Seviper",
    "instance": "2",
    "nature": "Quirky",
    "item": "Quick Claw",
    "move1": "Sludge Bomb",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Giga Drain",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 346,
    "name": "Zangoose 2",
    "species": "Zangoose",
    "instance": "2",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Crush Claw",
    "move2": "Shadow Ball",
    "move3": "Brick Break",
    "move4": "Aerial Ace",
    "speed50": 142,
    "speed100": 279
  },
  {
    "entry": 347,
    "name": "Camerupt 2",
    "species": "Camerupt",
    "instance": "2",
    "nature": "Quirky",
    "item": "Lax Incense",
    "move1": "Earthquake",
    "move2": "Eruption",
    "move3": "Body Slam",
    "move4": "Scary Face",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 348,
    "name": "Sharpedo 2",
    "species": "Sharpedo",
    "instance": "2",
    "nature": "Quirky",
    "item": "Scope Lens",
    "move1": "Double-Edge",
    "move2": "Crunch",
    "move3": "Earthquake",
    "move4": "Surf",
    "speed50": 136,
    "speed100": 268
  },
  {
    "entry": 349,
    "name": "Tropius 2",
    "species": "Tropius",
    "instance": "2",
    "nature": "Quiet",
    "item": "Focus Band",
    "move1": "SolarBeam",
    "move2": "Sunny Day",
    "move3": "Synthesis",
    "move4": "Body Slam",
    "speed50": 64,
    "speed100": 124
  },
  {
    "entry": 350,
    "name": "Magneton 2",
    "species": "Magneton",
    "instance": "2",
    "nature": "Hardy",
    "item": "Lum Berry",
    "move1": "Thunder",
    "move2": "Rain Dance",
    "move3": "Thunder Wave",
    "move4": "Metal Sound",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 351,
    "name": "Mantine 2",
    "species": "Mantine",
    "instance": "2",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Rain Dance",
    "move4": "Confuse Ray",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 352,
    "name": "Stantler 2",
    "species": "Stantler",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Frustration",
    "move2": "Shadow Ball",
    "move3": "Thunder Wave",
    "move4": "Confuse Ray",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 353,
    "name": "Absol 2",
    "species": "Absol",
    "instance": "2",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Double-Edge",
    "move2": "Shadow Ball",
    "move3": "Aerial Ace",
    "move4": "Iron Tail",
    "speed50": 127,
    "speed100": 249
  },
  {
    "entry": 354,
    "name": "Swalot 2",
    "species": "Swalot",
    "instance": "2",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Sludge Bomb",
    "move2": "Shadow Ball",
    "move3": "Body Slam",
    "move4": "Counter",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 355,
    "name": "Crawdaunt 2",
    "species": "Crawdaunt",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Guillotine",
    "move2": "Frustration",
    "move3": "AncientPower",
    "move4": "Aerial Ace",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 356,
    "name": "Pidgeot 2",
    "species": "Pidgeot",
    "instance": "2",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Return",
    "move2": "Aerial Ace",
    "move3": "Steel Wing",
    "move4": "Mud-Slap",
    "speed50": 143,
    "speed100": 281
  },
  {
    "entry": 357,
    "name": "Grumpig 2",
    "species": "Grumpig",
    "instance": "2",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Ice Punch",
    "move3": "ThunderPunch",
    "move4": "Fire Punch",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 358,
    "name": "Torkoal 2",
    "species": "Torkoal",
    "instance": "2",
    "nature": "Sassy",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Body Slam",
    "move3": "SmokeScreen",
    "move4": "Protect",
    "speed50": 36,
    "speed100": 68
  },
  {
    "entry": 359,
    "name": "Kingler 2",
    "species": "Kingler",
    "instance": "2",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Guillotine",
    "move2": "Rock Tomb",
    "move3": "Flail",
    "move4": "Endure",
    "speed50": 95,
    "speed100": 186
  },
  {
    "entry": 360,
    "name": "Cacturne 2",
    "species": "Cacturne",
    "instance": "2",
    "nature": "Hardy",
    "item": "Persim Berry",
    "move1": "Mega Kick",
    "move2": "Teeter Dance",
    "move3": "Faint Attack",
    "move4": "Sandstorm",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 361,
    "name": "Bellossom 2",
    "species": "Bellossom",
    "instance": "2",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "SolarBeam",
    "move2": "Attract",
    "move3": "Sunny Day",
    "move4": "Synthesis",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 362,
    "name": "Octillery 2",
    "species": "Octillery",
    "instance": "2",
    "nature": "Quirky",
    "item": "Lax Incense",
    "move1": "Octazooka",
    "move2": "Fire Blast",
    "move3": "Thunder Wave",
    "move4": "Mud-Slap",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 363,
    "name": "Huntail 2",
    "species": "Huntail",
    "instance": "2",
    "nature": "Quiet",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Rain Dance",
    "move3": "Crunch",
    "move4": "Body Slam",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 364,
    "name": "Gorebyss 2",
    "species": "Gorebyss",
    "instance": "2",
    "nature": "Quiet",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Rain Dance",
    "move3": "Psychic",
    "move4": "Body Slam",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 365,
    "name": "Relicanth 2",
    "species": "Relicanth",
    "instance": "2",
    "nature": "Sassy",
    "item": "Chesto Berry",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Amnesia",
    "move4": "Rest",
    "speed50": 67,
    "speed100": 131
  },
  {
    "entry": 366,
    "name": "Omastar 2",
    "species": "Omastar",
    "instance": "2",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Hydro Pump",
    "move2": "Rain Dance",
    "move3": "Ice Beam",
    "move4": "Protect",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 367,
    "name": "Kabutops 2",
    "species": "Kabutops",
    "instance": "2",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Slash",
    "move2": "Rock Slide",
    "move3": "Flail",
    "move4": "Endure",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 368,
    "name": "Poliwrath 2",
    "species": "Poliwrath",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Brick Break",
    "move2": "Hypnosis",
    "move3": "Rest",
    "move4": "Belly Drum",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 369,
    "name": "Scyther 2",
    "species": "Scyther",
    "instance": "2",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Silver Wind",
    "move2": "Aerial Ace",
    "move3": "Swords Dance",
    "move4": "Double Team",
    "speed50": 157,
    "speed100": 309
  },
  {
    "entry": 370,
    "name": "Pinsir 2",
    "species": "Pinsir",
    "instance": "2",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Guillotine",
    "move2": "Swords Dance",
    "move3": "Flail",
    "move4": "Endure",
    "speed50": 150,
    "speed100": 295
  },
  {
    "entry": 371,
    "name": "Politoed 2",
    "species": "Politoed",
    "instance": "2",
    "nature": "Modest",
    "item": "Lax Incense",
    "move1": "Surf",
    "move2": "Psychic",
    "move3": "Mud-Slap",
    "move4": "Swagger",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 372,
    "name": "Cloyster 2",
    "species": "Cloyster",
    "instance": "2",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Dive",
    "move2": "Toxic",
    "move3": "Double Team",
    "move4": "Protect",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 373,
    "name": "Dugtrio 1",
    "species": "Dugtrio",
    "instance": "1",
    "nature": "Adamant",
    "item": "Soft Sand",
    "move1": "Earthquake",
    "move2": "Tri Attack",
    "move3": "Slash",
    "move4": "Sand Tomb",
    "speed50": 172,
    "speed100": 339
  },
  {
    "entry": 374,
    "name": "Medicham 1",
    "species": "Medicham",
    "instance": "1",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Psychic",
    "move2": "Hi Jump Kick",
    "move3": "Calm Mind",
    "move4": "Baton Pass",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 375,
    "name": "Misdreavus 1",
    "species": "Misdreavus",
    "instance": "1",
    "nature": "Impish",
    "item": "Focus Band",
    "move1": "Pain Split",
    "move2": "Shadow Ball",
    "move3": "Confuse Ray",
    "move4": "Thunder Wave",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 376,
    "name": "Fearow 1",
    "species": "Fearow",
    "instance": "1",
    "nature": "Adamant",
    "item": "Sharp Beak",
    "move1": "Drill Peck",
    "move2": "Tri Attack",
    "move3": "Facade",
    "move4": "Mud-Slap",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 377,
    "name": "Granbull 1",
    "species": "Granbull",
    "instance": "1",
    "nature": "Adamant",
    "item": "Cheri Berry",
    "move1": "Mega Kick",
    "move2": "SmellingSalt",
    "move3": "Thunder Wave",
    "move4": "Roar",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 378,
    "name": "Jynx 1",
    "species": "Jynx",
    "instance": "1",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Ice Beam",
    "move2": "Fake Out",
    "move3": "Lovely Kiss",
    "move4": "Attract",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 379,
    "name": "Dusclops 1",
    "species": "Dusclops",
    "instance": "1",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Will-O-Wisp",
    "move2": "Seismic Toss",
    "move3": "Pain Split",
    "move4": "Confuse Ray",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 380,
    "name": "Dodrio 1",
    "species": "Dodrio",
    "instance": "1",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Drill Peck",
    "move2": "Tri Attack",
    "move3": "Sleep Talk",
    "move4": "Rest",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 381,
    "name": "Mrmime 1",
    "species": "Mr. Mime",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Leftovers",
    "move1": "Psychic",
    "move2": "Magical Leaf",
    "move3": "Fake Out",
    "move4": "Reflect",
    "speed50": 99,
    "speed100": 194
  },
  {
    "entry": 382,
    "name": "Lanturn 1",
    "species": "Lanturn",
    "instance": "1",
    "nature": "Quiet",
    "item": "Cheri Berry",
    "move1": "Surf",
    "move2": "Confuse Ray",
    "move3": "Attract",
    "move4": "Thunder Wave",
    "speed50": 78,
    "speed100": 153
  },
  {
    "entry": 383,
    "name": "Breloom 1",
    "species": "Breloom",
    "instance": "1",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Sky Uppercut",
    "move2": "Mach Punch",
    "move3": "Headbutt",
    "move4": "Counter",
    "speed50": 134,
    "speed100": 262
  },
  {
    "entry": 384,
    "name": "Forretress 1",
    "species": "Forretress",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Double-Edge",
    "move2": "Rock Slide",
    "move3": "Light Screen",
    "move4": "Spikes",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 385,
    "name": "Whiscash 1",
    "species": "Whiscash",
    "instance": "1",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Amnesia",
    "move4": "Rest",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 386,
    "name": "Xatu 1",
    "species": "Xatu",
    "instance": "1",
    "nature": "Hardy",
    "item": "Sharp Beak",
    "move1": "Drill Peck",
    "move2": "Night Shade",
    "move3": "Wish",
    "move4": "Future Sight",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 387,
    "name": "Skarmory 1",
    "species": "Skarmory",
    "instance": "1",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Steel Wing",
    "move2": "Air Cutter",
    "move3": "Counter",
    "move4": "Agility",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 388,
    "name": "Marowak 1",
    "species": "Marowak",
    "instance": "1",
    "nature": "Adamant",
    "item": "Thick Club",
    "move1": "Bonemerang",
    "move2": "Rock Slide",
    "move3": "Icy Wind",
    "move4": "Headbutt",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 389,
    "name": "Quagsire 1",
    "species": "Quagsire",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Earthquake",
    "move2": "Brick Break",
    "move3": "Counter",
    "move4": "Mud-Slap",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 390,
    "name": "Clefable 1",
    "species": "Clefable",
    "instance": "1",
    "nature": "Brave",
    "item": "Leftovers",
    "move1": "Metronome",
    "move2": "Double Team",
    "move3": "Reflect",
    "move4": "Follow Me",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 391,
    "name": "Hariyama 1",
    "species": "Hariyama",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Cross Chop",
    "move2": "Rock Slide",
    "move3": "Counter",
    "move4": "Fake Out",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 392,
    "name": "Raichu 1",
    "species": "Raichu",
    "instance": "1",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Thunderbolt",
    "move2": "Quick Attack",
    "move3": "Light Screen",
    "move4": "Double Team",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 393,
    "name": "Dewgong 1",
    "species": "Dewgong",
    "instance": "1",
    "nature": "Quiet",
    "item": "NeverMeltIce",
    "move1": "Ice Beam",
    "move2": "Icy Wind",
    "move3": "Headbutt",
    "move4": "Fake Out",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 394,
    "name": "Manectric 1",
    "species": "Manectric",
    "instance": "1",
    "nature": "Modest",
    "item": "Magnet",
    "move1": "Thunderbolt",
    "move2": "Flash",
    "move3": "Quick Attack",
    "move4": "Roar",
    "speed50": 157,
    "speed100": 309
  },
  {
    "entry": 395,
    "name": "Vileplume 1",
    "species": "Vileplume",
    "instance": "1",
    "nature": "Impish",
    "item": "Persim Berry",
    "move1": "Sludge Bomb",
    "move2": "Petal Dance",
    "move3": "Moonlight",
    "move4": "Aromatherapy",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 396,
    "name": "Victreebel 1",
    "species": "Victreebel",
    "instance": "1",
    "nature": "Quiet",
    "item": "Sitrus Berry",
    "move1": "Giga Drain",
    "move2": "Sleep Powder",
    "move3": "Sweet Scent",
    "move4": "Synthesis",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 397,
    "name": "Electrode 1",
    "species": "Electrode",
    "instance": "1",
    "nature": "Quiet",
    "item": "Focus Band",
    "move1": "Thunderbolt",
    "move2": "Swift",
    "move3": "Light Screen",
    "move4": "Protect",
    "speed50": 144,
    "speed100": 284
  },
  {
    "entry": 398,
    "name": "Exploud 1",
    "species": "Exploud",
    "instance": "1",
    "nature": "Impish",
    "item": "Chesto Berry",
    "move1": "Hyper Voice",
    "move2": "Shadow Ball",
    "move3": "Sleep Talk",
    "move4": "Rest",
    "speed50": 88,
    "speed100": 172
  },
  {
    "entry": 399,
    "name": "Shiftry 1",
    "species": "Shiftry",
    "instance": "1",
    "nature": "Quiet",
    "item": "Miracle Seed",
    "move1": "Giga Drain",
    "move2": "Faint Attack",
    "move3": "Quick Attack",
    "move4": "Fake Out",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 400,
    "name": "Glalie 1",
    "species": "Glalie",
    "instance": "1",
    "nature": "Modest",
    "item": "Petaya Berry",
    "move1": "Ice Beam",
    "move2": "Crunch",
    "move3": "Hail",
    "move4": "Protect",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 401,
    "name": "Ludicolo 1",
    "species": "Ludicolo",
    "instance": "1",
    "nature": "Quiet",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Rain Dance",
    "move3": "ThunderPunch",
    "move4": "Fire Punch",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 402,
    "name": "Hypno 1",
    "species": "Hypno",
    "instance": "1",
    "nature": "Quiet",
    "item": "TwistedSpoon",
    "move1": "ThunderPunch",
    "move2": "Fire Punch",
    "move3": "Ice Punch",
    "move4": "Hypnosis",
    "speed50": 78,
    "speed100": 153
  },
  {
    "entry": 403,
    "name": "Golem 1",
    "species": "Golem",
    "instance": "1",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Body Slam",
    "move3": "Counter",
    "move4": "Rock Tomb",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 404,
    "name": "Rhydon 1",
    "species": "Rhydon",
    "instance": "1",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Rock Tomb",
    "move3": "Scary Face",
    "move4": "Brick Break",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 405,
    "name": "Alakazam 1",
    "species": "Alakazam",
    "instance": "1",
    "nature": "Modest",
    "item": "Focus Band",
    "move1": "ThunderPunch",
    "move2": "Fire Punch",
    "move3": "Ice Punch",
    "move4": "Thunder Wave",
    "speed50": 140,
    "speed100": 276
  },
  {
    "entry": 406,
    "name": "Weezing 1",
    "species": "Weezing",
    "instance": "1",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Sludge Bomb",
    "move2": "Will-O-Wisp",
    "move3": "Shadow Ball",
    "move4": "SmokeScreen",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 407,
    "name": "Kangaskhan 1",
    "species": "Kangaskhan",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Dizzy Punch",
    "move2": "Brick Break",
    "move3": "Counter",
    "move4": "Fake Out",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 408,
    "name": "Electabuzz 1",
    "species": "Electabuzz",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Cheri Berry",
    "move1": "Thunderbolt",
    "move2": "Thunder Wave",
    "move3": "Brick Break",
    "move4": "Light Screen",
    "speed50": 112,
    "speed100": 221
  },
  {
    "entry": 409,
    "name": "Tauros 1",
    "species": "Tauros",
    "instance": "1",
    "nature": "Adamant",
    "item": "Persim Berry",
    "move1": "Earthquake",
    "move2": "Thrash",
    "move3": "Swagger",
    "move4": "Facade",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 410,
    "name": "Slowbro 1",
    "species": "Slowbro",
    "instance": "1",
    "nature": "Quiet",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Rain Dance",
    "move3": "Headbutt",
    "move4": "Ice Punch",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 411,
    "name": "Slowking 1",
    "species": "Slowking",
    "instance": "1",
    "nature": "Quiet",
    "item": "Leftovers",
    "move1": "Psychic",
    "move2": "Brick Break",
    "move3": "Amnesia",
    "move4": "Attract",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 412,
    "name": "Miltank 1",
    "species": "Miltank",
    "instance": "1",
    "nature": "Careful",
    "item": "Focus Band",
    "move1": "Facade",
    "move2": "Shadow Ball",
    "move3": "Counter",
    "move4": "Milk Drink",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 413,
    "name": "Altaria 1",
    "species": "Altaria",
    "instance": "1",
    "nature": "Docile",
    "item": "Cheri Berry",
    "move1": "Dragon Claw",
    "move2": "Aerial Ace",
    "move3": "Refresh",
    "move4": "Body Slam",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 414,
    "name": "Nidoqueen 1",
    "species": "Nidoqueen",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Sludge Bomb",
    "move2": "Double Kick",
    "move3": "Body Slam",
    "move4": "Counter",
    "speed50": 96,
    "speed100": 188
  },
  {
    "entry": 415,
    "name": "Nidoking 1",
    "species": "Nidoking",
    "instance": "1",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Horn Drill",
    "move2": "Double Kick",
    "move3": "Body Slam",
    "move4": "Counter",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 416,
    "name": "Magmar 1",
    "species": "Magmar",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Rawst Berry",
    "move1": "Flamethrower",
    "move2": "SmokeScreen",
    "move3": "Brick Break",
    "move4": "Barrier",
    "speed50": 102,
    "speed100": 199
  },
  {
    "entry": 417,
    "name": "Cradily 1",
    "species": "Cradily",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Leftovers",
    "move1": "Giga Drain",
    "move2": "Rock Slide",
    "move3": "Barrier",
    "move4": "Confuse Ray",
    "speed50": 57,
    "speed100": 109
  },
  {
    "entry": 418,
    "name": "Armaldo 1",
    "species": "Armaldo",
    "instance": "1",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Slash",
    "move2": "Aerial Ace",
    "move3": "AncientPower",
    "move4": "Protect",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 419,
    "name": "Golduck 1",
    "species": "Golduck",
    "instance": "1",
    "nature": "Quiet",
    "item": "Shell Bell",
    "move1": "Hydro Pump",
    "move2": "Dig",
    "move3": "Brick Break",
    "move4": "Light Screen",
    "speed50": 94,
    "speed100": 185
  },
  {
    "entry": 420,
    "name": "Rapidash 1",
    "species": "Rapidash",
    "instance": "1",
    "nature": "Quiet",
    "item": "Charcoal",
    "move1": "Flamethrower",
    "move2": "Double Kick",
    "move3": "Quick Attack",
    "move4": "Protect",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 421,
    "name": "Muk 1",
    "species": "Muk",
    "instance": "1",
    "nature": "Adamant",
    "item": "Poison Barb",
    "move1": "Sludge Bomb",
    "move2": "Body Slam",
    "move3": "Screech",
    "move4": "Minimize",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 422,
    "name": "Gengar 1",
    "species": "Gengar",
    "instance": "1",
    "nature": "Timid",
    "item": "Leftovers",
    "move1": "Dream Eater",
    "move2": "Hypnosis",
    "move3": "Confuse Ray",
    "move4": "Attract",
    "speed50": 166,
    "speed100": 327
  },
  {
    "entry": 423,
    "name": "Ampharos 1",
    "species": "Ampharos",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Magnet",
    "move1": "Thunder",
    "move2": "Rain Dance",
    "move3": "Thunder Wave",
    "move4": "Attract",
    "speed50": 67,
    "speed100": 131
  },
  {
    "entry": 424,
    "name": "Scizor 1",
    "species": "Scizor",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Metal Claw",
    "move2": "Aerial Ace",
    "move3": "Counter",
    "move4": "Quick Attack",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 425,
    "name": "Heracross 1",
    "species": "Heracross",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Megahorn",
    "move2": "Brick Break",
    "move3": "Rock Tomb",
    "move4": "Counter",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 426,
    "name": "Ursaring 1",
    "species": "Ursaring",
    "instance": "1",
    "nature": "Docile",
    "item": "Quick Claw",
    "move1": "Mega Kick",
    "move2": "Crunch",
    "move3": "Aerial Ace",
    "move4": "Counter",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 427,
    "name": "Houndoom 1",
    "species": "Houndoom",
    "instance": "1",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Flamethrower",
    "move2": "Shadow Ball",
    "move3": "Counter",
    "move4": "Will-O-Wisp",
    "speed50": 136,
    "speed100": 268
  },
  {
    "entry": 428,
    "name": "Donphan 1",
    "species": "Donphan",
    "instance": "1",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Earthquake",
    "move2": "AncientPower",
    "move3": "Swagger",
    "move4": "Rest",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 429,
    "name": "Claydol 1",
    "species": "Claydol",
    "instance": "1",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed50": 95,
    "speed100": 186
  },
  {
    "entry": 430,
    "name": "Wailord 1",
    "species": "Wailord",
    "instance": "1",
    "nature": "Sassy",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Icy Wind",
    "move3": "Body Slam",
    "move4": "Roar",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 431,
    "name": "Ninetales 1",
    "species": "Ninetales",
    "instance": "1",
    "nature": "Modest",
    "item": "Rawst Berry",
    "move1": "Flamethrower",
    "move2": "Roar",
    "move3": "Confuse Ray",
    "move4": "Will-O-Wisp",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 432,
    "name": "Machamp 1",
    "species": "Machamp",
    "instance": "1",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Cross Chop",
    "move2": "Rock Slide",
    "move3": "Counter",
    "move4": "Scary Face",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 433,
    "name": "Shuckle 1",
    "species": "Shuckle",
    "instance": "1",
    "nature": "Brave",
    "item": "Chesto Berry",
    "move1": "Rollout",
    "move2": "Defense Curl",
    "move3": "Sleep Talk",
    "move4": "Rest",
    "speed50": 22,
    "speed100": 41
  },
  {
    "entry": 434,
    "name": "Steelix 1",
    "species": "Steelix",
    "instance": "1",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Earthquake",
    "move2": "DragonBreath",
    "move3": "Rock Tomb",
    "move4": "Roar",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 435,
    "name": "Tentacruel 1",
    "species": "Tentacruel",
    "instance": "1",
    "nature": "Impish",
    "item": "Persim Berry",
    "move1": "Sludge Bomb",
    "move2": "Icy Wind",
    "move3": "Barrier",
    "move4": "Confuse Ray",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 436,
    "name": "Aerodactyl 1",
    "species": "Aerodactyl",
    "instance": "1",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "AncientPower",
    "move2": "DragonBreath",
    "move3": "Aerial Ace",
    "move4": "Roar",
    "speed50": 171,
    "speed100": 338
  },
  {
    "entry": 437,
    "name": "Porygon2 1",
    "species": "Porygon2",
    "instance": "1",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Tri Attack",
    "move2": "Aerial Ace",
    "move3": "Shadow Ball",
    "move4": "Recover",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 438,
    "name": "Gardevoir 1",
    "species": "Gardevoir",
    "instance": "1",
    "nature": "Timid",
    "item": "Leftovers",
    "move1": "Dream Eater",
    "move2": "Hypnosis",
    "move3": "Magical Leaf",
    "move4": "Reflect",
    "speed50": 133,
    "speed100": 261
  },
  {
    "entry": 439,
    "name": "Exeggutor 1",
    "species": "Exeggutor",
    "instance": "1",
    "nature": "Quiet",
    "item": "Quick Claw",
    "move1": "SolarBeam",
    "move2": "Sunny Day",
    "move3": "Synthesis",
    "move4": "Light Screen",
    "speed50": 67,
    "speed100": 131
  },
  {
    "entry": 440,
    "name": "Starmie 1",
    "species": "Starmie",
    "instance": "1",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Psychic",
    "move2": "Confuse Ray",
    "move3": "Thunder Wave",
    "move4": "Recover",
    "speed50": 135,
    "speed100": 266
  },
  {
    "entry": 441,
    "name": "Flygon 1",
    "species": "Flygon",
    "instance": "1",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Earthquake",
    "move2": "Steel Wing",
    "move3": "Faint Attack",
    "move4": "Facade",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 442,
    "name": "Venusaur 1",
    "species": "Venusaur",
    "instance": "1",
    "nature": "Quiet",
    "item": "Chesto Berry",
    "move1": "Giga Drain",
    "move2": "Sunny Day",
    "move3": "Synthesis",
    "move4": "Sleep Powder",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 443,
    "name": "Vaporeon 1",
    "species": "Vaporeon",
    "instance": "1",
    "nature": "Modest",
    "item": "Mystic Water",
    "move1": "Surf",
    "move2": "Roar",
    "move3": "Bite",
    "move4": "Quick Attack",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 444,
    "name": "Jolteon 1",
    "species": "Jolteon",
    "instance": "1",
    "nature": "Modest",
    "item": "Cheri Berry",
    "move1": "Thunderbolt",
    "move2": "Thunder Wave",
    "move3": "Attract",
    "move4": "Protect",
    "speed50": 182,
    "speed100": 359
  },
  {
    "entry": 445,
    "name": "Flareon 1",
    "species": "Flareon",
    "instance": "1",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Flamethrower",
    "move2": "Roar",
    "move3": "Bite",
    "move4": "Sand-Attack",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 446,
    "name": "Meganium 1",
    "species": "Meganium",
    "instance": "1",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "SolarBeam",
    "move2": "Sunny Day",
    "move3": "Light Screen",
    "move4": "Synthesis",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 447,
    "name": "Espeon 1",
    "species": "Espeon",
    "instance": "1",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Charm",
    "move3": "Calm Mind",
    "move4": "Baton Pass",
    "speed50": 151,
    "speed100": 298
  },
  {
    "entry": 448,
    "name": "Umbreon 1",
    "species": "Umbreon",
    "instance": "1",
    "nature": "Bold",
    "item": "BrightPowder",
    "move1": "Confuse Ray",
    "move2": "Faint Attack",
    "move3": "Double Team",
    "move4": "Baton Pass",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 449,
    "name": "Blastoise 1",
    "species": "Blastoise",
    "instance": "1",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Hydro Pump",
    "move2": "Rain Dance",
    "move3": "Bite",
    "move4": "Seismic Toss",
    "speed50": 98,
    "speed100": 192
  },
  {
    "entry": 450,
    "name": "Feraligatr 1",
    "species": "Feraligatr",
    "instance": "1",
    "nature": "Quiet",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Rain Dance",
    "move3": "Aerial Ace",
    "move4": "Roar",
    "speed50": 88,
    "speed100": 172
  },
  {
    "entry": 451,
    "name": "Aggron 1",
    "species": "Aggron",
    "instance": "1",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Iron Tail",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "Roar",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 452,
    "name": "Blaziken 1",
    "species": "Blaziken",
    "instance": "1",
    "nature": "Docile",
    "item": "Quick Claw",
    "move1": "Flamethrower",
    "move2": "Sunny Day",
    "move3": "Double Kick",
    "move4": "Roar",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 453,
    "name": "Walrein 1",
    "species": "Walrein",
    "instance": "1",
    "nature": "Quiet",
    "item": "Leftovers",
    "move1": "Blizzard",
    "move2": "Hail",
    "move3": "Yawn",
    "move4": "Protect",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 454,
    "name": "Sceptile 1",
    "species": "Sceptile",
    "instance": "1",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Leaf Blade",
    "move2": "Leech Seed",
    "move3": "Aerial Ace",
    "move4": "Detect",
    "speed50": 172,
    "speed100": 339
  },
  {
    "entry": 455,
    "name": "Charizard 1",
    "species": "Charizard",
    "instance": "1",
    "nature": "Modest",
    "item": "Focus Band",
    "move1": "Fire Blast",
    "move2": "Sunny Day",
    "move3": "Roar",
    "move4": "Scary Face",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 456,
    "name": "Typhlosion 1",
    "species": "Typhlosion",
    "instance": "1",
    "nature": "Modest",
    "item": "Focus Band",
    "move1": "Fire Blast",
    "move2": "Sunny Day",
    "move3": "SmokeScreen",
    "move4": "Roar",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 457,
    "name": "Lapras 1",
    "species": "Lapras",
    "instance": "1",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Surf",
    "move2": "Attract",
    "move3": "Confuse Ray",
    "move4": "Sing",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 458,
    "name": "Crobat 1",
    "species": "Crobat",
    "instance": "1",
    "nature": "Quirky",
    "item": "King's Rock",
    "move1": "Sludge Bomb",
    "move2": "Bite",
    "move3": "Astonish",
    "move4": "Screech",
    "speed50": 150,
    "speed100": 296
  },
  {
    "entry": 459,
    "name": "Swampert 1",
    "species": "Swampert",
    "instance": "1",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Earthquake",
    "move2": "Counter",
    "move3": "Rest",
    "move4": "Curse",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 460,
    "name": "Gyarados 1",
    "species": "Gyarados",
    "instance": "1",
    "nature": "Careful",
    "item": "Lum Berry",
    "move1": "Return",
    "move2": "Bite",
    "move3": "Thunder Wave",
    "move4": "Dragon Dance",
    "speed50": 101,
    "speed100": 198
  },
  {
    "entry": 461,
    "name": "Snorlax 1",
    "species": "Snorlax",
    "instance": "1",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Facade",
    "move2": "Shadow Ball",
    "move3": "Attract",
    "move4": "Double Team",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 462,
    "name": "Kingdra 1",
    "species": "Kingdra",
    "instance": "1",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Hydro Pump",
    "move2": "DragonBreath",
    "move3": "Icy Wind",
    "move4": "Attract",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 463,
    "name": "Blissey 1",
    "species": "Blissey",
    "instance": "1",
    "nature": "Bold",
    "item": "BrightPowder",
    "move1": "Toxic",
    "move2": "Double Team",
    "move3": "Sing",
    "move4": "Softboiled",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 464,
    "name": "Milotic 1",
    "species": "Milotic",
    "instance": "1",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Hydro Pump",
    "move2": "Icy Wind",
    "move3": "Recover",
    "move4": "Mirror Coat",
    "speed50": 101,
    "speed100": 198
  },
  {
    "entry": 465,
    "name": "Arcanine 1",
    "species": "Arcanine",
    "instance": "1",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Flamethrower",
    "move2": "ExtremeSpeed",
    "move3": "Crunch",
    "move4": "Body Slam",
    "speed50": 147,
    "speed100": 289
  },
  {
    "entry": 466,
    "name": "Salamence 1",
    "species": "Salamence",
    "instance": "1",
    "nature": "Hardy",
    "item": "King's Rock",
    "move1": "Dragon Claw",
    "move2": "Aerial Ace",
    "move3": "Headbutt",
    "move4": "Rock Slide",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 467,
    "name": "Metagross 1",
    "species": "Metagross",
    "instance": "1",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Meteor Mash",
    "move2": "Aerial Ace",
    "move3": "Facade",
    "move4": "Light Screen",
    "speed50": 111,
    "speed100": 218
  },
  {
    "entry": 468,
    "name": "Slaking 1",
    "species": "Slaking",
    "instance": "1",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Yawn",
    "move2": "Bulk Up",
    "move3": "Swagger",
    "move4": "Aerial Ace",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 469,
    "name": "Dugtrio 2",
    "species": "Dugtrio",
    "instance": "2",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Earthquake",
    "move2": "AncientPower",
    "move3": "Aerial Ace",
    "move4": "Tri Attack",
    "speed50": 172,
    "speed100": 339
  },
  {
    "entry": 470,
    "name": "Medicham 2",
    "species": "Medicham",
    "instance": "2",
    "nature": "Hardy",
    "item": "Salac Berry",
    "move1": "Reversal",
    "move2": "Endure",
    "move3": "Psychic",
    "move4": "Fake Out",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 471,
    "name": "Marowak 2",
    "species": "Marowak",
    "instance": "2",
    "nature": "Adamant",
    "item": "Thick Club",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Swords Dance",
    "move4": "Icy Wind",
    "speed50": 97,
    "speed100": 189
  },
  {
    "entry": 472,
    "name": "Quagsire 2",
    "species": "Quagsire",
    "instance": "2",
    "nature": "Sassy",
    "item": "Leftovers",
    "move1": "Curse",
    "move2": "Attract",
    "move3": "Yawn",
    "move4": "AncientPower",
    "speed50": 49,
    "speed100": 95
  },
  {
    "entry": 473,
    "name": "Misdreavus 2",
    "species": "Misdreavus",
    "instance": "2",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Psychic",
    "move2": "Attract",
    "move3": "Thunder Wave",
    "move4": "Confuse Ray",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 474,
    "name": "Fearow 2",
    "species": "Fearow",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Drill Peck",
    "move2": "Tri Attack",
    "move3": "Attract",
    "move4": "Pursuit",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 475,
    "name": "Granbull 2",
    "species": "Granbull",
    "instance": "2",
    "nature": "Quiet",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Thunderbolt",
    "move3": "Ice Punch",
    "move4": "Facade",
    "speed50": 58,
    "speed100": 113
  },
  {
    "entry": 476,
    "name": "Jynx 2",
    "species": "Jynx",
    "instance": "2",
    "nature": "Impish",
    "item": "BrightPowder",
    "move1": "Perish Song",
    "move2": "Mean Look",
    "move3": "Lovely Kiss",
    "move4": "Protect",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 477,
    "name": "Dusclops 2",
    "species": "Dusclops",
    "instance": "2",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Confuse Ray",
    "move3": "Double Team",
    "move4": "Protect",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 478,
    "name": "Dodrio 2",
    "species": "Dodrio",
    "instance": "2",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Drill Peck",
    "move2": "Double-Edge",
    "move3": "Faint Attack",
    "move4": "Protect",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 479,
    "name": "Mrmime 2",
    "species": "Mr. Mime",
    "instance": "2",
    "nature": "Adamant",
    "item": "Liechi Berry",
    "move1": "Baton Pass",
    "move2": "Swagger",
    "move3": "Psych Up",
    "move4": "Psychic",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 480,
    "name": "Lanturn 2",
    "species": "Lanturn",
    "instance": "2",
    "nature": "Docile",
    "item": "Salac Berry",
    "move1": "Flail",
    "move2": "Endure",
    "move3": "Thunderbolt",
    "move4": "Surf",
    "speed50": 87,
    "speed100": 170
  },
  {
    "entry": 481,
    "name": "Breloom 2",
    "species": "Breloom",
    "instance": "2",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Giga Drain",
    "move2": "Leech Seed",
    "move3": "Focus Punch",
    "move4": "Spore",
    "speed50": 122,
    "speed100": 239
  },
  {
    "entry": 482,
    "name": "Forretress 2",
    "species": "Forretress",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Earthquake",
    "move2": "Double-Edge",
    "move3": "Counter",
    "move4": "Protect",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 483,
    "name": "Skarmory 2",
    "species": "Skarmory",
    "instance": "2",
    "nature": "Careful",
    "item": "BrightPowder",
    "move1": "Spikes",
    "move2": "Roar",
    "move3": "Drill Peck",
    "move4": "Toxic",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 484,
    "name": "Whiscash 2",
    "species": "Whiscash",
    "instance": "2",
    "nature": "Hardy",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Earthquake",
    "move3": "Spark",
    "move4": "Future Sight",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 485,
    "name": "Xatu 2",
    "species": "Xatu",
    "instance": "2",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Fly",
    "move2": "Toxic",
    "move3": "Confuse Ray",
    "move4": "Attract",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 486,
    "name": "Clefable 2",
    "species": "Clefable",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Meteor Mash",
    "move2": "Cosmic Power",
    "move3": "Double Team",
    "move4": "Follow Me",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 487,
    "name": "Hariyama 2",
    "species": "Hariyama",
    "instance": "2",
    "nature": "Quiet",
    "item": "Quick Claw",
    "move1": "Cross Chop",
    "move2": "Fire Punch",
    "move3": "Ice Punch",
    "move4": "ThunderPunch",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 488,
    "name": "Raichu 2",
    "species": "Raichu",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Reversal",
    "move3": "Endure",
    "move4": "Agility",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 489,
    "name": "Dewgong 2",
    "species": "Dewgong",
    "instance": "2",
    "nature": "Docile",
    "item": "Shell Bell",
    "move1": "Blizzard",
    "move2": "Double-Edge",
    "move3": "Encore",
    "move4": "Disable",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 490,
    "name": "Manectric 2",
    "species": "Manectric",
    "instance": "2",
    "nature": "Modest",
    "item": "Petaya Berry",
    "move1": "Thunder",
    "move2": "Rain Dance",
    "move3": "Crunch",
    "move4": "Roar",
    "speed50": 157,
    "speed100": 309
  },
  {
    "entry": 491,
    "name": "Vileplume 2",
    "species": "Vileplume",
    "instance": "2",
    "nature": "Bold",
    "item": "BrightPowder",
    "move1": "Ingrain",
    "move2": "Double Team",
    "move3": "Toxic",
    "move4": "Giga Drain",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 492,
    "name": "Victreebel 2",
    "species": "Victreebel",
    "instance": "2",
    "nature": "Serious",
    "item": "Leftovers",
    "move1": "Giga Drain",
    "move2": "Sludge Bomb",
    "move3": "Sleep Powder",
    "move4": "Attract",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 493,
    "name": "Electrode 2",
    "species": "Electrode",
    "instance": "2",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Thunder",
    "move2": "Rain Dance",
    "move3": "Double Team",
    "move4": "Swagger",
    "speed50": 160,
    "speed100": 316
  },
  {
    "entry": 494,
    "name": "Exploud 2",
    "species": "Exploud",
    "instance": "2",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "SolarBeam",
    "move2": "Sunny Day",
    "move3": "Earthquake",
    "move4": "Counter",
    "speed50": 88,
    "speed100": 172
  },
  {
    "entry": 495,
    "name": "Shiftry 2",
    "species": "Shiftry",
    "instance": "2",
    "nature": "Impish",
    "item": "Chesto Berry",
    "move1": "Leech Seed",
    "move2": "Dig",
    "move3": "Double Team",
    "move4": "Rest",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 496,
    "name": "Glalie 2",
    "species": "Glalie",
    "instance": "2",
    "nature": "Quirky",
    "item": "Salac Berry",
    "move1": "Explosion",
    "move2": "Endure",
    "move3": "Body Slam",
    "move4": "Icy Wind",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 497,
    "name": "Ludicolo 2",
    "species": "Ludicolo",
    "instance": "2",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "ThunderPunch",
    "move4": "Fire Punch",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 498,
    "name": "Hypno 2",
    "species": "Hypno",
    "instance": "2",
    "nature": "Modest",
    "item": "TwistedSpoon",
    "move1": "Hypnosis",
    "move2": "Nightmare",
    "move3": "Dream Eater",
    "move4": "Psychic",
    "speed50": 87,
    "speed100": 170
  },
  {
    "entry": 499,
    "name": "Golem 2",
    "species": "Golem",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Focus Punch",
    "move2": "Substitute",
    "move3": "Double Team",
    "move4": "Rest",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 500,
    "name": "Rhydon 2",
    "species": "Rhydon",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Horn Drill",
    "move3": "Rock Slide",
    "move4": "Brick Break",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 501,
    "name": "Alakazam 2",
    "species": "Alakazam",
    "instance": "2",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Calm Mind",
    "move3": "Thunder Wave",
    "move4": "Recover",
    "speed50": 140,
    "speed100": 276
  },
  {
    "entry": 502,
    "name": "Weezing 2",
    "species": "Weezing",
    "instance": "2",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Memento",
    "move2": "Sludge Bomb",
    "move3": "Facade",
    "move4": "Destiny Bond",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 503,
    "name": "Kangaskhan 2",
    "species": "Kangaskhan",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Crush Claw",
    "move2": "Shadow Ball",
    "move3": "Attract",
    "move4": "Rest",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 504,
    "name": "Electabuzz 2",
    "species": "Electabuzz",
    "instance": "2",
    "nature": "Quirky",
    "item": "Leftovers",
    "move1": "Thunder",
    "move2": "Rain Dance",
    "move3": "Attract",
    "move4": "Focus Punch",
    "speed50": 146,
    "speed100": 288
  },
  {
    "entry": 505,
    "name": "Tauros 2",
    "species": "Tauros",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Double Team",
    "move4": "Rest",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 506,
    "name": "Slowbro 2",
    "species": "Slowbro",
    "instance": "2",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Calm Mind",
    "move4": "Yawn",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 507,
    "name": "Slowking 2",
    "species": "Slowking",
    "instance": "2",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Yawn",
    "move2": "Thunder Wave",
    "move3": "Surf",
    "move4": "Psychic",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 508,
    "name": "Miltank 2",
    "species": "Miltank",
    "instance": "2",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Focus Punch",
    "move2": "Shadow Ball",
    "move3": "Attract",
    "move4": "Thunder Wave",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 509,
    "name": "Altaria 2",
    "species": "Altaria",
    "instance": "2",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Perish Song",
    "move2": "DragonBreath",
    "move3": "Pursuit",
    "move4": "Attract",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 510,
    "name": "Nidoqueen 2",
    "species": "Nidoqueen",
    "instance": "2",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "Rock Slide",
    "speed50": 96,
    "speed100": 188
  },
  {
    "entry": 511,
    "name": "Nidoking 2",
    "species": "Nidoking",
    "instance": "2",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Mega Kick",
    "move2": "Earthquake",
    "move3": "Shadow Ball",
    "move4": "Brick Break",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 512,
    "name": "Magmar 2",
    "species": "Magmar",
    "instance": "2",
    "nature": "Modest",
    "item": "Quick Claw",
    "move1": "Fire Blast",
    "move2": "SmokeScreen",
    "move3": "ThunderPunch",
    "move4": "Confuse Ray",
    "speed50": 145,
    "speed100": 285
  },
  {
    "entry": 513,
    "name": "Cradily 2",
    "species": "Cradily",
    "instance": "2",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Earthquake",
    "move2": "AncientPower",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 514,
    "name": "Armaldo 2",
    "species": "Armaldo",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Iron Tail",
    "move2": "AncientPower",
    "move3": "Brick Break",
    "move4": "Knock Off",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 515,
    "name": "Golduck 2",
    "species": "Golduck",
    "instance": "2",
    "nature": "Quirky",
    "item": "Lum Berry",
    "move1": "Cross Chop",
    "move2": "Surf",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed50": 126,
    "speed100": 248
  },
  {
    "entry": 516,
    "name": "Rapidash 2",
    "species": "Rapidash",
    "instance": "2",
    "nature": "Docile",
    "item": "Leftovers",
    "move1": "Fire Blast",
    "move2": "Bounce",
    "move3": "Double Team",
    "move4": "Attract",
    "speed50": 146,
    "speed100": 288
  },
  {
    "entry": 517,
    "name": "Muk 2",
    "species": "Muk",
    "instance": "2",
    "nature": "Hardy",
    "item": "Chesto Berry",
    "move1": "Curse",
    "move2": "Rest",
    "move3": "Sludge Bomb",
    "move4": "DynamicPunch",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 518,
    "name": "Gengar 2",
    "species": "Gengar",
    "instance": "2",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Sludge Bomb",
    "move2": "Shadow Ball",
    "move3": "Confuse Ray",
    "move4": "Will-O-Wisp",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 519,
    "name": "Ampharos 2",
    "species": "Ampharos",
    "instance": "2",
    "nature": "Hardy",
    "item": "BrightPowder",
    "move1": "ThunderPunch",
    "move2": "Fire Punch",
    "move3": "Focus Punch",
    "move4": "Thunder Wave",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 520,
    "name": "Scizor 2",
    "species": "Scizor",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Silver Wind",
    "move2": "Steel Wing",
    "move3": "Swords Dance",
    "move4": "Light Screen",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 521,
    "name": "Heracross 2",
    "species": "Heracross",
    "instance": "2",
    "nature": "Jolly",
    "item": "Lum Berry",
    "move1": "Megahorn",
    "move2": "Earthquake",
    "move3": "Attract",
    "move4": "Bulk Up",
    "speed50": 150,
    "speed100": 295
  },
  {
    "entry": 522,
    "name": "Ursaring 2",
    "species": "Ursaring",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Brick Break",
    "move4": "Counter",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 523,
    "name": "Houndoom 2",
    "species": "Houndoom",
    "instance": "2",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Fire Blast",
    "move2": "Crunch",
    "move3": "Roar",
    "move4": "Rest",
    "speed50": 147,
    "speed100": 289
  },
  {
    "entry": 524,
    "name": "Donphan 2",
    "species": "Donphan",
    "instance": "2",
    "nature": "Jolly",
    "item": "Quick Claw",
    "move1": "Flail",
    "move2": "Endure",
    "move3": "Earthquake",
    "move4": "Rock Tomb",
    "speed50": 112,
    "speed100": 218
  },
  {
    "entry": 525,
    "name": "Claydol 2",
    "species": "Claydol",
    "instance": "2",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Psychic",
    "move2": "Earthquake",
    "move3": "Double Team",
    "move4": "Cosmic Power",
    "speed50": 95,
    "speed100": 186
  },
  {
    "entry": 526,
    "name": "Wailord 2",
    "species": "Wailord",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Double-Edge",
    "move2": "Rest",
    "move3": "Curse",
    "move4": "Amnesia",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 527,
    "name": "Ninetales 2",
    "species": "Ninetales",
    "instance": "2",
    "nature": "Quirky",
    "item": "Lum Berry",
    "move1": "Heat Wave",
    "move2": "Body Slam",
    "move3": "Grudge",
    "move4": "Sunny Day",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 528,
    "name": "Machamp 2",
    "species": "Machamp",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Cross Chop",
    "move2": "Earthquake",
    "move3": "Bulk Up",
    "move4": "Rest",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 529,
    "name": "Shuckle 2",
    "species": "Shuckle",
    "instance": "2",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Sandstorm",
    "move2": "Dig",
    "move3": "Flash",
    "move4": "Double Team",
    "speed50": 25,
    "speed100": 46
  },
  {
    "entry": 530,
    "name": "Steelix 2",
    "species": "Steelix",
    "instance": "2",
    "nature": "Hardy",
    "item": "Leftovers",
    "move1": "Earthquake",
    "move2": "DragonBreath",
    "move3": "Sandstorm",
    "move4": "Block",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 531,
    "name": "Tentacruel 2",
    "species": "Tentacruel",
    "instance": "2",
    "nature": "Hardy",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Giga Drain",
    "move3": "Confuse Ray",
    "move4": "Surf",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 532,
    "name": "Aerodactyl 2",
    "species": "Aerodactyl",
    "instance": "2",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Hyper Beam",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "AncientPower",
    "speed50": 171,
    "speed100": 338
  },
  {
    "entry": 533,
    "name": "Porygon2 2",
    "species": "Porygon2",
    "instance": "2",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "SolarBeam",
    "move2": "Sunny Day",
    "move3": "Thunder Wave",
    "move4": "Recover",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 534,
    "name": "Gardevoir 2",
    "species": "Gardevoir",
    "instance": "2",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Psychic",
    "move2": "Calm Mind",
    "move3": "Double Team",
    "move4": "Rest",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 535,
    "name": "Exeggutor 2",
    "species": "Exeggutor",
    "instance": "2",
    "nature": "Hardy",
    "item": "Chesto Berry",
    "move1": "Return",
    "move2": "Curse",
    "move3": "Sleep Powder",
    "move4": "Rest",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 536,
    "name": "Starmie 2",
    "species": "Starmie",
    "instance": "2",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Hydro Pump",
    "move2": "Thunder",
    "move3": "Rain Dance",
    "move4": "Recover",
    "speed50": 135,
    "speed100": 266
  },
  {
    "entry": 537,
    "name": "Flygon 2",
    "species": "Flygon",
    "instance": "2",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "SolarBeam",
    "move2": "Fire Blast",
    "move3": "Crunch",
    "move4": "Sunny Day",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 538,
    "name": "Venusaur 2",
    "species": "Venusaur",
    "instance": "2",
    "nature": "Bold",
    "item": "BrightPowder",
    "move1": "Leech Seed",
    "move2": "Giga Drain",
    "move3": "Double Team",
    "move4": "Light Screen",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 539,
    "name": "Vaporeon 2",
    "species": "Vaporeon",
    "instance": "2",
    "nature": "Docile",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Body Slam",
    "move4": "Shadow Ball",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 540,
    "name": "Jolteon 2",
    "species": "Jolteon",
    "instance": "2",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Thunderbolt",
    "move2": "Dig",
    "move3": "Double Kick",
    "move4": "Roar",
    "speed50": 150,
    "speed100": 296
  },
  {
    "entry": 541,
    "name": "Flareon 2",
    "species": "Flareon",
    "instance": "2",
    "nature": "Relaxed",
    "item": "Quick Claw",
    "move1": "Curse",
    "move2": "Attract",
    "move3": "Double-Edge",
    "move4": "Shadow Ball",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 542,
    "name": "Meganium 2",
    "species": "Meganium",
    "instance": "2",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Leech Seed",
    "move2": "Substitute",
    "move3": "Double Team",
    "move4": "GrassWhistle",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 543,
    "name": "Espeon 2",
    "species": "Espeon",
    "instance": "2",
    "nature": "Docile",
    "item": "Chesto Berry",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Calm Mind",
    "move4": "Rest",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 544,
    "name": "Umbreon 2",
    "species": "Umbreon",
    "instance": "2",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Curse",
    "move2": "Screech",
    "move3": "Double Team",
    "move4": "Double-Edge",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 545,
    "name": "Blastoise 2",
    "species": "Blastoise",
    "instance": "2",
    "nature": "Brave",
    "item": "Shell Bell",
    "move1": "Hydro Pump",
    "move2": "Mega Kick",
    "move3": "Brick Break",
    "move4": "Mirror Coat",
    "speed50": 88,
    "speed100": 172
  },
  {
    "entry": 546,
    "name": "Feraligatr 2",
    "species": "Feraligatr",
    "instance": "2",
    "nature": "Sassy",
    "item": "Quick Claw",
    "move1": "Surf",
    "move2": "Dragon Claw",
    "move3": "Brick Break",
    "move4": "Scary Face",
    "speed50": 88,
    "speed100": 172
  },
  {
    "entry": 547,
    "name": "Aggron 2",
    "species": "Aggron",
    "instance": "2",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Focus Punch",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Thunder Wave",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 548,
    "name": "Blaziken 2",
    "species": "Blaziken",
    "instance": "2",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Blaze Kick",
    "move2": "Mega Kick",
    "move3": "ThunderPunch",
    "move4": "Brick Break",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 549,
    "name": "Walrein 2",
    "species": "Walrein",
    "instance": "2",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Earthquake",
    "move2": "Ice Beam",
    "move3": "Curse",
    "move4": "Double Team",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 550,
    "name": "Sceptile 2",
    "species": "Sceptile",
    "instance": "2",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Leaf Blade",
    "move2": "ThunderPunch",
    "move3": "Attract",
    "move4": "Double Team",
    "speed50": 172,
    "speed100": 339
  },
  {
    "entry": 551,
    "name": "Charizard 2",
    "species": "Charizard",
    "instance": "2",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Earthquake",
    "move2": "Aerial Ace",
    "move3": "Dragon Dance",
    "move4": "SmokeScreen",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 552,
    "name": "Typhlosion 2",
    "species": "Typhlosion",
    "instance": "2",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Flamethrower",
    "move2": "ThunderPunch",
    "move3": "Aerial Ace",
    "move4": "Rock Slide",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 553,
    "name": "Lapras 2",
    "species": "Lapras",
    "instance": "2",
    "nature": "Timid",
    "item": "Quick Claw",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Body Slam",
    "move4": "Roar",
    "speed50": 123,
    "speed100": 240
  },
  {
    "entry": 554,
    "name": "Crobat 2",
    "species": "Crobat",
    "instance": "2",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Giga Drain",
    "move3": "Confuse Ray",
    "move4": "Double Team",
    "speed50": 150,
    "speed100": 296
  },
  {
    "entry": 555,
    "name": "Swampert 2",
    "species": "Swampert",
    "instance": "2",
    "nature": "Docile",
    "item": "Quick Claw",
    "move1": "Surf",
    "move2": "Earthquake",
    "move3": "Counter",
    "move4": "Mirror Coat",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 556,
    "name": "Gyarados 2",
    "species": "Gyarados",
    "instance": "2",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Hydro Pump",
    "move2": "Thunderbolt",
    "move3": "Fire Blast",
    "move4": "Blizzard",
    "speed50": 133,
    "speed100": 261
  },
  {
    "entry": 557,
    "name": "Snorlax 2",
    "species": "Snorlax",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Curse",
    "move4": "Rest",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 558,
    "name": "Kingdra 2",
    "species": "Kingdra",
    "instance": "2",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "DragonBreath",
    "move4": "Rest",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 559,
    "name": "Blissey 2",
    "species": "Blissey",
    "instance": "2",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Seismic Toss",
    "move2": "Sing",
    "move3": "Attract",
    "move4": "Substitute",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 560,
    "name": "Milotic 2",
    "species": "Milotic",
    "instance": "2",
    "nature": "Modest",
    "item": "Focus Band",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Safeguard",
    "move4": "Mirror Coat",
    "speed50": 101,
    "speed100": 198
  },
  {
    "entry": 561,
    "name": "Arcanine 2",
    "species": "Arcanine",
    "instance": "2",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "Fire Blast",
    "move2": "Sunny Day",
    "move3": "Crunch",
    "move4": "Roar",
    "speed50": 147,
    "speed100": 289
  },
  {
    "entry": 562,
    "name": "Salamence 2",
    "species": "Salamence",
    "instance": "2",
    "nature": "Hardy",
    "item": "Leftovers",
    "move1": "Double-Edge",
    "move2": "Crunch",
    "move3": "Swagger",
    "move4": "Protect",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 563,
    "name": "Metagross 2",
    "species": "Metagross",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Earthquake",
    "move2": "Meteor Mash",
    "move3": "Psych Up",
    "move4": "Swagger",
    "speed50": 111,
    "speed100": 218
  },
  {
    "entry": 564,
    "name": "Slaking 2",
    "species": "Slaking",
    "instance": "2",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Mega Kick",
    "move2": "Shadow Ball",
    "move3": "Yawn",
    "move4": "Amnesia",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 565,
    "name": "Dugtrio 3",
    "species": "Dugtrio",
    "instance": "3",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Earthquake",
    "move2": "Double-Edge",
    "move3": "Sludge Bomb",
    "move4": "Fissure",
    "speed50": 172,
    "speed100": 339
  },
  {
    "entry": 566,
    "name": "Medicham 3",
    "species": "Medicham",
    "instance": "3",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "DynamicPunch",
    "move2": "ThunderPunch",
    "move3": "Ice Punch",
    "move4": "Fire Punch",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 567,
    "name": "Misdreavus 3",
    "species": "Misdreavus",
    "instance": "3",
    "nature": "Bold",
    "item": "BrightPowder",
    "move1": "Perish Song",
    "move2": "Mean Look",
    "move3": "Thunder Wave",
    "move4": "Confuse Ray",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 568,
    "name": "Fearow 3",
    "species": "Fearow",
    "instance": "3",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Drill Peck",
    "move2": "Return",
    "move3": "Steel Wing",
    "move4": "Faint Attack",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 569,
    "name": "Granbull 3",
    "species": "Granbull",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Sludge Bomb",
    "move4": "Rock Slide",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 570,
    "name": "Jynx 3",
    "species": "Jynx",
    "instance": "3",
    "nature": "Hardy",
    "item": "Quick Claw",
    "move1": "Dream Eater",
    "move2": "Lovely Kiss",
    "move3": "Attract",
    "move4": "Substitute",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 571,
    "name": "Dusclops 3",
    "species": "Dusclops",
    "instance": "3",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Psych Up",
    "move2": "Swagger",
    "move3": "Shadow Ball",
    "move4": "Earthquake",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 572,
    "name": "Dodrio 3",
    "species": "Dodrio",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Double-Edge",
    "move2": "Drill Peck",
    "move3": "Steel Wing",
    "move4": "Faint Attack",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 573,
    "name": "Mrmime 3",
    "species": "Mr. Mime",
    "instance": "3",
    "nature": "Modest",
    "item": "Choice Band",
    "move1": "Trick",
    "move2": "Torment",
    "move3": "Psychic",
    "move4": "Thunderbolt",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 574,
    "name": "Lanturn 3",
    "species": "Lanturn",
    "instance": "3",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Hydro Pump",
    "move2": "Thunder",
    "move3": "Confuse Ray",
    "move4": "Rain Dance",
    "speed50": 119,
    "speed100": 233
  },
  {
    "entry": 575,
    "name": "Breloom 3",
    "species": "Breloom",
    "instance": "3",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Iron Tail",
    "move2": "Focus Punch",
    "move3": "Attract",
    "move4": "Spore",
    "speed50": 122,
    "speed100": 239
  },
  {
    "entry": 576,
    "name": "Forretress 3",
    "species": "Forretress",
    "instance": "3",
    "nature": "Quiet",
    "item": "Focus Band",
    "move1": "Explosion",
    "move2": "Earthquake",
    "move3": "Giga Drain",
    "move4": "Zap Cannon",
    "speed50": 54,
    "speed100": 104
  },
  {
    "entry": 577,
    "name": "Whiscash 3",
    "species": "Whiscash",
    "instance": "3",
    "nature": "Hardy",
    "item": "Chesto Berry",
    "move1": "Sleep Talk",
    "move2": "Rest",
    "move3": "Surf",
    "move4": "Fissure",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 578,
    "name": "Xatu 3",
    "species": "Xatu",
    "instance": "3",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Drill Peck",
    "move2": "Psychic",
    "move3": "Giga Drain",
    "move4": "Steel Wing",
    "speed50": 150,
    "speed100": 294
  },
  {
    "entry": 579,
    "name": "Skarmory 3",
    "species": "Skarmory",
    "instance": "3",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Toxic",
    "move2": "Curse",
    "move3": "Rest",
    "move4": "Fly",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 580,
    "name": "Marowak 3",
    "species": "Marowak",
    "instance": "3",
    "nature": "Adamant",
    "item": "Thick Club",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Swords Dance",
    "move4": "Brick Break",
    "speed50": 97,
    "speed100": 189
  },
  {
    "entry": 581,
    "name": "Quagsire 3",
    "species": "Quagsire",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Sludge Bomb",
    "move3": "Double-Edge",
    "move4": "Curse",
    "speed50": 55,
    "speed100": 106
  },
  {
    "entry": 582,
    "name": "Clefable 3",
    "species": "Clefable",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Ice Beam",
    "move3": "Flamethrower",
    "move4": "Magical Leaf",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 583,
    "name": "Hariyama 3",
    "species": "Hariyama",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Cross Chop",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Facade",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 584,
    "name": "Raichu 3",
    "species": "Raichu",
    "instance": "3",
    "nature": "Docile",
    "item": "Cheri Berry",
    "move1": "Thunder",
    "move2": "Rain Dance",
    "move3": "Iron Tail",
    "move4": "Attract",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 585,
    "name": "Dewgong 3",
    "species": "Dewgong",
    "instance": "3",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Horn Drill",
    "move2": "Sheer Cold",
    "move3": "Sleep Talk",
    "move4": "Rest",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 586,
    "name": "Manectric 3",
    "species": "Manectric",
    "instance": "3",
    "nature": "Quirky",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Iron Tail",
    "move3": "Thunder Wave",
    "move4": "Roar",
    "speed50": 157,
    "speed100": 309
  },
  {
    "entry": 587,
    "name": "Vileplume 3",
    "species": "Vileplume",
    "instance": "3",
    "nature": "Quirky",
    "item": "Leftovers",
    "move1": "Attract",
    "move2": "Stun Spore",
    "move3": "Sludge Bomb",
    "move4": "Giga Drain",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 588,
    "name": "Victreebel 3",
    "species": "Victreebel",
    "instance": "3",
    "nature": "Quirky",
    "item": "BrightPowder",
    "move1": "Stun Spore",
    "move2": "Ingrain",
    "move3": "Giga Drain",
    "move4": "Sludge Bomb",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 589,
    "name": "Electrode 3",
    "species": "Electrode",
    "instance": "3",
    "nature": "Naughty",
    "item": "Liechi Berry",
    "move1": "Explosion",
    "move2": "Thunderbolt",
    "move3": "Thunder Wave",
    "move4": "Endure",
    "speed50": 160,
    "speed100": 316
  },
  {
    "entry": 590,
    "name": "Exploud 3",
    "species": "Exploud",
    "instance": "3",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Ice Beam",
    "move3": "ThunderPunch",
    "move4": "Extrasensory",
    "speed50": 120,
    "speed100": 235
  },
  {
    "entry": 591,
    "name": "Shiftry 3",
    "species": "Shiftry",
    "instance": "3",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "SolarBeam",
    "move2": "Sunny Day",
    "move3": "Explosion",
    "move4": "Synthesis",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 592,
    "name": "Glalie 3",
    "species": "Glalie",
    "instance": "3",
    "nature": "Hardy",
    "item": "Shell Bell",
    "move1": "Blizzard",
    "move2": "Earthquake",
    "move3": "Double-Edge",
    "move4": "Shadow Ball",
    "speed50": 121,
    "speed100": 238
  },
  {
    "entry": 593,
    "name": "Ludicolo 3",
    "species": "Ludicolo",
    "instance": "3",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Leech Seed",
    "move2": "Rain Dance",
    "move3": "Double Team",
    "move4": "Giga Drain",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 594,
    "name": "Hypno 3",
    "species": "Hypno",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Psych Up",
    "move2": "Swagger",
    "move3": "Mega Kick",
    "move4": "Shadow Ball",
    "speed50": 87,
    "speed100": 170
  },
  {
    "entry": 595,
    "name": "Golem 3",
    "species": "Golem",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Explosion",
    "move2": "Earthquake",
    "move3": "Flamethrower",
    "move4": "Brick Break",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 596,
    "name": "Rhydon 3",
    "species": "Rhydon",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Megahorn",
    "move2": "Crush Claw",
    "move3": "Earthquake",
    "move4": "Horn Drill",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 597,
    "name": "Alakazam 3",
    "species": "Alakazam",
    "instance": "3",
    "nature": "Modest",
    "item": "Choice Band",
    "move1": "Trick",
    "move2": "Disable",
    "move3": "Psychic",
    "move4": "Skill Swap",
    "speed50": 140,
    "speed100": 276
  },
  {
    "entry": 598,
    "name": "Weezing 3",
    "species": "Weezing",
    "instance": "3",
    "nature": "Quirky",
    "item": "Focus Band",
    "move1": "Explosion",
    "move2": "Sludge Bomb",
    "move3": "Flamethrower",
    "move4": "Thunderbolt",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 599,
    "name": "Kangaskhan 3",
    "species": "Kangaskhan",
    "instance": "3",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Reversal",
    "move2": "Endure",
    "move3": "Thunderbolt",
    "move4": "Earthquake",
    "speed50": 156,
    "speed100": 306
  },
  {
    "entry": 600,
    "name": "Electabuzz 3",
    "species": "Electabuzz",
    "instance": "3",
    "nature": "Quirky",
    "item": "Lum Berry",
    "move1": "Fire Punch",
    "move2": "Ice Punch",
    "move3": "Thunderbolt",
    "move4": "Cross Chop",
    "speed50": 157,
    "speed100": 309
  },
  {
    "entry": 601,
    "name": "Tauros 3",
    "species": "Tauros",
    "instance": "3",
    "nature": "Docile",
    "item": "Leftovers",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Flamethrower",
    "move4": "Ice Beam",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 602,
    "name": "Slowbro 3",
    "species": "Slowbro",
    "instance": "3",
    "nature": "Quiet",
    "item": "Quick Claw",
    "move1": "Surf",
    "move2": "Psychic",
    "move3": "Shadow Ball",
    "move4": "Attract",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 603,
    "name": "Slowking 3",
    "species": "Slowking",
    "instance": "3",
    "nature": "Quiet",
    "item": "Quick Claw",
    "move1": "Psychic",
    "move2": "Surf",
    "move3": "Ice Beam",
    "move4": "Earthquake",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 604,
    "name": "Miltank 3",
    "species": "Miltank",
    "instance": "3",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Reversal",
    "move2": "Endure",
    "move3": "Earthquake",
    "move4": "Shadow Ball",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 605,
    "name": "Altaria 3",
    "species": "Altaria",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Sing",
    "move2": "Dragon Dance",
    "move3": "Earthquake",
    "move4": "Aerial Ace",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 606,
    "name": "Nidoqueen 3",
    "species": "Nidoqueen",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Flamethrower",
    "move3": "Ice Beam",
    "move4": "Crunch",
    "speed50": 96,
    "speed100": 188
  },
  {
    "entry": 607,
    "name": "Nidoking 3",
    "species": "Nidoking",
    "instance": "3",
    "nature": "Modest",
    "item": "Leppa Berry",
    "move1": "Horn Drill",
    "move2": "Fire Blast",
    "move3": "Blizzard",
    "move4": "Surf",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 608,
    "name": "Magmar 3",
    "species": "Magmar",
    "instance": "3",
    "nature": "Impish",
    "item": "Scope Lens",
    "move1": "Mega Kick",
    "move2": "Cross Chop",
    "move3": "Iron Tail",
    "move4": "Counter",
    "speed50": 113,
    "speed100": 222
  },
  {
    "entry": 609,
    "name": "Cradily 3",
    "species": "Cradily",
    "instance": "3",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Substitute",
    "move2": "SolarBeam",
    "move3": "Sunny Day",
    "move4": "Recover",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 610,
    "name": "Armaldo 3",
    "species": "Armaldo",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Brick Break",
    "move4": "Swords Dance",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 611,
    "name": "Golduck 3",
    "species": "Golduck",
    "instance": "3",
    "nature": "Docile",
    "item": "Shell Bell",
    "move1": "Hydro Pump",
    "move2": "Cross Chop",
    "move3": "Blizzard",
    "move4": "Protect",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 612,
    "name": "Rapidash 3",
    "species": "Rapidash",
    "instance": "3",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "SolarBeam",
    "move3": "Sunny Day",
    "move4": "Hypnosis",
    "speed50": 146,
    "speed100": 288
  },
  {
    "entry": 613,
    "name": "Muk 3",
    "species": "Muk",
    "instance": "3",
    "nature": "Quiet",
    "item": "Lum Berry",
    "move1": "Sludge Bomb",
    "move2": "Thunderbolt",
    "move3": "Flamethrower",
    "move4": "Ice Punch",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 614,
    "name": "Gengar 3",
    "species": "Gengar",
    "instance": "3",
    "nature": "Modest",
    "item": "Quick Claw",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Giga Drain",
    "move4": "Skill Swap",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 615,
    "name": "Ampharos 3",
    "species": "Ampharos",
    "instance": "3",
    "nature": "Hardy",
    "item": "Focus Band",
    "move1": "Thunderbolt",
    "move2": "Mega Kick",
    "move3": "Iron Tail",
    "move4": "Brick Break",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 616,
    "name": "Scizor 3",
    "species": "Scizor",
    "instance": "3",
    "nature": "Careful",
    "item": "Focus Band",
    "move1": "Reversal",
    "move2": "Endure",
    "move3": "Agility",
    "move4": "Slash",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 617,
    "name": "Heracross 3",
    "species": "Heracross",
    "instance": "3",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Megahorn",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Brick Break",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 618,
    "name": "Ursaring 3",
    "species": "Ursaring",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Fire Punch",
    "move2": "ThunderPunch",
    "move3": "Ice Punch",
    "move4": "Crunch",
    "speed50": 96,
    "speed100": 188
  },
  {
    "entry": 619,
    "name": "Houndoom 3",
    "species": "Houndoom",
    "instance": "3",
    "nature": "Quirky",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Shadow Ball",
    "move3": "Sludge Bomb",
    "move4": "Double-Edge",
    "speed50": 147,
    "speed100": 289
  },
  {
    "entry": 620,
    "name": "Donphan 3",
    "species": "Donphan",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Fissure",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Secret Power",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 621,
    "name": "Claydol 3",
    "species": "Claydol",
    "instance": "3",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Psychic",
    "move2": "Ice Beam",
    "move3": "SolarBeam",
    "move4": "Sunny Day",
    "speed50": 95,
    "speed100": 186
  },
  {
    "entry": 622,
    "name": "Wailord 3",
    "species": "Wailord",
    "instance": "3",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Hydro Pump",
    "move2": "Fissure",
    "move3": "Double Team",
    "move4": "Rest",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 623,
    "name": "Ninetales 3",
    "species": "Ninetales",
    "instance": "3",
    "nature": "Quirky",
    "item": "BrightPowder",
    "move1": "Fire Blast",
    "move2": "Iron Tail",
    "move3": "Confuse Ray",
    "move4": "Attract",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 624,
    "name": "Machamp 3",
    "species": "Machamp",
    "instance": "3",
    "nature": "Hardy",
    "item": "Quick Claw",
    "move1": "Cross Chop",
    "move2": "Fire Blast",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 625,
    "name": "Shuckle 3",
    "species": "Shuckle",
    "instance": "3",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Substitute",
    "move2": "Attract",
    "move3": "Toxic",
    "move4": "Double Team",
    "speed50": 25,
    "speed100": 46
  },
  {
    "entry": 626,
    "name": "Steelix 3",
    "species": "Steelix",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Body Slam",
    "move3": "Rock Slide",
    "move4": "Explosion",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 627,
    "name": "Tentacruel 3",
    "species": "Tentacruel",
    "instance": "3",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Giga Drain",
    "move3": "Ice Beam",
    "move4": "Mirror Coat",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 628,
    "name": "Aerodactyl 3",
    "species": "Aerodactyl",
    "instance": "3",
    "nature": "Hardy",
    "item": "King's Rock",
    "move1": "Double-Edge",
    "move2": "Rock Slide",
    "move3": "Fire Blast",
    "move4": "Dragon Claw",
    "speed50": 150,
    "speed100": 296
  },
  {
    "entry": 629,
    "name": "Porygon2 3",
    "species": "Porygon2",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Tri Attack",
    "move3": "Thunder Wave",
    "move4": "Recover",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 630,
    "name": "Gardevoir 3",
    "species": "Gardevoir",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Ice Punch",
    "move3": "Fire Punch",
    "move4": "Magical Leaf",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 631,
    "name": "Exeggutor 3",
    "species": "Exeggutor",
    "instance": "3",
    "nature": "Hardy",
    "item": "Leftovers",
    "move1": "Leech Seed",
    "move2": "Giga Drain",
    "move3": "Toxic",
    "move4": "Explosion",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 632,
    "name": "Starmie 3",
    "species": "Starmie",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Psychic",
    "move3": "Thunderbolt",
    "move4": "Ice Beam",
    "speed50": 167,
    "speed100": 329
  },
  {
    "entry": 633,
    "name": "Flygon 3",
    "species": "Flygon",
    "instance": "3",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Earthquake",
    "move2": "Dragon Claw",
    "move3": "Flamethrower",
    "move4": "Giga Drain",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 634,
    "name": "Venusaur 3",
    "species": "Venusaur",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Double-Edge",
    "move2": "Sludge Bomb",
    "move3": "Earthquake",
    "move4": "Sleep Powder",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 635,
    "name": "Vaporeon 3",
    "species": "Vaporeon",
    "instance": "3",
    "nature": "Calm",
    "item": "Quick Claw",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Acid Armor",
    "move4": "Baton Pass",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 636,
    "name": "Jolteon 3",
    "species": "Jolteon",
    "instance": "3",
    "nature": "Bold",
    "item": "BrightPowder",
    "move1": "Thunderbolt",
    "move2": "Thunder Wave",
    "move3": "Agility",
    "move4": "Baton Pass",
    "speed50": 150,
    "speed100": 296
  },
  {
    "entry": 637,
    "name": "Flareon 3",
    "species": "Flareon",
    "instance": "3",
    "nature": "Jolly",
    "item": "Quick Claw",
    "move1": "Shadow Ball",
    "move2": "Flail",
    "move3": "Endure",
    "move4": "Overheat",
    "speed50": 128,
    "speed100": 251
  },
  {
    "entry": 638,
    "name": "Meganium 3",
    "species": "Meganium",
    "instance": "3",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Earthquake",
    "move2": "Flail",
    "move3": "Endure",
    "move4": "Giga Drain",
    "speed50": 145,
    "speed100": 284
  },
  {
    "entry": 639,
    "name": "Espeon 3",
    "species": "Espeon",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Bite",
    "move3": "Wish",
    "move4": "Reflect",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 640,
    "name": "Umbreon 3",
    "species": "Umbreon",
    "instance": "3",
    "nature": "Bold",
    "item": "BrightPowder",
    "move1": "Swagger",
    "move2": "Psych Up",
    "move3": "Attract",
    "move4": "Shadow Ball",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 641,
    "name": "Blastoise 3",
    "species": "Blastoise",
    "instance": "3",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Surf",
    "move2": "Earthquake",
    "move3": "Ice Beam",
    "move4": "Counter",
    "speed50": 98,
    "speed100": 192
  },
  {
    "entry": 642,
    "name": "Feraligatr 3",
    "species": "Feraligatr",
    "instance": "3",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Hydro Pump",
    "move2": "Crunch",
    "move3": "Earthquake",
    "move4": "Rock Slide",
    "speed50": 98,
    "speed100": 192
  },
  {
    "entry": 643,
    "name": "Aggron 3",
    "species": "Aggron",
    "instance": "3",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Surf",
    "move2": "Thunder",
    "move3": "Fire Blast",
    "move4": "Blizzard",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 644,
    "name": "Blaziken 3",
    "species": "Blaziken",
    "instance": "3",
    "nature": "Hardy",
    "item": "Salac Berry",
    "move1": "Overheat",
    "move2": "Earthquake",
    "move3": "Endure",
    "move4": "Reversal",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 645,
    "name": "Walrein 3",
    "species": "Walrein",
    "instance": "3",
    "nature": "Hardy",
    "item": "Quick Claw",
    "move1": "Sheer Cold",
    "move2": "Fissure",
    "move3": "Surf",
    "move4": "Attract",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 646,
    "name": "Sceptile 3",
    "species": "Sceptile",
    "instance": "3",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Leaf Blade",
    "move2": "Earthquake",
    "move3": "Crush Claw",
    "move4": "Aerial Ace",
    "speed50": 161,
    "speed100": 318
  },
  {
    "entry": 647,
    "name": "Charizard 3",
    "species": "Charizard",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Flamethrower",
    "move2": "Dragon Claw",
    "move3": "Bite",
    "move4": "Brick Break",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 648,
    "name": "Typhlosion 3",
    "species": "Typhlosion",
    "instance": "3",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Earthquake",
    "move2": "Overheat",
    "move3": "Endure",
    "move4": "Reversal",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 649,
    "name": "Lapras 3",
    "species": "Lapras",
    "instance": "3",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Double-Edge",
    "move2": "Psychic",
    "move3": "Confuse Ray",
    "move4": "Dragon Dance",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 650,
    "name": "Crobat 3",
    "species": "Crobat",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Air Cutter",
    "move2": "Double-Edge",
    "move3": "Shadow Ball",
    "move4": "Screech",
    "speed50": 182,
    "speed100": 359
  },
  {
    "entry": 651,
    "name": "Swampert 3",
    "species": "Swampert",
    "instance": "3",
    "nature": "Brave",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Earthquake",
    "move3": "Ice Beam",
    "move4": "Counter",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 652,
    "name": "Gyarados 3",
    "species": "Gyarados",
    "instance": "3",
    "nature": "Quirky",
    "item": "Quick Claw",
    "move1": "Surf",
    "move2": "Thunder",
    "move3": "Rain Dance",
    "move4": "Earthquake",
    "speed50": 101,
    "speed100": 198
  },
  {
    "entry": 653,
    "name": "Snorlax 3",
    "species": "Snorlax",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Mega Kick",
    "move2": "Shadow Ball",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 654,
    "name": "Kingdra 3",
    "species": "Kingdra",
    "instance": "3",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Flail",
    "move2": "Hydro Pump",
    "move3": "Dragon Dance",
    "move4": "Endure",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 655,
    "name": "Blissey 3",
    "species": "Blissey",
    "instance": "3",
    "nature": "Bold",
    "item": "Focus Band",
    "move1": "Fire Blast",
    "move2": "Blizzard",
    "move3": "Calm Mind",
    "move4": "Softboiled",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 656,
    "name": "Milotic 3",
    "species": "Milotic",
    "instance": "3",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Surf",
    "move2": "Blizzard",
    "move3": "Attract",
    "move4": "Recover",
    "speed50": 101,
    "speed100": 198
  },
  {
    "entry": 657,
    "name": "Arcanine 3",
    "species": "Arcanine",
    "instance": "3",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "ExtremeSpeed",
    "move3": "Crunch",
    "move4": "Aerial Ace",
    "speed50": 147,
    "speed100": 289
  },
  {
    "entry": 658,
    "name": "Salamence 3",
    "species": "Salamence",
    "instance": "3",
    "nature": "Hardy",
    "item": "Salac Berry",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Endure",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 659,
    "name": "Metagross 3",
    "species": "Metagross",
    "instance": "3",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Earthquake",
    "move2": "Meteor Mash",
    "move3": "Double Team",
    "move4": "Rest",
    "speed50": 111,
    "speed100": 218
  },
  {
    "entry": 660,
    "name": "Slaking 3",
    "species": "Slaking",
    "instance": "3",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Earthquake",
    "move2": "Shadow Ball",
    "move3": "Aerial Ace",
    "move4": "Brick Break",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 661,
    "name": "Dugtrio 4",
    "species": "Dugtrio",
    "instance": "4",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Earthquake",
    "move2": "Double-Edge",
    "move3": "Rock Slide",
    "move4": "Fissure",
    "speed50": 172,
    "speed100": 339
  },
  {
    "entry": 662,
    "name": "Medicham 4",
    "species": "Medicham",
    "instance": "4",
    "nature": "Hardy",
    "item": "Lum Berry",
    "move1": "Mega Kick",
    "move2": "Psychic",
    "move3": "Shadow Ball",
    "move4": "Rock Slide",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 663,
    "name": "Misdreavus 4",
    "species": "Misdreavus",
    "instance": "4",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Destiny Bond",
    "move2": "Psychic",
    "move3": "Shadow Ball",
    "move4": "Thunderbolt",
    "speed50": 150,
    "speed100": 295
  },
  {
    "entry": 664,
    "name": "Fearow 4",
    "species": "Fearow",
    "instance": "4",
    "nature": "Hardy",
    "item": "Lum Berry",
    "move1": "Drill Peck",
    "move2": "Double-Edge",
    "move3": "Steel Wing",
    "move4": "Sky Attack",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 665,
    "name": "Granbull 4",
    "species": "Granbull",
    "instance": "4",
    "nature": "Brave",
    "item": "Choice Band",
    "move1": "Mega Kick",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Shadow Ball",
    "speed50": 58,
    "speed100": 113
  },
  {
    "entry": 666,
    "name": "Jynx 4",
    "species": "Jynx",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Ice Beam",
    "move3": "Lovely Kiss",
    "move4": "Fake Tears",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 667,
    "name": "Dusclops 4",
    "species": "Dusclops",
    "instance": "4",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Double-Edge",
    "move2": "Shadow Ball",
    "move3": "Curse",
    "move4": "Rest",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 668,
    "name": "Dodrio 4",
    "species": "Dodrio",
    "instance": "4",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Flail",
    "move2": "Endure",
    "move3": "Drill Peck",
    "move4": "Facade",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 669,
    "name": "Mrmime 4",
    "species": "Mr. Mime",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Ice Punch",
    "move4": "Fire Punch",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 670,
    "name": "Lanturn 4",
    "species": "Lanturn",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Confuse Ray",
    "speed50": 119,
    "speed100": 233
  },
  {
    "entry": 671,
    "name": "Breloom 4",
    "species": "Breloom",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Focus Punch",
    "move2": "Sludge Bomb",
    "move3": "Spore",
    "move4": "Double Team",
    "speed50": 122,
    "speed100": 239
  },
  {
    "entry": 672,
    "name": "Forretress 4",
    "species": "Forretress",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Explosion",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Double-Edge",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 673,
    "name": "Whiscash 4",
    "species": "Whiscash",
    "instance": "4",
    "nature": "Quiet",
    "item": "Quick Claw",
    "move1": "Fissure",
    "move2": "Surf",
    "move3": "Earthquake",
    "move4": "Ice Beam",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 674,
    "name": "Xatu 4",
    "species": "Xatu",
    "instance": "4",
    "nature": "Docile",
    "item": "Petaya Berry",
    "move1": "Psychic",
    "move2": "Drill Peck",
    "move3": "Shadow Ball",
    "move4": "Confuse Ray",
    "speed50": 115,
    "speed100": 226
  },
  {
    "entry": 675,
    "name": "Skarmory 4",
    "species": "Skarmory",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Drill Peck",
    "move2": "Steel Wing",
    "move3": "Counter",
    "move4": "Rock Slide",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 676,
    "name": "Marowak 4",
    "species": "Marowak",
    "instance": "4",
    "nature": "Adamant",
    "item": "Thick Club",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Swords Dance",
    "move4": "Mega Kick",
    "speed50": 97,
    "speed100": 189
  },
  {
    "entry": 677,
    "name": "Quagsire 4",
    "species": "Quagsire",
    "instance": "4",
    "nature": "Sassy",
    "item": "Leftovers",
    "move1": "Surf",
    "move2": "Earthquake",
    "move3": "Ice Beam",
    "move4": "Amnesia",
    "speed50": 49,
    "speed100": 95
  },
  {
    "entry": 678,
    "name": "Clefable 4",
    "species": "Clefable",
    "instance": "4",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Mega Kick",
    "move2": "Psychic",
    "move3": "Shadow Ball",
    "move4": "Softboiled",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 679,
    "name": "Hariyama 4",
    "species": "Hariyama",
    "instance": "4",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Cross Chop",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Fake Out",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 680,
    "name": "Raichu 4",
    "species": "Raichu",
    "instance": "4",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Thunderbolt",
    "move2": "Thunder Wave",
    "move3": "Protect",
    "move4": "Mega Kick",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 681,
    "name": "Dewgong 4",
    "species": "Dewgong",
    "instance": "4",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "Sheer Cold",
    "move2": "Ice Beam",
    "move3": "Surf",
    "move4": "Signal Beam",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 682,
    "name": "Manectric 4",
    "species": "Manectric",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Crunch",
    "move3": "Thunder Wave",
    "move4": "Roar",
    "speed50": 157,
    "speed100": 309
  },
  {
    "entry": 683,
    "name": "Vileplume 4",
    "species": "Vileplume",
    "instance": "4",
    "nature": "Quiet",
    "item": "Quick Claw",
    "move1": "SolarBeam",
    "move2": "Sludge Bomb",
    "move3": "Sunny Day",
    "move4": "Synthesis",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 684,
    "name": "Victreebel 4",
    "species": "Victreebel",
    "instance": "4",
    "nature": "Quirky",
    "item": "BrightPowder",
    "move1": "Giga Drain",
    "move2": "Double-Edge",
    "move3": "Sludge Bomb",
    "move4": "Synthesis",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 685,
    "name": "Electrode 4",
    "species": "Electrode",
    "instance": "4",
    "nature": "Naughty",
    "item": "Lum Berry",
    "move1": "Explosion",
    "move2": "Thunderbolt",
    "move3": "Thunder Wave",
    "move4": "Mirror Coat",
    "speed50": 160,
    "speed100": 316
  },
  {
    "entry": 686,
    "name": "Exploud 4",
    "species": "Exploud",
    "instance": "4",
    "nature": "Hardy",
    "item": "White Herb",
    "move1": "Mega Kick",
    "move2": "Earthquake",
    "move3": "Shadow Ball",
    "move4": "Overheat",
    "speed50": 88,
    "speed100": 172
  },
  {
    "entry": 687,
    "name": "Shiftry 4",
    "species": "Shiftry",
    "instance": "4",
    "nature": "Hardy",
    "item": "Focus Band",
    "move1": "Explosion",
    "move2": "Giga Drain",
    "move3": "Mega Kick",
    "move4": "Fake Out",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 688,
    "name": "Glalie 4",
    "species": "Glalie",
    "instance": "4",
    "nature": "Hardy",
    "item": "Leftovers",
    "move1": "Ice Beam",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Shadow Ball",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 689,
    "name": "Ludicolo 4",
    "species": "Ludicolo",
    "instance": "4",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Leech Seed",
    "move2": "Rain Dance",
    "move3": "Double Team",
    "move4": "Toxic",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 690,
    "name": "Hypno 4",
    "species": "Hypno",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "ThunderPunch",
    "move3": "Fire Punch",
    "move4": "Ice Punch",
    "speed50": 87,
    "speed100": 170
  },
  {
    "entry": 691,
    "name": "Golem 4",
    "species": "Golem",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Explosion",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Double-Edge",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 692,
    "name": "Rhydon 4",
    "species": "Rhydon",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Megahorn",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Horn Drill",
    "speed50": 60,
    "speed100": 116
  },
  {
    "entry": 693,
    "name": "Alakazam 4",
    "species": "Alakazam",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "ThunderPunch",
    "move3": "Fire Punch",
    "move4": "Ice Punch",
    "speed50": 140,
    "speed100": 276
  },
  {
    "entry": 694,
    "name": "Weezing 4",
    "species": "Weezing",
    "instance": "4",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Explosion",
    "move2": "Sludge Bomb",
    "move3": "Frustration",
    "move4": "Shadow Ball",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 695,
    "name": "Kangaskhan 4",
    "species": "Kangaskhan",
    "instance": "4",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Mega Kick",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "Shadow Ball",
    "speed50": 142,
    "speed100": 279
  },
  {
    "entry": 696,
    "name": "Electabuzz 4",
    "species": "Electabuzz",
    "instance": "4",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Thunderbolt",
    "move2": "Psychic",
    "move3": "Mega Kick",
    "move4": "Cross Chop",
    "speed50": 125,
    "speed100": 246
  },
  {
    "entry": 697,
    "name": "Tauros 4",
    "species": "Tauros",
    "instance": "4",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Double-Edge",
    "move2": "Rock Tomb",
    "move3": "Thunderbolt",
    "move4": "Surf",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 698,
    "name": "Slowbro 4",
    "species": "Slowbro",
    "instance": "4",
    "nature": "Sassy",
    "item": "Quick Claw",
    "move1": "Psychic",
    "move2": "Surf",
    "move3": "Earthquake",
    "move4": "Ice Beam",
    "speed50": 45,
    "speed100": 86
  },
  {
    "entry": 699,
    "name": "Slowking 4",
    "species": "Slowking",
    "instance": "4",
    "nature": "Modest",
    "item": "Quick Claw",
    "move1": "Psychic",
    "move2": "Surf",
    "move3": "Ice Beam",
    "move4": "Flamethrower",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 700,
    "name": "Miltank 4",
    "species": "Miltank",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Double-Edge",
    "move2": "Curse",
    "move3": "Double Team",
    "move4": "Milk Drink",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 701,
    "name": "Altaria 4",
    "species": "Altaria",
    "instance": "4",
    "nature": "Docile",
    "item": "Shell Bell",
    "move1": "Dragon Claw",
    "move2": "Earthquake",
    "move3": "Flamethrower",
    "move4": "Ice Beam",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 702,
    "name": "Nidoqueen 4",
    "species": "Nidoqueen",
    "instance": "4",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Superpower",
    "move2": "Sludge Bomb",
    "move3": "Earthquake",
    "move4": "Shadow Ball",
    "speed50": 96,
    "speed100": 188
  },
  {
    "entry": 703,
    "name": "Nidoking 4",
    "species": "Nidoking",
    "instance": "4",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "Megahorn",
    "move2": "Sludge Bomb",
    "move3": "Earthquake",
    "move4": "Thunder",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 704,
    "name": "Magmar 4",
    "species": "Magmar",
    "instance": "4",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Flamethrower",
    "move2": "Psychic",
    "move3": "Cross Chop",
    "move4": "Confuse Ray",
    "speed50": 113,
    "speed100": 222
  },
  {
    "entry": 705,
    "name": "Cradily 4",
    "species": "Cradily",
    "instance": "4",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Ingrain",
    "move3": "Mirror Coat",
    "move4": "Giga Drain",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 706,
    "name": "Armaldo 4",
    "species": "Armaldo",
    "instance": "4",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "Rock Slide",
    "speed50": 65,
    "speed100": 126
  },
  {
    "entry": 707,
    "name": "Golduck 4",
    "species": "Golduck",
    "instance": "4",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Surf",
    "move2": "Cross Chop",
    "move3": "Ice Beam",
    "move4": "Aerial Ace",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 708,
    "name": "Rapidash 4",
    "species": "Rapidash",
    "instance": "4",
    "nature": "Docile",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Double-Edge",
    "move3": "Iron Tail",
    "move4": "Double Kick",
    "speed50": 146,
    "speed100": 288
  },
  {
    "entry": 709,
    "name": "Muk 4",
    "species": "Muk",
    "instance": "4",
    "nature": "Brave",
    "item": "Quick Claw",
    "move1": "Sludge Bomb",
    "move2": "Brick Break",
    "move3": "Giga Drain",
    "move4": "Explosion",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 710,
    "name": "Gengar 4",
    "species": "Gengar",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Fire Punch",
    "move3": "Ice Punch",
    "move4": "Destiny Bond",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 711,
    "name": "Ampharos 4",
    "species": "Ampharos",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Fire Punch",
    "move3": "Thunder Wave",
    "move4": "Reflect",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 712,
    "name": "Scizor 4",
    "species": "Scizor",
    "instance": "4",
    "nature": "Careful",
    "item": "BrightPowder",
    "move1": "Silver Wind",
    "move2": "Swords Dance",
    "move3": "Agility",
    "move4": "Baton Pass",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 713,
    "name": "Heracross 4",
    "species": "Heracross",
    "instance": "4",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Megahorn",
    "move2": "Earthquake",
    "move3": "Reversal",
    "move4": "Endure",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 714,
    "name": "Ursaring 4",
    "species": "Ursaring",
    "instance": "4",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Aerial Ace",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 715,
    "name": "Houndoom 4",
    "species": "Houndoom",
    "instance": "4",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "SolarBeam",
    "move3": "Crunch",
    "move4": "Sunny Day",
    "speed50": 147,
    "speed100": 289
  },
  {
    "entry": 716,
    "name": "Donphan 4",
    "species": "Donphan",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Fissure",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Iron Tail",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 717,
    "name": "Claydol 4",
    "species": "Claydol",
    "instance": "4",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Psychic",
    "move2": "Earthquake",
    "move3": "Shadow Ball",
    "move4": "Explosion",
    "speed50": 95,
    "speed100": 186
  },
  {
    "entry": 718,
    "name": "Wailord 4",
    "species": "Wailord",
    "instance": "4",
    "nature": "Hardy",
    "item": "Quick Claw",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Earthquake",
    "move4": "Fissure",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 719,
    "name": "Ninetales 4",
    "species": "Ninetales",
    "instance": "4",
    "nature": "Quirky",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Double-Edge",
    "move3": "Confuse Ray",
    "move4": "Will-O-Wisp",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 720,
    "name": "Machamp 4",
    "species": "Machamp",
    "instance": "4",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Cross Chop",
    "move2": "Earthquake",
    "move3": "Flamethrower",
    "move4": "Rock Slide",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 721,
    "name": "Shuckle 4",
    "species": "Shuckle",
    "instance": "4",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Toxic",
    "move2": "Double Team",
    "move3": "Wrap",
    "move4": "Rest",
    "speed50": 25,
    "speed100": 46
  },
  {
    "entry": 722,
    "name": "Steelix 4",
    "species": "Steelix",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Iron Tail",
    "move3": "Double-Edge",
    "move4": "Explosion",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 723,
    "name": "Tentacruel 4",
    "species": "Tentacruel",
    "instance": "4",
    "nature": "Quirky",
    "item": "Shell Bell",
    "move1": "Hydro Pump",
    "move2": "Sludge Bomb",
    "move3": "Ice Beam",
    "move4": "Mirror Coat",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 724,
    "name": "Aerodactyl 4",
    "species": "Aerodactyl",
    "instance": "4",
    "nature": "Hardy",
    "item": "King's Rock",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Fire Blast",
    "move4": "Bite",
    "speed50": 150,
    "speed100": 296
  },
  {
    "entry": 725,
    "name": "Porygon2 4",
    "species": "Porygon2",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Recover",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 726,
    "name": "Gardevoir 4",
    "species": "Gardevoir",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Ice Punch",
    "move4": "Fire Punch",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 727,
    "name": "Exeggutor 4",
    "species": "Exeggutor",
    "instance": "4",
    "nature": "Hardy",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Giga Drain",
    "move3": "Sludge Bomb",
    "move4": "Explosion",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 728,
    "name": "Starmie 4",
    "species": "Starmie",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Recover",
    "speed50": 167,
    "speed100": 329
  },
  {
    "entry": 729,
    "name": "Flygon 4",
    "species": "Flygon",
    "instance": "4",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Earthquake",
    "move2": "Dragon Claw",
    "move3": "Double-Edge",
    "move4": "Crunch",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 730,
    "name": "Venusaur 4",
    "species": "Venusaur",
    "instance": "4",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "SolarBeam",
    "move2": "Sludge Bomb",
    "move3": "Sunny Day",
    "move4": "Earthquake",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 731,
    "name": "Vaporeon 4",
    "species": "Vaporeon",
    "instance": "4",
    "nature": "Calm",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Acid Armor",
    "move4": "Rest",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 732,
    "name": "Jolteon 4",
    "species": "Jolteon",
    "instance": "4",
    "nature": "Timid",
    "item": "King's Rock",
    "move1": "Thunderbolt",
    "move2": "Thunder Wave",
    "move3": "Bite",
    "move4": "Shadow Ball",
    "speed50": 200,
    "speed100": 394
  },
  {
    "entry": 733,
    "name": "Flareon 4",
    "species": "Flareon",
    "instance": "4",
    "nature": "Quiet",
    "item": "Quick Claw",
    "move1": "Overheat",
    "move2": "Sunny Day",
    "move3": "Double-Edge",
    "move4": "Shadow Ball",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 734,
    "name": "Meganium 4",
    "species": "Meganium",
    "instance": "4",
    "nature": "Hardy",
    "item": "BrightPowder",
    "move1": "Giga Drain",
    "move2": "Earthquake",
    "move3": "AncientPower",
    "move4": "Body Slam",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 735,
    "name": "Espeon 4",
    "species": "Espeon",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Bite",
    "move3": "Attract",
    "move4": "Calm Mind",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 736,
    "name": "Umbreon 4",
    "species": "Umbreon",
    "instance": "4",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Confuse Ray",
    "move2": "Toxic",
    "move3": "Faint Attack",
    "move4": "Double Team",
    "speed50": 85,
    "speed100": 166
  },
  {
    "entry": 737,
    "name": "Blastoise 4",
    "species": "Blastoise",
    "instance": "4",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Surf",
    "move2": "Earthquake",
    "move3": "Ice Beam",
    "move4": "Mirror Coat",
    "speed50": 98,
    "speed100": 192
  },
  {
    "entry": 738,
    "name": "Feraligatr 4",
    "species": "Feraligatr",
    "instance": "4",
    "nature": "Hardy",
    "item": "Scope Lens",
    "move1": "Hydro Pump",
    "move2": "Ice Beam",
    "move3": "Earthquake",
    "move4": "Aerial Ace",
    "speed50": 98,
    "speed100": 192
  },
  {
    "entry": 739,
    "name": "Aggron 4",
    "species": "Aggron",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Aerial Ace",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 740,
    "name": "Blaziken 4",
    "species": "Blaziken",
    "instance": "4",
    "nature": "Hardy",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Earthquake",
    "move3": "ThunderPunch",
    "move4": "Rock Slide",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 741,
    "name": "Walrein 4",
    "species": "Walrein",
    "instance": "4",
    "nature": "Quiet",
    "item": "BrightPowder",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Earthquake",
    "move4": "Sheer Cold",
    "speed50": 76,
    "speed100": 149
  },
  {
    "entry": 742,
    "name": "Sceptile 4",
    "species": "Sceptile",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Leaf Blade",
    "move2": "Dragon Claw",
    "move3": "Crunch",
    "move4": "ThunderPunch",
    "speed50": 172,
    "speed100": 339
  },
  {
    "entry": 743,
    "name": "Charizard 4",
    "species": "Charizard",
    "instance": "4",
    "nature": "Hardy",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "Rock Slide",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 744,
    "name": "Typhlosion 4",
    "species": "Typhlosion",
    "instance": "4",
    "nature": "Hardy",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "ThunderPunch",
    "move3": "Earthquake",
    "move4": "Crush Claw",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 745,
    "name": "Lapras 4",
    "species": "Lapras",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Thunderbolt",
    "move4": "Psychic",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 746,
    "name": "Crobat 4",
    "species": "Crobat",
    "instance": "4",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Sludge Bomb",
    "move2": "Aerial Ace",
    "move3": "Shadow Ball",
    "move4": "Confuse Ray",
    "speed50": 182,
    "speed100": 359
  },
  {
    "entry": 747,
    "name": "Swampert 4",
    "species": "Swampert",
    "instance": "4",
    "nature": "Quiet",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Earthquake",
    "move3": "Ice Beam",
    "move4": "Mirror Coat",
    "speed50": 72,
    "speed100": 140
  },
  {
    "entry": 748,
    "name": "Gyarados 4",
    "species": "Gyarados",
    "instance": "4",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Return",
    "move2": "Earthquake",
    "move3": "Dragon Dance",
    "move4": "Rest",
    "speed50": 101,
    "speed100": 198
  },
  {
    "entry": 749,
    "name": "Snorlax 4",
    "species": "Snorlax",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Double-Edge",
    "move2": "Shadow Ball",
    "move3": "Brick Break",
    "move4": "Curse",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 750,
    "name": "Kingdra 4",
    "species": "Kingdra",
    "instance": "4",
    "nature": "Hardy",
    "item": "Chesto Berry",
    "move1": "Double-Edge",
    "move2": "Ice Beam",
    "move3": "Dragon Dance",
    "move4": "Rest",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 751,
    "name": "Blissey 4",
    "species": "Blissey",
    "instance": "4",
    "nature": "Bold",
    "item": "Focus Band",
    "move1": "Ice Beam",
    "move2": "Calm Mind",
    "move3": "Counter",
    "move4": "Softboiled",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 752,
    "name": "Milotic 4",
    "species": "Milotic",
    "instance": "4",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Recover",
    "move4": "Mirror Coat",
    "speed50": 101,
    "speed100": 198
  },
  {
    "entry": 753,
    "name": "Arcanine 4",
    "species": "Arcanine",
    "instance": "4",
    "nature": "Docile",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "ExtremeSpeed",
    "move3": "Crunch",
    "move4": "Double-Edge",
    "speed50": 147,
    "speed100": 289
  },
  {
    "entry": 754,
    "name": "Salamence 4",
    "species": "Salamence",
    "instance": "4",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "Dragon Dance",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 755,
    "name": "Metagross 4",
    "species": "Metagross",
    "instance": "4",
    "nature": "Hardy",
    "item": "Quick Claw",
    "move1": "Meteor Mash",
    "move2": "Psychic",
    "move3": "Earthquake",
    "move4": "Shadow Ball",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 756,
    "name": "Slaking 4",
    "species": "Slaking",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Flamethrower",
    "move3": "Ice Beam",
    "move4": "Yawn",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 757,
    "name": "Articuno 1",
    "species": "Articuno",
    "instance": "1",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Ice Beam",
    "move2": "Water Pulse",
    "move3": "Icy Wind",
    "move4": "Roar",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 758,
    "name": "Zapdos 1",
    "species": "Zapdos",
    "instance": "1",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Drill Peck",
    "move3": "Thunder Wave",
    "move4": "Roar",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 759,
    "name": "Moltres 1",
    "species": "Moltres",
    "instance": "1",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "Flamethrower",
    "move2": "Aerial Ace",
    "move3": "Mud-Slap",
    "move4": "Roar",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 760,
    "name": "Raikou 1",
    "species": "Raikou",
    "instance": "1",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Thunderbolt",
    "move2": "Thunder Wave",
    "move3": "Calm Mind",
    "move4": "Rest",
    "speed50": 167,
    "speed100": 329
  },
  {
    "entry": 761,
    "name": "Entei 1",
    "species": "Entei",
    "instance": "1",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Flamethrower",
    "move2": "Double Team",
    "move3": "Calm Mind",
    "move4": "Rest",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 762,
    "name": "Suicune 1",
    "species": "Suicune",
    "instance": "1",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Surf",
    "move2": "Double Team",
    "move3": "Calm Mind",
    "move4": "Rest",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 763,
    "name": "Regirock 1",
    "species": "Regirock",
    "instance": "1",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Superpower",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Explosion",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 764,
    "name": "Regice 1",
    "species": "Regice",
    "instance": "1",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Ice Beam",
    "move2": "Thunderbolt",
    "move3": "Amnesia",
    "move4": "Rest",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 765,
    "name": "Registeel 1",
    "species": "Registeel",
    "instance": "1",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Metal Claw",
    "move2": "Curse",
    "move3": "Amnesia",
    "move4": "Rest",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 766,
    "name": "Latias 1",
    "species": "Latias",
    "instance": "1",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Dragon Claw",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 767,
    "name": "Latios 1",
    "species": "Latios",
    "instance": "1",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Dragon Claw",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 768,
    "name": "Articuno 2",
    "species": "Articuno",
    "instance": "2",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Substitute",
    "move2": "Toxic",
    "move3": "Blizzard",
    "move4": "Double Team",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 769,
    "name": "Zapdos 2",
    "species": "Zapdos",
    "instance": "2",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Thunder",
    "move2": "Rain Dance",
    "move3": "Drill Peck",
    "move4": "Double Team",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 770,
    "name": "Moltres 2",
    "species": "Moltres",
    "instance": "2",
    "nature": "Hardy",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Aerial Ace",
    "move3": "Double Team",
    "move4": "Protect",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 771,
    "name": "Raikou 2",
    "species": "Raikou",
    "instance": "2",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Thunder",
    "move2": "Rain Dance",
    "move3": "Double Team",
    "move4": "Reflect",
    "speed50": 167,
    "speed100": 329
  },
  {
    "entry": 772,
    "name": "Entei 2",
    "species": "Entei",
    "instance": "2",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Fire Blast",
    "move2": "Sunny Day",
    "move3": "SolarBeam",
    "move4": "Reflect",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 773,
    "name": "Suicune 2",
    "species": "Suicune",
    "instance": "2",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Dive",
    "move3": "Double Team",
    "move4": "Protect",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 774,
    "name": "Regirock 2",
    "species": "Regirock",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Counter",
    "move4": "Explosion",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 775,
    "name": "Regice 2",
    "species": "Regice",
    "instance": "2",
    "nature": "Quiet",
    "item": "BrightPowder",
    "move1": "Thunder",
    "move2": "Rain Dance",
    "move3": "Blizzard",
    "move4": "Brick Break",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 776,
    "name": "Registeel 2",
    "species": "Registeel",
    "instance": "2",
    "nature": "Quiet",
    "item": "BrightPowder",
    "move1": "Thunderbolt",
    "move2": "Ice Punch",
    "move3": "Earthquake",
    "move4": "Aerial Ace",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 777,
    "name": "Latias 2",
    "species": "Latias",
    "instance": "2",
    "nature": "Docile",
    "item": "Quick Claw",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Earthquake",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 778,
    "name": "Latios 2",
    "species": "Latios",
    "instance": "2",
    "nature": "Docile",
    "item": "Quick Claw",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Earthquake",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 779,
    "name": "Articuno 3",
    "species": "Articuno",
    "instance": "3",
    "nature": "Docile",
    "item": "BrightPowder",
    "move1": "Ice Beam",
    "move2": "Facade",
    "move3": "Aerial Ace",
    "move4": "Protect",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 780,
    "name": "Zapdos 3",
    "species": "Zapdos",
    "instance": "3",
    "nature": "Docile",
    "item": "Leftovers",
    "move1": "Thunderbolt",
    "move2": "Drill Peck",
    "move3": "Thunder Wave",
    "move4": "Substitute",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 781,
    "name": "Moltres 3",
    "species": "Moltres",
    "instance": "3",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Fire Blast",
    "move2": "Sunny Day",
    "move3": "Double Team",
    "move4": "Rest",
    "speed50": 142,
    "speed100": 279
  },
  {
    "entry": 782,
    "name": "Raikou 3",
    "species": "Raikou",
    "instance": "3",
    "nature": "Modest",
    "item": "King's Rock",
    "move1": "Thunderbolt",
    "move2": "Thunder Wave",
    "move3": "Quick Attack",
    "move4": "Roar",
    "speed50": 167,
    "speed100": 329
  },
  {
    "entry": 783,
    "name": "Entei 3",
    "species": "Entei",
    "instance": "3",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "Flamethrower",
    "move2": "Double-Edge",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 784,
    "name": "Suicune 3",
    "species": "Suicune",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Rain Dance",
    "move4": "Roar",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 785,
    "name": "Regirock 3",
    "species": "Regirock",
    "instance": "3",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Rock Slide",
    "move2": "Earthquake",
    "move3": "Curse",
    "move4": "Rest",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 786,
    "name": "Regice 3",
    "species": "Regice",
    "instance": "3",
    "nature": "Quiet",
    "item": "Lum Berry",
    "move1": "Ice Beam",
    "move2": "Thunderbolt",
    "move3": "Thunder Wave",
    "move4": "Explosion",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 787,
    "name": "Registeel 3",
    "species": "Registeel",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "AncientPower",
    "move2": "Amnesia",
    "move3": "Counter",
    "move4": "Explosion",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 788,
    "name": "Latias 3",
    "species": "Latias",
    "instance": "3",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Dragon Claw",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Earthquake",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 789,
    "name": "Latios 3",
    "species": "Latios",
    "instance": "3",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Dragon Claw",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Earthquake",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 790,
    "name": "Articuno 4",
    "species": "Articuno",
    "instance": "4",
    "nature": "Docile",
    "item": "Chesto Berry",
    "move1": "Blizzard",
    "move2": "Double-Edge",
    "move3": "Rest",
    "move4": "Reflect",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 791,
    "name": "Zapdos 4",
    "species": "Zapdos",
    "instance": "4",
    "nature": "Docile",
    "item": "Shell Bell",
    "move1": "Thunderbolt",
    "move2": "Drill Peck",
    "move3": "Thunder Wave",
    "move4": "Light Screen",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 792,
    "name": "Moltres 4",
    "species": "Moltres",
    "instance": "4",
    "nature": "Quiet",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Double-Edge",
    "move3": "Steel Wing",
    "move4": "Safeguard",
    "speed50": 99,
    "speed100": 194
  },
  {
    "entry": 793,
    "name": "Raikou 4",
    "species": "Raikou",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Bite",
    "move3": "Thunder Wave",
    "move4": "Reflect",
    "speed50": 167,
    "speed100": 329
  },
  {
    "entry": 794,
    "name": "Entei 4",
    "species": "Entei",
    "instance": "4",
    "nature": "Modest",
    "item": "King's Rock",
    "move1": "Flamethrower",
    "move2": "Bite",
    "move3": "Double Team",
    "move4": "Reflect",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 795,
    "name": "Suicune 4",
    "species": "Suicune",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Bite",
    "move4": "Reflect",
    "speed50": 137,
    "speed100": 269
  },
  {
    "entry": 796,
    "name": "Regirock 4",
    "species": "Regirock",
    "instance": "4",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Rock Slide",
    "move2": "Brick Break",
    "move3": "Double Team",
    "move4": "Thunder Wave",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 797,
    "name": "Regice 4",
    "species": "Regice",
    "instance": "4",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Ice Beam",
    "move2": "Hail",
    "move3": "Double Team",
    "move4": "Thunder Wave",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 798,
    "name": "Registeel 4",
    "species": "Registeel",
    "instance": "4",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "AncientPower",
    "move2": "Earthquake",
    "move3": "Double Team",
    "move4": "Thunder Wave",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 799,
    "name": "Latias 4",
    "species": "Latias",
    "instance": "4",
    "nature": "Docile",
    "item": "Leftovers",
    "move1": "Mist Ball",
    "move2": "Shadow Ball",
    "move3": "Charm",
    "move4": "Reflect",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 800,
    "name": "Latios 4",
    "species": "Latios",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Luster Purge",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Dragon Claw",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 801,
    "name": "Gengar 5",
    "species": "Gengar",
    "instance": "5",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Thunderbolt",
    "move4": "Fire Punch",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 802,
    "name": "Gengar 6",
    "species": "Gengar",
    "instance": "6",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Thunderbolt",
    "move4": "Ice Punch",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 803,
    "name": "Gengar 7",
    "species": "Gengar",
    "instance": "7",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Fire Punch",
    "move4": "Destiny Bond",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 804,
    "name": "Gengar 8",
    "species": "Gengar",
    "instance": "8",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Ice Punch",
    "move4": "Destiny Bond",
    "speed50": 162,
    "speed100": 319
  },
  {
    "entry": 805,
    "name": "Ursaring 5",
    "species": "Ursaring",
    "instance": "5",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Mega Kick",
    "move2": "Aerial Ace",
    "move3": "Rock Slide",
    "move4": "Brick Break",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 806,
    "name": "Ursaring 6",
    "species": "Ursaring",
    "instance": "6",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Hyper Beam",
    "move2": "Yawn",
    "move3": "Swords Dance",
    "move4": "Double Team",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 807,
    "name": "Ursaring 7",
    "species": "Ursaring",
    "instance": "7",
    "nature": "Docile",
    "item": "Quick Claw",
    "move1": "Facade",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Bulk Up",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 808,
    "name": "Ursaring 8",
    "species": "Ursaring",
    "instance": "8",
    "nature": "Docile",
    "item": "Quick Claw",
    "move1": "Facade",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Brick Break",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 809,
    "name": "Machamp 5",
    "species": "Machamp",
    "instance": "5",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Cross Chop",
    "move2": "Double-Edge",
    "move3": "Earthquake",
    "move4": "Rock Slide",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 810,
    "name": "Machamp 6",
    "species": "Machamp",
    "instance": "6",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Cross Chop",
    "move2": "Earthquake",
    "move3": "Counter",
    "move4": "Rock Tomb",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 811,
    "name": "Machamp 7",
    "species": "Machamp",
    "instance": "7",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Focus Punch",
    "move2": "Substitute",
    "move3": "Attract",
    "move4": "Double Team",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 812,
    "name": "Machamp 8",
    "species": "Machamp",
    "instance": "8",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Revenge",
    "move2": "Rock Slide",
    "move3": "Facade",
    "move4": "Counter",
    "speed50": 75,
    "speed100": 146
  },
  {
    "entry": 813,
    "name": "Gardevoir 5",
    "species": "Gardevoir",
    "instance": "5",
    "nature": "Docile",
    "item": "Salac Berry",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Endure",
    "move4": "Destiny Bond",
    "speed50": 121,
    "speed100": 238
  },
  {
    "entry": 814,
    "name": "Gardevoir 6",
    "species": "Gardevoir",
    "instance": "6",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Will-O-Wisp",
    "move4": "Destiny Bond",
    "speed50": 145,
    "speed100": 284
  },
  {
    "entry": 815,
    "name": "Gardevoir 7",
    "species": "Gardevoir",
    "instance": "7",
    "nature": "Bold",
    "item": "Quick Claw",
    "move1": "Psychic",
    "move2": "Calm Mind",
    "move3": "Will-O-Wisp",
    "move4": "Destiny Bond",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 816,
    "name": "Gardevoir 8",
    "species": "Gardevoir",
    "instance": "8",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Magical Leaf",
    "move3": "Attract",
    "move4": "Double Team",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 817,
    "name": "Starmie 5",
    "species": "Starmie",
    "instance": "5",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Psychic",
    "move3": "Recover",
    "move4": "Light Screen",
    "speed50": 167,
    "speed100": 329
  },
  {
    "entry": 818,
    "name": "Starmie 6",
    "species": "Starmie",
    "instance": "6",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Surf",
    "move2": "Confuse Ray",
    "move3": "Thunder Wave",
    "move4": "Recover",
    "speed50": 135,
    "speed100": 266
  },
  {
    "entry": 819,
    "name": "Starmie 7",
    "species": "Starmie",
    "instance": "7",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Ice Beam",
    "move3": "Cosmic Power",
    "move4": "Recover",
    "speed50": 167,
    "speed100": 329
  },
  {
    "entry": 820,
    "name": "Starmie 8",
    "species": "Starmie",
    "instance": "8",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Surf",
    "move2": "Thunderbolt",
    "move3": "Cosmic Power",
    "move4": "Recover",
    "speed50": 167,
    "speed100": 329
  },
  {
    "entry": 821,
    "name": "Lapras 5",
    "species": "Lapras",
    "instance": "5",
    "nature": "Docile",
    "item": "Shell Bell",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Iron Tail",
    "move4": "Double-Edge",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 822,
    "name": "Lapras 6",
    "species": "Lapras",
    "instance": "6",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Hydro Pump",
    "move2": "Thunder",
    "move3": "Rain Dance",
    "move4": "Blizzard",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 823,
    "name": "Lapras 7",
    "species": "Lapras",
    "instance": "7",
    "nature": "Calm",
    "item": "Leppa Berry",
    "move1": "Sheer Cold",
    "move2": "Horn Drill",
    "move3": "Rest",
    "move4": "Sleep Talk",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 824,
    "name": "Lapras 8",
    "species": "Lapras",
    "instance": "8",
    "nature": "Calm",
    "item": "Quick Claw",
    "move1": "Sheer Cold",
    "move2": "Horn Drill",
    "move3": "Sing",
    "move4": "Attract",
    "speed50": 80,
    "speed100": 156
  },
  {
    "entry": 825,
    "name": "Snorlax 5",
    "species": "Snorlax",
    "instance": "5",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Mega Kick",
    "move2": "Shadow Ball",
    "move3": "Brick Break",
    "move4": "Counter",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 826,
    "name": "Snorlax 6",
    "species": "Snorlax",
    "instance": "6",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Earthquake",
    "move2": "Shadow Ball",
    "move3": "Brick Break",
    "move4": "Counter",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 827,
    "name": "Snorlax 7",
    "species": "Snorlax",
    "instance": "7",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Hyper Beam",
    "move2": "Shadow Ball",
    "move3": "Earthquake",
    "move4": "Curse",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 828,
    "name": "Snorlax 8",
    "species": "Snorlax",
    "instance": "8",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Return",
    "move2": "Shadow Ball",
    "move3": "Belly Drum",
    "move4": "Rest",
    "speed50": 50,
    "speed100": 96
  },
  {
    "entry": 829,
    "name": "Salamence 5",
    "species": "Salamence",
    "instance": "5",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Facade",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Dragon Dance",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 830,
    "name": "Salamence 6",
    "species": "Salamence",
    "instance": "6",
    "nature": "Hardy",
    "item": "Lum Berry",
    "move1": "Headbutt",
    "move2": "Aerial Ace",
    "move3": "Crunch",
    "move4": "Dragon Dance",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 831,
    "name": "Salamence 7",
    "species": "Salamence",
    "instance": "7",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Flamethrower",
    "move2": "Dragon Claw",
    "move3": "Crunch",
    "move4": "Brick Break",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 832,
    "name": "Salamence 8",
    "species": "Salamence",
    "instance": "8",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Flamethrower",
    "move2": "Dragon Claw",
    "move3": "Crunch",
    "move4": "Attract",
    "speed50": 152,
    "speed100": 299
  },
  {
    "entry": 833,
    "name": "Metagross 5",
    "species": "Metagross",
    "instance": "5",
    "nature": "Jolly",
    "item": "Quick Claw",
    "move1": "Explosion",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Brick Break",
    "speed50": 122,
    "speed100": 239
  },
  {
    "entry": 834,
    "name": "Metagross 6",
    "species": "Metagross",
    "instance": "6",
    "nature": "Hardy",
    "item": "BrightPowder",
    "move1": "Meteor Mash",
    "move2": "Psychic",
    "move3": "Ice Punch",
    "move4": "ThunderPunch",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 835,
    "name": "Metagross 7",
    "species": "Metagross",
    "instance": "7",
    "nature": "Hardy",
    "item": "Shell Bell",
    "move1": "Earthquake",
    "move2": "Shadow Ball",
    "move3": "Ice Punch",
    "move4": "ThunderPunch",
    "speed50": 90,
    "speed100": 176
  },
  {
    "entry": 836,
    "name": "Metagross 8",
    "species": "Metagross",
    "instance": "8",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Meteor Mash",
    "move2": "Earthquake",
    "move3": "Brick Break",
    "move4": "Explosion",
    "speed50": 111,
    "speed100": 218
  },
  {
    "entry": 837,
    "name": "Regirock 5",
    "species": "Regirock",
    "instance": "5",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Hyper Beam",
    "move2": "Focus Punch",
    "move3": "Rock Slide",
    "move4": "Double Team",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 838,
    "name": "Regirock 6",
    "species": "Regirock",
    "instance": "6",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Swagger",
    "move2": "Psych Up",
    "move3": "Rock Slide",
    "move4": "Explosion",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 839,
    "name": "Regice 5",
    "species": "Regice",
    "instance": "5",
    "nature": "Brave",
    "item": "Leftovers",
    "move1": "Earthquake",
    "move2": "Ice Beam",
    "move3": "Curse",
    "move4": "Counter",
    "speed50": 63,
    "speed100": 122
  },
  {
    "entry": 840,
    "name": "Regice 6",
    "species": "Regice",
    "instance": "6",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Ice Beam",
    "move2": "Thunderbolt",
    "move3": "Sleep Talk",
    "move4": "Rest",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 841,
    "name": "Registeel 5",
    "species": "Registeel",
    "instance": "5",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Focus Punch",
    "move2": "Substitute",
    "move3": "Toxic",
    "move4": "Double Team",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 842,
    "name": "Registeel 6",
    "species": "Registeel",
    "instance": "6",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Superpower",
    "move2": "Aerial Ace",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed50": 70,
    "speed100": 136
  },
  {
    "entry": 843,
    "name": "Latias 5",
    "species": "Latias",
    "instance": "5",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Dragon Claw",
    "move2": "Thunder Wave",
    "move3": "Calm Mind",
    "move4": "Recover",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 844,
    "name": "Latias 6",
    "species": "Latias",
    "instance": "6",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Mist Ball",
    "move2": "Dragon Claw",
    "move3": "Attract",
    "move4": "Thunder Wave",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 845,
    "name": "Latias 7",
    "species": "Latias",
    "instance": "7",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Earthquake",
    "move2": "Shadow Ball",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 846,
    "name": "Latias 8",
    "species": "Latias",
    "instance": "8",
    "nature": "Docile",
    "item": "King's Rock",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Earthquake",
    "move4": "Aerial Ace",
    "speed50": 151,
    "speed100": 298
  },
  {
    "entry": 847,
    "name": "Latios 5",
    "species": "Latios",
    "instance": "5",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Dragon Claw",
    "move2": "Thunder Wave",
    "move3": "Calm Mind",
    "move4": "Recover",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 848,
    "name": "Latios 6",
    "species": "Latios",
    "instance": "6",
    "nature": "Docile",
    "item": "Shell Bell",
    "move1": "Luster Purge",
    "move2": "Shadow Ball",
    "move3": "Dragon Claw",
    "move4": "Thunder Wave",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 849,
    "name": "Latios 7",
    "species": "Latios",
    "instance": "7",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Earthquake",
    "move2": "Shadow Ball",
    "move3": "Dragon Dance",
    "move4": "Recover",
    "speed50": 130,
    "speed100": 256
  },
  {
    "entry": 850,
    "name": "Latios 8",
    "species": "Latios",
    "instance": "8",
    "nature": "Docile",
    "item": "King's Rock",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Earthquake",
    "move4": "Aerial Ace",
    "speed50": 151,
    "speed100": 298
  },
  {
    "entry": 851,
    "name": "Dragonite 1",
    "species": "Dragonite",
    "instance": "1",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Earthquake",
    "move2": "Aerial Ace",
    "move3": "Brick Break",
    "move4": "Dragon Dance",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 852,
    "name": "Dragonite 2",
    "species": "Dragonite",
    "instance": "2",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Earthquake",
    "move2": "Double-Edge",
    "move3": "Aerial Ace",
    "move4": "Dragon Dance",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 853,
    "name": "Dragonite 3",
    "species": "Dragonite",
    "instance": "3",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Hyper Beam",
    "move2": "Attract",
    "move3": "Double Team",
    "move4": "Thunder Wave",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 854,
    "name": "Dragonite 4",
    "species": "Dragonite",
    "instance": "4",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Hyper Beam",
    "move2": "Thunder Wave",
    "move3": "Dragon Dance",
    "move4": "Rest",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 855,
    "name": "Dragonite 5",
    "species": "Dragonite",
    "instance": "5",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "Outrage",
    "move2": "Double-Edge",
    "move3": "Thunder Wave",
    "move4": "Roar",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 856,
    "name": "Dragonite 6",
    "species": "Dragonite",
    "instance": "6",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Dragon Claw",
    "move2": "Thunderbolt",
    "move3": "Surf",
    "move4": "Flamethrower",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 857,
    "name": "Dragonite 7",
    "species": "Dragonite",
    "instance": "7",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Dragon Claw",
    "move2": "Thunderbolt",
    "move3": "Surf",
    "move4": "Ice Beam",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 858,
    "name": "Dragonite 8",
    "species": "Dragonite",
    "instance": "8",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Dragon Claw",
    "move2": "Flamethrower",
    "move3": "Ice Beam",
    "move4": "Brick Break",
    "speed50": 132,
    "speed100": 259
  },
  {
    "entry": 859,
    "name": "Dragonite 9",
    "species": "Dragonite",
    "instance": "9",
    "nature": "Docile",
    "item": "Quick Claw",
    "move1": "Thunder",
    "move2": "Surf",
    "move3": "Rain Dance",
    "move4": "Earthquake",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 860,
    "name": "Dragonite 10",
    "species": "Dragonite",
    "instance": "10",
    "nature": "Docile",
    "item": "Quick Claw",
    "move1": "Fire Blast",
    "move2": "Blizzard",
    "move3": "Sunny Day",
    "move4": "Earthquake",
    "speed50": 100,
    "speed100": 196
  },
  {
    "entry": 861,
    "name": "Tyranitar 1",
    "species": "Tyranitar",
    "instance": "1",
    "nature": "Hardy",
    "item": "BrightPowder",
    "move1": "Earthquake",
    "move2": "Aerial Ace",
    "move3": "Thunderbolt",
    "move4": "Surf",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 862,
    "name": "Tyranitar 2",
    "species": "Tyranitar",
    "instance": "2",
    "nature": "Hardy",
    "item": "BrightPowder",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Crunch",
    "move4": "Thunderbolt",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 863,
    "name": "Tyranitar 3",
    "species": "Tyranitar",
    "instance": "3",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Counter",
    "move4": "Dragon Dance",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 864,
    "name": "Tyranitar 4",
    "species": "Tyranitar",
    "instance": "4",
    "nature": "Modest",
    "item": "Quick Claw",
    "move1": "Crunch",
    "move2": "Ice Beam",
    "move3": "Thunderbolt",
    "move4": "Flamethrower",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 865,
    "name": "Tyranitar 5",
    "species": "Tyranitar",
    "instance": "5",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Dragon Dance",
    "move4": "Rest",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 866,
    "name": "Tyranitar 6",
    "species": "Tyranitar",
    "instance": "6",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Curse",
    "move4": "Rest",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 867,
    "name": "Tyranitar 7",
    "species": "Tyranitar",
    "instance": "7",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Rock Slide",
    "move2": "Aerial Ace",
    "move3": "Brick Break",
    "move4": "Curse",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 868,
    "name": "Tyranitar 8",
    "species": "Tyranitar",
    "instance": "8",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Rock Slide",
    "move2": "Thunder Wave",
    "move3": "Dragon Dance",
    "move4": "Rest",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 869,
    "name": "Tyranitar 9",
    "species": "Tyranitar",
    "instance": "9",
    "nature": "Hardy",
    "item": "Quick Claw",
    "move1": "Crunch",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "Attract",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 870,
    "name": "Tyranitar 10",
    "species": "Tyranitar",
    "instance": "10",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Dragon Dance",
    "speed50": 81,
    "speed100": 158
  },
  {
    "entry": 871,
    "name": "Articuno 5",
    "species": "Articuno",
    "instance": "5",
    "nature": "Docile",
    "item": "Focus Band",
    "move1": "Blizzard",
    "move2": "Double-Edge",
    "move3": "Agility",
    "move4": "Swagger",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 872,
    "name": "Articuno 6",
    "species": "Articuno",
    "instance": "6",
    "nature": "Docile",
    "item": "Chesto Berry",
    "move1": "Ice Beam",
    "move2": "Aerial Ace",
    "move3": "Reflect",
    "move4": "Rest",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 873,
    "name": "Zapdos 5",
    "species": "Zapdos",
    "instance": "5",
    "nature": "Docile",
    "item": "Scope Lens",
    "move1": "Thunderbolt",
    "move2": "Drill Peck",
    "move3": "Double-Edge",
    "move4": "Thunder Wave",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 874,
    "name": "Zapdos 6",
    "species": "Zapdos",
    "instance": "6",
    "nature": "Docile",
    "item": "Lum Berry",
    "move1": "Thunder",
    "move2": "Drill Peck",
    "move3": "Rain Dance",
    "move4": "Double-Edge",
    "speed50": 141,
    "speed100": 278
  },
  {
    "entry": 875,
    "name": "Moltres 5",
    "species": "Moltres",
    "instance": "5",
    "nature": "Docile",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Sunny Day",
    "move3": "Swagger",
    "move4": "Facade",
    "speed50": 142,
    "speed100": 279
  },
  {
    "entry": 876,
    "name": "Moltres 6",
    "species": "Moltres",
    "instance": "6",
    "nature": "Docile",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Double-Edge",
    "move3": "Aerial Ace",
    "move4": "Steel Wing",
    "speed50": 110,
    "speed100": 216
  },
  {
    "entry": 877,
    "name": "Raikou 5",
    "species": "Raikou",
    "instance": "5",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Thunderbolt",
    "move2": "Double-Edge",
    "move3": "Roar",
    "move4": "Reflect",
    "speed50": 167,
    "speed100": 329
  },
  {
    "entry": 878,
    "name": "Raikou 6",
    "species": "Raikou",
    "instance": "6",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Thunderbolt",
    "move2": "Calm Mind",
    "move3": "Substitute",
    "move4": "Rest",
    "speed50": 135,
    "speed100": 266
  },
  {
    "entry": 879,
    "name": "Entei 5",
    "species": "Entei",
    "instance": "5",
    "nature": "Docile",
    "item": "Salac Berry",
    "move1": "Fire Blast",
    "move2": "Double-Edge",
    "move3": "Endure",
    "move4": "Reflect",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 880,
    "name": "Entei 6",
    "species": "Entei",
    "instance": "6",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Flamethrower",
    "move2": "Calm Mind",
    "move3": "Roar",
    "move4": "Rest",
    "speed50": 120,
    "speed100": 236
  },
  {
    "entry": 881,
    "name": "Suicune 5",
    "species": "Suicune",
    "instance": "5",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Calm Mind",
    "move4": "Icy Wind",
    "speed50": 105,
    "speed100": 206
  },
  {
    "entry": 882,
    "name": "Suicune 6",
    "species": "Suicune",
    "instance": "6",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Calm Mind",
    "move4": "Rest",
    "speed50": 105,
    "speed100": 206
  }
];
